import { C as e, S as t, T as n, _ as r, a as i, c as a, d as o, f as s, g as c, h as l, i as u, l as d, n as f, o as p, p as m, r as h, s as g, t as _, u as v, w as y, y as b } from "./dp-map-styles-6CIMdHTb.js";
import { n as x, t as S } from "./dp-i18n-Bh6Mi68k.js";
import { n as C, t as w } from "./dp-loader-circle-paAKKpCU.js";
//#region src/lib/analytics.ts
var T = /* @__PURE__ */ new Set([
	"dearplace.studio",
	"www.dearplace.studio",
	"shop.dearplace.studio"
]), E = /* @__PURE__ */ new Set(/* @__PURE__ */ "model_id.design_id.option.value.selected_value.size.base.style.frame.color.zoom.scale.source.results.button.placement.action.media_id.media_type.gallery.position.seconds.error_kind.product_id.variant_id.currency.item_count".split(".")), ee = !1, te = [];
function D(e, t = {}) {
	if (typeof window > "u" || !T.has(window.location.hostname)) return;
	let n = window.Shopify, r = window.Shopify?.customerPrivacy;
	if (!r && n?.loadFeatures) {
		if (te.length < 20 && te.push(() => D(e, t)), !ee) {
			ee = !0;
			try {
				n.loadFeatures([{
					name: "consent-tracking-api",
					version: "0.1"
				}], (e) => {
					ee = !1;
					let t = te;
					te = [], !e && n.customerPrivacy && t.forEach((e) => e());
				});
			} catch {
				ee = !1, te = [];
			}
		}
		return;
	}
	if (!r || !(r.analyticsProcessingAllowed?.() || r.marketingAllowed?.())) return;
	let i = { ...t };
	if (typeof i.color == "string" && /^(pastell?|forest)$/i.test(i.color) && (i.color = "forest"), typeof i.frame == "string" && (i.frame = i.frame.replace(/^Frame-/i, "").toLowerCase()), i.size != null) {
		let e = String(i.size).match(/^(20|25|55)(?:\s*x|$)/)?.[1];
		e && (i.size = `${e} x ${e} cm`);
	}
	let a = Object.fromEntries(Object.entries(i).filter(([e, t]) => E.has(e) && [
		"string",
		"number",
		"boolean"
	].includes(typeof t)));
	try {
		let t = window.Shopify;
		return (t?.analytics?.publish(`dp_${e}`, a))?.catch?.(() => {}), typeof t?.analytics?.publish == "function";
	} catch {}
}
function ne(e, t = {}) {
	let n = !1, r = !0, i = () => {
		r && !n && window.Shopify?.customerPrivacy && (n = !!D(e, t));
	};
	document.addEventListener("visitorConsentCollected", i);
	let a = window.Shopify;
	if (!a?.customerPrivacy && a?.loadFeatures) try {
		a.loadFeatures([{
			name: "consent-tracking-api",
			version: "0.1"
		}], i);
	} catch {}
	return i(), () => {
		r = !1, document.removeEventListener("visitorConsentCollected", i);
	};
}
var re = (e) => ne("product_viewed", e), ie = (e, t = {}) => D("button_clicked", {
	button: e,
	...t
}), ae = (e = {}) => D("preview_started", e), O = /* @__PURE__ */ new Set(), k = (e, t = {}) => {
	O.has(e) || (O.add(e), D("preview_ready", {
		...t,
		model_id: e
	}));
}, A = (e = {}) => D("preview_failed", e), oe = (e, t = {}) => D("media_engagement", {
	action: e,
	...t
}), se = (e, t, n = {}) => D("option_selected", {
	option: e,
	selected_value: t,
	...n
}), ce = (e = {}) => D("place_selected", e), le = (e, t = {}) => D("place_searched", t), j = (e) => D("configurator_started", { placement: e }), ue = /* @__PURE__ */ y(((e) => {
	function t(e, t) {
		var n = e.length;
		e.push(t);
		a: for (; 0 < n;) {
			var r = n - 1 >>> 1, a = e[r];
			if (0 < i(a, t)) e[r] = t, e[n] = a, n = r;
			else break a;
		}
	}
	function n(e) {
		return e.length === 0 ? null : e[0];
	}
	function r(e) {
		if (e.length === 0) return null;
		var t = e[0], n = e.pop();
		if (n !== t) {
			e[0] = n;
			a: for (var r = 0, a = e.length, o = a >>> 1; r < o;) {
				var s = 2 * (r + 1) - 1, c = e[s], l = s + 1, u = e[l];
				if (0 > i(c, n)) l < a && 0 > i(u, c) ? (e[r] = u, e[l] = n, r = l) : (e[r] = c, e[s] = n, r = s);
				else if (l < a && 0 > i(u, n)) e[r] = u, e[l] = n, r = l;
				else break a;
			}
		}
		return t;
	}
	function i(e, t) {
		var n = e.sortIndex - t.sortIndex;
		return n === 0 ? e.id - t.id : n;
	}
	if (e.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
		var a = performance;
		e.unstable_now = function() {
			return a.now();
		};
	} else {
		var o = Date, s = o.now();
		e.unstable_now = function() {
			return o.now() - s;
		};
	}
	var c = [], l = [], u = 1, d = null, f = 3, p = !1, m = !1, h = !1, g = !1, _ = typeof setTimeout == "function" ? setTimeout : null, v = typeof clearTimeout == "function" ? clearTimeout : null, y = typeof setImmediate < "u" ? setImmediate : null;
	function b(e) {
		for (var i = n(l); i !== null;) {
			if (i.callback === null) r(l);
			else if (i.startTime <= e) r(l), i.sortIndex = i.expirationTime, t(c, i);
			else break;
			i = n(l);
		}
	}
	function x(e) {
		if (h = !1, b(e), !m) {
			if (n(c) !== null) m = !0, S || (S = !0, te());
			else {
				var t = n(l);
				t !== null && re(x, t.startTime - e);
			}
		}
	}
	var S = !1, C = -1, w = 5, T = -1;
	function E() {
		return g ? !0 : !(e.unstable_now() - T < w);
	}
	function ee() {
		if (g = !1, S) {
			var t = e.unstable_now();
			T = t;
			var i = !0;
			try {
				a: {
					m = !1, h && (h = !1, v(C), C = -1), p = !0;
					var a = f;
					try {
						b: {
							for (b(t), d = n(c); d !== null && !(d.expirationTime > t && E());) {
								var o = d.callback;
								if (typeof o == "function") {
									d.callback = null, f = d.priorityLevel;
									var s = o(d.expirationTime <= t);
									if (t = e.unstable_now(), typeof s == "function") {
										d.callback = s, b(t), i = !0;
										break b;
									}
									d === n(c) && r(c), b(t);
								} else r(c);
								d = n(c);
							}
							if (d !== null) i = !0;
							else {
								var u = n(l);
								u !== null && re(x, u.startTime - t), i = !1;
							}
						}
						break a;
					} finally {
						d = null, f = a, p = !1;
					}
					i = void 0;
				}
			} finally {
				i ? te() : S = !1;
			}
		}
	}
	var te;
	if (typeof y == "function") te = function() {
		y(ee);
	};
	else if (typeof MessageChannel < "u") {
		var D = new MessageChannel(), ne = D.port2;
		D.port1.onmessage = ee, te = function() {
			ne.postMessage(null);
		};
	} else te = function() {
		_(ee, 0);
	};
	function re(t, n) {
		C = _(function() {
			t(e.unstable_now());
		}, n);
	}
	e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(e) {
		e.callback = null;
	}, e.unstable_forceFrameRate = function(e) {
		0 > e || 125 < e ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : w = 0 < e ? Math.floor(1e3 / e) : 5;
	}, e.unstable_getCurrentPriorityLevel = function() {
		return f;
	}, e.unstable_next = function(e) {
		switch (f) {
			case 1:
			case 2:
			case 3:
				var t = 3;
				break;
			default: t = f;
		}
		var n = f;
		f = t;
		try {
			return e();
		} finally {
			f = n;
		}
	}, e.unstable_requestPaint = function() {
		g = !0;
	}, e.unstable_runWithPriority = function(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 3:
			case 4:
			case 5: break;
			default: e = 3;
		}
		var n = f;
		f = e;
		try {
			return t();
		} finally {
			f = n;
		}
	}, e.unstable_scheduleCallback = function(r, i, a) {
		var o = e.unstable_now();
		switch (typeof a == "object" && a ? (a = a.delay, a = typeof a == "number" && 0 < a ? o + a : o) : a = o, r) {
			case 1:
				var s = -1;
				break;
			case 2:
				s = 250;
				break;
			case 5:
				s = 1073741823;
				break;
			case 4:
				s = 1e4;
				break;
			default: s = 5e3;
		}
		return s = a + s, r = {
			id: u++,
			callback: i,
			priorityLevel: r,
			startTime: a,
			expirationTime: s,
			sortIndex: -1
		}, a > o ? (r.sortIndex = a, t(l, r), n(c) === null && r === n(l) && (h ? (v(C), C = -1) : h = !0, re(x, a - o))) : (r.sortIndex = s, t(c, r), m || p || (m = !0, S || (S = !0, te()))), r;
	}, e.unstable_shouldYield = E, e.unstable_wrapCallback = function(e) {
		var t = f;
		return function() {
			var n = f;
			f = t;
			try {
				return e.apply(this, arguments);
			} finally {
				f = n;
			}
		};
	};
})), de = /* @__PURE__ */ y(((e, t) => {
	t.exports = ue();
})), M = /* @__PURE__ */ y(((t) => {
	var n = e();
	function r(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function i() {}
	var a = {
		d: {
			f: i,
			r: function() {
				throw Error(r(522));
			},
			D: i,
			C: i,
			L: i,
			m: i,
			X: i,
			S: i,
			M: i
		},
		p: 0,
		findDOMNode: null
	}, o = Symbol.for("react.portal");
	function s(e, t, n) {
		var r = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
		return {
			$$typeof: o,
			key: r == null ? null : "" + r,
			children: e,
			containerInfo: t,
			implementation: n
		};
	}
	var c = n.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
	function l(e, t) {
		if (e === "font") return "";
		if (typeof t == "string") return t === "use-credentials" ? t : "";
	}
	t.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = a, t.createPortal = function(e, t) {
		var n = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
		if (!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11) throw Error(r(299));
		return s(e, t, null, n);
	}, t.flushSync = function(e) {
		var t = c.T, n = a.p;
		try {
			if (c.T = null, a.p = 2, e) return e();
		} finally {
			c.T = t, a.p = n, a.d.f();
		}
	}, t.preconnect = function(e, t) {
		typeof e == "string" && (t ? (t = t.crossOrigin, t = typeof t == "string" ? t === "use-credentials" ? t : "" : void 0) : t = null, a.d.C(e, t));
	}, t.prefetchDNS = function(e) {
		typeof e == "string" && a.d.D(e);
	}, t.preinit = function(e, t) {
		if (typeof e == "string" && t && typeof t.as == "string") {
			var n = t.as, r = l(n, t.crossOrigin), i = typeof t.integrity == "string" ? t.integrity : void 0, o = typeof t.fetchPriority == "string" ? t.fetchPriority : void 0;
			n === "style" ? a.d.S(e, typeof t.precedence == "string" ? t.precedence : void 0, {
				crossOrigin: r,
				integrity: i,
				fetchPriority: o
			}) : n === "script" && a.d.X(e, {
				crossOrigin: r,
				integrity: i,
				fetchPriority: o,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0
			});
		}
	}, t.preinitModule = function(e, t) {
		if (typeof e == "string") {
			if (typeof t == "object" && t) {
				if (t.as == null || t.as === "script") {
					var n = l(t.as, t.crossOrigin);
					a.d.M(e, {
						crossOrigin: n,
						integrity: typeof t.integrity == "string" ? t.integrity : void 0,
						nonce: typeof t.nonce == "string" ? t.nonce : void 0
					});
				}
			} else t ?? a.d.M(e);
		}
	}, t.preload = function(e, t) {
		if (typeof e == "string" && typeof t == "object" && t && typeof t.as == "string") {
			var n = t.as, r = l(n, t.crossOrigin);
			a.d.L(e, n, {
				crossOrigin: r,
				integrity: typeof t.integrity == "string" ? t.integrity : void 0,
				nonce: typeof t.nonce == "string" ? t.nonce : void 0,
				type: typeof t.type == "string" ? t.type : void 0,
				fetchPriority: typeof t.fetchPriority == "string" ? t.fetchPriority : void 0,
				referrerPolicy: typeof t.referrerPolicy == "string" ? t.referrerPolicy : void 0,
				imageSrcSet: typeof t.imageSrcSet == "string" ? t.imageSrcSet : void 0,
				imageSizes: typeof t.imageSizes == "string" ? t.imageSizes : void 0,
				media: typeof t.media == "string" ? t.media : void 0
			});
		}
	}, t.preloadModule = function(e, t) {
		if (typeof e == "string") {
			if (t) {
				var n = l(t.as, t.crossOrigin);
				a.d.m(e, {
					as: typeof t.as == "string" && t.as !== "script" ? t.as : void 0,
					crossOrigin: n,
					integrity: typeof t.integrity == "string" ? t.integrity : void 0
				});
			} else a.d.m(e);
		}
	}, t.requestFormReset = function(e) {
		a.d.r(e);
	}, t.unstable_batchedUpdates = function(e, t) {
		return e(t);
	}, t.useFormState = function(e, t, n) {
		return c.H.useFormState(e, t, n);
	}, t.useFormStatus = function() {
		return c.H.useHostTransitionStatus();
	}, t.version = "19.2.8";
})), N = /* @__PURE__ */ y(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = M();
})), P = /* @__PURE__ */ y(((t) => {
	var n = de(), r = e(), i = N();
	function a(e) {
		var t = "https://react.dev/errors/" + e;
		if (1 < arguments.length) {
			t += "?args[]=" + encodeURIComponent(arguments[1]);
			for (var n = 2; n < arguments.length; n++) t += "&args[]=" + encodeURIComponent(arguments[n]);
		}
		return "Minified React error #" + e + "; visit " + t + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
	}
	function o(e) {
		return !(!e || e.nodeType !== 1 && e.nodeType !== 9 && e.nodeType !== 11);
	}
	function s(e) {
		var t = e, n = e;
		if (e.alternate) for (; t.return;) t = t.return;
		else {
			e = t;
			do
				t = e, t.flags & 4098 && (n = t.return), e = t.return;
			while (e);
		}
		return t.tag === 3 ? n : null;
	}
	function c(e) {
		if (e.tag === 13) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function l(e) {
		if (e.tag === 31) {
			var t = e.memoizedState;
			if (t === null && (e = e.alternate, e !== null && (t = e.memoizedState)), t !== null) return t.dehydrated;
		}
		return null;
	}
	function u(e) {
		if (s(e) !== e) throw Error(a(188));
	}
	function d(e) {
		var t = e.alternate;
		if (!t) {
			if (t = s(e), t === null) throw Error(a(188));
			return t === e ? e : null;
		}
		for (var n = e, r = t;;) {
			var i = n.return;
			if (i === null) break;
			var o = i.alternate;
			if (o === null) {
				if (r = i.return, r !== null) {
					n = r;
					continue;
				}
				break;
			}
			if (i.child === o.child) {
				for (o = i.child; o;) {
					if (o === n) return u(i), e;
					if (o === r) return u(i), t;
					o = o.sibling;
				}
				throw Error(a(188));
			}
			if (n.return !== r.return) n = i, r = o;
			else {
				for (var c = !1, l = i.child; l;) {
					if (l === n) {
						c = !0, n = i, r = o;
						break;
					}
					if (l === r) {
						c = !0, r = i, n = o;
						break;
					}
					l = l.sibling;
				}
				if (!c) {
					for (l = o.child; l;) {
						if (l === n) {
							c = !0, n = o, r = i;
							break;
						}
						if (l === r) {
							c = !0, r = o, n = i;
							break;
						}
						l = l.sibling;
					}
					if (!c) throw Error(a(189));
				}
			}
			if (n.alternate !== r) throw Error(a(190));
		}
		if (n.tag !== 3) throw Error(a(188));
		return n.stateNode.current === n ? e : t;
	}
	function f(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e;
		for (e = e.child; e !== null;) {
			if (t = f(e), t !== null) return t;
			e = e.sibling;
		}
		return null;
	}
	var p = Object.assign, m = Symbol.for("react.element"), h = Symbol.for("react.transitional.element"), g = Symbol.for("react.portal"), _ = Symbol.for("react.fragment"), v = Symbol.for("react.strict_mode"), y = Symbol.for("react.profiler"), b = Symbol.for("react.consumer"), x = Symbol.for("react.context"), S = Symbol.for("react.forward_ref"), C = Symbol.for("react.suspense"), w = Symbol.for("react.suspense_list"), T = Symbol.for("react.memo"), E = Symbol.for("react.lazy"), ee = Symbol.for("react.activity"), te = Symbol.for("react.memo_cache_sentinel"), D = Symbol.iterator;
	function ne(e) {
		return typeof e != "object" || !e ? null : (e = D && e[D] || e["@@iterator"], typeof e == "function" ? e : null);
	}
	var re = Symbol.for("react.client.reference");
	function ie(e) {
		if (e == null) return null;
		if (typeof e == "function") return e.$$typeof === re ? null : e.displayName || e.name || null;
		if (typeof e == "string") return e;
		switch (e) {
			case _: return "Fragment";
			case y: return "Profiler";
			case v: return "StrictMode";
			case C: return "Suspense";
			case w: return "SuspenseList";
			case ee: return "Activity";
		}
		if (typeof e == "object") switch (e.$$typeof) {
			case g: return "Portal";
			case x: return e.displayName || "Context";
			case b: return (e._context.displayName || "Context") + ".Consumer";
			case S:
				var t = e.render;
				return e = e.displayName, e ||= (e = t.displayName || t.name || "", e === "" ? "ForwardRef" : "ForwardRef(" + e + ")"), e;
			case T: return t = e.displayName || null, t === null ? ie(e.type) || "Memo" : t;
			case E:
				t = e._payload, e = e._init;
				try {
					return ie(e(t));
				} catch {}
		}
		return null;
	}
	var ae = Array.isArray, O = r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, k = i.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, A = {
		pending: !1,
		data: null,
		method: null,
		action: null
	}, oe = [], se = -1;
	function ce(e) {
		return { current: e };
	}
	function le(e) {
		0 > se || (e.current = oe[se], oe[se] = null, se--);
	}
	function j(e, t) {
		se++, oe[se] = e.current, e.current = t;
	}
	var ue = ce(null), M = ce(null), P = ce(null), fe = ce(null);
	function F(e, t) {
		switch (j(P, t), j(M, e), j(ue, null), t.nodeType) {
			case 9:
			case 11:
				e = (e = t.documentElement) && (e = e.namespaceURI) ? Vd(e) : 0;
				break;
			default: if (e = t.tagName, t = t.namespaceURI) t = Vd(t), e = Hd(t, e);
			else switch (e) {
				case "svg":
					e = 1;
					break;
				case "math":
					e = 2;
					break;
				default: e = 0;
			}
		}
		le(ue), j(ue, e);
	}
	function I() {
		le(ue), le(M), le(P);
	}
	function pe(e) {
		e.memoizedState !== null && j(fe, e);
		var t = ue.current, n = Hd(t, e.type);
		t !== n && (j(M, e), j(ue, n));
	}
	function me(e) {
		M.current === e && (le(ue), le(M)), fe.current === e && (le(fe), Qf._currentValue = A);
	}
	var he, ge;
	function _e(e) {
		if (he === void 0) try {
			throw Error();
		} catch (e) {
			var t = e.stack.trim().match(/\n( *(at )?)/);
			he = t && t[1] || "", ge = -1 < e.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < e.stack.indexOf("@") ? "@unknown:0:0" : "";
		}
		return "\n" + he + e + ge;
	}
	var ve = !1;
	function ye(e, t) {
		if (!e || ve) return "";
		ve = !0;
		var n = Error.prepareStackTrace;
		Error.prepareStackTrace = void 0;
		try {
			var r = { DetermineComponentFrameRoot: function() {
				try {
					if (t) {
						var n = function() {
							throw Error();
						};
						if (Object.defineProperty(n.prototype, "props", { set: function() {
							throw Error();
						} }), typeof Reflect == "object" && Reflect.construct) {
							try {
								Reflect.construct(n, []);
							} catch (e) {
								var r = e;
							}
							Reflect.construct(e, [], n);
						} else {
							try {
								n.call();
							} catch (e) {
								r = e;
							}
							e.call(n.prototype);
						}
					} else {
						try {
							throw Error();
						} catch (e) {
							r = e;
						}
						(n = e()) && typeof n.catch == "function" && n.catch(function() {});
					}
				} catch (e) {
					if (e && r && typeof e.stack == "string") return [e.stack, r.stack];
				}
				return [null, null];
			} };
			r.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
			var i = Object.getOwnPropertyDescriptor(r.DetermineComponentFrameRoot, "name");
			i && i.configurable && Object.defineProperty(r.DetermineComponentFrameRoot, "name", { value: "DetermineComponentFrameRoot" });
			var a = r.DetermineComponentFrameRoot(), o = a[0], s = a[1];
			if (o && s) {
				var c = o.split("\n"), l = s.split("\n");
				for (i = r = 0; r < c.length && !c[r].includes("DetermineComponentFrameRoot");) r++;
				for (; i < l.length && !l[i].includes("DetermineComponentFrameRoot");) i++;
				if (r === c.length || i === l.length) for (r = c.length - 1, i = l.length - 1; 1 <= r && 0 <= i && c[r] !== l[i];) i--;
				for (; 1 <= r && 0 <= i; r--, i--) if (c[r] !== l[i]) {
					if (r !== 1 || i !== 1) do
						if (r--, i--, 0 > i || c[r] !== l[i]) {
							var u = "\n" + c[r].replace(" at new ", " at ");
							return e.displayName && u.includes("<anonymous>") && (u = u.replace("<anonymous>", e.displayName)), u;
						}
					while (1 <= r && 0 <= i);
					break;
				}
			}
		} finally {
			ve = !1, Error.prepareStackTrace = n;
		}
		return (n = e ? e.displayName || e.name : "") ? _e(n) : "";
	}
	function L(e, t) {
		switch (e.tag) {
			case 26:
			case 27:
			case 5: return _e(e.type);
			case 16: return _e("Lazy");
			case 13: return e.child !== t && t !== null ? _e("Suspense Fallback") : _e("Suspense");
			case 19: return _e("SuspenseList");
			case 0:
			case 15: return ye(e.type, !1);
			case 11: return ye(e.type.render, !1);
			case 1: return ye(e.type, !0);
			case 31: return _e("Activity");
			default: return "";
		}
	}
	function be(e) {
		try {
			var t = "", n = null;
			do
				t += L(e, n), n = e, e = e.return;
			while (e);
			return t;
		} catch (e) {
			return "\nError generating stack: " + e.message + "\n" + e.stack;
		}
	}
	var xe = Object.prototype.hasOwnProperty, Se = n.unstable_scheduleCallback, R = n.unstable_cancelCallback, Ce = n.unstable_shouldYield, z = n.unstable_requestPaint, we = n.unstable_now, Te = n.unstable_getCurrentPriorityLevel, Ee = n.unstable_ImmediatePriority, De = n.unstable_UserBlockingPriority, Oe = n.unstable_NormalPriority, ke = n.unstable_LowPriority, Ae = n.unstable_IdlePriority, je = n.log, Me = n.unstable_setDisableYieldValue, Ne = null, Pe = null;
	function Fe(e) {
		if (typeof je == "function" && Me(e), Pe && typeof Pe.setStrictMode == "function") try {
			Pe.setStrictMode(Ne, e);
		} catch {}
	}
	var Ie = Math.clz32 ? Math.clz32 : ze, Le = Math.log, Re = Math.LN2;
	function ze(e) {
		return e >>>= 0, e === 0 ? 32 : 31 - (Le(e) / Re | 0) | 0;
	}
	var Be = 256, Ve = 262144, He = 4194304;
	function Ue(e) {
		var t = e & 42;
		if (t !== 0) return t;
		switch (e & -e) {
			case 1: return 1;
			case 2: return 2;
			case 4: return 4;
			case 8: return 8;
			case 16: return 16;
			case 32: return 32;
			case 64: return 64;
			case 128: return 128;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072: return e & 261888;
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return e & 3932160;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return e & 62914560;
			case 67108864: return 67108864;
			case 134217728: return 134217728;
			case 268435456: return 268435456;
			case 536870912: return 536870912;
			case 1073741824: return 0;
			default: return e;
		}
	}
	function We(e, t, n) {
		var r = e.pendingLanes;
		if (r === 0) return 0;
		var i = 0, a = e.suspendedLanes, o = e.pingedLanes;
		e = e.warmLanes;
		var s = r & 134217727;
		return s === 0 ? (s = r & ~a, s === 0 ? o === 0 ? n || (n = r & ~e, n !== 0 && (i = Ue(n))) : i = Ue(o) : i = Ue(s)) : (r = s & ~a, r === 0 ? (o &= s, o === 0 ? n || (n = s & ~e, n !== 0 && (i = Ue(n))) : i = Ue(o)) : i = Ue(r)), i === 0 ? 0 : t !== 0 && t !== i && (t & a) === 0 && (a = i & -i, n = t & -t, a >= n || a === 32 && n & 4194048) ? t : i;
	}
	function Ge(e, t) {
		return (e.pendingLanes & ~(e.suspendedLanes & ~e.pingedLanes) & t) === 0;
	}
	function Ke(e, t) {
		switch (e) {
			case 1:
			case 2:
			case 4:
			case 8:
			case 64: return t + 250;
			case 16:
			case 32:
			case 128:
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152: return t + 5e3;
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432: return -1;
			case 67108864:
			case 134217728:
			case 268435456:
			case 536870912:
			case 1073741824: return -1;
			default: return -1;
		}
	}
	function qe() {
		var e = He;
		return He <<= 1, !(He & 62914560) && (He = 4194304), e;
	}
	function Je(e) {
		for (var t = [], n = 0; 31 > n; n++) t.push(e);
		return t;
	}
	function Ye(e, t) {
		e.pendingLanes |= t, t !== 268435456 && (e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0);
	}
	function Xe(e, t, n, r, i, a) {
		var o = e.pendingLanes;
		e.pendingLanes = n, e.suspendedLanes = 0, e.pingedLanes = 0, e.warmLanes = 0, e.expiredLanes &= n, e.entangledLanes &= n, e.errorRecoveryDisabledLanes &= n, e.shellSuspendCounter = 0;
		var s = e.entanglements, c = e.expirationTimes, l = e.hiddenUpdates;
		for (n = o & ~n; 0 < n;) {
			var u = 31 - Ie(n), d = 1 << u;
			s[u] = 0, c[u] = -1;
			var f = l[u];
			if (f !== null) for (l[u] = null, u = 0; u < f.length; u++) {
				var p = f[u];
				p !== null && (p.lane &= -536870913);
			}
			n &= ~d;
		}
		r !== 0 && Ze(e, r, 0), a !== 0 && i === 0 && e.tag !== 0 && (e.suspendedLanes |= a & ~(o & ~t));
	}
	function Ze(e, t, n) {
		e.pendingLanes |= t, e.suspendedLanes &= ~t;
		var r = 31 - Ie(t);
		e.entangledLanes |= t, e.entanglements[r] = e.entanglements[r] | 1073741824 | n & 261930;
	}
	function Qe(e, t) {
		var n = e.entangledLanes |= t;
		for (e = e.entanglements; n;) {
			var r = 31 - Ie(n), i = 1 << r;
			i & t | e[r] & t && (e[r] |= t), n &= ~i;
		}
	}
	function $e(e, t) {
		var n = t & -t;
		return n = n & 42 ? 1 : et(n), (n & (e.suspendedLanes | t)) === 0 ? n : 0;
	}
	function et(e) {
		switch (e) {
			case 2:
				e = 1;
				break;
			case 8:
				e = 4;
				break;
			case 32:
				e = 16;
				break;
			case 256:
			case 512:
			case 1024:
			case 2048:
			case 4096:
			case 8192:
			case 16384:
			case 32768:
			case 65536:
			case 131072:
			case 262144:
			case 524288:
			case 1048576:
			case 2097152:
			case 4194304:
			case 8388608:
			case 16777216:
			case 33554432:
				e = 128;
				break;
			case 268435456:
				e = 134217728;
				break;
			default: e = 0;
		}
		return e;
	}
	function tt(e) {
		return e &= -e, 2 < e ? 8 < e ? e & 134217727 ? 32 : 268435456 : 8 : 2;
	}
	function nt() {
		var e = k.p;
		return e === 0 ? (e = window.event, e === void 0 ? 32 : mp(e.type)) : e;
	}
	function rt(e, t) {
		var n = k.p;
		try {
			return k.p = e, t();
		} finally {
			k.p = n;
		}
	}
	var it = Math.random().toString(36).slice(2), at = "__reactFiber$" + it, ot = "__reactProps$" + it, st = "__reactContainer$" + it, ct = "__reactEvents$" + it, lt = "__reactListeners$" + it, ut = "__reactHandles$" + it, dt = "__reactResources$" + it, ft = "__reactMarker$" + it;
	function pt(e) {
		delete e[at], delete e[ot], delete e[ct], delete e[lt], delete e[ut];
	}
	function mt(e) {
		var t = e[at];
		if (t) return t;
		for (var n = e.parentNode; n;) {
			if (t = n[st] || n[at]) {
				if (n = t.alternate, t.child !== null || n !== null && n.child !== null) for (e = df(e); e !== null;) {
					if (n = e[at]) return n;
					e = df(e);
				}
				return t;
			}
			e = n, n = e.parentNode;
		}
		return null;
	}
	function ht(e) {
		if (e = e[at] || e[st]) {
			var t = e.tag;
			if (t === 5 || t === 6 || t === 13 || t === 31 || t === 26 || t === 27 || t === 3) return e;
		}
		return null;
	}
	function gt(e) {
		var t = e.tag;
		if (t === 5 || t === 26 || t === 27 || t === 6) return e.stateNode;
		throw Error(a(33));
	}
	function _t(e) {
		var t = e[dt];
		return t ||= e[dt] = {
			hoistableStyles: /* @__PURE__ */ new Map(),
			hoistableScripts: /* @__PURE__ */ new Map()
		}, t;
	}
	function vt(e) {
		e[ft] = !0;
	}
	var yt = /* @__PURE__ */ new Set(), bt = {};
	function xt(e, t) {
		St(e, t), St(e + "Capture", t);
	}
	function St(e, t) {
		for (bt[e] = t, e = 0; e < t.length; e++) yt.add(t[e]);
	}
	var Ct = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), wt = {}, Tt = {};
	function Et(e) {
		return xe.call(Tt, e) ? !0 : xe.call(wt, e) ? !1 : Ct.test(e) ? Tt[e] = !0 : (wt[e] = !0, !1);
	}
	function Dt(e, t, n) {
		if (Et(t)) {
			if (n === null) e.removeAttribute(t);
			else {
				switch (typeof n) {
					case "undefined":
					case "function":
					case "symbol":
						e.removeAttribute(t);
						return;
					case "boolean":
						var r = t.toLowerCase().slice(0, 5);
						if (r !== "data-" && r !== "aria-") {
							e.removeAttribute(t);
							return;
						}
				}
				e.setAttribute(t, "" + n);
			}
		}
	}
	function Ot(e, t, n) {
		if (n === null) e.removeAttribute(t);
		else {
			switch (typeof n) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(t);
					return;
			}
			e.setAttribute(t, "" + n);
		}
	}
	function B(e, t, n, r) {
		if (r === null) e.removeAttribute(n);
		else {
			switch (typeof r) {
				case "undefined":
				case "function":
				case "symbol":
				case "boolean":
					e.removeAttribute(n);
					return;
			}
			e.setAttributeNS(t, n, "" + r);
		}
	}
	function kt(e) {
		switch (typeof e) {
			case "bigint":
			case "boolean":
			case "number":
			case "string":
			case "undefined": return e;
			case "object": return e;
			default: return "";
		}
	}
	function At(e) {
		var t = e.type;
		return (e = e.nodeName) && e.toLowerCase() === "input" && (t === "checkbox" || t === "radio");
	}
	function jt(e, t, n) {
		var r = Object.getOwnPropertyDescriptor(e.constructor.prototype, t);
		if (!e.hasOwnProperty(t) && r !== void 0 && typeof r.get == "function" && typeof r.set == "function") {
			var i = r.get, a = r.set;
			return Object.defineProperty(e, t, {
				configurable: !0,
				get: function() {
					return i.call(this);
				},
				set: function(e) {
					n = "" + e, a.call(this, e);
				}
			}), Object.defineProperty(e, t, { enumerable: r.enumerable }), {
				getValue: function() {
					return n;
				},
				setValue: function(e) {
					n = "" + e;
				},
				stopTracking: function() {
					e._valueTracker = null, delete e[t];
				}
			};
		}
	}
	function Mt(e) {
		if (!e._valueTracker) {
			var t = At(e) ? "checked" : "value";
			e._valueTracker = jt(e, t, "" + e[t]);
		}
	}
	function Nt(e) {
		if (!e) return !1;
		var t = e._valueTracker;
		if (!t) return !0;
		var n = t.getValue(), r = "";
		return e && (r = At(e) ? e.checked ? "true" : "false" : e.value), e = r, e !== n && (t.setValue(e), !0);
	}
	function Pt(e) {
		if (e ||= typeof document < "u" ? document : void 0, e === void 0) return null;
		try {
			return e.activeElement || e.body;
		} catch {
			return e.body;
		}
	}
	var Ft = /[\n"\\]/g;
	function It(e) {
		return e.replace(Ft, function(e) {
			return "\\" + e.charCodeAt(0).toString(16) + " ";
		});
	}
	function Lt(e, t, n, r, i, a, o, s) {
		e.name = "", o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" ? e.type = o : e.removeAttribute("type"), t == null ? o !== "submit" && o !== "reset" || e.removeAttribute("value") : o === "number" ? (t === 0 && e.value === "" || e.value != t) && (e.value = "" + kt(t)) : e.value !== "" + kt(t) && (e.value = "" + kt(t)), t == null ? n == null ? r != null && e.removeAttribute("value") : zt(e, o, kt(n)) : zt(e, o, kt(t)), i == null && a != null && (e.defaultChecked = !!a), i != null && (e.checked = i && typeof i != "function" && typeof i != "symbol"), s != null && typeof s != "function" && typeof s != "symbol" && typeof s != "boolean" ? e.name = "" + kt(s) : e.removeAttribute("name");
	}
	function Rt(e, t, n, r, i, a, o, s) {
		if (a != null && typeof a != "function" && typeof a != "symbol" && typeof a != "boolean" && (e.type = a), t != null || n != null) {
			if (!(a !== "submit" && a !== "reset" || t != null)) {
				Mt(e);
				return;
			}
			n = n == null ? "" : "" + kt(n), t = t == null ? n : "" + kt(t), s || t === e.value || (e.value = t), e.defaultValue = t;
		}
		r ??= i, r = typeof r != "function" && typeof r != "symbol" && !!r, e.checked = s ? e.checked : !!r, e.defaultChecked = !!r, o != null && typeof o != "function" && typeof o != "symbol" && typeof o != "boolean" && (e.name = o), Mt(e);
	}
	function zt(e, t, n) {
		t === "number" && Pt(e.ownerDocument) === e || e.defaultValue === "" + n || (e.defaultValue = "" + n);
	}
	function Bt(e, t, n, r) {
		if (e = e.options, t) {
			t = {};
			for (var i = 0; i < n.length; i++) t["$" + n[i]] = !0;
			for (n = 0; n < e.length; n++) i = t.hasOwnProperty("$" + e[n].value), e[n].selected !== i && (e[n].selected = i), i && r && (e[n].defaultSelected = !0);
		} else {
			for (n = "" + kt(n), t = null, i = 0; i < e.length; i++) {
				if (e[i].value === n) {
					e[i].selected = !0, r && (e[i].defaultSelected = !0);
					return;
				}
				t !== null || e[i].disabled || (t = e[i]);
			}
			t !== null && (t.selected = !0);
		}
	}
	function Vt(e, t, n) {
		if (t != null && (t = "" + kt(t), t !== e.value && (e.value = t), n == null)) {
			e.defaultValue !== t && (e.defaultValue = t);
			return;
		}
		e.defaultValue = n == null ? "" : "" + kt(n);
	}
	function Ht(e, t, n, r) {
		if (t == null) {
			if (r != null) {
				if (n != null) throw Error(a(92));
				if (ae(r)) {
					if (1 < r.length) throw Error(a(93));
					r = r[0];
				}
				n = r;
			}
			n ??= "", t = n;
		}
		n = kt(t), e.defaultValue = n, r = e.textContent, r === n && r !== "" && r !== null && (e.value = r), Mt(e);
	}
	function Ut(e, t) {
		if (t) {
			var n = e.firstChild;
			if (n && n === e.lastChild && n.nodeType === 3) {
				n.nodeValue = t;
				return;
			}
		}
		e.textContent = t;
	}
	var Wt = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
	function Gt(e, t, n) {
		var r = t.indexOf("--") === 0;
		n == null || typeof n == "boolean" || n === "" ? r ? e.setProperty(t, "") : t === "float" ? e.cssFloat = "" : e[t] = "" : r ? e.setProperty(t, n) : typeof n != "number" || n === 0 || Wt.has(t) ? t === "float" ? e.cssFloat = n : e[t] = ("" + n).trim() : e[t] = n + "px";
	}
	function Kt(e, t, n) {
		if (t != null && typeof t != "object") throw Error(a(62));
		if (e = e.style, n != null) {
			for (var r in n) !n.hasOwnProperty(r) || t != null && t.hasOwnProperty(r) || (r.indexOf("--") === 0 ? e.setProperty(r, "") : r === "float" ? e.cssFloat = "" : e[r] = "");
			for (var i in t) r = t[i], t.hasOwnProperty(i) && n[i] !== r && Gt(e, i, r);
		} else for (var o in t) t.hasOwnProperty(o) && Gt(e, o, t[o]);
	}
	function qt(e) {
		if (e.indexOf("-") === -1) return !1;
		switch (e) {
			case "annotation-xml":
			case "color-profile":
			case "font-face":
			case "font-face-src":
			case "font-face-uri":
			case "font-face-format":
			case "font-face-name":
			case "missing-glyph": return !1;
			default: return !0;
		}
	}
	var Jt = /* @__PURE__ */ new Map([
		["acceptCharset", "accept-charset"],
		["htmlFor", "for"],
		["httpEquiv", "http-equiv"],
		["crossOrigin", "crossorigin"],
		["accentHeight", "accent-height"],
		["alignmentBaseline", "alignment-baseline"],
		["arabicForm", "arabic-form"],
		["baselineShift", "baseline-shift"],
		["capHeight", "cap-height"],
		["clipPath", "clip-path"],
		["clipRule", "clip-rule"],
		["colorInterpolation", "color-interpolation"],
		["colorInterpolationFilters", "color-interpolation-filters"],
		["colorProfile", "color-profile"],
		["colorRendering", "color-rendering"],
		["dominantBaseline", "dominant-baseline"],
		["enableBackground", "enable-background"],
		["fillOpacity", "fill-opacity"],
		["fillRule", "fill-rule"],
		["floodColor", "flood-color"],
		["floodOpacity", "flood-opacity"],
		["fontFamily", "font-family"],
		["fontSize", "font-size"],
		["fontSizeAdjust", "font-size-adjust"],
		["fontStretch", "font-stretch"],
		["fontStyle", "font-style"],
		["fontVariant", "font-variant"],
		["fontWeight", "font-weight"],
		["glyphName", "glyph-name"],
		["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
		["glyphOrientationVertical", "glyph-orientation-vertical"],
		["horizAdvX", "horiz-adv-x"],
		["horizOriginX", "horiz-origin-x"],
		["imageRendering", "image-rendering"],
		["letterSpacing", "letter-spacing"],
		["lightingColor", "lighting-color"],
		["markerEnd", "marker-end"],
		["markerMid", "marker-mid"],
		["markerStart", "marker-start"],
		["overlinePosition", "overline-position"],
		["overlineThickness", "overline-thickness"],
		["paintOrder", "paint-order"],
		["panose-1", "panose-1"],
		["pointerEvents", "pointer-events"],
		["renderingIntent", "rendering-intent"],
		["shapeRendering", "shape-rendering"],
		["stopColor", "stop-color"],
		["stopOpacity", "stop-opacity"],
		["strikethroughPosition", "strikethrough-position"],
		["strikethroughThickness", "strikethrough-thickness"],
		["strokeDasharray", "stroke-dasharray"],
		["strokeDashoffset", "stroke-dashoffset"],
		["strokeLinecap", "stroke-linecap"],
		["strokeLinejoin", "stroke-linejoin"],
		["strokeMiterlimit", "stroke-miterlimit"],
		["strokeOpacity", "stroke-opacity"],
		["strokeWidth", "stroke-width"],
		["textAnchor", "text-anchor"],
		["textDecoration", "text-decoration"],
		["textRendering", "text-rendering"],
		["transformOrigin", "transform-origin"],
		["underlinePosition", "underline-position"],
		["underlineThickness", "underline-thickness"],
		["unicodeBidi", "unicode-bidi"],
		["unicodeRange", "unicode-range"],
		["unitsPerEm", "units-per-em"],
		["vAlphabetic", "v-alphabetic"],
		["vHanging", "v-hanging"],
		["vIdeographic", "v-ideographic"],
		["vMathematical", "v-mathematical"],
		["vectorEffect", "vector-effect"],
		["vertAdvY", "vert-adv-y"],
		["vertOriginX", "vert-origin-x"],
		["vertOriginY", "vert-origin-y"],
		["wordSpacing", "word-spacing"],
		["writingMode", "writing-mode"],
		["xmlnsXlink", "xmlns:xlink"],
		["xHeight", "x-height"]
	]), Yt = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
	function Xt(e) {
		return Yt.test("" + e) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : e;
	}
	function Zt() {}
	var Qt = null;
	function $t(e) {
		return e = e.target || e.srcElement || window, e.correspondingUseElement && (e = e.correspondingUseElement), e.nodeType === 3 ? e.parentNode : e;
	}
	var en = null, tn = null;
	function nn(e) {
		var t = ht(e);
		if (t && (e = t.stateNode)) {
			var n = e[ot] || null;
			a: switch (e = t.stateNode, t.type) {
				case "input":
					if (Lt(e, n.value, n.defaultValue, n.defaultValue, n.checked, n.defaultChecked, n.type, n.name), t = n.name, n.type === "radio" && t != null) {
						for (n = e; n.parentNode;) n = n.parentNode;
						for (n = n.querySelectorAll("input[name=\"" + It("" + t) + "\"][type=\"radio\"]"), t = 0; t < n.length; t++) {
							var r = n[t];
							if (r !== e && r.form === e.form) {
								var i = r[ot] || null;
								if (!i) throw Error(a(90));
								Lt(r, i.value, i.defaultValue, i.defaultValue, i.checked, i.defaultChecked, i.type, i.name);
							}
						}
						for (t = 0; t < n.length; t++) r = n[t], r.form === e.form && Nt(r);
					}
					break a;
				case "textarea":
					Vt(e, n.value, n.defaultValue);
					break a;
				case "select": t = n.value, t != null && Bt(e, !!n.multiple, t, !1);
			}
		}
	}
	var rn = !1;
	function an(e, t, n) {
		if (rn) return e(t, n);
		rn = !0;
		try {
			return e(t);
		} finally {
			if (rn = !1, (en !== null || tn !== null) && (bu(), en && (t = en, e = tn, tn = en = null, nn(t), e))) for (t = 0; t < e.length; t++) nn(e[t]);
		}
	}
	function on(e, t) {
		var n = e.stateNode;
		if (n === null) return null;
		var r = n[ot] || null;
		if (r === null) return null;
		n = r[t];
		a: switch (t) {
			case "onClick":
			case "onClickCapture":
			case "onDoubleClick":
			case "onDoubleClickCapture":
			case "onMouseDown":
			case "onMouseDownCapture":
			case "onMouseMove":
			case "onMouseMoveCapture":
			case "onMouseUp":
			case "onMouseUpCapture":
			case "onMouseEnter":
				(r = !r.disabled) || (e = e.type, r = e !== "button" && e !== "input" && e !== "select" && e !== "textarea"), e = !r;
				break a;
			default: e = !1;
		}
		if (e) return null;
		if (n && typeof n != "function") throw Error(a(231, t, typeof n));
		return n;
	}
	var sn = !(typeof window > "u" || window.document === void 0 || window.document.createElement === void 0), cn = !1;
	if (sn) try {
		var ln = {};
		Object.defineProperty(ln, "passive", { get: function() {
			cn = !0;
		} }), window.addEventListener("test", ln, ln), window.removeEventListener("test", ln, ln);
	} catch {
		cn = !1;
	}
	var un = null, dn = null, fn = null;
	function pn() {
		if (fn) return fn;
		var e, t = dn, n = t.length, r, i = "value" in un ? un.value : un.textContent, a = i.length;
		for (e = 0; e < n && t[e] === i[e]; e++);
		var o = n - e;
		for (r = 1; r <= o && t[n - r] === i[a - r]; r++);
		return fn = i.slice(e, 1 < r ? 1 - r : void 0);
	}
	function mn(e) {
		var t = e.keyCode;
		return "charCode" in e ? (e = e.charCode, e === 0 && t === 13 && (e = 13)) : e = t, e === 10 && (e = 13), 32 <= e || e === 13 ? e : 0;
	}
	function hn() {
		return !0;
	}
	function gn() {
		return !1;
	}
	function _n(e) {
		function t(t, n, r, i, a) {
			for (var o in this._reactName = t, this._targetInst = r, this.type = n, this.nativeEvent = i, this.target = a, this.currentTarget = null, e) e.hasOwnProperty(o) && (t = e[o], this[o] = t ? t(i) : i[o]);
			return this.isDefaultPrevented = (i.defaultPrevented == null ? !1 === i.returnValue : i.defaultPrevented) ? hn : gn, this.isPropagationStopped = gn, this;
		}
		return p(t.prototype, {
			preventDefault: function() {
				this.defaultPrevented = !0;
				var e = this.nativeEvent;
				e && (e.preventDefault ? e.preventDefault() : typeof e.returnValue != "unknown" && (e.returnValue = !1), this.isDefaultPrevented = hn);
			},
			stopPropagation: function() {
				var e = this.nativeEvent;
				e && (e.stopPropagation ? e.stopPropagation() : typeof e.cancelBubble != "unknown" && (e.cancelBubble = !0), this.isPropagationStopped = hn);
			},
			persist: function() {},
			isPersistent: hn
		}), t;
	}
	var vn = {
		eventPhase: 0,
		bubbles: 0,
		cancelable: 0,
		timeStamp: function(e) {
			return e.timeStamp || Date.now();
		},
		defaultPrevented: 0,
		isTrusted: 0
	}, yn = _n(vn), bn = p({}, vn, {
		view: 0,
		detail: 0
	}), xn = _n(bn), Sn, Cn, wn, Tn = p({}, bn, {
		screenX: 0,
		screenY: 0,
		clientX: 0,
		clientY: 0,
		pageX: 0,
		pageY: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		getModifierState: In,
		button: 0,
		buttons: 0,
		relatedTarget: function(e) {
			return e.relatedTarget === void 0 ? e.fromElement === e.srcElement ? e.toElement : e.fromElement : e.relatedTarget;
		},
		movementX: function(e) {
			return "movementX" in e ? e.movementX : (e !== wn && (wn && e.type === "mousemove" ? (Sn = e.screenX - wn.screenX, Cn = e.screenY - wn.screenY) : Cn = Sn = 0, wn = e), Sn);
		},
		movementY: function(e) {
			return "movementY" in e ? e.movementY : Cn;
		}
	}), En = _n(Tn), Dn = _n(p({}, Tn, { dataTransfer: 0 })), On = _n(p({}, bn, { relatedTarget: 0 })), kn = _n(p({}, vn, {
		animationName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), An = _n(p({}, vn, { clipboardData: function(e) {
		return "clipboardData" in e ? e.clipboardData : window.clipboardData;
	} })), jn = _n(p({}, vn, { data: 0 })), Mn = {
		Esc: "Escape",
		Spacebar: " ",
		Left: "ArrowLeft",
		Up: "ArrowUp",
		Right: "ArrowRight",
		Down: "ArrowDown",
		Del: "Delete",
		Win: "OS",
		Menu: "ContextMenu",
		Apps: "ContextMenu",
		Scroll: "ScrollLock",
		MozPrintableKey: "Unidentified"
	}, Nn = {
		8: "Backspace",
		9: "Tab",
		12: "Clear",
		13: "Enter",
		16: "Shift",
		17: "Control",
		18: "Alt",
		19: "Pause",
		20: "CapsLock",
		27: "Escape",
		32: " ",
		33: "PageUp",
		34: "PageDown",
		35: "End",
		36: "Home",
		37: "ArrowLeft",
		38: "ArrowUp",
		39: "ArrowRight",
		40: "ArrowDown",
		45: "Insert",
		46: "Delete",
		112: "F1",
		113: "F2",
		114: "F3",
		115: "F4",
		116: "F5",
		117: "F6",
		118: "F7",
		119: "F8",
		120: "F9",
		121: "F10",
		122: "F11",
		123: "F12",
		144: "NumLock",
		145: "ScrollLock",
		224: "Meta"
	}, Pn = {
		Alt: "altKey",
		Control: "ctrlKey",
		Meta: "metaKey",
		Shift: "shiftKey"
	};
	function Fn(e) {
		var t = this.nativeEvent;
		return t.getModifierState ? t.getModifierState(e) : (e = Pn[e]) ? !!t[e] : !1;
	}
	function In() {
		return Fn;
	}
	var Ln = _n(p({}, bn, {
		key: function(e) {
			if (e.key) {
				var t = Mn[e.key] || e.key;
				if (t !== "Unidentified") return t;
			}
			return e.type === "keypress" ? (e = mn(e), e === 13 ? "Enter" : String.fromCharCode(e)) : e.type === "keydown" || e.type === "keyup" ? Nn[e.keyCode] || "Unidentified" : "";
		},
		code: 0,
		location: 0,
		ctrlKey: 0,
		shiftKey: 0,
		altKey: 0,
		metaKey: 0,
		repeat: 0,
		locale: 0,
		getModifierState: In,
		charCode: function(e) {
			return e.type === "keypress" ? mn(e) : 0;
		},
		keyCode: function(e) {
			return e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		},
		which: function(e) {
			return e.type === "keypress" ? mn(e) : e.type === "keydown" || e.type === "keyup" ? e.keyCode : 0;
		}
	})), Rn = _n(p({}, Tn, {
		pointerId: 0,
		width: 0,
		height: 0,
		pressure: 0,
		tangentialPressure: 0,
		tiltX: 0,
		tiltY: 0,
		twist: 0,
		pointerType: 0,
		isPrimary: 0
	})), zn = _n(p({}, bn, {
		touches: 0,
		targetTouches: 0,
		changedTouches: 0,
		altKey: 0,
		metaKey: 0,
		ctrlKey: 0,
		shiftKey: 0,
		getModifierState: In
	})), Bn = _n(p({}, vn, {
		propertyName: 0,
		elapsedTime: 0,
		pseudoElement: 0
	})), Vn = _n(p({}, Tn, {
		deltaX: function(e) {
			return "deltaX" in e ? e.deltaX : "wheelDeltaX" in e ? -e.wheelDeltaX : 0;
		},
		deltaY: function(e) {
			return "deltaY" in e ? e.deltaY : "wheelDeltaY" in e ? -e.wheelDeltaY : "wheelDelta" in e ? -e.wheelDelta : 0;
		},
		deltaZ: 0,
		deltaMode: 0
	})), Hn = _n(p({}, vn, {
		newState: 0,
		oldState: 0
	})), Un = [
		9,
		13,
		27,
		32
	], Wn = sn && "CompositionEvent" in window, Gn = null;
	sn && "documentMode" in document && (Gn = document.documentMode);
	var Kn = sn && "TextEvent" in window && !Gn, qn = sn && (!Wn || Gn && 8 < Gn && 11 >= Gn), Jn = " ", Yn = !1;
	function Xn(e, t) {
		switch (e) {
			case "keyup": return Un.indexOf(t.keyCode) !== -1;
			case "keydown": return t.keyCode !== 229;
			case "keypress":
			case "mousedown":
			case "focusout": return !0;
			default: return !1;
		}
	}
	function Zn(e) {
		return e = e.detail, typeof e == "object" && "data" in e ? e.data : null;
	}
	var Qn = !1;
	function $n(e, t) {
		switch (e) {
			case "compositionend": return Zn(t);
			case "keypress": return t.which === 32 ? (Yn = !0, Jn) : null;
			case "textInput": return e = t.data, e === Jn && Yn ? null : e;
			default: return null;
		}
	}
	function er(e, t) {
		if (Qn) return e === "compositionend" || !Wn && Xn(e, t) ? (e = pn(), fn = dn = un = null, Qn = !1, e) : null;
		switch (e) {
			case "paste": return null;
			case "keypress":
				if (!(t.ctrlKey || t.altKey || t.metaKey) || t.ctrlKey && t.altKey) {
					if (t.char && 1 < t.char.length) return t.char;
					if (t.which) return String.fromCharCode(t.which);
				}
				return null;
			case "compositionend": return qn && t.locale !== "ko" ? null : t.data;
			default: return null;
		}
	}
	var tr = {
		color: !0,
		date: !0,
		datetime: !0,
		"datetime-local": !0,
		email: !0,
		month: !0,
		number: !0,
		password: !0,
		range: !0,
		search: !0,
		tel: !0,
		text: !0,
		time: !0,
		url: !0,
		week: !0
	};
	function nr(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t === "input" ? !!tr[e.type] : t === "textarea";
	}
	function rr(e, t, n, r) {
		en ? tn ? tn.push(r) : tn = [r] : en = r, t = Ed(t, "onChange"), 0 < t.length && (n = new yn("onChange", "change", null, n, r), e.push({
			event: n,
			listeners: t
		}));
	}
	var ir = null, ar = null;
	function or(e) {
		yd(e, 0);
	}
	function sr(e) {
		if (Nt(gt(e))) return e;
	}
	function cr(e, t) {
		if (e === "change") return t;
	}
	var lr = !1;
	if (sn) {
		var ur;
		if (sn) {
			var dr = "oninput" in document;
			if (!dr) {
				var fr = document.createElement("div");
				fr.setAttribute("oninput", "return;"), dr = typeof fr.oninput == "function";
			}
			ur = dr;
		} else ur = !1;
		lr = ur && (!document.documentMode || 9 < document.documentMode);
	}
	function pr() {
		ir && (ir.detachEvent("onpropertychange", mr), ar = ir = null);
	}
	function mr(e) {
		if (e.propertyName === "value" && sr(ar)) {
			var t = [];
			rr(t, ar, e, $t(e)), an(or, t);
		}
	}
	function hr(e, t, n) {
		e === "focusin" ? (pr(), ir = t, ar = n, ir.attachEvent("onpropertychange", mr)) : e === "focusout" && pr();
	}
	function gr(e) {
		if (e === "selectionchange" || e === "keyup" || e === "keydown") return sr(ar);
	}
	function _r(e, t) {
		if (e === "click") return sr(t);
	}
	function vr(e, t) {
		if (e === "input" || e === "change") return sr(t);
	}
	function yr(e, t) {
		return e === t && (e !== 0 || 1 / e == 1 / t) || e !== e && t !== t;
	}
	var br = typeof Object.is == "function" ? Object.is : yr;
	function xr(e, t) {
		if (br(e, t)) return !0;
		if (typeof e != "object" || !e || typeof t != "object" || !t) return !1;
		var n = Object.keys(e), r = Object.keys(t);
		if (n.length !== r.length) return !1;
		for (r = 0; r < n.length; r++) {
			var i = n[r];
			if (!xe.call(t, i) || !br(e[i], t[i])) return !1;
		}
		return !0;
	}
	function Sr(e) {
		for (; e && e.firstChild;) e = e.firstChild;
		return e;
	}
	function Cr(e, t) {
		var n = Sr(e);
		e = 0;
		for (var r; n;) {
			if (n.nodeType === 3) {
				if (r = e + n.textContent.length, e <= t && r >= t) return {
					node: n,
					offset: t - e
				};
				e = r;
			}
			a: {
				for (; n;) {
					if (n.nextSibling) {
						n = n.nextSibling;
						break a;
					}
					n = n.parentNode;
				}
				n = void 0;
			}
			n = Sr(n);
		}
	}
	function wr(e, t) {
		return e && t ? e === t ? !0 : e && e.nodeType === 3 ? !1 : t && t.nodeType === 3 ? wr(e, t.parentNode) : "contains" in e ? e.contains(t) : e.compareDocumentPosition ? !!(e.compareDocumentPosition(t) & 16) : !1 : !1;
	}
	function Tr(e) {
		e = e != null && e.ownerDocument != null && e.ownerDocument.defaultView != null ? e.ownerDocument.defaultView : window;
		for (var t = Pt(e.document); t instanceof e.HTMLIFrameElement;) {
			try {
				var n = typeof t.contentWindow.location.href == "string";
			} catch {
				n = !1;
			}
			if (n) e = t.contentWindow;
			else break;
			t = Pt(e.document);
		}
		return t;
	}
	function Er(e) {
		var t = e && e.nodeName && e.nodeName.toLowerCase();
		return t && (t === "input" && (e.type === "text" || e.type === "search" || e.type === "tel" || e.type === "url" || e.type === "password") || t === "textarea" || e.contentEditable === "true");
	}
	var Dr = sn && "documentMode" in document && 11 >= document.documentMode, Or = null, kr = null, Ar = null, jr = !1;
	function Mr(e, t, n) {
		var r = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
		jr || Or == null || Or !== Pt(r) || (r = Or, "selectionStart" in r && Er(r) ? r = {
			start: r.selectionStart,
			end: r.selectionEnd
		} : (r = (r.ownerDocument && r.ownerDocument.defaultView || window).getSelection(), r = {
			anchorNode: r.anchorNode,
			anchorOffset: r.anchorOffset,
			focusNode: r.focusNode,
			focusOffset: r.focusOffset
		}), Ar && xr(Ar, r) || (Ar = r, r = Ed(kr, "onSelect"), 0 < r.length && (t = new yn("onSelect", "select", null, t, n), e.push({
			event: t,
			listeners: r
		}), t.target = Or)));
	}
	function Nr(e, t) {
		var n = {};
		return n[e.toLowerCase()] = t.toLowerCase(), n["Webkit" + e] = "webkit" + t, n["Moz" + e] = "moz" + t, n;
	}
	var Pr = {
		animationend: Nr("Animation", "AnimationEnd"),
		animationiteration: Nr("Animation", "AnimationIteration"),
		animationstart: Nr("Animation", "AnimationStart"),
		transitionrun: Nr("Transition", "TransitionRun"),
		transitionstart: Nr("Transition", "TransitionStart"),
		transitioncancel: Nr("Transition", "TransitionCancel"),
		transitionend: Nr("Transition", "TransitionEnd")
	}, Fr = {}, Ir = {};
	sn && (Ir = document.createElement("div").style, "AnimationEvent" in window || (delete Pr.animationend.animation, delete Pr.animationiteration.animation, delete Pr.animationstart.animation), "TransitionEvent" in window || delete Pr.transitionend.transition);
	function Lr(e) {
		if (Fr[e]) return Fr[e];
		if (!Pr[e]) return e;
		var t = Pr[e], n;
		for (n in t) if (t.hasOwnProperty(n) && n in Ir) return Fr[e] = t[n];
		return e;
	}
	var Rr = Lr("animationend"), zr = Lr("animationiteration"), Br = Lr("animationstart"), Vr = Lr("transitionrun"), Hr = Lr("transitionstart"), Ur = Lr("transitioncancel"), Wr = Lr("transitionend"), Gr = /* @__PURE__ */ new Map(), Kr = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
	Kr.push("scrollEnd");
	function qr(e, t) {
		Gr.set(e, t), xt(t, [e]);
	}
	var Jr = typeof reportError == "function" ? reportError : function(e) {
		if (typeof window == "object" && typeof window.ErrorEvent == "function") {
			var t = new window.ErrorEvent("error", {
				bubbles: !0,
				cancelable: !0,
				message: typeof e == "object" && e && typeof e.message == "string" ? String(e.message) : String(e),
				error: e
			});
			if (!window.dispatchEvent(t)) return;
		} else if (typeof process == "object" && typeof process.emit == "function") {
			process.emit("uncaughtException", e);
			return;
		}
		console.error(e);
	}, Yr = [], Xr = 0, Zr = 0;
	function Qr() {
		for (var e = Xr, t = Zr = Xr = 0; t < e;) {
			var n = Yr[t];
			Yr[t++] = null;
			var r = Yr[t];
			Yr[t++] = null;
			var i = Yr[t];
			Yr[t++] = null;
			var a = Yr[t];
			if (Yr[t++] = null, r !== null && i !== null) {
				var o = r.pending;
				o === null ? i.next = i : (i.next = o.next, o.next = i), r.pending = i;
			}
			a !== 0 && ni(n, i, a);
		}
	}
	function $r(e, t, n, r) {
		Yr[Xr++] = e, Yr[Xr++] = t, Yr[Xr++] = n, Yr[Xr++] = r, Zr |= r, e.lanes |= r, e = e.alternate, e !== null && (e.lanes |= r);
	}
	function ei(e, t, n, r) {
		return $r(e, t, n, r), ri(e);
	}
	function ti(e, t) {
		return $r(e, null, null, t), ri(e);
	}
	function ni(e, t, n) {
		e.lanes |= n;
		var r = e.alternate;
		r !== null && (r.lanes |= n);
		for (var i = !1, a = e.return; a !== null;) a.childLanes |= n, r = a.alternate, r !== null && (r.childLanes |= n), a.tag === 22 && (e = a.stateNode, e === null || e._visibility & 1 || (i = !0)), e = a, a = a.return;
		return e.tag === 3 ? (a = e.stateNode, i && t !== null && (i = 31 - Ie(n), e = a.hiddenUpdates, r = e[i], r === null ? e[i] = [t] : r.push(t), t.lane = n | 536870912), a) : null;
	}
	function ri(e) {
		if (50 < du) throw du = 0, fu = null, Error(a(185));
		for (var t = e.return; t !== null;) e = t, t = e.return;
		return e.tag === 3 ? e.stateNode : null;
	}
	var ii = {};
	function ai(e, t, n, r) {
		this.tag = e, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = t, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = r, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
	}
	function oi(e, t, n, r) {
		return new ai(e, t, n, r);
	}
	function si(e) {
		return e = e.prototype, !(!e || !e.isReactComponent);
	}
	function ci(e, t) {
		var n = e.alternate;
		return n === null ? (n = oi(e.tag, t, e.key, e.mode), n.elementType = e.elementType, n.type = e.type, n.stateNode = e.stateNode, n.alternate = e, e.alternate = n) : (n.pendingProps = t, n.type = e.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = e.flags & 65011712, n.childLanes = e.childLanes, n.lanes = e.lanes, n.child = e.child, n.memoizedProps = e.memoizedProps, n.memoizedState = e.memoizedState, n.updateQueue = e.updateQueue, t = e.dependencies, n.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}, n.sibling = e.sibling, n.index = e.index, n.ref = e.ref, n.refCleanup = e.refCleanup, n;
	}
	function li(e, t) {
		e.flags &= 65011714;
		var n = e.alternate;
		return n === null ? (e.childLanes = 0, e.lanes = t, e.child = null, e.subtreeFlags = 0, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null, e.stateNode = null) : (e.childLanes = n.childLanes, e.lanes = n.lanes, e.child = n.child, e.subtreeFlags = 0, e.deletions = null, e.memoizedProps = n.memoizedProps, e.memoizedState = n.memoizedState, e.updateQueue = n.updateQueue, e.type = n.type, t = n.dependencies, e.dependencies = t === null ? null : {
			lanes: t.lanes,
			firstContext: t.firstContext
		}), e;
	}
	function ui(e, t, n, r, i, o) {
		var s = 0;
		if (r = e, typeof e == "function") si(e) && (s = 1);
		else if (typeof e == "string") s = Uf(e, n, ue.current) ? 26 : e === "html" || e === "head" || e === "body" ? 27 : 5;
		else a: switch (e) {
			case ee: return e = oi(31, n, t, i), e.elementType = ee, e.lanes = o, e;
			case _: return V(n.children, i, o, t);
			case v:
				s = 8, i |= 24;
				break;
			case y: return e = oi(12, n, t, i | 2), e.elementType = y, e.lanes = o, e;
			case C: return e = oi(13, n, t, i), e.elementType = C, e.lanes = o, e;
			case w: return e = oi(19, n, t, i), e.elementType = w, e.lanes = o, e;
			default:
				if (typeof e == "object" && e) switch (e.$$typeof) {
					case x:
						s = 10;
						break a;
					case b:
						s = 9;
						break a;
					case S:
						s = 11;
						break a;
					case T:
						s = 14;
						break a;
					case E:
						s = 16, r = null;
						break a;
				}
				s = 29, n = Error(a(130, e === null ? "null" : typeof e, "")), r = null;
		}
		return t = oi(s, n, t, i), t.elementType = e, t.type = r, t.lanes = o, t;
	}
	function V(e, t, n, r) {
		return e = oi(7, e, r, t), e.lanes = n, e;
	}
	function di(e, t, n) {
		return e = oi(6, e, null, t), e.lanes = n, e;
	}
	function fi(e) {
		var t = oi(18, null, null, 0);
		return t.stateNode = e, t;
	}
	function pi(e, t, n) {
		return t = oi(4, e.children === null ? [] : e.children, e.key, t), t.lanes = n, t.stateNode = {
			containerInfo: e.containerInfo,
			pendingChildren: null,
			implementation: e.implementation
		}, t;
	}
	var mi = /* @__PURE__ */ new WeakMap();
	function hi(e, t) {
		if (typeof e == "object" && e) {
			var n = mi.get(e);
			return n === void 0 ? (t = {
				value: e,
				source: t,
				stack: be(t)
			}, mi.set(e, t), t) : n;
		}
		return {
			value: e,
			source: t,
			stack: be(t)
		};
	}
	var gi = [], _i = 0, vi = null, yi = 0, bi = [], xi = 0, H = null, Si = 1, Ci = "";
	function wi(e, t) {
		gi[_i++] = yi, gi[_i++] = vi, vi = e, yi = t;
	}
	function Ti(e, t, n) {
		bi[xi++] = Si, bi[xi++] = Ci, bi[xi++] = H, H = e;
		var r = Si;
		e = Ci;
		var i = 32 - Ie(r) - 1;
		r &= ~(1 << i), n += 1;
		var a = 32 - Ie(t) + i;
		if (30 < a) {
			var o = i - i % 5;
			a = (r & (1 << o) - 1).toString(32), r >>= o, i -= o, Si = 1 << 32 - Ie(t) + i | n << i | r, Ci = a + e;
		} else Si = 1 << a | n << i | r, Ci = e;
	}
	function Ei(e) {
		e.return !== null && (wi(e, 1), Ti(e, 1, 0));
	}
	function Di(e) {
		for (; e === vi;) vi = gi[--_i], gi[_i] = null, yi = gi[--_i], gi[_i] = null;
		for (; e === H;) H = bi[--xi], bi[xi] = null, Ci = bi[--xi], bi[xi] = null, Si = bi[--xi], bi[xi] = null;
	}
	function Oi(e, t) {
		bi[xi++] = Si, bi[xi++] = Ci, bi[xi++] = H, Si = t.id, Ci = t.overflow, H = e;
	}
	var U = null, ki = null, W = !1, Ai = null, ji = !1, Mi = Error(a(519));
	function Ni(e) {
		throw zi(hi(Error(a(418, 1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML", "")), e)), Mi;
	}
	function Pi(e) {
		var t = e.stateNode, n = e.type, r = e.memoizedProps;
		switch (t[at] = e, t[ot] = r, n) {
			case "dialog":
				Q("cancel", t), Q("close", t);
				break;
			case "iframe":
			case "object":
			case "embed":
				Q("load", t);
				break;
			case "video":
			case "audio":
				for (n = 0; n < _d.length; n++) Q(_d[n], t);
				break;
			case "source":
				Q("error", t);
				break;
			case "img":
			case "image":
			case "link":
				Q("error", t), Q("load", t);
				break;
			case "details":
				Q("toggle", t);
				break;
			case "input":
				Q("invalid", t), Rt(t, r.value, r.defaultValue, r.checked, r.defaultChecked, r.type, r.name, !0);
				break;
			case "select":
				Q("invalid", t);
				break;
			case "textarea": Q("invalid", t), Ht(t, r.value, r.defaultValue, r.children);
		}
		n = r.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || t.textContent === "" + n || !0 === r.suppressHydrationWarning || Md(t.textContent, n) ? (r.popover != null && (Q("beforetoggle", t), Q("toggle", t)), r.onScroll != null && Q("scroll", t), r.onScrollEnd != null && Q("scrollend", t), r.onClick != null && (t.onclick = Zt), t = !0) : t = !1, t || Ni(e, !0);
	}
	function Fi(e) {
		for (U = e.return; U;) switch (U.tag) {
			case 5:
			case 31:
			case 13:
				ji = !1;
				return;
			case 27:
			case 3:
				ji = !0;
				return;
			default: U = U.return;
		}
	}
	function Ii(e) {
		if (e !== U) return !1;
		if (!W) return Fi(e), W = !0, !1;
		var t = e.tag, n;
		if ((n = t !== 3 && t !== 27) && ((n = t === 5) && (n = e.type, n = n === "form" || n === "button" || Ud(e.type, e.memoizedProps)), n = !n), n && ki && Ni(e), Fi(e), t === 13) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(a(317));
			ki = uf(e);
		} else if (t === 31) {
			if (e = e.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(a(317));
			ki = uf(e);
		} else t === 27 ? (t = ki, Zd(e.type) ? (e = lf, lf = null, ki = e) : ki = t) : ki = U ? cf(e.stateNode.nextSibling) : null;
		return !0;
	}
	function Li() {
		ki = U = null, W = !1;
	}
	function Ri() {
		var e = Ai;
		return e !== null && (Zl === null ? Zl = e : Zl.push.apply(Zl, e), Ai = null), e;
	}
	function zi(e) {
		Ai === null ? Ai = [e] : Ai.push(e);
	}
	var Bi = ce(null), Vi = null, Hi = null;
	function Ui(e, t, n) {
		j(Bi, t._currentValue), t._currentValue = n;
	}
	function Wi(e) {
		e._currentValue = Bi.current, le(Bi);
	}
	function Gi(e, t, n) {
		for (; e !== null;) {
			var r = e.alternate;
			if ((e.childLanes & t) === t ? r !== null && (r.childLanes & t) !== t && (r.childLanes |= t) : (e.childLanes |= t, r !== null && (r.childLanes |= t)), e === n) break;
			e = e.return;
		}
	}
	function Ki(e, t, n, r) {
		var i = e.child;
		for (i !== null && (i.return = e); i !== null;) {
			var o = i.dependencies;
			if (o !== null) {
				var s = i.child;
				o = o.firstContext;
				a: for (; o !== null;) {
					var c = o;
					o = i;
					for (var l = 0; l < t.length; l++) if (c.context === t[l]) {
						o.lanes |= n, c = o.alternate, c !== null && (c.lanes |= n), Gi(o.return, n, e), r || (s = null);
						break a;
					}
					o = c.next;
				}
			} else if (i.tag === 18) {
				if (s = i.return, s === null) throw Error(a(341));
				s.lanes |= n, o = s.alternate, o !== null && (o.lanes |= n), Gi(s, n, e), s = null;
			} else s = i.child;
			if (s !== null) s.return = i;
			else for (s = i; s !== null;) {
				if (s === e) {
					s = null;
					break;
				}
				if (i = s.sibling, i !== null) {
					i.return = s.return, s = i;
					break;
				}
				s = s.return;
			}
			i = s;
		}
	}
	function qi(e, t, n, r) {
		e = null;
		for (var i = t, o = !1; i !== null;) {
			if (!o) {
				if (i.flags & 524288) o = !0;
				else if (i.flags & 262144) break;
			}
			if (i.tag === 10) {
				var s = i.alternate;
				if (s === null) throw Error(a(387));
				if (s = s.memoizedProps, s !== null) {
					var c = i.type;
					br(i.pendingProps.value, s.value) || (e === null ? e = [c] : e.push(c));
				}
			} else if (i === fe.current) {
				if (s = i.alternate, s === null) throw Error(a(387));
				s.memoizedState.memoizedState !== i.memoizedState.memoizedState && (e === null ? e = [Qf] : e.push(Qf));
			}
			i = i.return;
		}
		e !== null && Ki(t, e, n, r), t.flags |= 262144;
	}
	function Ji(e) {
		for (e = e.firstContext; e !== null;) {
			if (!br(e.context._currentValue, e.memoizedValue)) return !0;
			e = e.next;
		}
		return !1;
	}
	function Yi(e) {
		Vi = e, Hi = null, e = e.dependencies, e !== null && (e.firstContext = null);
	}
	function Xi(e) {
		return Qi(Vi, e);
	}
	function Zi(e, t) {
		return Vi === null && Yi(e), Qi(e, t);
	}
	function Qi(e, t) {
		var n = t._currentValue;
		if (t = {
			context: t,
			memoizedValue: n,
			next: null
		}, Hi === null) {
			if (e === null) throw Error(a(308));
			Hi = t, e.dependencies = {
				lanes: 0,
				firstContext: t
			}, e.flags |= 524288;
		} else Hi = Hi.next = t;
		return n;
	}
	var $i = typeof AbortController < "u" ? AbortController : function() {
		var e = [], t = this.signal = {
			aborted: !1,
			addEventListener: function(t, n) {
				e.push(n);
			}
		};
		this.abort = function() {
			t.aborted = !0, e.forEach(function(e) {
				return e();
			});
		};
	}, ea = n.unstable_scheduleCallback, ta = n.unstable_NormalPriority, na = {
		$$typeof: x,
		Consumer: null,
		Provider: null,
		_currentValue: null,
		_currentValue2: null,
		_threadCount: 0
	};
	function ra() {
		return {
			controller: new $i(),
			data: /* @__PURE__ */ new Map(),
			refCount: 0
		};
	}
	function ia(e) {
		e.refCount--, e.refCount === 0 && ea(ta, function() {
			e.controller.abort();
		});
	}
	var aa = null, oa = 0, sa = 0, ca = null;
	function la(e, t) {
		if (aa === null) {
			var n = aa = [];
			oa = 0, sa = dd(), ca = {
				status: "pending",
				value: void 0,
				then: function(e) {
					n.push(e);
				}
			};
		}
		return oa++, t.then(ua, ua), t;
	}
	function ua() {
		if (--oa === 0 && aa !== null) {
			ca !== null && (ca.status = "fulfilled");
			var e = aa;
			aa = null, sa = 0, ca = null;
			for (var t = 0; t < e.length; t++) (0, e[t])();
		}
	}
	function da(e, t) {
		var n = [], r = {
			status: "pending",
			value: null,
			reason: null,
			then: function(e) {
				n.push(e);
			}
		};
		return e.then(function() {
			r.status = "fulfilled", r.value = t;
			for (var e = 0; e < n.length; e++) (0, n[e])(t);
		}, function(e) {
			for (r.status = "rejected", r.reason = e, e = 0; e < n.length; e++) (0, n[e])(void 0);
		}), r;
	}
	var fa = O.S;
	O.S = function(e, t) {
		eu = we(), typeof t == "object" && t && typeof t.then == "function" && la(e, t), fa !== null && fa(e, t);
	};
	var pa = ce(null);
	function ma() {
		var e = pa.current;
		return e === null ? Rl.pooledCache : e;
	}
	function ha(e, t) {
		t === null ? j(pa, pa.current) : j(pa, t.pool);
	}
	function ga() {
		var e = ma();
		return e === null ? null : {
			parent: na._currentValue,
			pool: e
		};
	}
	var _a = Error(a(460)), va = Error(a(474)), ya = Error(a(542)), ba = { then: function() {} };
	function xa(e) {
		return e = e.status, e === "fulfilled" || e === "rejected";
	}
	function Sa(e, t, n) {
		switch (n = e[n], n === void 0 ? e.push(t) : n !== t && (t.then(Zt, Zt), t = n), t.status) {
			case "fulfilled": return t.value;
			case "rejected": throw e = t.reason, Ea(e), e;
			default:
				if (typeof t.status == "string") t.then(Zt, Zt);
				else {
					if (e = Rl, e !== null && 100 < e.shellSuspendCounter) throw Error(a(482));
					e = t, e.status = "pending", e.then(function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "fulfilled", n.value = e;
						}
					}, function(e) {
						if (t.status === "pending") {
							var n = t;
							n.status = "rejected", n.reason = e;
						}
					});
				}
				switch (t.status) {
					case "fulfilled": return t.value;
					case "rejected": throw e = t.reason, Ea(e), e;
				}
				throw wa = t, _a;
		}
	}
	function Ca(e) {
		try {
			var t = e._init;
			return t(e._payload);
		} catch (e) {
			throw typeof e == "object" && e && typeof e.then == "function" ? (wa = e, _a) : e;
		}
	}
	var wa = null;
	function Ta() {
		if (wa === null) throw Error(a(459));
		var e = wa;
		return wa = null, e;
	}
	function Ea(e) {
		if (e === _a || e === ya) throw Error(a(483));
	}
	var Da = null, G = 0;
	function Oa(e) {
		var t = G;
		return G += 1, Da === null && (Da = []), Sa(Da, e, t);
	}
	function ka(e, t) {
		t = t.props.ref, e.ref = t === void 0 ? null : t;
	}
	function Aa(e, t) {
		throw t.$$typeof === m ? Error(a(525)) : (e = Object.prototype.toString.call(t), Error(a(31, e === "[object Object]" ? "object with keys {" + Object.keys(t).join(", ") + "}" : e)));
	}
	function ja(e) {
		function t(t, n) {
			if (e) {
				var r = t.deletions;
				r === null ? (t.deletions = [n], t.flags |= 16) : r.push(n);
			}
		}
		function n(n, r) {
			if (!e) return null;
			for (; r !== null;) t(n, r), r = r.sibling;
			return null;
		}
		function r(e) {
			for (var t = /* @__PURE__ */ new Map(); e !== null;) e.key === null ? t.set(e.index, e) : t.set(e.key, e), e = e.sibling;
			return t;
		}
		function i(e, t) {
			return e = ci(e, t), e.index = 0, e.sibling = null, e;
		}
		function o(t, n, r) {
			return t.index = r, e ? (r = t.alternate, r === null ? (t.flags |= 67108866, n) : (r = r.index, r < n ? (t.flags |= 67108866, n) : r)) : (t.flags |= 1048576, n);
		}
		function s(t) {
			return e && t.alternate === null && (t.flags |= 67108866), t;
		}
		function c(e, t, n, r) {
			return t === null || t.tag !== 6 ? (t = di(n, e.mode, r), t.return = e, t) : (t = i(t, n), t.return = e, t);
		}
		function l(e, t, n, r) {
			var a = n.type;
			return a === _ ? d(e, t, n.props.children, r, n.key) : t !== null && (t.elementType === a || typeof a == "object" && a && a.$$typeof === E && Ca(a) === t.type) ? (t = i(t, n.props), ka(t, n), t.return = e, t) : (t = ui(n.type, n.key, n.props, null, e.mode, r), ka(t, n), t.return = e, t);
		}
		function u(e, t, n, r) {
			return t === null || t.tag !== 4 || t.stateNode.containerInfo !== n.containerInfo || t.stateNode.implementation !== n.implementation ? (t = pi(n, e.mode, r), t.return = e, t) : (t = i(t, n.children || []), t.return = e, t);
		}
		function d(e, t, n, r, a) {
			return t === null || t.tag !== 7 ? (t = V(n, e.mode, r, a), t.return = e, t) : (t = i(t, n), t.return = e, t);
		}
		function f(e, t, n) {
			if (typeof t == "string" && t !== "" || typeof t == "number" || typeof t == "bigint") return t = di("" + t, e.mode, n), t.return = e, t;
			if (typeof t == "object" && t) {
				switch (t.$$typeof) {
					case h: return n = ui(t.type, t.key, t.props, null, e.mode, n), ka(n, t), n.return = e, n;
					case g: return t = pi(t, e.mode, n), t.return = e, t;
					case E: return t = Ca(t), f(e, t, n);
				}
				if (ae(t) || ne(t)) return t = V(t, e.mode, n, null), t.return = e, t;
				if (typeof t.then == "function") return f(e, Oa(t), n);
				if (t.$$typeof === x) return f(e, Zi(e, t), n);
				Aa(e, t);
			}
			return null;
		}
		function p(e, t, n, r) {
			var i = t === null ? null : t.key;
			if (typeof n == "string" && n !== "" || typeof n == "number" || typeof n == "bigint") return i === null ? c(e, t, "" + n, r) : null;
			if (typeof n == "object" && n) {
				switch (n.$$typeof) {
					case h: return n.key === i ? l(e, t, n, r) : null;
					case g: return n.key === i ? u(e, t, n, r) : null;
					case E: return n = Ca(n), p(e, t, n, r);
				}
				if (ae(n) || ne(n)) return i === null ? d(e, t, n, r, null) : null;
				if (typeof n.then == "function") return p(e, t, Oa(n), r);
				if (n.$$typeof === x) return p(e, t, Zi(e, n), r);
				Aa(e, n);
			}
			return null;
		}
		function m(e, t, n, r, i) {
			if (typeof r == "string" && r !== "" || typeof r == "number" || typeof r == "bigint") return e = e.get(n) || null, c(t, e, "" + r, i);
			if (typeof r == "object" && r) {
				switch (r.$$typeof) {
					case h: return e = e.get(r.key === null ? n : r.key) || null, l(t, e, r, i);
					case g: return e = e.get(r.key === null ? n : r.key) || null, u(t, e, r, i);
					case E: return r = Ca(r), m(e, t, n, r, i);
				}
				if (ae(r) || ne(r)) return e = e.get(n) || null, d(t, e, r, i, null);
				if (typeof r.then == "function") return m(e, t, n, Oa(r), i);
				if (r.$$typeof === x) return m(e, t, n, Zi(t, r), i);
				Aa(t, r);
			}
			return null;
		}
		function v(i, a, s, c) {
			for (var l = null, u = null, d = a, h = a = 0, g = null; d !== null && h < s.length; h++) {
				d.index > h ? (g = d, d = null) : g = d.sibling;
				var _ = p(i, d, s[h], c);
				if (_ === null) {
					d === null && (d = g);
					break;
				}
				e && d && _.alternate === null && t(i, d), a = o(_, a, h), u === null ? l = _ : u.sibling = _, u = _, d = g;
			}
			if (h === s.length) return n(i, d), W && wi(i, h), l;
			if (d === null) {
				for (; h < s.length; h++) d = f(i, s[h], c), d !== null && (a = o(d, a, h), u === null ? l = d : u.sibling = d, u = d);
				return W && wi(i, h), l;
			}
			for (d = r(d); h < s.length; h++) g = m(d, i, h, s[h], c), g !== null && (e && g.alternate !== null && d.delete(g.key === null ? h : g.key), a = o(g, a, h), u === null ? l = g : u.sibling = g, u = g);
			return e && d.forEach(function(e) {
				return t(i, e);
			}), W && wi(i, h), l;
		}
		function y(i, s, c, l) {
			if (c == null) throw Error(a(151));
			for (var u = null, d = null, h = s, g = s = 0, _ = null, v = c.next(); h !== null && !v.done; g++, v = c.next()) {
				h.index > g ? (_ = h, h = null) : _ = h.sibling;
				var y = p(i, h, v.value, l);
				if (y === null) {
					h === null && (h = _);
					break;
				}
				e && h && y.alternate === null && t(i, h), s = o(y, s, g), d === null ? u = y : d.sibling = y, d = y, h = _;
			}
			if (v.done) return n(i, h), W && wi(i, g), u;
			if (h === null) {
				for (; !v.done; g++, v = c.next()) v = f(i, v.value, l), v !== null && (s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
				return W && wi(i, g), u;
			}
			for (h = r(h); !v.done; g++, v = c.next()) v = m(h, i, g, v.value, l), v !== null && (e && v.alternate !== null && h.delete(v.key === null ? g : v.key), s = o(v, s, g), d === null ? u = v : d.sibling = v, d = v);
			return e && h.forEach(function(e) {
				return t(i, e);
			}), W && wi(i, g), u;
		}
		function b(e, r, o, c) {
			if (typeof o == "object" && o && o.type === _ && o.key === null && (o = o.props.children), typeof o == "object" && o) {
				switch (o.$$typeof) {
					case h:
						a: {
							for (var l = o.key; r !== null;) {
								if (r.key === l) {
									if (l = o.type, l === _) {
										if (r.tag === 7) {
											n(e, r.sibling), c = i(r, o.props.children), c.return = e, e = c;
											break a;
										}
									} else if (r.elementType === l || typeof l == "object" && l && l.$$typeof === E && Ca(l) === r.type) {
										n(e, r.sibling), c = i(r, o.props), ka(c, o), c.return = e, e = c;
										break a;
									}
									n(e, r);
									break;
								}
								t(e, r), r = r.sibling;
							}
							o.type === _ ? (c = V(o.props.children, e.mode, c, o.key), c.return = e, e = c) : (c = ui(o.type, o.key, o.props, null, e.mode, c), ka(c, o), c.return = e, e = c);
						}
						return s(e);
					case g:
						a: {
							for (l = o.key; r !== null;) {
								if (r.key === l) {
									if (r.tag === 4 && r.stateNode.containerInfo === o.containerInfo && r.stateNode.implementation === o.implementation) {
										n(e, r.sibling), c = i(r, o.children || []), c.return = e, e = c;
										break a;
									}
									n(e, r);
									break;
								}
								t(e, r), r = r.sibling;
							}
							c = pi(o, e.mode, c), c.return = e, e = c;
						}
						return s(e);
					case E: return o = Ca(o), b(e, r, o, c);
				}
				if (ae(o)) return v(e, r, o, c);
				if (ne(o)) {
					if (l = ne(o), typeof l != "function") throw Error(a(150));
					return o = l.call(o), y(e, r, o, c);
				}
				if (typeof o.then == "function") return b(e, r, Oa(o), c);
				if (o.$$typeof === x) return b(e, r, Zi(e, o), c);
				Aa(e, o);
			}
			return typeof o == "string" && o !== "" || typeof o == "number" || typeof o == "bigint" ? (o = "" + o, r !== null && r.tag === 6 ? (n(e, r.sibling), c = i(r, o), c.return = e, e = c) : (n(e, r), c = di(o, e.mode, c), c.return = e, e = c), s(e)) : n(e, r);
		}
		return function(e, t, n, r) {
			try {
				G = 0;
				var i = b(e, t, n, r);
				return Da = null, i;
			} catch (t) {
				if (t === _a || t === ya) throw t;
				var a = oi(29, t, null, e.mode);
				return a.lanes = r, a.return = e, a;
			}
		};
	}
	var Ma = ja(!0), Na = ja(!1), Pa = !1;
	function Fa(e) {
		e.updateQueue = {
			baseState: e.memoizedState,
			firstBaseUpdate: null,
			lastBaseUpdate: null,
			shared: {
				pending: null,
				lanes: 0,
				hiddenCallbacks: null
			},
			callbacks: null
		};
	}
	function Ia(e, t) {
		e = e.updateQueue, t.updateQueue === e && (t.updateQueue = {
			baseState: e.baseState,
			firstBaseUpdate: e.firstBaseUpdate,
			lastBaseUpdate: e.lastBaseUpdate,
			shared: e.shared,
			callbacks: null
		});
	}
	function La(e) {
		return {
			lane: e,
			tag: 0,
			payload: null,
			callback: null,
			next: null
		};
	}
	function Ra(e, t, n) {
		var r = e.updateQueue;
		if (r === null) return null;
		if (r = r.shared, q & 2) {
			var i = r.pending;
			return i === null ? t.next = t : (t.next = i.next, i.next = t), r.pending = t, t = ri(e), ni(e, null, n), t;
		}
		return $r(e, r, t, n), ri(e);
	}
	function za(e, t, n) {
		if (t = t.updateQueue, t !== null && (t = t.shared, n & 4194048)) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, Qe(e, n);
		}
	}
	function Ba(e, t) {
		var n = e.updateQueue, r = e.alternate;
		if (r !== null && (r = r.updateQueue, n === r)) {
			var i = null, a = null;
			if (n = n.firstBaseUpdate, n !== null) {
				do {
					var o = {
						lane: n.lane,
						tag: n.tag,
						payload: n.payload,
						callback: null,
						next: null
					};
					a === null ? i = a = o : a = a.next = o, n = n.next;
				} while (n !== null);
				a === null ? i = a = t : a = a.next = t;
			} else i = a = t;
			n = {
				baseState: r.baseState,
				firstBaseUpdate: i,
				lastBaseUpdate: a,
				shared: r.shared,
				callbacks: r.callbacks
			}, e.updateQueue = n;
			return;
		}
		e = n.lastBaseUpdate, e === null ? n.firstBaseUpdate = t : e.next = t, n.lastBaseUpdate = t;
	}
	var Va = !1;
	function Ha() {
		if (Va) {
			var e = ca;
			if (e !== null) throw e;
		}
	}
	function Ua(e, t, n, r) {
		Va = !1;
		var i = e.updateQueue;
		Pa = !1;
		var a = i.firstBaseUpdate, o = i.lastBaseUpdate, s = i.shared.pending;
		if (s !== null) {
			i.shared.pending = null;
			var c = s, l = c.next;
			c.next = null, o === null ? a = l : o.next = l, o = c;
			var u = e.alternate;
			u !== null && (u = u.updateQueue, s = u.lastBaseUpdate, s !== o && (s === null ? u.firstBaseUpdate = l : s.next = l, u.lastBaseUpdate = c));
		}
		if (a !== null) {
			var d = i.baseState;
			o = 0, u = l = c = null, s = a;
			do {
				var f = s.lane & -536870913, m = f !== s.lane;
				if (m ? (Y & f) === f : (r & f) === f) {
					f !== 0 && f === sa && (Va = !0), u !== null && (u = u.next = {
						lane: 0,
						tag: s.tag,
						payload: s.payload,
						callback: null,
						next: null
					});
					a: {
						var h = e, g = s;
						f = t;
						var _ = n;
						switch (g.tag) {
							case 1:
								if (h = g.payload, typeof h == "function") {
									d = h.call(_, d, f);
									break a;
								}
								d = h;
								break a;
							case 3: h.flags = h.flags & -65537 | 128;
							case 0:
								if (h = g.payload, f = typeof h == "function" ? h.call(_, d, f) : h, f == null) break a;
								d = p({}, d, f);
								break a;
							case 2: Pa = !0;
						}
					}
					f = s.callback, f !== null && (e.flags |= 64, m && (e.flags |= 8192), m = i.callbacks, m === null ? i.callbacks = [f] : m.push(f));
				} else m = {
					lane: f,
					tag: s.tag,
					payload: s.payload,
					callback: s.callback,
					next: null
				}, u === null ? (l = u = m, c = d) : u = u.next = m, o |= f;
				if (s = s.next, s === null) {
					if (s = i.shared.pending, s === null) break;
					m = s, s = m.next, m.next = null, i.lastBaseUpdate = m, i.shared.pending = null;
				}
			} while (1);
			u === null && (c = d), i.baseState = c, i.firstBaseUpdate = l, i.lastBaseUpdate = u, a === null && (i.shared.lanes = 0), Gl |= o, e.lanes = o, e.memoizedState = d;
		}
	}
	function Wa(e, t) {
		if (typeof e != "function") throw Error(a(191, e));
		e.call(t);
	}
	function Ga(e, t) {
		var n = e.callbacks;
		if (n !== null) for (e.callbacks = null, e = 0; e < n.length; e++) Wa(n[e], t);
	}
	var Ka = ce(null), qa = ce(0);
	function Ja(e, t) {
		e = Ul, j(qa, e), j(Ka, t), Ul = e | t.baseLanes;
	}
	function Ya() {
		j(qa, Ul), j(Ka, Ka.current);
	}
	function Xa() {
		Ul = qa.current, le(Ka), le(qa);
	}
	var Za = ce(null), Qa = null;
	function $a(e) {
		var t = e.alternate;
		j(io, io.current & 1), j(Za, e), Qa === null && (t === null || Ka.current !== null || t.memoizedState !== null) && (Qa = e);
	}
	function eo(e) {
		j(io, io.current), j(Za, e), Qa === null && (Qa = e);
	}
	function to(e) {
		e.tag === 22 ? (j(io, io.current), j(Za, e), Qa === null && (Qa = e)) : no(e);
	}
	function no() {
		j(io, io.current), j(Za, Za.current);
	}
	function ro(e) {
		le(Za), Qa === e && (Qa = null), le(io);
	}
	var io = ce(0);
	function ao(e) {
		for (var t = e; t !== null;) {
			if (t.tag === 13) {
				var n = t.memoizedState;
				if (n !== null && (n = n.dehydrated, n === null || af(n) || of(n))) return t;
			} else if (t.tag === 19 && (t.memoizedProps.revealOrder === "forwards" || t.memoizedProps.revealOrder === "backwards" || t.memoizedProps.revealOrder === "unstable_legacy-backwards" || t.memoizedProps.revealOrder === "together")) {
				if (t.flags & 128) return t;
			} else if (t.child !== null) {
				t.child.return = t, t = t.child;
				continue;
			}
			if (t === e) break;
			for (; t.sibling === null;) {
				if (t.return === null || t.return === e) return null;
				t = t.return;
			}
			t.sibling.return = t.return, t = t.sibling;
		}
		return null;
	}
	var oo = 0, K = null, so = null, co = null, lo = !1, uo = !1, fo = !1, po = 0, mo = 0, ho = null, go = 0;
	function _o() {
		throw Error(a(321));
	}
	function vo(e, t) {
		if (t === null) return !1;
		for (var n = 0; n < t.length && n < e.length; n++) if (!br(e[n], t[n])) return !1;
		return !0;
	}
	function yo(e, t, n, r, i, a) {
		return oo = a, K = t, t.memoizedState = null, t.updateQueue = null, t.lanes = 0, O.H = e === null || e.memoizedState === null ? Is : Ls, fo = !1, a = n(r, i), fo = !1, uo && (a = xo(t, n, r, i)), bo(e), a;
	}
	function bo(e) {
		O.H = Fs;
		var t = so !== null && so.next !== null;
		if (oo = 0, co = so = K = null, lo = !1, mo = 0, ho = null, t) throw Error(a(300));
		e === null || ec || (e = e.dependencies, e !== null && Ji(e) && (ec = !0));
	}
	function xo(e, t, n, r) {
		K = e;
		var i = 0;
		do {
			if (uo && (ho = null), mo = 0, uo = !1, 25 <= i) throw Error(a(301));
			if (i += 1, co = so = null, e.updateQueue != null) {
				var o = e.updateQueue;
				o.lastEffect = null, o.events = null, o.stores = null, o.memoCache != null && (o.memoCache.index = 0);
			}
			O.H = Rs, o = t(n, r);
		} while (uo);
		return o;
	}
	function So() {
		var e = O.H, t = e.useState()[0];
		return t = typeof t.then == "function" ? ko(t) : t, e = e.useState()[0], (so === null ? null : so.memoizedState) !== e && (K.flags |= 1024), t;
	}
	function Co() {
		var e = po !== 0;
		return po = 0, e;
	}
	function wo(e, t, n) {
		t.updateQueue = e.updateQueue, t.flags &= -2053, e.lanes &= ~n;
	}
	function To(e) {
		if (lo) {
			for (e = e.memoizedState; e !== null;) {
				var t = e.queue;
				t !== null && (t.pending = null), e = e.next;
			}
			lo = !1;
		}
		oo = 0, co = so = K = null, uo = !1, mo = po = 0, ho = null;
	}
	function Eo() {
		var e = {
			memoizedState: null,
			baseState: null,
			baseQueue: null,
			queue: null,
			next: null
		};
		return co === null ? K.memoizedState = co = e : co = co.next = e, co;
	}
	function Do() {
		if (so === null) {
			var e = K.alternate;
			e = e === null ? null : e.memoizedState;
		} else e = so.next;
		var t = co === null ? K.memoizedState : co.next;
		if (t !== null) co = t, so = e;
		else {
			if (e === null) throw K.alternate === null ? Error(a(467)) : Error(a(310));
			so = e, e = {
				memoizedState: so.memoizedState,
				baseState: so.baseState,
				baseQueue: so.baseQueue,
				queue: so.queue,
				next: null
			}, co === null ? K.memoizedState = co = e : co = co.next = e;
		}
		return co;
	}
	function Oo() {
		return {
			lastEffect: null,
			events: null,
			stores: null,
			memoCache: null
		};
	}
	function ko(e) {
		var t = mo;
		return mo += 1, ho === null && (ho = []), e = Sa(ho, e, t), t = K, (co === null ? t.memoizedState : co.next) === null && (t = t.alternate, O.H = t === null || t.memoizedState === null ? Is : Ls), e;
	}
	function Ao(e) {
		if (typeof e == "object" && e) {
			if (typeof e.then == "function") return ko(e);
			if (e.$$typeof === x) return Xi(e);
		}
		throw Error(a(438, String(e)));
	}
	function jo(e) {
		var t = null, n = K.updateQueue;
		if (n !== null && (t = n.memoCache), t == null) {
			var r = K.alternate;
			r !== null && (r = r.updateQueue, r !== null && (r = r.memoCache, r != null && (t = {
				data: r.data.map(function(e) {
					return e.slice();
				}),
				index: 0
			})));
		}
		if (t ??= {
			data: [],
			index: 0
		}, n === null && (n = Oo(), K.updateQueue = n), n.memoCache = t, n = t.data[t.index], n === void 0) for (n = t.data[t.index] = Array(e), r = 0; r < e; r++) n[r] = te;
		return t.index++, n;
	}
	function Mo(e, t) {
		return typeof t == "function" ? t(e) : t;
	}
	function No(e) {
		return Po(Do(), so, e);
	}
	function Po(e, t, n) {
		var r = e.queue;
		if (r === null) throw Error(a(311));
		r.lastRenderedReducer = n;
		var i = e.baseQueue, o = r.pending;
		if (o !== null) {
			if (i !== null) {
				var s = i.next;
				i.next = o.next, o.next = s;
			}
			t.baseQueue = i = o, r.pending = null;
		}
		if (o = e.baseState, i === null) e.memoizedState = o;
		else {
			t = i.next;
			var c = s = null, l = null, u = t, d = !1;
			do {
				var f = u.lane & -536870913;
				if (f === u.lane ? (oo & f) === f : (Y & f) === f) {
					var p = u.revertLane;
					if (p === 0) l !== null && (l = l.next = {
						lane: 0,
						revertLane: 0,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}), f === sa && (d = !0);
					else if ((oo & p) === p) {
						u = u.next, p === sa && (d = !0);
						continue;
					} else f = {
						lane: 0,
						revertLane: u.revertLane,
						gesture: null,
						action: u.action,
						hasEagerState: u.hasEagerState,
						eagerState: u.eagerState,
						next: null
					}, l === null ? (c = l = f, s = o) : l = l.next = f, K.lanes |= p, Gl |= p;
					f = u.action, fo && n(o, f), o = u.hasEagerState ? u.eagerState : n(o, f);
				} else p = {
					lane: f,
					revertLane: u.revertLane,
					gesture: u.gesture,
					action: u.action,
					hasEagerState: u.hasEagerState,
					eagerState: u.eagerState,
					next: null
				}, l === null ? (c = l = p, s = o) : l = l.next = p, K.lanes |= f, Gl |= f;
				u = u.next;
			} while (u !== null && u !== t);
			if (l === null ? s = o : l.next = c, !br(o, e.memoizedState) && (ec = !0, d && (n = ca, n !== null))) throw n;
			e.memoizedState = o, e.baseState = s, e.baseQueue = l, r.lastRenderedState = o;
		}
		return i === null && (r.lanes = 0), [e.memoizedState, r.dispatch];
	}
	function Fo(e) {
		var t = Do(), n = t.queue;
		if (n === null) throw Error(a(311));
		n.lastRenderedReducer = e;
		var r = n.dispatch, i = n.pending, o = t.memoizedState;
		if (i !== null) {
			n.pending = null;
			var s = i = i.next;
			do
				o = e(o, s.action), s = s.next;
			while (s !== i);
			br(o, t.memoizedState) || (ec = !0), t.memoizedState = o, t.baseQueue === null && (t.baseState = o), n.lastRenderedState = o;
		}
		return [o, r];
	}
	function Io(e, t, n) {
		var r = K, i = Do(), o = W;
		if (o) {
			if (n === void 0) throw Error(a(407));
			n = n();
		} else n = t();
		var s = !br((so || i).memoizedState, n);
		if (s && (i.memoizedState = n, ec = !0), i = i.queue, ss(zo.bind(null, r, i, e), [e]), i.getSnapshot !== t || s || co !== null && co.memoizedState.tag & 1) {
			if (r.flags |= 2048, ns(9, { destroy: void 0 }, Ro.bind(null, r, i, n, t), null), Rl === null) throw Error(a(349));
			o || oo & 127 || Lo(r, t, n);
		}
		return n;
	}
	function Lo(e, t, n) {
		e.flags |= 16384, e = {
			getSnapshot: t,
			value: n
		}, t = K.updateQueue, t === null ? (t = Oo(), K.updateQueue = t, t.stores = [e]) : (n = t.stores, n === null ? t.stores = [e] : n.push(e));
	}
	function Ro(e, t, n, r) {
		t.value = n, t.getSnapshot = r, Bo(t) && Vo(e);
	}
	function zo(e, t, n) {
		return n(function() {
			Bo(t) && Vo(e);
		});
	}
	function Bo(e) {
		var t = e.getSnapshot;
		e = e.value;
		try {
			var n = t();
			return !br(e, n);
		} catch {
			return !0;
		}
	}
	function Vo(e) {
		var t = ti(e, 2);
		t !== null && hu(t, e, 2);
	}
	function Ho(e) {
		var t = Eo();
		if (typeof e == "function") {
			var n = e;
			if (e = n(), fo) {
				Fe(!0);
				try {
					n();
				} finally {
					Fe(!1);
				}
			}
		}
		return t.memoizedState = t.baseState = e, t.queue = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: Mo,
			lastRenderedState: e
		}, t;
	}
	function Uo(e, t, n, r) {
		return e.baseState = n, Po(e, so, typeof r == "function" ? r : Mo);
	}
	function Wo(e, t, n, r, i) {
		if (Ms(e)) throw Error(a(485));
		if (e = t.action, e !== null) {
			var o = {
				payload: i,
				action: e,
				next: null,
				isTransition: !0,
				status: "pending",
				value: null,
				reason: null,
				listeners: [],
				then: function(e) {
					o.listeners.push(e);
				}
			};
			O.T === null ? o.isTransition = !1 : n(!0), r(o), n = t.pending, n === null ? (o.next = t.pending = o, Go(t, o)) : (o.next = n.next, t.pending = n.next = o);
		}
	}
	function Go(e, t) {
		var n = t.action, r = t.payload, i = e.state;
		if (t.isTransition) {
			var a = O.T, o = {};
			O.T = o;
			try {
				var s = n(i, r), c = O.S;
				c !== null && c(o, s), Ko(e, t, s);
			} catch (n) {
				Jo(e, t, n);
			} finally {
				a !== null && o.types !== null && (a.types = o.types), O.T = a;
			}
		} else try {
			a = n(i, r), Ko(e, t, a);
		} catch (n) {
			Jo(e, t, n);
		}
	}
	function Ko(e, t, n) {
		typeof n == "object" && n && typeof n.then == "function" ? n.then(function(n) {
			qo(e, t, n);
		}, function(n) {
			return Jo(e, t, n);
		}) : qo(e, t, n);
	}
	function qo(e, t, n) {
		t.status = "fulfilled", t.value = n, Yo(t), e.state = n, t = e.pending, t !== null && (n = t.next, n === t ? e.pending = null : (n = n.next, t.next = n, Go(e, n)));
	}
	function Jo(e, t, n) {
		var r = e.pending;
		if (e.pending = null, r !== null) {
			r = r.next;
			do
				t.status = "rejected", t.reason = n, Yo(t), t = t.next;
			while (t !== r);
		}
		e.action = null;
	}
	function Yo(e) {
		e = e.listeners;
		for (var t = 0; t < e.length; t++) (0, e[t])();
	}
	function Xo(e, t) {
		return t;
	}
	function Zo(e, t) {
		if (W) {
			var n = Rl.formState;
			if (n !== null) {
				a: {
					var r = K;
					if (W) {
						if (ki) {
							b: {
								for (var i = ki, a = ji; i.nodeType !== 8;) {
									if (!a) {
										i = null;
										break b;
									}
									if (i = cf(i.nextSibling), i === null) {
										i = null;
										break b;
									}
								}
								a = i.data, i = a === "F!" || a === "F" ? i : null;
							}
							if (i) {
								ki = cf(i.nextSibling), r = i.data === "F!";
								break a;
							}
						}
						Ni(r);
					}
					r = !1;
				}
				r && (t = n[0]);
			}
		}
		return n = Eo(), n.memoizedState = n.baseState = t, r = {
			pending: null,
			lanes: 0,
			dispatch: null,
			lastRenderedReducer: Xo,
			lastRenderedState: t
		}, n.queue = r, n = ks.bind(null, K, r), r.dispatch = n, r = Ho(!1), a = js.bind(null, K, !1, r.queue), r = Eo(), i = {
			state: t,
			dispatch: null,
			action: e,
			pending: null
		}, r.queue = i, n = Wo.bind(null, K, i, a, n), i.dispatch = n, r.memoizedState = e, [
			t,
			n,
			!1
		];
	}
	function Qo(e) {
		return $o(Do(), so, e);
	}
	function $o(e, t, n) {
		if (t = Po(e, t, Xo)[0], e = No(Mo)[0], typeof t == "object" && t && typeof t.then == "function") try {
			var r = ko(t);
		} catch (e) {
			throw e === _a ? ya : e;
		}
		else r = t;
		t = Do();
		var i = t.queue, a = i.dispatch;
		return n !== t.memoizedState && (K.flags |= 2048, ns(9, { destroy: void 0 }, es.bind(null, i, n), null)), [
			r,
			a,
			e
		];
	}
	function es(e, t) {
		e.action = t;
	}
	function ts(e) {
		var t = Do(), n = so;
		if (n !== null) return $o(t, n, e);
		Do(), t = t.memoizedState, n = Do();
		var r = n.queue.dispatch;
		return n.memoizedState = e, [
			t,
			r,
			!1
		];
	}
	function ns(e, t, n, r) {
		return e = {
			tag: e,
			create: n,
			deps: r,
			inst: t,
			next: null
		}, t = K.updateQueue, t === null && (t = Oo(), K.updateQueue = t), n = t.lastEffect, n === null ? t.lastEffect = e.next = e : (r = n.next, n.next = e, e.next = r, t.lastEffect = e), e;
	}
	function rs() {
		return Do().memoizedState;
	}
	function is(e, t, n, r) {
		var i = Eo();
		K.flags |= e, i.memoizedState = ns(1 | t, { destroy: void 0 }, n, r === void 0 ? null : r);
	}
	function as(e, t, n, r) {
		var i = Do();
		r = r === void 0 ? null : r;
		var a = i.memoizedState.inst;
		so !== null && r !== null && vo(r, so.memoizedState.deps) ? i.memoizedState = ns(t, a, n, r) : (K.flags |= e, i.memoizedState = ns(1 | t, a, n, r));
	}
	function os(e, t) {
		is(8390656, 8, e, t);
	}
	function ss(e, t) {
		as(2048, 8, e, t);
	}
	function cs(e) {
		K.flags |= 4;
		var t = K.updateQueue;
		if (t === null) t = Oo(), K.updateQueue = t, t.events = [e];
		else {
			var n = t.events;
			n === null ? t.events = [e] : n.push(e);
		}
	}
	function ls(e) {
		var t = Do().memoizedState;
		return cs({
			ref: t,
			nextImpl: e
		}), function() {
			if (q & 2) throw Error(a(440));
			return t.impl.apply(void 0, arguments);
		};
	}
	function us(e, t) {
		return as(4, 2, e, t);
	}
	function ds(e, t) {
		return as(4, 4, e, t);
	}
	function fs(e, t) {
		if (typeof t == "function") {
			e = e();
			var n = t(e);
			return function() {
				typeof n == "function" ? n() : t(null);
			};
		}
		if (t != null) return e = e(), t.current = e, function() {
			t.current = null;
		};
	}
	function ps(e, t, n) {
		n = n == null ? null : n.concat([e]), as(4, 4, fs.bind(null, t, e), n);
	}
	function ms() {}
	function hs(e, t) {
		var n = Do();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		return t !== null && vo(t, r[1]) ? r[0] : (n.memoizedState = [e, t], e);
	}
	function gs(e, t) {
		var n = Do();
		t = t === void 0 ? null : t;
		var r = n.memoizedState;
		if (t !== null && vo(t, r[1])) return r[0];
		if (r = e(), fo) {
			Fe(!0);
			try {
				e();
			} finally {
				Fe(!1);
			}
		}
		return n.memoizedState = [r, t], r;
	}
	function _s(e, t, n) {
		return n === void 0 || oo & 1073741824 && !(Y & 261930) ? e.memoizedState = t : (e.memoizedState = n, e = mu(), K.lanes |= e, Gl |= e, n);
	}
	function vs(e, t, n, r) {
		return br(n, t) ? n : Ka.current === null ? !(oo & 42) || oo & 1073741824 && !(Y & 261930) ? (ec = !0, e.memoizedState = n) : (e = mu(), K.lanes |= e, Gl |= e, t) : (e = _s(e, n, r), br(e, t) || (ec = !0), e);
	}
	function ys(e, t, n, r, i) {
		var a = k.p;
		k.p = a !== 0 && 8 > a ? a : 8;
		var o = O.T, s = {};
		O.T = s, js(e, !1, t, n);
		try {
			var c = i(), l = O.S;
			l !== null && l(s, c), typeof c == "object" && c && typeof c.then == "function" ? As(e, t, da(c, r), pu(e)) : As(e, t, r, pu(e));
		} catch (n) {
			As(e, t, {
				then: function() {},
				status: "rejected",
				reason: n
			}, pu());
		} finally {
			k.p = a, o !== null && s.types !== null && (o.types = s.types), O.T = o;
		}
	}
	function bs() {}
	function xs(e, t, n, r) {
		if (e.tag !== 5) throw Error(a(476));
		var i = Ss(e).queue;
		ys(e, i, t, A, n === null ? bs : function() {
			return Cs(e), n(r);
		});
	}
	function Ss(e) {
		var t = e.memoizedState;
		if (t !== null) return t;
		t = {
			memoizedState: A,
			baseState: A,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: Mo,
				lastRenderedState: A
			},
			next: null
		};
		var n = {};
		return t.next = {
			memoizedState: n,
			baseState: n,
			baseQueue: null,
			queue: {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: Mo,
				lastRenderedState: n
			},
			next: null
		}, e.memoizedState = t, e = e.alternate, e !== null && (e.memoizedState = t), t;
	}
	function Cs(e) {
		var t = Ss(e);
		t.next === null && (t = e.alternate.memoizedState), As(e, t.next.queue, {}, pu());
	}
	function ws() {
		return Xi(Qf);
	}
	function Ts() {
		return Do().memoizedState;
	}
	function Es() {
		return Do().memoizedState;
	}
	function Ds(e) {
		for (var t = e.return; t !== null;) {
			switch (t.tag) {
				case 24:
				case 3:
					var n = pu();
					e = La(n);
					var r = Ra(t, e, n);
					r !== null && (hu(r, t, n), za(r, t, n)), t = { cache: ra() }, e.payload = t;
					return;
			}
			t = t.return;
		}
	}
	function Os(e, t, n) {
		var r = pu();
		n = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Ms(e) ? Ns(t, n) : (n = ei(e, t, n, r), n !== null && (hu(n, e, r), Ps(n, t, r)));
	}
	function ks(e, t, n) {
		As(e, t, n, pu());
	}
	function As(e, t, n, r) {
		var i = {
			lane: r,
			revertLane: 0,
			gesture: null,
			action: n,
			hasEagerState: !1,
			eagerState: null,
			next: null
		};
		if (Ms(e)) Ns(t, i);
		else {
			var a = e.alternate;
			if (e.lanes === 0 && (a === null || a.lanes === 0) && (a = t.lastRenderedReducer, a !== null)) try {
				var o = t.lastRenderedState, s = a(o, n);
				if (i.hasEagerState = !0, i.eagerState = s, br(s, o)) return $r(e, t, i, 0), Rl === null && Qr(), !1;
			} catch {}
			if (n = ei(e, t, i, r), n !== null) return hu(n, e, r), Ps(n, t, r), !0;
		}
		return !1;
	}
	function js(e, t, n, r) {
		if (r = {
			lane: 2,
			revertLane: dd(),
			gesture: null,
			action: r,
			hasEagerState: !1,
			eagerState: null,
			next: null
		}, Ms(e)) {
			if (t) throw Error(a(479));
		} else t = ei(e, n, r, 2), t !== null && hu(t, e, 2);
	}
	function Ms(e) {
		var t = e.alternate;
		return e === K || t !== null && t === K;
	}
	function Ns(e, t) {
		uo = lo = !0;
		var n = e.pending;
		n === null ? t.next = t : (t.next = n.next, n.next = t), e.pending = t;
	}
	function Ps(e, t, n) {
		if (n & 4194048) {
			var r = t.lanes;
			r &= e.pendingLanes, n |= r, t.lanes = n, Qe(e, n);
		}
	}
	var Fs = {
		readContext: Xi,
		use: Ao,
		useCallback: _o,
		useContext: _o,
		useEffect: _o,
		useImperativeHandle: _o,
		useLayoutEffect: _o,
		useInsertionEffect: _o,
		useMemo: _o,
		useReducer: _o,
		useRef: _o,
		useState: _o,
		useDebugValue: _o,
		useDeferredValue: _o,
		useTransition: _o,
		useSyncExternalStore: _o,
		useId: _o,
		useHostTransitionStatus: _o,
		useFormState: _o,
		useActionState: _o,
		useOptimistic: _o,
		useMemoCache: _o,
		useCacheRefresh: _o
	};
	Fs.useEffectEvent = _o;
	var Is = {
		readContext: Xi,
		use: Ao,
		useCallback: function(e, t) {
			return Eo().memoizedState = [e, t === void 0 ? null : t], e;
		},
		useContext: Xi,
		useEffect: os,
		useImperativeHandle: function(e, t, n) {
			n = n == null ? null : n.concat([e]), is(4194308, 4, fs.bind(null, t, e), n);
		},
		useLayoutEffect: function(e, t) {
			return is(4194308, 4, e, t);
		},
		useInsertionEffect: function(e, t) {
			is(4, 2, e, t);
		},
		useMemo: function(e, t) {
			var n = Eo();
			t = t === void 0 ? null : t;
			var r = e();
			if (fo) {
				Fe(!0);
				try {
					e();
				} finally {
					Fe(!1);
				}
			}
			return n.memoizedState = [r, t], r;
		},
		useReducer: function(e, t, n) {
			var r = Eo();
			if (n !== void 0) {
				var i = n(t);
				if (fo) {
					Fe(!0);
					try {
						n(t);
					} finally {
						Fe(!1);
					}
				}
			} else i = t;
			return r.memoizedState = r.baseState = i, e = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: e,
				lastRenderedState: i
			}, r.queue = e, e = e.dispatch = Os.bind(null, K, e), [r.memoizedState, e];
		},
		useRef: function(e) {
			var t = Eo();
			return e = { current: e }, t.memoizedState = e;
		},
		useState: function(e) {
			e = Ho(e);
			var t = e.queue, n = ks.bind(null, K, t);
			return t.dispatch = n, [e.memoizedState, n];
		},
		useDebugValue: ms,
		useDeferredValue: function(e, t) {
			return _s(Eo(), e, t);
		},
		useTransition: function() {
			var e = Ho(!1);
			return e = ys.bind(null, K, e.queue, !0, !1), Eo().memoizedState = e, [!1, e];
		},
		useSyncExternalStore: function(e, t, n) {
			var r = K, i = Eo();
			if (W) {
				if (n === void 0) throw Error(a(407));
				n = n();
			} else {
				if (n = t(), Rl === null) throw Error(a(349));
				Y & 127 || Lo(r, t, n);
			}
			i.memoizedState = n;
			var o = {
				value: n,
				getSnapshot: t
			};
			return i.queue = o, os(zo.bind(null, r, o, e), [e]), r.flags |= 2048, ns(9, { destroy: void 0 }, Ro.bind(null, r, o, n, t), null), n;
		},
		useId: function() {
			var e = Eo(), t = Rl.identifierPrefix;
			if (W) {
				var n = Ci, r = Si;
				n = (r & ~(1 << 32 - Ie(r) - 1)).toString(32) + n, t = "_" + t + "R_" + n, n = po++, 0 < n && (t += "H" + n.toString(32)), t += "_";
			} else n = go++, t = "_" + t + "r_" + n.toString(32) + "_";
			return e.memoizedState = t;
		},
		useHostTransitionStatus: ws,
		useFormState: Zo,
		useActionState: Zo,
		useOptimistic: function(e) {
			var t = Eo();
			t.memoizedState = t.baseState = e;
			var n = {
				pending: null,
				lanes: 0,
				dispatch: null,
				lastRenderedReducer: null,
				lastRenderedState: null
			};
			return t.queue = n, t = js.bind(null, K, !0, n), n.dispatch = t, [e, t];
		},
		useMemoCache: jo,
		useCacheRefresh: function() {
			return Eo().memoizedState = Ds.bind(null, K);
		},
		useEffectEvent: function(e) {
			var t = Eo(), n = { impl: e };
			return t.memoizedState = n, function() {
				if (q & 2) throw Error(a(440));
				return n.impl.apply(void 0, arguments);
			};
		}
	}, Ls = {
		readContext: Xi,
		use: Ao,
		useCallback: hs,
		useContext: Xi,
		useEffect: ss,
		useImperativeHandle: ps,
		useInsertionEffect: us,
		useLayoutEffect: ds,
		useMemo: gs,
		useReducer: No,
		useRef: rs,
		useState: function() {
			return No(Mo);
		},
		useDebugValue: ms,
		useDeferredValue: function(e, t) {
			return vs(Do(), so.memoizedState, e, t);
		},
		useTransition: function() {
			var e = No(Mo)[0], t = Do().memoizedState;
			return [typeof e == "boolean" ? e : ko(e), t];
		},
		useSyncExternalStore: Io,
		useId: Ts,
		useHostTransitionStatus: ws,
		useFormState: Qo,
		useActionState: Qo,
		useOptimistic: function(e, t) {
			return Uo(Do(), so, e, t);
		},
		useMemoCache: jo,
		useCacheRefresh: Es
	};
	Ls.useEffectEvent = ls;
	var Rs = {
		readContext: Xi,
		use: Ao,
		useCallback: hs,
		useContext: Xi,
		useEffect: ss,
		useImperativeHandle: ps,
		useInsertionEffect: us,
		useLayoutEffect: ds,
		useMemo: gs,
		useReducer: Fo,
		useRef: rs,
		useState: function() {
			return Fo(Mo);
		},
		useDebugValue: ms,
		useDeferredValue: function(e, t) {
			var n = Do();
			return so === null ? _s(n, e, t) : vs(n, so.memoizedState, e, t);
		},
		useTransition: function() {
			var e = Fo(Mo)[0], t = Do().memoizedState;
			return [typeof e == "boolean" ? e : ko(e), t];
		},
		useSyncExternalStore: Io,
		useId: Ts,
		useHostTransitionStatus: ws,
		useFormState: ts,
		useActionState: ts,
		useOptimistic: function(e, t) {
			var n = Do();
			return so === null ? (n.baseState = e, [e, n.queue.dispatch]) : Uo(n, so, e, t);
		},
		useMemoCache: jo,
		useCacheRefresh: Es
	};
	Rs.useEffectEvent = ls;
	function zs(e, t, n, r) {
		t = e.memoizedState, n = n(r, t), n = n == null ? t : p({}, t, n), e.memoizedState = n, e.lanes === 0 && (e.updateQueue.baseState = n);
	}
	var Bs = {
		enqueueSetState: function(e, t, n) {
			e = e._reactInternals;
			var r = pu(), i = La(r);
			i.payload = t, n != null && (i.callback = n), t = Ra(e, i, r), t !== null && (hu(t, e, r), za(t, e, r));
		},
		enqueueReplaceState: function(e, t, n) {
			e = e._reactInternals;
			var r = pu(), i = La(r);
			i.tag = 1, i.payload = t, n != null && (i.callback = n), t = Ra(e, i, r), t !== null && (hu(t, e, r), za(t, e, r));
		},
		enqueueForceUpdate: function(e, t) {
			e = e._reactInternals;
			var n = pu(), r = La(n);
			r.tag = 2, t != null && (r.callback = t), t = Ra(e, r, n), t !== null && (hu(t, e, n), za(t, e, n));
		}
	};
	function Vs(e, t, n, r, i, a, o) {
		return e = e.stateNode, typeof e.shouldComponentUpdate == "function" ? e.shouldComponentUpdate(r, a, o) : t.prototype && t.prototype.isPureReactComponent ? !xr(n, r) || !xr(i, a) : !0;
	}
	function Hs(e, t, n, r) {
		e = t.state, typeof t.componentWillReceiveProps == "function" && t.componentWillReceiveProps(n, r), typeof t.UNSAFE_componentWillReceiveProps == "function" && t.UNSAFE_componentWillReceiveProps(n, r), t.state !== e && Bs.enqueueReplaceState(t, t.state, null);
	}
	function Us(e, t) {
		var n = t;
		if ("ref" in t) for (var r in n = {}, t) r !== "ref" && (n[r] = t[r]);
		if (e = e.defaultProps) for (var i in n === t && (n = p({}, n)), e) n[i] === void 0 && (n[i] = e[i]);
		return n;
	}
	function Ws(e) {
		Jr(e);
	}
	function Gs(e) {
		console.error(e);
	}
	function Ks(e) {
		Jr(e);
	}
	function qs(e, t) {
		try {
			var n = e.onUncaughtError;
			n(t.value, { componentStack: t.stack });
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Js(e, t, n) {
		try {
			var r = e.onCaughtError;
			r(n.value, {
				componentStack: n.stack,
				errorBoundary: t.tag === 1 ? t.stateNode : null
			});
		} catch (e) {
			setTimeout(function() {
				throw e;
			});
		}
	}
	function Ys(e, t, n) {
		return n = La(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
			qs(e, t);
		}, n;
	}
	function Xs(e) {
		return e = La(e), e.tag = 3, e;
	}
	function Zs(e, t, n, r) {
		var i = n.type.getDerivedStateFromError;
		if (typeof i == "function") {
			var a = r.value;
			e.payload = function() {
				return i(a);
			}, e.callback = function() {
				Js(t, n, r);
			};
		}
		var o = n.stateNode;
		o !== null && typeof o.componentDidCatch == "function" && (e.callback = function() {
			Js(t, n, r), typeof i != "function" && (ru === null ? ru = /* @__PURE__ */ new Set([this]) : ru.add(this));
			var e = r.stack;
			this.componentDidCatch(r.value, { componentStack: e === null ? "" : e });
		});
	}
	function Qs(e, t, n, r, i) {
		if (n.flags |= 32768, typeof r == "object" && r && typeof r.then == "function") {
			if (t = n.alternate, t !== null && qi(t, n, i, !0), n = Za.current, n !== null) {
				switch (n.tag) {
					case 31:
					case 13: return Qa === null ? Du() : n.alternate === null && Wl === 0 && (Wl = 3), n.flags &= -257, n.flags |= 65536, n.lanes = i, r === ba ? n.flags |= 16384 : (t = n.updateQueue, t === null ? n.updateQueue = /* @__PURE__ */ new Set([r]) : t.add(r), Gu(e, r, i)), !1;
					case 22: return n.flags |= 65536, r === ba ? n.flags |= 16384 : (t = n.updateQueue, t === null ? (t = {
						transitions: null,
						markerInstances: null,
						retryQueue: /* @__PURE__ */ new Set([r])
					}, n.updateQueue = t) : (n = t.retryQueue, n === null ? t.retryQueue = /* @__PURE__ */ new Set([r]) : n.add(r)), Gu(e, r, i)), !1;
				}
				throw Error(a(435, n.tag));
			}
			return Gu(e, r, i), Du(), !1;
		}
		if (W) return t = Za.current, t === null ? (r !== Mi && (t = Error(a(423), { cause: r }), zi(hi(t, n))), e = e.current.alternate, e.flags |= 65536, i &= -i, e.lanes |= i, r = hi(r, n), i = Ys(e.stateNode, r, i), Ba(e, i), Wl !== 4 && (Wl = 2)) : (!(t.flags & 65536) && (t.flags |= 256), t.flags |= 65536, t.lanes = i, r !== Mi && (e = Error(a(422), { cause: r }), zi(hi(e, n)))), !1;
		var o = Error(a(520), { cause: r });
		if (o = hi(o, n), Xl === null ? Xl = [o] : Xl.push(o), Wl !== 4 && (Wl = 2), t === null) return !0;
		r = hi(r, n), n = t;
		do {
			switch (n.tag) {
				case 3: return n.flags |= 65536, e = i & -i, n.lanes |= e, e = Ys(n.stateNode, r, e), Ba(n, e), !1;
				case 1: if (t = n.type, o = n.stateNode, !(n.flags & 128) && (typeof t.getDerivedStateFromError == "function" || o !== null && typeof o.componentDidCatch == "function" && (ru === null || !ru.has(o)))) return n.flags |= 65536, i &= -i, n.lanes |= i, i = Xs(i), Zs(i, e, n, r), Ba(n, i), !1;
			}
			n = n.return;
		} while (n !== null);
		return !1;
	}
	var $s = Error(a(461)), ec = !1;
	function tc(e, t, n, r) {
		t.child = e === null ? Na(t, null, n, r) : Ma(t, e.child, n, r);
	}
	function nc(e, t, n, r, i) {
		n = n.render;
		var a = t.ref;
		if ("ref" in r) {
			var o = {};
			for (var s in r) s !== "ref" && (o[s] = r[s]);
		} else o = r;
		return Yi(t), r = yo(e, t, n, o, a, i), s = Co(), e !== null && !ec ? (wo(e, t, i), Ec(e, t, i)) : (W && s && Ei(t), t.flags |= 1, tc(e, t, r, i), t.child);
	}
	function rc(e, t, n, r, i) {
		if (e === null) {
			var a = n.type;
			return typeof a == "function" && !si(a) && a.defaultProps === void 0 && n.compare === null ? (t.tag = 15, t.type = a, ic(e, t, a, r, i)) : (e = ui(n.type, null, r, t, t.mode, i), e.ref = t.ref, e.return = t, t.child = e);
		}
		if (a = e.child, !Dc(e, i)) {
			var o = a.memoizedProps;
			if (n = n.compare, n = n === null ? xr : n, n(o, r) && e.ref === t.ref) return Ec(e, t, i);
		}
		return t.flags |= 1, e = ci(a, r), e.ref = t.ref, e.return = t, t.child = e;
	}
	function ic(e, t, n, r, i) {
		if (e !== null) {
			var a = e.memoizedProps;
			if (xr(a, r) && e.ref === t.ref) {
				if (ec = !1, t.pendingProps = r = a, Dc(e, i)) e.flags & 131072 && (ec = !0);
				else return t.lanes = e.lanes, Ec(e, t, i);
			}
		}
		return fc(e, t, n, r, i);
	}
	function ac(e, t, n, r) {
		var i = r.children, a = e === null ? null : e.memoizedState;
		if (e === null && t.stateNode === null && (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), r.mode === "hidden") {
			if (t.flags & 128) {
				if (a = a === null ? n : a.baseLanes | n, e !== null) {
					for (r = t.child = e.child, i = 0; r !== null;) i = i | r.lanes | r.childLanes, r = r.sibling;
					r = i & ~a;
				} else r = 0, t.child = null;
				return sc(e, t, a, n, r);
			}
			if (n & 536870912) t.memoizedState = {
				baseLanes: 0,
				cachePool: null
			}, e !== null && ha(t, a === null ? null : a.cachePool), a === null ? Ya() : Ja(t, a), to(t);
			else return r = t.lanes = 536870912, sc(e, t, a === null ? n : a.baseLanes | n, n, r);
		} else a === null ? (e !== null && ha(t, null), Ya(), no(t)) : (ha(t, a.cachePool), Ja(t, a), no(t), t.memoizedState = null);
		return tc(e, t, i, n), t.child;
	}
	function oc(e, t) {
		return e !== null && e.tag === 22 || t.stateNode !== null || (t.stateNode = {
			_visibility: 1,
			_pendingMarkers: null,
			_retryCache: null,
			_transitions: null
		}), t.sibling;
	}
	function sc(e, t, n, r, i) {
		var a = ma();
		return a = a === null ? null : {
			parent: na._currentValue,
			pool: a
		}, t.memoizedState = {
			baseLanes: n,
			cachePool: a
		}, e !== null && ha(t, null), Ya(), to(t), e !== null && qi(e, t, r, !0), t.childLanes = i, null;
	}
	function cc(e, t) {
		return t = xc({
			mode: t.mode,
			children: t.children
		}, e.mode), t.ref = e.ref, e.child = t, t.return = e, t;
	}
	function lc(e, t, n) {
		return Ma(t, e.child, null, n), e = cc(t, t.pendingProps), e.flags |= 2, ro(t), t.memoizedState = null, e;
	}
	function uc(e, t, n) {
		var r = t.pendingProps, i = !!(t.flags & 128);
		if (t.flags &= -129, e === null) {
			if (W) {
				if (r.mode === "hidden") return e = cc(t, r), t.lanes = 536870912, oc(null, e);
				if (eo(t), (e = ki) ? (e = rf(e, ji), e = e !== null && e.data === "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: H === null ? null : {
						id: Si,
						overflow: Ci
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = fi(e), n.return = t, t.child = n, U = t, ki = null)) : e = null, e === null) throw Ni(t);
				return t.lanes = 536870912, null;
			}
			return cc(t, r);
		}
		var o = e.memoizedState;
		if (o !== null) {
			var s = o.dehydrated;
			if (eo(t), i) {
				if (t.flags & 256) t.flags &= -257, t = lc(e, t, n);
				else if (t.memoizedState !== null) t.child = e.child, t.flags |= 128, t = null;
				else throw Error(a(558));
			} else if (ec || qi(e, t, n, !1), i = (n & e.childLanes) !== 0, ec || i) {
				if (r = Rl, r !== null && (s = $e(r, n), s !== 0 && s !== o.retryLane)) throw o.retryLane = s, ti(e, s), hu(r, e, s), $s;
				Du(), t = lc(e, t, n);
			} else e = o.treeContext, ki = cf(s.nextSibling), U = t, W = !0, Ai = null, ji = !1, e !== null && Oi(t, e), t = cc(t, r), t.flags |= 4096;
			return t;
		}
		return e = ci(e.child, {
			mode: r.mode,
			children: r.children
		}), e.ref = t.ref, t.child = e, e.return = t, e;
	}
	function dc(e, t) {
		var n = t.ref;
		if (n === null) e !== null && e.ref !== null && (t.flags |= 4194816);
		else {
			if (typeof n != "function" && typeof n != "object") throw Error(a(284));
			(e === null || e.ref !== n) && (t.flags |= 4194816);
		}
	}
	function fc(e, t, n, r, i) {
		return Yi(t), n = yo(e, t, n, r, void 0, i), r = Co(), e !== null && !ec ? (wo(e, t, i), Ec(e, t, i)) : (W && r && Ei(t), t.flags |= 1, tc(e, t, n, i), t.child);
	}
	function pc(e, t, n, r, i, a) {
		return Yi(t), t.updateQueue = null, n = xo(t, r, n, i), bo(e), r = Co(), e !== null && !ec ? (wo(e, t, a), Ec(e, t, a)) : (W && r && Ei(t), t.flags |= 1, tc(e, t, n, a), t.child);
	}
	function mc(e, t, n, r, i) {
		if (Yi(t), t.stateNode === null) {
			var a = ii, o = n.contextType;
			typeof o == "object" && o && (a = Xi(o)), a = new n(r, a), t.memoizedState = a.state !== null && a.state !== void 0 ? a.state : null, a.updater = Bs, t.stateNode = a, a._reactInternals = t, a = t.stateNode, a.props = r, a.state = t.memoizedState, a.refs = {}, Fa(t), o = n.contextType, a.context = typeof o == "object" && o ? Xi(o) : ii, a.state = t.memoizedState, o = n.getDerivedStateFromProps, typeof o == "function" && (zs(t, n, o, r), a.state = t.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof a.getSnapshotBeforeUpdate == "function" || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (o = a.state, typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount(), o !== a.state && Bs.enqueueReplaceState(a, a.state, null), Ua(t, r, a, i), Ha(), a.state = t.memoizedState), typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !0;
		} else if (e === null) {
			a = t.stateNode;
			var s = t.memoizedProps, c = Us(n, s);
			a.props = c;
			var l = a.context, u = n.contextType;
			o = ii, typeof u == "object" && u && (o = Xi(u));
			var d = n.getDerivedStateFromProps;
			u = typeof d == "function" || typeof a.getSnapshotBeforeUpdate == "function", s = t.pendingProps !== s, u || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (s || l !== o) && Hs(t, a, r, o), Pa = !1;
			var f = t.memoizedState;
			a.state = f, Ua(t, r, a, i), Ha(), l = t.memoizedState, s || f !== l || Pa ? (typeof d == "function" && (zs(t, n, d, r), l = t.memoizedState), (c = Pa || Vs(t, n, c, r, f, l, o)) ? (u || typeof a.UNSAFE_componentWillMount != "function" && typeof a.componentWillMount != "function" || (typeof a.componentWillMount == "function" && a.componentWillMount(), typeof a.UNSAFE_componentWillMount == "function" && a.UNSAFE_componentWillMount()), typeof a.componentDidMount == "function" && (t.flags |= 4194308)) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), t.memoizedProps = r, t.memoizedState = l), a.props = r, a.state = l, a.context = o, r = c) : (typeof a.componentDidMount == "function" && (t.flags |= 4194308), r = !1);
		} else {
			a = t.stateNode, Ia(e, t), o = t.memoizedProps, u = Us(n, o), a.props = u, d = t.pendingProps, f = a.context, l = n.contextType, c = ii, typeof l == "object" && l && (c = Xi(l)), s = n.getDerivedStateFromProps, (l = typeof s == "function" || typeof a.getSnapshotBeforeUpdate == "function") || typeof a.UNSAFE_componentWillReceiveProps != "function" && typeof a.componentWillReceiveProps != "function" || (o !== d || f !== c) && Hs(t, a, r, c), Pa = !1, f = t.memoizedState, a.state = f, Ua(t, r, a, i), Ha();
			var p = t.memoizedState;
			o !== d || f !== p || Pa || e !== null && e.dependencies !== null && Ji(e.dependencies) ? (typeof s == "function" && (zs(t, n, s, r), p = t.memoizedState), (u = Pa || Vs(t, n, u, r, f, p, c) || e !== null && e.dependencies !== null && Ji(e.dependencies)) ? (l || typeof a.UNSAFE_componentWillUpdate != "function" && typeof a.componentWillUpdate != "function" || (typeof a.componentWillUpdate == "function" && a.componentWillUpdate(r, p, c), typeof a.UNSAFE_componentWillUpdate == "function" && a.UNSAFE_componentWillUpdate(r, p, c)), typeof a.componentDidUpdate == "function" && (t.flags |= 4), typeof a.getSnapshotBeforeUpdate == "function" && (t.flags |= 1024)) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), t.memoizedProps = r, t.memoizedState = p), a.props = r, a.state = p, a.context = c, r = u) : (typeof a.componentDidUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 4), typeof a.getSnapshotBeforeUpdate != "function" || o === e.memoizedProps && f === e.memoizedState || (t.flags |= 1024), r = !1);
		}
		return a = r, dc(e, t), r = !!(t.flags & 128), a || r ? (a = t.stateNode, n = r && typeof n.getDerivedStateFromError != "function" ? null : a.render(), t.flags |= 1, e !== null && r ? (t.child = Ma(t, e.child, null, i), t.child = Ma(t, null, n, i)) : tc(e, t, n, i), t.memoizedState = a.state, e = t.child) : e = Ec(e, t, i), e;
	}
	function hc(e, t, n, r) {
		return Li(), t.flags |= 256, tc(e, t, n, r), t.child;
	}
	var gc = {
		dehydrated: null,
		treeContext: null,
		retryLane: 0,
		hydrationErrors: null
	};
	function _c(e) {
		return {
			baseLanes: e,
			cachePool: ga()
		};
	}
	function vc(e, t, n) {
		return e = e === null ? 0 : e.childLanes & ~n, t && (e |= Jl), e;
	}
	function yc(e, t, n) {
		var r = t.pendingProps, i = !1, o = !!(t.flags & 128), s;
		if ((s = o) || (s = e !== null && e.memoizedState === null ? !1 : !!(io.current & 2)), s && (i = !0, t.flags &= -129), s = !!(t.flags & 32), t.flags &= -33, e === null) {
			if (W) {
				if (i ? $a(t) : no(t), (e = ki) ? (e = rf(e, ji), e = e !== null && e.data !== "&" ? e : null, e !== null && (t.memoizedState = {
					dehydrated: e,
					treeContext: H === null ? null : {
						id: Si,
						overflow: Ci
					},
					retryLane: 536870912,
					hydrationErrors: null
				}, n = fi(e), n.return = t, t.child = n, U = t, ki = null)) : e = null, e === null) throw Ni(t);
				return of(e) ? t.lanes = 32 : t.lanes = 536870912, null;
			}
			var c = r.children;
			return r = r.fallback, i ? (no(t), i = t.mode, c = xc({
				mode: "hidden",
				children: c
			}, i), r = V(r, i, n, null), c.return = t, r.return = t, c.sibling = r, t.child = c, r = t.child, r.memoizedState = _c(n), r.childLanes = vc(e, s, n), t.memoizedState = gc, oc(null, r)) : ($a(t), bc(t, c));
		}
		var l = e.memoizedState;
		if (l !== null && (c = l.dehydrated, c !== null)) {
			if (o) t.flags & 256 ? ($a(t), t.flags &= -257, t = Sc(e, t, n)) : t.memoizedState === null ? (no(t), c = r.fallback, i = t.mode, r = xc({
				mode: "visible",
				children: r.children
			}, i), c = V(c, i, n, null), c.flags |= 2, r.return = t, c.return = t, r.sibling = c, t.child = r, Ma(t, e.child, null, n), r = t.child, r.memoizedState = _c(n), r.childLanes = vc(e, s, n), t.memoizedState = gc, t = oc(null, r)) : (no(t), t.child = e.child, t.flags |= 128, t = null);
			else if ($a(t), of(c)) {
				if (s = c.nextSibling && c.nextSibling.dataset, s) var u = s.dgst;
				s = u, r = Error(a(419)), r.stack = "", r.digest = s, zi({
					value: r,
					source: null,
					stack: null
				}), t = Sc(e, t, n);
			} else if (ec || qi(e, t, n, !1), s = (n & e.childLanes) !== 0, ec || s) {
				if (s = Rl, s !== null && (r = $e(s, n), r !== 0 && r !== l.retryLane)) throw l.retryLane = r, ti(e, r), hu(s, e, r), $s;
				af(c) || Du(), t = Sc(e, t, n);
			} else af(c) ? (t.flags |= 192, t.child = e.child, t = null) : (e = l.treeContext, ki = cf(c.nextSibling), U = t, W = !0, Ai = null, ji = !1, e !== null && Oi(t, e), t = bc(t, r.children), t.flags |= 4096);
			return t;
		}
		return i ? (no(t), c = r.fallback, i = t.mode, l = e.child, u = l.sibling, r = ci(l, {
			mode: "hidden",
			children: r.children
		}), r.subtreeFlags = l.subtreeFlags & 65011712, u === null ? (c = V(c, i, n, null), c.flags |= 2) : c = ci(u, c), c.return = t, r.return = t, r.sibling = c, t.child = r, oc(null, r), r = t.child, c = e.child.memoizedState, c === null ? c = _c(n) : (i = c.cachePool, i === null ? i = ga() : (l = na._currentValue, i = i.parent === l ? i : {
			parent: l,
			pool: l
		}), c = {
			baseLanes: c.baseLanes | n,
			cachePool: i
		}), r.memoizedState = c, r.childLanes = vc(e, s, n), t.memoizedState = gc, oc(e.child, r)) : ($a(t), n = e.child, e = n.sibling, n = ci(n, {
			mode: "visible",
			children: r.children
		}), n.return = t, n.sibling = null, e !== null && (s = t.deletions, s === null ? (t.deletions = [e], t.flags |= 16) : s.push(e)), t.child = n, t.memoizedState = null, n);
	}
	function bc(e, t) {
		return t = xc({
			mode: "visible",
			children: t
		}, e.mode), t.return = e, e.child = t;
	}
	function xc(e, t) {
		return e = oi(22, e, null, t), e.lanes = 0, e;
	}
	function Sc(e, t, n) {
		return Ma(t, e.child, null, n), e = bc(t, t.pendingProps.children), e.flags |= 2, t.memoizedState = null, e;
	}
	function Cc(e, t, n) {
		e.lanes |= t;
		var r = e.alternate;
		r !== null && (r.lanes |= t), Gi(e.return, t, n);
	}
	function wc(e, t, n, r, i, a) {
		var o = e.memoizedState;
		o === null ? e.memoizedState = {
			isBackwards: t,
			rendering: null,
			renderingStartTime: 0,
			last: r,
			tail: n,
			tailMode: i,
			treeForkCount: a
		} : (o.isBackwards = t, o.rendering = null, o.renderingStartTime = 0, o.last = r, o.tail = n, o.tailMode = i, o.treeForkCount = a);
	}
	function Tc(e, t, n) {
		var r = t.pendingProps, i = r.revealOrder, a = r.tail;
		r = r.children;
		var o = io.current, s = !!(o & 2);
		if (s ? (o = o & 1 | 2, t.flags |= 128) : o &= 1, j(io, o), tc(e, t, r, n), r = W ? yi : 0, !s && e !== null && e.flags & 128) a: for (e = t.child; e !== null;) {
			if (e.tag === 13) e.memoizedState !== null && Cc(e, n, t);
			else if (e.tag === 19) Cc(e, n, t);
			else if (e.child !== null) {
				e.child.return = e, e = e.child;
				continue;
			}
			if (e === t) break a;
			for (; e.sibling === null;) {
				if (e.return === null || e.return === t) break a;
				e = e.return;
			}
			e.sibling.return = e.return, e = e.sibling;
		}
		switch (i) {
			case "forwards":
				for (n = t.child, i = null; n !== null;) e = n.alternate, e !== null && ao(e) === null && (i = n), n = n.sibling;
				n = i, n === null ? (i = t.child, t.child = null) : (i = n.sibling, n.sibling = null), wc(t, !1, i, n, a, r);
				break;
			case "backwards":
			case "unstable_legacy-backwards":
				for (n = null, i = t.child, t.child = null; i !== null;) {
					if (e = i.alternate, e !== null && ao(e) === null) {
						t.child = i;
						break;
					}
					e = i.sibling, i.sibling = n, n = i, i = e;
				}
				wc(t, !0, n, null, a, r);
				break;
			case "together":
				wc(t, !1, null, null, void 0, r);
				break;
			default: t.memoizedState = null;
		}
		return t.child;
	}
	function Ec(e, t, n) {
		if (e !== null && (t.dependencies = e.dependencies), Gl |= t.lanes, (n & t.childLanes) === 0) {
			if (e !== null) {
				if (qi(e, t, n, !1), (n & t.childLanes) === 0) return null;
			} else return null;
		}
		if (e !== null && t.child !== e.child) throw Error(a(153));
		if (t.child !== null) {
			for (e = t.child, n = ci(e, e.pendingProps), t.child = n, n.return = t; e.sibling !== null;) e = e.sibling, n = n.sibling = ci(e, e.pendingProps), n.return = t;
			n.sibling = null;
		}
		return t.child;
	}
	function Dc(e, t) {
		return (e.lanes & t) !== 0 || (e = e.dependencies, !!(e !== null && Ji(e)));
	}
	function Oc(e, t, n) {
		switch (t.tag) {
			case 3:
				F(t, t.stateNode.containerInfo), Ui(t, na, e.memoizedState.cache), Li();
				break;
			case 27:
			case 5:
				pe(t);
				break;
			case 4:
				F(t, t.stateNode.containerInfo);
				break;
			case 10:
				Ui(t, t.type, t.memoizedProps.value);
				break;
			case 31:
				if (t.memoizedState !== null) return t.flags |= 128, eo(t), null;
				break;
			case 13:
				var r = t.memoizedState;
				if (r !== null) return r.dehydrated === null ? (n & t.child.childLanes) === 0 ? ($a(t), e = Ec(e, t, n), e === null ? null : e.sibling) : yc(e, t, n) : ($a(t), t.flags |= 128, null);
				$a(t);
				break;
			case 19:
				var i = !!(e.flags & 128);
				if (r = (n & t.childLanes) !== 0, r ||= (qi(e, t, n, !1), (n & t.childLanes) !== 0), i) {
					if (r) return Tc(e, t, n);
					t.flags |= 128;
				}
				if (i = t.memoizedState, i !== null && (i.rendering = null, i.tail = null, i.lastEffect = null), j(io, io.current), r) break;
				return null;
			case 22: return t.lanes = 0, ac(e, t, n, t.pendingProps);
			case 24: Ui(t, na, e.memoizedState.cache);
		}
		return Ec(e, t, n);
	}
	function kc(e, t, n) {
		if (e !== null) {
			if (e.memoizedProps !== t.pendingProps) ec = !0;
			else {
				if (!Dc(e, n) && !(t.flags & 128)) return ec = !1, Oc(e, t, n);
				ec = !!(e.flags & 131072);
			}
		} else ec = !1, W && t.flags & 1048576 && Ti(t, yi, t.index);
		switch (t.lanes = 0, t.tag) {
			case 16:
				a: {
					var r = t.pendingProps;
					if (e = Ca(t.elementType), t.type = e, typeof e == "function") si(e) ? (r = Us(e, r), t.tag = 1, t = mc(null, t, e, r, n)) : (t.tag = 0, t = fc(null, t, e, r, n));
					else {
						if (e != null) {
							var i = e.$$typeof;
							if (i === S) {
								t.tag = 11, t = nc(null, t, e, r, n);
								break a;
							}
							if (i === T) {
								t.tag = 14, t = rc(null, t, e, r, n);
								break a;
							}
						}
						throw t = ie(e) || e, Error(a(306, t, ""));
					}
				}
				return t;
			case 0: return fc(e, t, t.type, t.pendingProps, n);
			case 1: return r = t.type, i = Us(r, t.pendingProps), mc(e, t, r, i, n);
			case 3:
				a: {
					if (F(t, t.stateNode.containerInfo), e === null) throw Error(a(387));
					r = t.pendingProps;
					var o = t.memoizedState;
					i = o.element, Ia(e, t), Ua(t, r, null, n);
					var s = t.memoizedState;
					if (r = s.cache, Ui(t, na, r), r !== o.cache && Ki(t, [na], n, !0), Ha(), r = s.element, o.isDehydrated) {
						if (o = {
							element: r,
							isDehydrated: !1,
							cache: s.cache
						}, t.updateQueue.baseState = o, t.memoizedState = o, t.flags & 256) {
							t = hc(e, t, r, n);
							break a;
						}
						if (r !== i) {
							i = hi(Error(a(424)), t), zi(i), t = hc(e, t, r, n);
							break a;
						}
						switch (e = t.stateNode.containerInfo, e.nodeType) {
							case 9:
								e = e.body;
								break;
							default: e = e.nodeName === "HTML" ? e.ownerDocument.body : e;
						}
						for (ki = cf(e.firstChild), U = t, W = !0, Ai = null, ji = !0, n = Na(t, null, r, n), t.child = n; n;) n.flags = n.flags & -3 | 4096, n = n.sibling;
					} else {
						if (Li(), r === i) {
							t = Ec(e, t, n);
							break a;
						}
						tc(e, t, r, n);
					}
					t = t.child;
				}
				return t;
			case 26: return dc(e, t), e === null ? (n = kf(t.type, null, t.pendingProps, null)) ? t.memoizedState = n : W || (n = t.type, e = t.pendingProps, r = Bd(P.current).createElement(n), r[at] = t, r[ot] = e, Pd(r, n, e), vt(r), t.stateNode = r) : t.memoizedState = kf(t.type, e.memoizedProps, t.pendingProps, e.memoizedState), null;
			case 27: return pe(t), e === null && W && (r = t.stateNode = ff(t.type, t.pendingProps, P.current), U = t, ji = !0, i = ki, Zd(t.type) ? (lf = i, ki = cf(r.firstChild)) : ki = i), tc(e, t, t.pendingProps.children, n), dc(e, t), e === null && (t.flags |= 4194304), t.child;
			case 5: return e === null && W && ((i = r = ki) && (r = tf(r, t.type, t.pendingProps, ji), r === null ? i = !1 : (t.stateNode = r, U = t, ki = cf(r.firstChild), ji = !1, i = !0)), i || Ni(t)), pe(t), i = t.type, o = t.pendingProps, s = e === null ? null : e.memoizedProps, r = o.children, Ud(i, o) ? r = null : s !== null && Ud(i, s) && (t.flags |= 32), t.memoizedState !== null && (i = yo(e, t, So, null, null, n), Qf._currentValue = i), dc(e, t), tc(e, t, r, n), t.child;
			case 6: return e === null && W && ((e = n = ki) && (n = nf(n, t.pendingProps, ji), n === null ? e = !1 : (t.stateNode = n, U = t, ki = null, e = !0)), e || Ni(t)), null;
			case 13: return yc(e, t, n);
			case 4: return F(t, t.stateNode.containerInfo), r = t.pendingProps, e === null ? t.child = Ma(t, null, r, n) : tc(e, t, r, n), t.child;
			case 11: return nc(e, t, t.type, t.pendingProps, n);
			case 7: return tc(e, t, t.pendingProps, n), t.child;
			case 8: return tc(e, t, t.pendingProps.children, n), t.child;
			case 12: return tc(e, t, t.pendingProps.children, n), t.child;
			case 10: return r = t.pendingProps, Ui(t, t.type, r.value), tc(e, t, r.children, n), t.child;
			case 9: return i = t.type._context, r = t.pendingProps.children, Yi(t), i = Xi(i), r = r(i), t.flags |= 1, tc(e, t, r, n), t.child;
			case 14: return rc(e, t, t.type, t.pendingProps, n);
			case 15: return ic(e, t, t.type, t.pendingProps, n);
			case 19: return Tc(e, t, n);
			case 31: return uc(e, t, n);
			case 22: return ac(e, t, n, t.pendingProps);
			case 24: return Yi(t), r = Xi(na), e === null ? (i = ma(), i === null && (i = Rl, o = ra(), i.pooledCache = o, o.refCount++, o !== null && (i.pooledCacheLanes |= n), i = o), t.memoizedState = {
				parent: r,
				cache: i
			}, Fa(t), Ui(t, na, i)) : ((e.lanes & n) !== 0 && (Ia(e, t), Ua(t, null, null, n), Ha()), i = e.memoizedState, o = t.memoizedState, i.parent === r ? (r = o.cache, Ui(t, na, r), r !== i.cache && Ki(t, [na], n, !0)) : (i = {
				parent: r,
				cache: r
			}, t.memoizedState = i, t.lanes === 0 && (t.memoizedState = t.updateQueue.baseState = i), Ui(t, na, r))), tc(e, t, t.pendingProps.children, n), t.child;
			case 29: throw t.pendingProps;
		}
		throw Error(a(156, t.tag));
	}
	function Ac(e) {
		e.flags |= 4;
	}
	function jc(e, t, n, r, i) {
		if ((t = !!(e.mode & 32)) && (t = !1), t) {
			if (e.flags |= 16777216, (i & 335544128) === i) {
				if (e.stateNode.complete) e.flags |= 8192;
				else if (wu()) e.flags |= 8192;
				else throw wa = ba, va;
			}
		} else e.flags &= -16777217;
	}
	function Mc(e, t) {
		if (t.type !== "stylesheet" || t.state.loading & 4) e.flags &= -16777217;
		else if (e.flags |= 16777216, !Wf(t)) {
			if (wu()) e.flags |= 8192;
			else throw wa = ba, va;
		}
	}
	function Nc(e, t) {
		t !== null && (e.flags |= 4), e.flags & 16384 && (t = e.tag === 22 ? 536870912 : qe(), e.lanes |= t, Yl |= t);
	}
	function Pc(e, t) {
		if (!W) switch (e.tailMode) {
			case "hidden":
				t = e.tail;
				for (var n = null; t !== null;) t.alternate !== null && (n = t), t = t.sibling;
				n === null ? e.tail = null : n.sibling = null;
				break;
			case "collapsed":
				n = e.tail;
				for (var r = null; n !== null;) n.alternate !== null && (r = n), n = n.sibling;
				r === null ? t || e.tail === null ? e.tail = null : e.tail.sibling = null : r.sibling = null;
		}
	}
	function Fc(e) {
		var t = e.alternate !== null && e.alternate.child === e.child, n = 0, r = 0;
		if (t) for (var i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags & 65011712, r |= i.flags & 65011712, i.return = e, i = i.sibling;
		else for (i = e.child; i !== null;) n |= i.lanes | i.childLanes, r |= i.subtreeFlags, r |= i.flags, i.return = e, i = i.sibling;
		return e.subtreeFlags |= r, e.childLanes = n, t;
	}
	function Ic(e, t, n) {
		var r = t.pendingProps;
		switch (Di(t), t.tag) {
			case 16:
			case 15:
			case 0:
			case 11:
			case 7:
			case 8:
			case 12:
			case 9:
			case 14: return Fc(t), null;
			case 1: return Fc(t), null;
			case 3: return n = t.stateNode, r = null, e !== null && (r = e.memoizedState.cache), t.memoizedState.cache !== r && (t.flags |= 2048), Wi(na), I(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (e === null || e.child === null) && (Ii(t) ? Ac(t) : e === null || e.memoizedState.isDehydrated && !(t.flags & 256) || (t.flags |= 1024, Ri())), Fc(t), null;
			case 26:
				var i = t.type, o = t.memoizedState;
				return e === null ? (Ac(t), o === null ? (Fc(t), jc(t, i, null, r, n)) : (Fc(t), Mc(t, o))) : o ? o === e.memoizedState ? (Fc(t), t.flags &= -16777217) : (Ac(t), Fc(t), Mc(t, o)) : (e = e.memoizedProps, e !== r && Ac(t), Fc(t), jc(t, i, e, r, n)), null;
			case 27:
				if (me(t), n = P.current, i = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Ac(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(a(166));
						return Fc(t), null;
					}
					e = ue.current, Ii(t) ? Pi(t, e) : (e = ff(i, r, n), t.stateNode = e, Ac(t));
				}
				return Fc(t), null;
			case 5:
				if (me(t), i = t.type, e !== null && t.stateNode != null) e.memoizedProps !== r && Ac(t);
				else {
					if (!r) {
						if (t.stateNode === null) throw Error(a(166));
						return Fc(t), null;
					}
					if (o = ue.current, Ii(t)) Pi(t, o);
					else {
						var s = Bd(P.current);
						switch (o) {
							case 1:
								o = s.createElementNS("http://www.w3.org/2000/svg", i);
								break;
							case 2:
								o = s.createElementNS("http://www.w3.org/1998/Math/MathML", i);
								break;
							default: switch (i) {
								case "svg":
									o = s.createElementNS("http://www.w3.org/2000/svg", i);
									break;
								case "math":
									o = s.createElementNS("http://www.w3.org/1998/Math/MathML", i);
									break;
								case "script":
									o = s.createElement("div"), o.innerHTML = "<script><\/script>", o = o.removeChild(o.firstChild);
									break;
								case "select":
									o = typeof r.is == "string" ? s.createElement("select", { is: r.is }) : s.createElement("select"), r.multiple ? o.multiple = !0 : r.size && (o.size = r.size);
									break;
								default: o = typeof r.is == "string" ? s.createElement(i, { is: r.is }) : s.createElement(i);
							}
						}
						o[at] = t, o[ot] = r;
						a: for (s = t.child; s !== null;) {
							if (s.tag === 5 || s.tag === 6) o.appendChild(s.stateNode);
							else if (s.tag !== 4 && s.tag !== 27 && s.child !== null) {
								s.child.return = s, s = s.child;
								continue;
							}
							if (s === t) break a;
							for (; s.sibling === null;) {
								if (s.return === null || s.return === t) break a;
								s = s.return;
							}
							s.sibling.return = s.return, s = s.sibling;
						}
						t.stateNode = o;
						a: switch (Pd(o, i, r), i) {
							case "button":
							case "input":
							case "select":
							case "textarea":
								r = !!r.autoFocus;
								break a;
							case "img":
								r = !0;
								break a;
							default: r = !1;
						}
						r && Ac(t);
					}
				}
				return Fc(t), jc(t, t.type, e === null ? null : e.memoizedProps, t.pendingProps, n), null;
			case 6:
				if (e && t.stateNode != null) e.memoizedProps !== r && Ac(t);
				else {
					if (typeof r != "string" && t.stateNode === null) throw Error(a(166));
					if (e = P.current, Ii(t)) {
						if (e = t.stateNode, n = t.memoizedProps, r = null, i = U, i !== null) switch (i.tag) {
							case 27:
							case 5: r = i.memoizedProps;
						}
						e[at] = t, e = !!(e.nodeValue === n || r !== null && !0 === r.suppressHydrationWarning || Md(e.nodeValue, n)), e || Ni(t, !0);
					} else e = Bd(e).createTextNode(r), e[at] = t, t.stateNode = e;
				}
				return Fc(t), null;
			case 31:
				if (n = t.memoizedState, e === null || e.memoizedState !== null) {
					if (r = Ii(t), n !== null) {
						if (e === null) {
							if (!r) throw Error(a(318));
							if (e = t.memoizedState, e = e === null ? null : e.dehydrated, !e) throw Error(a(557));
							e[at] = t;
						} else Li(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						Fc(t), e = !1;
					} else n = Ri(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = n), e = !0;
					if (!e) return t.flags & 256 ? (ro(t), t) : (ro(t), null);
					if (t.flags & 128) throw Error(a(558));
				}
				return Fc(t), null;
			case 13:
				if (r = t.memoizedState, e === null || e.memoizedState !== null && e.memoizedState.dehydrated !== null) {
					if (i = Ii(t), r !== null && r.dehydrated !== null) {
						if (e === null) {
							if (!i) throw Error(a(318));
							if (i = t.memoizedState, i = i === null ? null : i.dehydrated, !i) throw Error(a(317));
							i[at] = t;
						} else Li(), !(t.flags & 128) && (t.memoizedState = null), t.flags |= 4;
						Fc(t), i = !1;
					} else i = Ri(), e !== null && e.memoizedState !== null && (e.memoizedState.hydrationErrors = i), i = !0;
					if (!i) return t.flags & 256 ? (ro(t), t) : (ro(t), null);
				}
				return ro(t), t.flags & 128 ? (t.lanes = n, t) : (n = r !== null, e = e !== null && e.memoizedState !== null, n && (r = t.child, i = null, r.alternate !== null && r.alternate.memoizedState !== null && r.alternate.memoizedState.cachePool !== null && (i = r.alternate.memoizedState.cachePool.pool), o = null, r.memoizedState !== null && r.memoizedState.cachePool !== null && (o = r.memoizedState.cachePool.pool), o !== i && (r.flags |= 2048)), n !== e && n && (t.child.flags |= 8192), Nc(t, t.updateQueue), Fc(t), null);
			case 4: return I(), e === null && Sd(t.stateNode.containerInfo), Fc(t), null;
			case 10: return Wi(t.type), Fc(t), null;
			case 19:
				if (le(io), r = t.memoizedState, r === null) return Fc(t), null;
				if (i = !!(t.flags & 128), o = r.rendering, o === null) {
					if (i) Pc(r, !1);
					else {
						if (Wl !== 0 || e !== null && e.flags & 128) for (e = t.child; e !== null;) {
							if (o = ao(e), o !== null) {
								for (t.flags |= 128, Pc(r, !1), e = o.updateQueue, t.updateQueue = e, Nc(t, e), t.subtreeFlags = 0, e = n, n = t.child; n !== null;) li(n, e), n = n.sibling;
								return j(io, io.current & 1 | 2), W && wi(t, r.treeForkCount), t.child;
							}
							e = e.sibling;
						}
						r.tail !== null && we() > tu && (t.flags |= 128, i = !0, Pc(r, !1), t.lanes = 4194304);
					}
				} else {
					if (!i) {
						if (e = ao(o), e !== null) {
							if (t.flags |= 128, i = !0, e = e.updateQueue, t.updateQueue = e, Nc(t, e), Pc(r, !0), r.tail === null && r.tailMode === "hidden" && !o.alternate && !W) return Fc(t), null;
						} else 2 * we() - r.renderingStartTime > tu && n !== 536870912 && (t.flags |= 128, i = !0, Pc(r, !1), t.lanes = 4194304);
					}
					r.isBackwards ? (o.sibling = t.child, t.child = o) : (e = r.last, e === null ? t.child = o : e.sibling = o, r.last = o);
				}
				return r.tail === null ? (Fc(t), null) : (e = r.tail, r.rendering = e, r.tail = e.sibling, r.renderingStartTime = we(), e.sibling = null, n = io.current, j(io, i ? n & 1 | 2 : n & 1), W && wi(t, r.treeForkCount), e);
			case 22:
			case 23: return ro(t), Xa(), r = t.memoizedState !== null, e === null ? r && (t.flags |= 8192) : e.memoizedState !== null !== r && (t.flags |= 8192), r ? n & 536870912 && !(t.flags & 128) && (Fc(t), t.subtreeFlags & 6 && (t.flags |= 8192)) : Fc(t), n = t.updateQueue, n !== null && Nc(t, n.retryQueue), n = null, e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), r = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (r = t.memoizedState.cachePool.pool), r !== n && (t.flags |= 2048), e !== null && le(pa), null;
			case 24: return n = null, e !== null && (n = e.memoizedState.cache), t.memoizedState.cache !== n && (t.flags |= 2048), Wi(na), Fc(t), null;
			case 25: return null;
			case 30: return null;
		}
		throw Error(a(156, t.tag));
	}
	function Lc(e, t) {
		switch (Di(t), t.tag) {
			case 1: return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 3: return Wi(na), I(), e = t.flags, e & 65536 && !(e & 128) ? (t.flags = e & -65537 | 128, t) : null;
			case 26:
			case 27:
			case 5: return me(t), null;
			case 31:
				if (t.memoizedState !== null) {
					if (ro(t), t.alternate === null) throw Error(a(340));
					Li();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 13:
				if (ro(t), e = t.memoizedState, e !== null && e.dehydrated !== null) {
					if (t.alternate === null) throw Error(a(340));
					Li();
				}
				return e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 19: return le(io), null;
			case 4: return I(), null;
			case 10: return Wi(t.type), null;
			case 22:
			case 23: return ro(t), Xa(), e !== null && le(pa), e = t.flags, e & 65536 ? (t.flags = e & -65537 | 128, t) : null;
			case 24: return Wi(na), null;
			case 25: return null;
			default: return null;
		}
	}
	function Rc(e, t) {
		switch (Di(t), t.tag) {
			case 3:
				Wi(na), I();
				break;
			case 26:
			case 27:
			case 5:
				me(t);
				break;
			case 4:
				I();
				break;
			case 31:
				t.memoizedState !== null && ro(t);
				break;
			case 13:
				ro(t);
				break;
			case 19:
				le(io);
				break;
			case 10:
				Wi(t.type);
				break;
			case 22:
			case 23:
				ro(t), Xa(), e !== null && le(pa);
				break;
			case 24: Wi(na);
		}
	}
	function zc(e, t) {
		try {
			var n = t.updateQueue, r = n === null ? null : n.lastEffect;
			if (r !== null) {
				var i = r.next;
				n = i;
				do {
					if ((n.tag & e) === e) {
						r = void 0;
						var a = n.create, o = n.inst;
						r = a(), o.destroy = r;
					}
					n = n.next;
				} while (n !== i);
			}
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function Bc(e, t, n) {
		try {
			var r = t.updateQueue, i = r === null ? null : r.lastEffect;
			if (i !== null) {
				var a = i.next;
				r = a;
				do {
					if ((r.tag & e) === e) {
						var o = r.inst, s = o.destroy;
						if (s !== void 0) {
							o.destroy = void 0, i = t;
							var c = n, l = s;
							try {
								l();
							} catch (e) {
								Z(i, c, e);
							}
						}
					}
					r = r.next;
				} while (r !== a);
			}
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function Vc(e) {
		var t = e.updateQueue;
		if (t !== null) {
			var n = e.stateNode;
			try {
				Ga(t, n);
			} catch (t) {
				Z(e, e.return, t);
			}
		}
	}
	function Hc(e, t, n) {
		n.props = Us(e.type, e.memoizedProps), n.state = e.memoizedState;
		try {
			n.componentWillUnmount();
		} catch (n) {
			Z(e, t, n);
		}
	}
	function Uc(e, t) {
		try {
			var n = e.ref;
			if (n !== null) {
				switch (e.tag) {
					case 26:
					case 27:
					case 5:
						var r = e.stateNode;
						break;
					case 30:
						r = e.stateNode;
						break;
					default: r = e.stateNode;
				}
				typeof n == "function" ? e.refCleanup = n(r) : n.current = r;
			}
		} catch (n) {
			Z(e, t, n);
		}
	}
	function Wc(e, t) {
		var n = e.ref, r = e.refCleanup;
		if (n !== null) {
			if (typeof r == "function") try {
				r();
			} catch (n) {
				Z(e, t, n);
			} finally {
				e.refCleanup = null, e = e.alternate, e != null && (e.refCleanup = null);
			}
			else if (typeof n == "function") try {
				n(null);
			} catch (n) {
				Z(e, t, n);
			}
			else n.current = null;
		}
	}
	function Gc(e) {
		var t = e.type, n = e.memoizedProps, r = e.stateNode;
		try {
			a: switch (t) {
				case "button":
				case "input":
				case "select":
				case "textarea":
					n.autoFocus && r.focus();
					break a;
				case "img": n.src ? r.src = n.src : n.srcSet && (r.srcset = n.srcSet);
			}
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	function Kc(e, t, n) {
		try {
			var r = e.stateNode;
			Fd(r, e.type, n, t), r[ot] = t;
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	function qc(e) {
		return e.tag === 5 || e.tag === 3 || e.tag === 26 || e.tag === 27 && Zd(e.type) || e.tag === 4;
	}
	function Jc(e) {
		a: for (;;) {
			for (; e.sibling === null;) {
				if (e.return === null || qc(e.return)) return null;
				e = e.return;
			}
			for (e.sibling.return = e.return, e = e.sibling; e.tag !== 5 && e.tag !== 6 && e.tag !== 18;) {
				if (e.tag === 27 && Zd(e.type) || e.flags & 2 || e.child === null || e.tag === 4) continue a;
				e.child.return = e, e = e.child;
			}
			if (!(e.flags & 2)) return e.stateNode;
		}
	}
	function Yc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(e, t) : (t = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, t.appendChild(e), n = n._reactRootContainer, n != null || t.onclick !== null || (t.onclick = Zt));
		else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode, t = null), e = e.child, e !== null)) for (Yc(e, t, n), e = e.sibling; e !== null;) Yc(e, t, n), e = e.sibling;
	}
	function Xc(e, t, n) {
		var r = e.tag;
		if (r === 5 || r === 6) e = e.stateNode, t ? n.insertBefore(e, t) : n.appendChild(e);
		else if (r !== 4 && (r === 27 && Zd(e.type) && (n = e.stateNode), e = e.child, e !== null)) for (Xc(e, t, n), e = e.sibling; e !== null;) Xc(e, t, n), e = e.sibling;
	}
	function Zc(e) {
		var t = e.stateNode, n = e.memoizedProps;
		try {
			for (var r = e.type, i = t.attributes; i.length;) t.removeAttributeNode(i[0]);
			Pd(t, r, n), t[at] = e, t[ot] = n;
		} catch (t) {
			Z(e, e.return, t);
		}
	}
	var Qc = !1, $c = !1, el = !1, tl = typeof WeakSet == "function" ? WeakSet : Set, nl = null;
	function rl(e, t) {
		if (e = e.containerInfo, Rd = sp, e = Tr(e), Er(e)) {
			if ("selectionStart" in e) var n = {
				start: e.selectionStart,
				end: e.selectionEnd
			};
			else a: {
				n = (n = e.ownerDocument) && n.defaultView || window;
				var r = n.getSelection && n.getSelection();
				if (r && r.rangeCount !== 0) {
					n = r.anchorNode;
					var i = r.anchorOffset, o = r.focusNode;
					r = r.focusOffset;
					try {
						n.nodeType, o.nodeType;
					} catch {
						n = null;
						break a;
					}
					var s = 0, c = -1, l = -1, u = 0, d = 0, f = e, p = null;
					b: for (;;) {
						for (var m; f !== n || i !== 0 && f.nodeType !== 3 || (c = s + i), f !== o || r !== 0 && f.nodeType !== 3 || (l = s + r), f.nodeType === 3 && (s += f.nodeValue.length), (m = f.firstChild) !== null;) p = f, f = m;
						for (;;) {
							if (f === e) break b;
							if (p === n && ++u === i && (c = s), p === o && ++d === r && (l = s), (m = f.nextSibling) !== null) break;
							f = p, p = f.parentNode;
						}
						f = m;
					}
					n = c === -1 || l === -1 ? null : {
						start: c,
						end: l
					};
				} else n = null;
			}
			n ||= {
				start: 0,
				end: 0
			};
		} else n = null;
		for (zd = {
			focusedElem: e,
			selectionRange: n
		}, sp = !1, nl = t; nl !== null;) if (t = nl, e = t.child, t.subtreeFlags & 1028 && e !== null) e.return = t, nl = e;
		else for (; nl !== null;) {
			switch (t = nl, o = t.alternate, e = t.flags, t.tag) {
				case 0:
					if (e & 4 && (e = t.updateQueue, e = e === null ? null : e.events, e !== null)) for (n = 0; n < e.length; n++) i = e[n], i.ref.impl = i.nextImpl;
					break;
				case 11:
				case 15: break;
				case 1:
					if (e & 1024 && o !== null) {
						e = void 0, n = t, i = o.memoizedProps, o = o.memoizedState, r = n.stateNode;
						try {
							var h = Us(n.type, i);
							e = r.getSnapshotBeforeUpdate(h, o), r.__reactInternalSnapshotBeforeUpdate = e;
						} catch (e) {
							Z(n, n.return, e);
						}
					}
					break;
				case 3:
					if (e & 1024) {
						if (e = t.stateNode.containerInfo, n = e.nodeType, n === 9) ef(e);
						else if (n === 1) switch (e.nodeName) {
							case "HEAD":
							case "HTML":
							case "BODY":
								ef(e);
								break;
							default: e.textContent = "";
						}
					}
					break;
				case 5:
				case 26:
				case 27:
				case 6:
				case 4:
				case 17: break;
				default: if (e & 1024) throw Error(a(163));
			}
			if (e = t.sibling, e !== null) {
				e.return = t.return, nl = e;
				break;
			}
			nl = t.return;
		}
	}
	function il(e, t, n) {
		var r = n.flags;
		switch (n.tag) {
			case 0:
			case 11:
			case 15:
				yl(e, n), r & 4 && zc(5, n);
				break;
			case 1:
				if (yl(e, n), r & 4) {
					if (e = n.stateNode, t === null) try {
						e.componentDidMount();
					} catch (e) {
						Z(n, n.return, e);
					}
					else {
						var i = Us(n.type, t.memoizedProps);
						t = t.memoizedState;
						try {
							e.componentDidUpdate(i, t, e.__reactInternalSnapshotBeforeUpdate);
						} catch (e) {
							Z(n, n.return, e);
						}
					}
				}
				r & 64 && Vc(n), r & 512 && Uc(n, n.return);
				break;
			case 3:
				if (yl(e, n), r & 64 && (e = n.updateQueue, e !== null)) {
					if (t = null, n.child !== null) switch (n.child.tag) {
						case 27:
						case 5:
							t = n.child.stateNode;
							break;
						case 1: t = n.child.stateNode;
					}
					try {
						Ga(e, t);
					} catch (e) {
						Z(n, n.return, e);
					}
				}
				break;
			case 27: t === null && r & 4 && Zc(n);
			case 26:
			case 5:
				yl(e, n), t === null && r & 4 && Gc(n), r & 512 && Uc(n, n.return);
				break;
			case 12:
				yl(e, n);
				break;
			case 31:
				yl(e, n), r & 4 && ul(e, n);
				break;
			case 13:
				yl(e, n), r & 4 && dl(e, n), r & 64 && (e = n.memoizedState, e !== null && (e = e.dehydrated, e !== null && (n = Ju.bind(null, n), sf(e, n))));
				break;
			case 22:
				if (r = n.memoizedState !== null || Qc, !r) {
					t = t !== null && t.memoizedState !== null || $c, i = Qc;
					var a = $c;
					Qc = r, ($c = t) && !a ? xl(e, n, !!(n.subtreeFlags & 8772)) : yl(e, n), Qc = i, $c = a;
				}
				break;
			case 30: break;
			default: yl(e, n);
		}
	}
	function al(e) {
		var t = e.alternate;
		t !== null && (e.alternate = null, al(t)), e.child = null, e.deletions = null, e.sibling = null, e.tag === 5 && (t = e.stateNode, t !== null && pt(t)), e.stateNode = null, e.return = null, e.dependencies = null, e.memoizedProps = null, e.memoizedState = null, e.pendingProps = null, e.stateNode = null, e.updateQueue = null;
	}
	var ol = null, sl = !1;
	function cl(e, t, n) {
		for (n = n.child; n !== null;) ll(e, t, n), n = n.sibling;
	}
	function ll(e, t, n) {
		if (Pe && typeof Pe.onCommitFiberUnmount == "function") try {
			Pe.onCommitFiberUnmount(Ne, n);
		} catch {}
		switch (n.tag) {
			case 26:
				$c || Wc(n, t), cl(e, t, n), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
				break;
			case 27:
				$c || Wc(n, t);
				var r = ol, i = sl;
				Zd(n.type) && (ol = n.stateNode, sl = !1), cl(e, t, n), pf(n.stateNode), ol = r, sl = i;
				break;
			case 5: $c || Wc(n, t);
			case 6:
				if (r = ol, i = sl, ol = null, cl(e, t, n), ol = r, sl = i, ol !== null) {
					if (sl) try {
						(ol.nodeType === 9 ? ol.body : ol.nodeName === "HTML" ? ol.ownerDocument.body : ol).removeChild(n.stateNode);
					} catch (e) {
						Z(n, t, e);
					}
					else try {
						ol.removeChild(n.stateNode);
					} catch (e) {
						Z(n, t, e);
					}
				}
				break;
			case 18:
				ol !== null && (sl ? (e = ol, Qd(e.nodeType === 9 ? e.body : e.nodeName === "HTML" ? e.ownerDocument.body : e, n.stateNode), Np(e)) : Qd(ol, n.stateNode));
				break;
			case 4:
				r = ol, i = sl, ol = n.stateNode.containerInfo, sl = !0, cl(e, t, n), ol = r, sl = i;
				break;
			case 0:
			case 11:
			case 14:
			case 15:
				Bc(2, n, t), $c || Bc(4, n, t), cl(e, t, n);
				break;
			case 1:
				$c || (Wc(n, t), r = n.stateNode, typeof r.componentWillUnmount == "function" && Hc(n, t, r)), cl(e, t, n);
				break;
			case 21:
				cl(e, t, n);
				break;
			case 22:
				$c = (r = $c) || n.memoizedState !== null, cl(e, t, n), $c = r;
				break;
			default: cl(e, t, n);
		}
	}
	function ul(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null))) {
			e = e.dehydrated;
			try {
				Np(e);
			} catch (e) {
				Z(t, t.return, e);
			}
		}
	}
	function dl(e, t) {
		if (t.memoizedState === null && (e = t.alternate, e !== null && (e = e.memoizedState, e !== null && (e = e.dehydrated, e !== null)))) try {
			Np(e);
		} catch (e) {
			Z(t, t.return, e);
		}
	}
	function fl(e) {
		switch (e.tag) {
			case 31:
			case 13:
			case 19:
				var t = e.stateNode;
				return t === null && (t = e.stateNode = new tl()), t;
			case 22: return e = e.stateNode, t = e._retryCache, t === null && (t = e._retryCache = new tl()), t;
			default: throw Error(a(435, e.tag));
		}
	}
	function pl(e, t) {
		var n = fl(e);
		t.forEach(function(t) {
			if (!n.has(t)) {
				n.add(t);
				var r = Yu.bind(null, e, t);
				t.then(r, r);
			}
		});
	}
	function ml(e, t) {
		var n = t.deletions;
		if (n !== null) for (var r = 0; r < n.length; r++) {
			var i = n[r], o = e, s = t, c = s;
			a: for (; c !== null;) {
				switch (c.tag) {
					case 27:
						if (Zd(c.type)) {
							ol = c.stateNode, sl = !1;
							break a;
						}
						break;
					case 5:
						ol = c.stateNode, sl = !1;
						break a;
					case 3:
					case 4:
						ol = c.stateNode.containerInfo, sl = !0;
						break a;
				}
				c = c.return;
			}
			if (ol === null) throw Error(a(160));
			ll(o, s, i), ol = null, sl = !1, o = i.alternate, o !== null && (o.return = null), i.return = null;
		}
		if (t.subtreeFlags & 13886) for (t = t.child; t !== null;) gl(t, e), t = t.sibling;
	}
	var hl = null;
	function gl(e, t) {
		var n = e.alternate, r = e.flags;
		switch (e.tag) {
			case 0:
			case 11:
			case 14:
			case 15:
				ml(t, e), _l(e), r & 4 && (Bc(3, e, e.return), zc(3, e), Bc(5, e, e.return));
				break;
			case 1:
				ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), r & 64 && Qc && (e = e.updateQueue, e !== null && (r = e.callbacks, r !== null && (n = e.shared.hiddenCallbacks, e.shared.hiddenCallbacks = n === null ? r : n.concat(r))));
				break;
			case 26:
				var i = hl;
				if (ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), r & 4) {
					var o = n === null ? null : n.memoizedState;
					if (r = e.memoizedState, n === null) {
						if (r === null) {
							if (e.stateNode === null) {
								a: {
									r = e.type, n = e.memoizedProps, i = i.ownerDocument || i;
									b: switch (r) {
										case "title":
											o = i.getElementsByTagName("title")[0], (!o || o[ft] || o[at] || o.namespaceURI === "http://www.w3.org/2000/svg" || o.hasAttribute("itemprop")) && (o = i.createElement(r), i.head.insertBefore(o, i.querySelector("head > title"))), Pd(o, r, n), o[at] = e, vt(o), r = o;
											break a;
										case "link":
											var s = Vf("link", "href", i).get(r + (n.href || ""));
											if (s) {
												for (var c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("href") === (n.href == null || n.href === "" ? null : n.href) && o.getAttribute("rel") === (n.rel == null ? null : n.rel) && o.getAttribute("title") === (n.title == null ? null : n.title) && o.getAttribute("crossorigin") === (n.crossOrigin == null ? null : n.crossOrigin)) {
													s.splice(c, 1);
													break b;
												}
											}
											o = i.createElement(r), Pd(o, r, n), i.head.appendChild(o);
											break;
										case "meta":
											if (s = Vf("meta", "content", i).get(r + (n.content || ""))) {
												for (c = 0; c < s.length; c++) if (o = s[c], o.getAttribute("content") === (n.content == null ? null : "" + n.content) && o.getAttribute("name") === (n.name == null ? null : n.name) && o.getAttribute("property") === (n.property == null ? null : n.property) && o.getAttribute("http-equiv") === (n.httpEquiv == null ? null : n.httpEquiv) && o.getAttribute("charset") === (n.charSet == null ? null : n.charSet)) {
													s.splice(c, 1);
													break b;
												}
											}
											o = i.createElement(r), Pd(o, r, n), i.head.appendChild(o);
											break;
										default: throw Error(a(468, r));
									}
									o[at] = e, vt(o), r = o;
								}
								e.stateNode = r;
							} else Hf(i, e.type, e.stateNode);
						} else e.stateNode = If(i, r, e.memoizedProps);
					} else o === r ? r === null && e.stateNode !== null && Kc(e, e.memoizedProps, n.memoizedProps) : (o === null ? n.stateNode !== null && (n = n.stateNode, n.parentNode.removeChild(n)) : o.count--, r === null ? Hf(i, e.type, e.stateNode) : If(i, r, e.memoizedProps));
				}
				break;
			case 27:
				ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), n !== null && r & 4 && Kc(e, e.memoizedProps, n.memoizedProps);
				break;
			case 5:
				if (ml(t, e), _l(e), r & 512 && ($c || n === null || Wc(n, n.return)), e.flags & 32) {
					i = e.stateNode;
					try {
						Ut(i, "");
					} catch (t) {
						Z(e, e.return, t);
					}
				}
				r & 4 && e.stateNode != null && (i = e.memoizedProps, Kc(e, i, n === null ? i : n.memoizedProps)), r & 1024 && (el = !0);
				break;
			case 6:
				if (ml(t, e), _l(e), r & 4) {
					if (e.stateNode === null) throw Error(a(162));
					r = e.memoizedProps, n = e.stateNode;
					try {
						n.nodeValue = r;
					} catch (t) {
						Z(e, e.return, t);
					}
				}
				break;
			case 3:
				if (Bf = null, i = hl, hl = gf(t.containerInfo), ml(t, e), hl = i, _l(e), r & 4 && n !== null && n.memoizedState.isDehydrated) try {
					Np(t.containerInfo);
				} catch (t) {
					Z(e, e.return, t);
				}
				el && (el = !1, vl(e));
				break;
			case 4:
				r = hl, hl = gf(e.stateNode.containerInfo), ml(t, e), _l(e), hl = r;
				break;
			case 12:
				ml(t, e), _l(e);
				break;
			case 31:
				ml(t, e), _l(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, pl(e, r)));
				break;
			case 13:
				ml(t, e), _l(e), e.child.flags & 8192 && e.memoizedState !== null != (n !== null && n.memoizedState !== null) && ($l = we()), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, pl(e, r)));
				break;
			case 22:
				i = e.memoizedState !== null;
				var l = n !== null && n.memoizedState !== null, u = Qc, d = $c;
				if (Qc = u || i, $c = d || l, ml(t, e), $c = d, Qc = u, _l(e), r & 8192) a: for (t = e.stateNode, t._visibility = i ? t._visibility & -2 : t._visibility | 1, i && (n === null || l || Qc || $c || bl(e)), n = null, t = e;;) {
					if (t.tag === 5 || t.tag === 26) {
						if (n === null) {
							l = n = t;
							try {
								if (o = l.stateNode, i) s = o.style, typeof s.setProperty == "function" ? s.setProperty("display", "none", "important") : s.display = "none";
								else {
									c = l.stateNode;
									var f = l.memoizedProps.style, p = f != null && f.hasOwnProperty("display") ? f.display : null;
									c.style.display = p == null || typeof p == "boolean" ? "" : ("" + p).trim();
								}
							} catch (e) {
								Z(l, l.return, e);
							}
						}
					} else if (t.tag === 6) {
						if (n === null) {
							l = t;
							try {
								l.stateNode.nodeValue = i ? "" : l.memoizedProps;
							} catch (e) {
								Z(l, l.return, e);
							}
						}
					} else if (t.tag === 18) {
						if (n === null) {
							l = t;
							try {
								var m = l.stateNode;
								i ? $d(m, !0) : $d(l.stateNode, !1);
							} catch (e) {
								Z(l, l.return, e);
							}
						}
					} else if ((t.tag !== 22 && t.tag !== 23 || t.memoizedState === null || t === e) && t.child !== null) {
						t.child.return = t, t = t.child;
						continue;
					}
					if (t === e) break a;
					for (; t.sibling === null;) {
						if (t.return === null || t.return === e) break a;
						n === t && (n = null), t = t.return;
					}
					n === t && (n = null), t.sibling.return = t.return, t = t.sibling;
				}
				r & 4 && (r = e.updateQueue, r !== null && (n = r.retryQueue, n !== null && (r.retryQueue = null, pl(e, n))));
				break;
			case 19:
				ml(t, e), _l(e), r & 4 && (r = e.updateQueue, r !== null && (e.updateQueue = null, pl(e, r)));
				break;
			case 30: break;
			case 21: break;
			default: ml(t, e), _l(e);
		}
	}
	function _l(e) {
		var t = e.flags;
		if (t & 2) {
			try {
				for (var n, r = e.return; r !== null;) {
					if (qc(r)) {
						n = r;
						break;
					}
					r = r.return;
				}
				if (n == null) throw Error(a(160));
				switch (n.tag) {
					case 27:
						var i = n.stateNode;
						Xc(e, Jc(e), i);
						break;
					case 5:
						var o = n.stateNode;
						n.flags & 32 && (Ut(o, ""), n.flags &= -33), Xc(e, Jc(e), o);
						break;
					case 3:
					case 4:
						var s = n.stateNode.containerInfo;
						Yc(e, Jc(e), s);
						break;
					default: throw Error(a(161));
				}
			} catch (t) {
				Z(e, e.return, t);
			}
			e.flags &= -3;
		}
		t & 4096 && (e.flags &= -4097);
	}
	function vl(e) {
		if (e.subtreeFlags & 1024) for (e = e.child; e !== null;) {
			var t = e;
			vl(t), t.tag === 5 && t.flags & 1024 && t.stateNode.reset(), e = e.sibling;
		}
	}
	function yl(e, t) {
		if (t.subtreeFlags & 8772) for (t = t.child; t !== null;) il(e, t.alternate, t), t = t.sibling;
	}
	function bl(e) {
		for (e = e.child; e !== null;) {
			var t = e;
			switch (t.tag) {
				case 0:
				case 11:
				case 14:
				case 15:
					Bc(4, t, t.return), bl(t);
					break;
				case 1:
					Wc(t, t.return);
					var n = t.stateNode;
					typeof n.componentWillUnmount == "function" && Hc(t, t.return, n), bl(t);
					break;
				case 27: pf(t.stateNode);
				case 26:
				case 5:
					Wc(t, t.return), bl(t);
					break;
				case 22:
					t.memoizedState === null && bl(t);
					break;
				case 30:
					bl(t);
					break;
				default: bl(t);
			}
			e = e.sibling;
		}
	}
	function xl(e, t, n) {
		for (n &&= !!(t.subtreeFlags & 8772), t = t.child; t !== null;) {
			var r = t.alternate, i = e, a = t, o = a.flags;
			switch (a.tag) {
				case 0:
				case 11:
				case 15:
					xl(i, a, n), zc(4, a);
					break;
				case 1:
					if (xl(i, a, n), r = a, i = r.stateNode, typeof i.componentDidMount == "function") try {
						i.componentDidMount();
					} catch (e) {
						Z(r, r.return, e);
					}
					if (r = a, i = r.updateQueue, i !== null) {
						var s = r.stateNode;
						try {
							var c = i.shared.hiddenCallbacks;
							if (c !== null) for (i.shared.hiddenCallbacks = null, i = 0; i < c.length; i++) Wa(c[i], s);
						} catch (e) {
							Z(r, r.return, e);
						}
					}
					n && o & 64 && Vc(a), Uc(a, a.return);
					break;
				case 27: Zc(a);
				case 26:
				case 5:
					xl(i, a, n), n && r === null && o & 4 && Gc(a), Uc(a, a.return);
					break;
				case 12:
					xl(i, a, n);
					break;
				case 31:
					xl(i, a, n), n && o & 4 && ul(i, a);
					break;
				case 13:
					xl(i, a, n), n && o & 4 && dl(i, a);
					break;
				case 22:
					a.memoizedState === null && xl(i, a, n), Uc(a, a.return);
					break;
				case 30: break;
				default: xl(i, a, n);
			}
			t = t.sibling;
		}
	}
	function Sl(e, t) {
		var n = null;
		e !== null && e.memoizedState !== null && e.memoizedState.cachePool !== null && (n = e.memoizedState.cachePool.pool), e = null, t.memoizedState !== null && t.memoizedState.cachePool !== null && (e = t.memoizedState.cachePool.pool), e !== n && (e != null && e.refCount++, n != null && ia(n));
	}
	function Cl(e, t) {
		e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ia(e));
	}
	function wl(e, t, n, r) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) Tl(e, t, n, r), t = t.sibling;
	}
	function Tl(e, t, n, r) {
		var i = t.flags;
		switch (t.tag) {
			case 0:
			case 11:
			case 15:
				wl(e, t, n, r), i & 2048 && zc(9, t);
				break;
			case 1:
				wl(e, t, n, r);
				break;
			case 3:
				wl(e, t, n, r), i & 2048 && (e = null, t.alternate !== null && (e = t.alternate.memoizedState.cache), t = t.memoizedState.cache, t !== e && (t.refCount++, e != null && ia(e)));
				break;
			case 12:
				if (i & 2048) {
					wl(e, t, n, r), e = t.stateNode;
					try {
						var a = t.memoizedProps, o = a.id, s = a.onPostCommit;
						typeof s == "function" && s(o, t.alternate === null ? "mount" : "update", e.passiveEffectDuration, -0);
					} catch (e) {
						Z(t, t.return, e);
					}
				} else wl(e, t, n, r);
				break;
			case 31:
				wl(e, t, n, r);
				break;
			case 13:
				wl(e, t, n, r);
				break;
			case 23: break;
			case 22:
				a = t.stateNode, o = t.alternate, t.memoizedState === null ? a._visibility & 2 ? wl(e, t, n, r) : (a._visibility |= 2, El(e, t, n, r, !!(t.subtreeFlags & 10256) || !1)) : a._visibility & 2 ? wl(e, t, n, r) : Dl(e, t), i & 2048 && Sl(o, t);
				break;
			case 24:
				wl(e, t, n, r), i & 2048 && Cl(t.alternate, t);
				break;
			default: wl(e, t, n, r);
		}
	}
	function El(e, t, n, r, i) {
		for (i &&= !!(t.subtreeFlags & 10256) || !1, t = t.child; t !== null;) {
			var a = e, o = t, s = n, c = r, l = o.flags;
			switch (o.tag) {
				case 0:
				case 11:
				case 15:
					El(a, o, s, c, i), zc(8, o);
					break;
				case 23: break;
				case 22:
					var u = o.stateNode;
					o.memoizedState === null ? (u._visibility |= 2, El(a, o, s, c, i)) : u._visibility & 2 ? El(a, o, s, c, i) : Dl(a, o), i && l & 2048 && Sl(o.alternate, o);
					break;
				case 24:
					El(a, o, s, c, i), i && l & 2048 && Cl(o.alternate, o);
					break;
				default: El(a, o, s, c, i);
			}
			t = t.sibling;
		}
	}
	function Dl(e, t) {
		if (t.subtreeFlags & 10256) for (t = t.child; t !== null;) {
			var n = e, r = t, i = r.flags;
			switch (r.tag) {
				case 22:
					Dl(n, r), i & 2048 && Sl(r.alternate, r);
					break;
				case 24:
					Dl(n, r), i & 2048 && Cl(r.alternate, r);
					break;
				default: Dl(n, r);
			}
			t = t.sibling;
		}
	}
	var Ol = 8192;
	function kl(e, t, n) {
		if (e.subtreeFlags & Ol) for (e = e.child; e !== null;) Al(e, t, n), e = e.sibling;
	}
	function Al(e, t, n) {
		switch (e.tag) {
			case 26:
				kl(e, t, n), e.flags & Ol && e.memoizedState !== null && Gf(n, hl, e.memoizedState, e.memoizedProps);
				break;
			case 5:
				kl(e, t, n);
				break;
			case 3:
			case 4:
				var r = hl;
				hl = gf(e.stateNode.containerInfo), kl(e, t, n), hl = r;
				break;
			case 22:
				e.memoizedState === null && (r = e.alternate, r !== null && r.memoizedState !== null ? (r = Ol, Ol = 16777216, kl(e, t, n), Ol = r) : kl(e, t, n));
				break;
			default: kl(e, t, n);
		}
	}
	function jl(e) {
		var t = e.alternate;
		if (t !== null && (e = t.child, e !== null)) {
			t.child = null;
			do
				t = e.sibling, e.sibling = null, e = t;
			while (e !== null);
		}
	}
	function Ml(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				nl = r, Fl(r, e);
			}
			jl(e);
		}
		if (e.subtreeFlags & 10256) for (e = e.child; e !== null;) Nl(e), e = e.sibling;
	}
	function Nl(e) {
		switch (e.tag) {
			case 0:
			case 11:
			case 15:
				Ml(e), e.flags & 2048 && Bc(9, e, e.return);
				break;
			case 3:
				Ml(e);
				break;
			case 12:
				Ml(e);
				break;
			case 22:
				var t = e.stateNode;
				e.memoizedState !== null && t._visibility & 2 && (e.return === null || e.return.tag !== 13) ? (t._visibility &= -3, Pl(e)) : Ml(e);
				break;
			default: Ml(e);
		}
	}
	function Pl(e) {
		var t = e.deletions;
		if (e.flags & 16) {
			if (t !== null) for (var n = 0; n < t.length; n++) {
				var r = t[n];
				nl = r, Fl(r, e);
			}
			jl(e);
		}
		for (e = e.child; e !== null;) {
			switch (t = e, t.tag) {
				case 0:
				case 11:
				case 15:
					Bc(8, t, t.return), Pl(t);
					break;
				case 22:
					n = t.stateNode, n._visibility & 2 && (n._visibility &= -3, Pl(t));
					break;
				default: Pl(t);
			}
			e = e.sibling;
		}
	}
	function Fl(e, t) {
		for (; nl !== null;) {
			var n = nl;
			switch (n.tag) {
				case 0:
				case 11:
				case 15:
					Bc(8, n, t);
					break;
				case 23:
				case 22:
					if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
						var r = n.memoizedState.cachePool.pool;
						r != null && r.refCount++;
					}
					break;
				case 24: ia(n.memoizedState.cache);
			}
			if (r = n.child, r !== null) r.return = n, nl = r;
			else a: for (n = e; nl !== null;) {
				r = nl;
				var i = r.sibling, a = r.return;
				if (al(r), r === n) {
					nl = null;
					break a;
				}
				if (i !== null) {
					i.return = a, nl = i;
					break a;
				}
				nl = a;
			}
		}
	}
	var Il = {
		getCacheForType: function(e) {
			var t = Xi(na), n = t.data.get(e);
			return n === void 0 && (n = e(), t.data.set(e, n)), n;
		},
		cacheSignal: function() {
			return Xi(na).controller.signal;
		}
	}, Ll = typeof WeakMap == "function" ? WeakMap : Map, q = 0, Rl = null, J = null, Y = 0, X = 0, zl = null, Bl = !1, Vl = !1, Hl = !1, Ul = 0, Wl = 0, Gl = 0, Kl = 0, ql = 0, Jl = 0, Yl = 0, Xl = null, Zl = null, Ql = !1, $l = 0, eu = 0, tu = Infinity, nu = null, ru = null, iu = 0, au = null, ou = null, su = 0, cu = 0, lu = null, uu = null, du = 0, fu = null;
	function pu() {
		return q & 2 && Y !== 0 ? Y & -Y : O.T === null ? nt() : dd();
	}
	function mu() {
		if (Jl === 0) {
			if (!(Y & 536870912) || W) {
				var e = Ve;
				Ve <<= 1, !(Ve & 3932160) && (Ve = 262144), Jl = e;
			} else Jl = 536870912;
		}
		return e = Za.current, e !== null && (e.flags |= 32), Jl;
	}
	function hu(e, t, n) {
		(e === Rl && (X === 2 || X === 9) || e.cancelPendingCommit !== null) && (Su(e, 0), yu(e, Y, Jl, !1)), Ye(e, n), (!(q & 2) || e !== Rl) && (e === Rl && (!(q & 2) && (Kl |= n), Wl === 4 && yu(e, Y, Jl, !1)), rd(e));
	}
	function gu(e, t, n) {
		if (q & 6) throw Error(a(327));
		var r = !n && !(t & 127) && (t & e.expiredLanes) === 0 || Ge(e, t), i = r ? Au(e, t) : Ou(e, t, !0), o = r;
		do {
			if (i === 0) {
				Vl && !r && yu(e, t, 0, !1);
				break;
			}
			if (n = e.current.alternate, o && !vu(n)) {
				i = Ou(e, t, !1), o = !1;
				continue;
			}
			if (i === 2) {
				if (o = t, e.errorRecoveryDisabledLanes & o) var s = 0;
				else s = e.pendingLanes & -536870913, s = s === 0 ? s & 536870912 ? 536870912 : 0 : s;
				if (s !== 0) {
					t = s;
					a: {
						var c = e;
						i = Xl;
						var l = c.current.memoizedState.isDehydrated;
						if (l && (Su(c, s).flags |= 256), s = Ou(c, s, !1), s !== 2) {
							if (Hl && !l) {
								c.errorRecoveryDisabledLanes |= o, Kl |= o, i = 4;
								break a;
							}
							o = Zl, Zl = i, o !== null && (Zl === null ? Zl = o : Zl.push.apply(Zl, o));
						}
						i = s;
					}
					if (o = !1, i !== 2) continue;
				}
			}
			if (i === 1) {
				Su(e, 0), yu(e, t, 0, !0);
				break;
			}
			a: {
				switch (r = e, o = i, o) {
					case 0:
					case 1: throw Error(a(345));
					case 4: if ((t & 4194048) !== t) break;
					case 6:
						yu(r, t, Jl, !Bl);
						break a;
					case 2:
						Zl = null;
						break;
					case 3:
					case 5: break;
					default: throw Error(a(329));
				}
				if ((t & 62914560) === t && (i = $l + 300 - we(), 10 < i)) {
					if (yu(r, t, Jl, !Bl), We(r, 0, !0) !== 0) break a;
					su = t, r.timeoutHandle = Kd(_u.bind(null, r, n, Zl, nu, Ql, t, Jl, Kl, Yl, Bl, o, "Throttled", -0, 0), i);
					break a;
				}
				_u(r, n, Zl, nu, Ql, t, Jl, Kl, Yl, Bl, o, null, -0, 0);
			}
			break;
		} while (1);
		rd(e);
	}
	function _u(e, t, n, r, i, a, o, s, c, l, u, d, f, p) {
		if (e.timeoutHandle = -1, d = t.subtreeFlags, d & 8192 || (d & 16785408) == 16785408) {
			d = {
				stylesheets: null,
				count: 0,
				imgCount: 0,
				imgBytes: 0,
				suspenseyImages: [],
				waitingForImages: !0,
				waitingForViewTransition: !1,
				unsuspend: Zt
			}, Al(t, a, d);
			var m = (a & 62914560) === a ? $l - we() : (a & 4194048) === a ? eu - we() : 0;
			if (m = qf(d, m), m !== null) {
				su = a, e.cancelPendingCommit = m(Lu.bind(null, e, t, a, n, r, i, o, s, c, u, d, null, f, p)), yu(e, a, o, !l);
				return;
			}
		}
		Lu(e, t, a, n, r, i, o, s, c);
	}
	function vu(e) {
		for (var t = e;;) {
			var n = t.tag;
			if ((n === 0 || n === 11 || n === 15) && t.flags & 16384 && (n = t.updateQueue, n !== null && (n = n.stores, n !== null))) for (var r = 0; r < n.length; r++) {
				var i = n[r], a = i.getSnapshot;
				i = i.value;
				try {
					if (!br(a(), i)) return !1;
				} catch {
					return !1;
				}
			}
			if (n = t.child, t.subtreeFlags & 16384 && n !== null) n.return = t, t = n;
			else {
				if (t === e) break;
				for (; t.sibling === null;) {
					if (t.return === null || t.return === e) return !0;
					t = t.return;
				}
				t.sibling.return = t.return, t = t.sibling;
			}
		}
		return !0;
	}
	function yu(e, t, n, r) {
		t &= ~ql, t &= ~Kl, e.suspendedLanes |= t, e.pingedLanes &= ~t, r && (e.warmLanes |= t), r = e.expirationTimes;
		for (var i = t; 0 < i;) {
			var a = 31 - Ie(i), o = 1 << a;
			r[a] = -1, i &= ~o;
		}
		n !== 0 && Ze(e, n, t);
	}
	function bu() {
		return q & 6 ? !0 : (id(0, !1), !1);
	}
	function xu() {
		if (J !== null) {
			if (X === 0) var e = J.return;
			else e = J, Hi = Vi = null, To(e), Da = null, G = 0, e = J;
			for (; e !== null;) Rc(e.alternate, e), e = e.return;
			J = null;
		}
	}
	function Su(e, t) {
		var n = e.timeoutHandle;
		n !== -1 && (e.timeoutHandle = -1, qd(n)), n = e.cancelPendingCommit, n !== null && (e.cancelPendingCommit = null, n()), su = 0, xu(), Rl = e, J = n = ci(e.current, null), Y = t, X = 0, zl = null, Bl = !1, Vl = Ge(e, t), Hl = !1, Yl = Jl = ql = Kl = Gl = Wl = 0, Zl = Xl = null, Ql = !1, t & 8 && (t |= t & 32);
		var r = e.entangledLanes;
		if (r !== 0) for (e = e.entanglements, r &= t; 0 < r;) {
			var i = 31 - Ie(r), a = 1 << i;
			t |= e[i], r &= ~a;
		}
		return Ul = t, Qr(), n;
	}
	function Cu(e, t) {
		K = null, O.H = Fs, t === _a || t === ya ? (t = Ta(), X = 3) : t === va ? (t = Ta(), X = 4) : X = t === $s ? 8 : typeof t == "object" && t && typeof t.then == "function" ? 6 : 1, zl = t, J === null && (Wl = 1, qs(e, hi(t, e.current)));
	}
	function wu() {
		var e = Za.current;
		return e === null ? !0 : (Y & 4194048) === Y ? Qa === null : (Y & 62914560) === Y || Y & 536870912 ? e === Qa : !1;
	}
	function Tu() {
		var e = O.H;
		return O.H = Fs, e === null ? Fs : e;
	}
	function Eu() {
		var e = O.A;
		return O.A = Il, e;
	}
	function Du() {
		Wl = 4, Bl || (Y & 4194048) !== Y && Za.current !== null || (Vl = !0), !(Gl & 134217727) && !(Kl & 134217727) || Rl === null || yu(Rl, Y, Jl, !1);
	}
	function Ou(e, t, n) {
		var r = q;
		q |= 2;
		var i = Tu(), a = Eu();
		(Rl !== e || Y !== t) && (nu = null, Su(e, t)), t = !1;
		var o = Wl;
		a: do
			try {
				if (X !== 0 && J !== null) {
					var s = J, c = zl;
					switch (X) {
						case 8:
							xu(), o = 6;
							break a;
						case 3:
						case 2:
						case 9:
						case 6:
							Za.current === null && (t = !0);
							var l = X;
							if (X = 0, zl = null, Pu(e, s, c, l), n && Vl) {
								o = 0;
								break a;
							}
							break;
						default: l = X, X = 0, zl = null, Pu(e, s, c, l);
					}
				}
				ku(), o = Wl;
				break;
			} catch (t) {
				Cu(e, t);
			}
		while (1);
		return t && e.shellSuspendCounter++, Hi = Vi = null, q = r, O.H = i, O.A = a, J === null && (Rl = null, Y = 0, Qr()), o;
	}
	function ku() {
		for (; J !== null;) Mu(J);
	}
	function Au(e, t) {
		var n = q;
		q |= 2;
		var r = Tu(), i = Eu();
		Rl !== e || Y !== t ? (nu = null, tu = we() + 500, Su(e, t)) : Vl = Ge(e, t);
		a: do
			try {
				if (X !== 0 && J !== null) {
					t = J;
					var o = zl;
					b: switch (X) {
						case 1:
							X = 0, zl = null, Pu(e, t, o, 1);
							break;
						case 2:
						case 9:
							if (xa(o)) {
								X = 0, zl = null, Nu(t);
								break;
							}
							t = function() {
								X !== 2 && X !== 9 || Rl !== e || (X = 7), rd(e);
							}, o.then(t, t);
							break a;
						case 3:
							X = 7;
							break a;
						case 4:
							X = 5;
							break a;
						case 7:
							xa(o) ? (X = 0, zl = null, Nu(t)) : (X = 0, zl = null, Pu(e, t, o, 7));
							break;
						case 5:
							var s = null;
							switch (J.tag) {
								case 26: s = J.memoizedState;
								case 5:
								case 27:
									var c = J;
									if (s ? Wf(s) : c.stateNode.complete) {
										X = 0, zl = null;
										var l = c.sibling;
										if (l !== null) J = l;
										else {
											var u = c.return;
											u === null ? J = null : (J = u, Fu(u));
										}
										break b;
									}
							}
							X = 0, zl = null, Pu(e, t, o, 5);
							break;
						case 6:
							X = 0, zl = null, Pu(e, t, o, 6);
							break;
						case 8:
							xu(), Wl = 6;
							break a;
						default: throw Error(a(462));
					}
				}
				ju();
				break;
			} catch (t) {
				Cu(e, t);
			}
		while (1);
		return Hi = Vi = null, O.H = r, O.A = i, q = n, J === null ? (Rl = null, Y = 0, Qr(), Wl) : 0;
	}
	function ju() {
		for (; J !== null && !Ce();) Mu(J);
	}
	function Mu(e) {
		var t = kc(e.alternate, e, Ul);
		e.memoizedProps = e.pendingProps, t === null ? Fu(e) : J = t;
	}
	function Nu(e) {
		var t = e, n = t.alternate;
		switch (t.tag) {
			case 15:
			case 0:
				t = pc(n, t, t.pendingProps, t.type, void 0, Y);
				break;
			case 11:
				t = pc(n, t, t.pendingProps, t.type.render, t.ref, Y);
				break;
			case 5: To(t);
			default: Rc(n, t), t = J = li(t, Ul), t = kc(n, t, Ul);
		}
		e.memoizedProps = e.pendingProps, t === null ? Fu(e) : J = t;
	}
	function Pu(e, t, n, r) {
		Hi = Vi = null, To(t), Da = null, G = 0;
		var i = t.return;
		try {
			if (Qs(e, i, t, n, Y)) {
				Wl = 1, qs(e, hi(n, e.current)), J = null;
				return;
			}
		} catch (t) {
			if (i !== null) throw J = i, t;
			Wl = 1, qs(e, hi(n, e.current)), J = null;
			return;
		}
		t.flags & 32768 ? (W || r === 1 ? e = !0 : Vl || Y & 536870912 ? e = !1 : (Bl = e = !0, (r === 2 || r === 9 || r === 3 || r === 6) && (r = Za.current, r !== null && r.tag === 13 && (r.flags |= 16384))), Iu(t, e)) : Fu(t);
	}
	function Fu(e) {
		var t = e;
		do {
			if (t.flags & 32768) {
				Iu(t, Bl);
				return;
			}
			e = t.return;
			var n = Ic(t.alternate, t, Ul);
			if (n !== null) {
				J = n;
				return;
			}
			if (t = t.sibling, t !== null) {
				J = t;
				return;
			}
			J = t = e;
		} while (t !== null);
		Wl === 0 && (Wl = 5);
	}
	function Iu(e, t) {
		do {
			var n = Lc(e.alternate, e);
			if (n !== null) {
				n.flags &= 32767, J = n;
				return;
			}
			if (n = e.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !t && (e = e.sibling, e !== null)) {
				J = e;
				return;
			}
			J = e = n;
		} while (e !== null);
		Wl = 6, J = null;
	}
	function Lu(e, t, n, r, i, o, s, c, l) {
		e.cancelPendingCommit = null;
		do
			Hu();
		while (iu !== 0);
		if (q & 6) throw Error(a(327));
		if (t !== null) {
			if (t === e.current) throw Error(a(177));
			if (o = t.lanes | t.childLanes, o |= Zr, Xe(e, n, o, s, c, l), e === Rl && (J = Rl = null, Y = 0), ou = t, au = e, su = n, cu = o, lu = i, uu = r, t.subtreeFlags & 10256 || t.flags & 10256 ? (e.callbackNode = null, e.callbackPriority = 0, Xu(Oe, function() {
				return Uu(), null;
			})) : (e.callbackNode = null, e.callbackPriority = 0), r = !!(t.flags & 13878), t.subtreeFlags & 13878 || r) {
				r = O.T, O.T = null, i = k.p, k.p = 2, s = q, q |= 4;
				try {
					rl(e, t, n);
				} finally {
					q = s, k.p = i, O.T = r;
				}
			}
			iu = 1, Ru(), zu(), Bu();
		}
	}
	function Ru() {
		if (iu === 1) {
			iu = 0;
			var e = au, t = ou, n = !!(t.flags & 13878);
			if (t.subtreeFlags & 13878 || n) {
				n = O.T, O.T = null;
				var r = k.p;
				k.p = 2;
				var i = q;
				q |= 4;
				try {
					gl(t, e);
					var a = zd, o = Tr(e.containerInfo), s = a.focusedElem, c = a.selectionRange;
					if (o !== s && s && s.ownerDocument && wr(s.ownerDocument.documentElement, s)) {
						if (c !== null && Er(s)) {
							var l = c.start, u = c.end;
							if (u === void 0 && (u = l), "selectionStart" in s) s.selectionStart = l, s.selectionEnd = Math.min(u, s.value.length);
							else {
								var d = s.ownerDocument || document, f = d && d.defaultView || window;
								if (f.getSelection) {
									var p = f.getSelection(), m = s.textContent.length, h = Math.min(c.start, m), g = c.end === void 0 ? h : Math.min(c.end, m);
									!p.extend && h > g && (o = g, g = h, h = o);
									var _ = Cr(s, h), v = Cr(s, g);
									if (_ && v && (p.rangeCount !== 1 || p.anchorNode !== _.node || p.anchorOffset !== _.offset || p.focusNode !== v.node || p.focusOffset !== v.offset)) {
										var y = d.createRange();
										y.setStart(_.node, _.offset), p.removeAllRanges(), h > g ? (p.addRange(y), p.extend(v.node, v.offset)) : (y.setEnd(v.node, v.offset), p.addRange(y));
									}
								}
							}
						}
						for (d = [], p = s; p = p.parentNode;) p.nodeType === 1 && d.push({
							element: p,
							left: p.scrollLeft,
							top: p.scrollTop
						});
						for (typeof s.focus == "function" && s.focus(), s = 0; s < d.length; s++) {
							var b = d[s];
							b.element.scrollLeft = b.left, b.element.scrollTop = b.top;
						}
					}
					sp = !!Rd, zd = Rd = null;
				} finally {
					q = i, k.p = r, O.T = n;
				}
			}
			e.current = t, iu = 2;
		}
	}
	function zu() {
		if (iu === 2) {
			iu = 0;
			var e = au, t = ou, n = !!(t.flags & 8772);
			if (t.subtreeFlags & 8772 || n) {
				n = O.T, O.T = null;
				var r = k.p;
				k.p = 2;
				var i = q;
				q |= 4;
				try {
					il(e, t.alternate, t);
				} finally {
					q = i, k.p = r, O.T = n;
				}
			}
			iu = 3;
		}
	}
	function Bu() {
		if (iu === 4 || iu === 3) {
			iu = 0, z();
			var e = au, t = ou, n = su, r = uu;
			t.subtreeFlags & 10256 || t.flags & 10256 ? iu = 5 : (iu = 0, ou = au = null, Vu(e, e.pendingLanes));
			var i = e.pendingLanes;
			if (i === 0 && (ru = null), tt(n), t = t.stateNode, Pe && typeof Pe.onCommitFiberRoot == "function") try {
				Pe.onCommitFiberRoot(Ne, t, void 0, (t.current.flags & 128) == 128);
			} catch {}
			if (r !== null) {
				t = O.T, i = k.p, k.p = 2, O.T = null;
				try {
					for (var a = e.onRecoverableError, o = 0; o < r.length; o++) {
						var s = r[o];
						a(s.value, { componentStack: s.stack });
					}
				} finally {
					O.T = t, k.p = i;
				}
			}
			su & 3 && Hu(), rd(e), i = e.pendingLanes, n & 261930 && i & 42 ? e === fu ? du++ : (du = 0, fu = e) : du = 0, id(0, !1);
		}
	}
	function Vu(e, t) {
		(e.pooledCacheLanes &= t) === 0 && (t = e.pooledCache, t != null && (e.pooledCache = null, ia(t)));
	}
	function Hu() {
		return Ru(), zu(), Bu(), Uu();
	}
	function Uu() {
		if (iu !== 5) return !1;
		var e = au, t = cu;
		cu = 0;
		var n = tt(su), r = O.T, i = k.p;
		try {
			k.p = 32 > n ? 32 : n, O.T = null, n = lu, lu = null;
			var o = au, s = su;
			if (iu = 0, ou = au = null, su = 0, q & 6) throw Error(a(331));
			var c = q;
			if (q |= 4, Nl(o.current), Tl(o, o.current, s, n), q = c, id(0, !1), Pe && typeof Pe.onPostCommitFiberRoot == "function") try {
				Pe.onPostCommitFiberRoot(Ne, o);
			} catch {}
			return !0;
		} finally {
			k.p = i, O.T = r, Vu(e, t);
		}
	}
	function Wu(e, t, n) {
		t = hi(n, t), t = Ys(e.stateNode, t, 2), e = Ra(e, t, 2), e !== null && (Ye(e, 2), rd(e));
	}
	function Z(e, t, n) {
		if (e.tag === 3) Wu(e, e, n);
		else for (; t !== null;) {
			if (t.tag === 3) {
				Wu(t, e, n);
				break;
			}
			if (t.tag === 1) {
				var r = t.stateNode;
				if (typeof t.type.getDerivedStateFromError == "function" || typeof r.componentDidCatch == "function" && (ru === null || !ru.has(r))) {
					e = hi(n, e), n = Xs(2), r = Ra(t, n, 2), r !== null && (Zs(n, r, t, e), Ye(r, 2), rd(r));
					break;
				}
			}
			t = t.return;
		}
	}
	function Gu(e, t, n) {
		var r = e.pingCache;
		if (r === null) {
			r = e.pingCache = new Ll();
			var i = /* @__PURE__ */ new Set();
			r.set(t, i);
		} else i = r.get(t), i === void 0 && (i = /* @__PURE__ */ new Set(), r.set(t, i));
		i.has(n) || (Hl = !0, i.add(n), e = Ku.bind(null, e, t, n), t.then(e, e));
	}
	function Ku(e, t, n) {
		var r = e.pingCache;
		r !== null && r.delete(t), e.pingedLanes |= e.suspendedLanes & n, e.warmLanes &= ~n, Rl === e && (Y & n) === n && (Wl === 4 || Wl === 3 && (Y & 62914560) === Y && 300 > we() - $l ? !(q & 2) && Su(e, 0) : ql |= n, Yl === Y && (Yl = 0)), rd(e);
	}
	function qu(e, t) {
		t === 0 && (t = qe()), e = ti(e, t), e !== null && (Ye(e, t), rd(e));
	}
	function Ju(e) {
		var t = e.memoizedState, n = 0;
		t !== null && (n = t.retryLane), qu(e, n);
	}
	function Yu(e, t) {
		var n = 0;
		switch (e.tag) {
			case 31:
			case 13:
				var r = e.stateNode, i = e.memoizedState;
				i !== null && (n = i.retryLane);
				break;
			case 19:
				r = e.stateNode;
				break;
			case 22:
				r = e.stateNode._retryCache;
				break;
			default: throw Error(a(314));
		}
		r !== null && r.delete(t), qu(e, n);
	}
	function Xu(e, t) {
		return Se(e, t);
	}
	var Zu = null, Qu = null, $u = !1, ed = !1, td = !1, nd = 0;
	function rd(e) {
		e !== Qu && e.next === null && (Qu === null ? Zu = Qu = e : Qu = Qu.next = e), ed = !0, $u || ($u = !0, ud());
	}
	function id(e, t) {
		if (!td && ed) {
			td = !0;
			do
				for (var n = !1, r = Zu; r !== null;) {
					if (!t) {
						if (e !== 0) {
							var i = r.pendingLanes;
							if (i === 0) var a = 0;
							else {
								var o = r.suspendedLanes, s = r.pingedLanes;
								a = (1 << 31 - Ie(42 | e) + 1) - 1, a &= i & ~(o & ~s), a = a & 201326741 ? a & 201326741 | 1 : a ? a | 2 : 0;
							}
							a !== 0 && (n = !0, ld(r, a));
						} else a = Y, a = We(r, r === Rl ? a : 0, r.cancelPendingCommit !== null || r.timeoutHandle !== -1), !(a & 3) || Ge(r, a) || (n = !0, ld(r, a));
					}
					r = r.next;
				}
			while (n);
			td = !1;
		}
	}
	function ad() {
		od();
	}
	function od() {
		ed = $u = !1;
		var e = 0;
		nd !== 0 && Gd() && (e = nd);
		for (var t = we(), n = null, r = Zu; r !== null;) {
			var i = r.next, a = sd(r, t);
			a === 0 ? (r.next = null, n === null ? Zu = i : n.next = i, i === null && (Qu = n)) : (n = r, (e !== 0 || a & 3) && (ed = !0)), r = i;
		}
		iu !== 0 && iu !== 5 || id(e, !1), nd !== 0 && (nd = 0);
	}
	function sd(e, t) {
		for (var n = e.suspendedLanes, r = e.pingedLanes, i = e.expirationTimes, a = e.pendingLanes & -62914561; 0 < a;) {
			var o = 31 - Ie(a), s = 1 << o, c = i[o];
			c === -1 ? ((s & n) === 0 || (s & r) !== 0) && (i[o] = Ke(s, t)) : c <= t && (e.expiredLanes |= s), a &= ~s;
		}
		if (t = Rl, n = Y, n = We(e, e === t ? n : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r = e.callbackNode, n === 0 || e === t && (X === 2 || X === 9) || e.cancelPendingCommit !== null) return r !== null && r !== null && R(r), e.callbackNode = null, e.callbackPriority = 0;
		if (!(n & 3) || Ge(e, n)) {
			if (t = n & -n, t === e.callbackPriority) return t;
			switch (r !== null && R(r), tt(n)) {
				case 2:
				case 8:
					n = De;
					break;
				case 32:
					n = Oe;
					break;
				case 268435456:
					n = Ae;
					break;
				default: n = Oe;
			}
			return r = cd.bind(null, e), n = Se(n, r), e.callbackPriority = t, e.callbackNode = n, t;
		}
		return r !== null && r !== null && R(r), e.callbackPriority = 2, e.callbackNode = null, 2;
	}
	function cd(e, t) {
		if (iu !== 0 && iu !== 5) return e.callbackNode = null, e.callbackPriority = 0, null;
		var n = e.callbackNode;
		if (Hu() && e.callbackNode !== n) return null;
		var r = Y;
		return r = We(e, e === Rl ? r : 0, e.cancelPendingCommit !== null || e.timeoutHandle !== -1), r === 0 ? null : (gu(e, r, t), sd(e, we()), e.callbackNode != null && e.callbackNode === n ? cd.bind(null, e) : null);
	}
	function ld(e, t) {
		if (Hu()) return null;
		gu(e, t, !0);
	}
	function ud() {
		Yd(function() {
			q & 6 ? Se(Ee, ad) : od();
		});
	}
	function dd() {
		if (nd === 0) {
			var e = sa;
			e === 0 && (e = Be, Be <<= 1, !(Be & 261888) && (Be = 256)), nd = e;
		}
		return nd;
	}
	function fd(e) {
		return e == null || typeof e == "symbol" || typeof e == "boolean" ? null : typeof e == "function" ? e : Xt("" + e);
	}
	function pd(e, t) {
		var n = t.ownerDocument.createElement("input");
		return n.name = t.name, n.value = t.value, e.id && n.setAttribute("form", e.id), t.parentNode.insertBefore(n, t), e = new FormData(e), n.parentNode.removeChild(n), e;
	}
	function md(e, t, n, r, i) {
		if (t === "submit" && n && n.stateNode === i) {
			var a = fd((i[ot] || null).action), o = r.submitter;
			o && (t = (t = o[ot] || null) ? fd(t.formAction) : o.getAttribute("formAction"), t !== null && (a = t, o = null));
			var s = new yn("action", "action", null, r, i);
			e.push({
				event: s,
				listeners: [{
					instance: null,
					listener: function() {
						if (r.defaultPrevented) {
							if (nd !== 0) {
								var e = o ? pd(i, o) : new FormData(i);
								xs(n, {
									pending: !0,
									data: e,
									method: i.method,
									action: a
								}, null, e);
							}
						} else typeof a == "function" && (s.preventDefault(), e = o ? pd(i, o) : new FormData(i), xs(n, {
							pending: !0,
							data: e,
							method: i.method,
							action: a
						}, a, e));
					},
					currentTarget: i
				}]
			});
		}
	}
	for (var hd = 0; hd < Kr.length; hd++) {
		var gd = Kr[hd];
		qr(gd.toLowerCase(), "on" + (gd[0].toUpperCase() + gd.slice(1)));
	}
	qr(Rr, "onAnimationEnd"), qr(zr, "onAnimationIteration"), qr(Br, "onAnimationStart"), qr("dblclick", "onDoubleClick"), qr("focusin", "onFocus"), qr("focusout", "onBlur"), qr(Vr, "onTransitionRun"), qr(Hr, "onTransitionStart"), qr(Ur, "onTransitionCancel"), qr(Wr, "onTransitionEnd"), St("onMouseEnter", ["mouseout", "mouseover"]), St("onMouseLeave", ["mouseout", "mouseover"]), St("onPointerEnter", ["pointerout", "pointerover"]), St("onPointerLeave", ["pointerout", "pointerover"]), xt("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), xt("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), xt("onBeforeInput", [
		"compositionend",
		"keypress",
		"textInput",
		"paste"
	]), xt("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), xt("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), xt("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
	var _d = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), vd = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(_d));
	function yd(e, t) {
		t = !!(t & 4);
		for (var n = 0; n < e.length; n++) {
			var r = e[n], i = r.event;
			r = r.listeners;
			a: {
				var a = void 0;
				if (t) for (var o = r.length - 1; 0 <= o; o--) {
					var s = r[o], c = s.instance, l = s.currentTarget;
					if (s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						Jr(e);
					}
					i.currentTarget = null, a = c;
				}
				else for (o = 0; o < r.length; o++) {
					if (s = r[o], c = s.instance, l = s.currentTarget, s = s.listener, c !== a && i.isPropagationStopped()) break a;
					a = s, i.currentTarget = l;
					try {
						a(i);
					} catch (e) {
						Jr(e);
					}
					i.currentTarget = null, a = c;
				}
			}
		}
	}
	function Q(e, t) {
		var n = t[ct];
		n === void 0 && (n = t[ct] = /* @__PURE__ */ new Set());
		var r = e + "__bubble";
		n.has(r) || (Cd(t, e, 2, !1), n.add(r));
	}
	function bd(e, t, n) {
		var r = 0;
		t && (r |= 4), Cd(n, e, r, t);
	}
	var xd = "_reactListening" + Math.random().toString(36).slice(2);
	function Sd(e) {
		if (!e[xd]) {
			e[xd] = !0, yt.forEach(function(t) {
				t !== "selectionchange" && (vd.has(t) || bd(t, !1, e), bd(t, !0, e));
			});
			var t = e.nodeType === 9 ? e : e.ownerDocument;
			t === null || t[xd] || (t[xd] = !0, bd("selectionchange", !1, t));
		}
	}
	function Cd(e, t, n, r) {
		switch (mp(t)) {
			case 2:
				var i = cp;
				break;
			case 8:
				i = lp;
				break;
			default: i = up;
		}
		n = i.bind(null, t, n, e), i = void 0, !cn || t !== "touchstart" && t !== "touchmove" && t !== "wheel" || (i = !0), r ? i === void 0 ? e.addEventListener(t, n, !0) : e.addEventListener(t, n, {
			capture: !0,
			passive: i
		}) : i === void 0 ? e.addEventListener(t, n, !1) : e.addEventListener(t, n, { passive: i });
	}
	function wd(e, t, n, r, i) {
		var a = r;
		if (!(t & 1) && !(t & 2) && r !== null) a: for (;;) {
			if (r === null) return;
			var o = r.tag;
			if (o === 3 || o === 4) {
				var c = r.stateNode.containerInfo;
				if (c === i) break;
				if (o === 4) for (o = r.return; o !== null;) {
					var l = o.tag;
					if ((l === 3 || l === 4) && o.stateNode.containerInfo === i) return;
					o = o.return;
				}
				for (; c !== null;) {
					if (o = mt(c), o === null) return;
					if (l = o.tag, l === 5 || l === 6 || l === 26 || l === 27) {
						r = a = o;
						continue a;
					}
					c = c.parentNode;
				}
			}
			r = r.return;
		}
		an(function() {
			var r = a, i = $t(n), o = [];
			a: {
				var c = Gr.get(e);
				if (c !== void 0) {
					var l = yn, u = e;
					switch (e) {
						case "keypress": if (mn(n) === 0) break a;
						case "keydown":
						case "keyup":
							l = Ln;
							break;
						case "focusin":
							u = "focus", l = On;
							break;
						case "focusout":
							u = "blur", l = On;
							break;
						case "beforeblur":
						case "afterblur":
							l = On;
							break;
						case "click": if (n.button === 2) break a;
						case "auxclick":
						case "dblclick":
						case "mousedown":
						case "mousemove":
						case "mouseup":
						case "mouseout":
						case "mouseover":
						case "contextmenu":
							l = En;
							break;
						case "drag":
						case "dragend":
						case "dragenter":
						case "dragexit":
						case "dragleave":
						case "dragover":
						case "dragstart":
						case "drop":
							l = Dn;
							break;
						case "touchcancel":
						case "touchend":
						case "touchmove":
						case "touchstart":
							l = zn;
							break;
						case Rr:
						case zr:
						case Br:
							l = kn;
							break;
						case Wr:
							l = Bn;
							break;
						case "scroll":
						case "scrollend":
							l = xn;
							break;
						case "wheel":
							l = Vn;
							break;
						case "copy":
						case "cut":
						case "paste":
							l = An;
							break;
						case "gotpointercapture":
						case "lostpointercapture":
						case "pointercancel":
						case "pointerdown":
						case "pointermove":
						case "pointerout":
						case "pointerover":
						case "pointerup":
							l = Rn;
							break;
						case "toggle":
						case "beforetoggle": l = Hn;
					}
					var d = !!(t & 4), f = !d && (e === "scroll" || e === "scrollend"), p = d ? c === null ? null : c + "Capture" : c;
					d = [];
					for (var m = r, h; m !== null;) {
						var g = m;
						if (h = g.stateNode, g = g.tag, g !== 5 && g !== 26 && g !== 27 || h === null || p === null || (g = on(m, p), g != null && d.push(Td(m, g, h))), f) break;
						m = m.return;
					}
					0 < d.length && (c = new l(c, u, null, n, i), o.push({
						event: c,
						listeners: d
					}));
				}
			}
			if (!(t & 7)) {
				a: {
					if (c = e === "mouseover" || e === "pointerover", l = e === "mouseout" || e === "pointerout", c && n !== Qt && (u = n.relatedTarget || n.fromElement) && (mt(u) || u[st])) break a;
					if ((l || c) && (c = i.window === i ? i : (c = i.ownerDocument) ? c.defaultView || c.parentWindow : window, l ? (u = n.relatedTarget || n.toElement, l = r, u = u ? mt(u) : null, u !== null && (f = s(u), d = u.tag, u !== f || d !== 5 && d !== 27 && d !== 6) && (u = null)) : (l = null, u = r), l !== u)) {
						if (d = En, g = "onMouseLeave", p = "onMouseEnter", m = "mouse", (e === "pointerout" || e === "pointerover") && (d = Rn, g = "onPointerLeave", p = "onPointerEnter", m = "pointer"), f = l == null ? c : gt(l), h = u == null ? c : gt(u), c = new d(g, m + "leave", l, n, i), c.target = f, c.relatedTarget = h, g = null, mt(i) === r && (d = new d(p, m + "enter", u, n, i), d.target = h, d.relatedTarget = f, g = d), f = g, l && u) b: {
							for (d = Dd, p = l, m = u, h = 0, g = p; g; g = d(g)) h++;
							g = 0;
							for (var _ = m; _; _ = d(_)) g++;
							for (; 0 < h - g;) p = d(p), h--;
							for (; 0 < g - h;) m = d(m), g--;
							for (; h--;) {
								if (p === m || m !== null && p === m.alternate) {
									d = p;
									break b;
								}
								p = d(p), m = d(m);
							}
							d = null;
						}
						else d = null;
						l !== null && Od(o, c, l, d, !1), u !== null && f !== null && Od(o, f, u, d, !0);
					}
				}
				a: {
					if (c = r ? gt(r) : window, l = c.nodeName && c.nodeName.toLowerCase(), l === "select" || l === "input" && c.type === "file") var v = cr;
					else if (nr(c)) {
						if (lr) v = vr;
						else {
							v = gr;
							var y = hr;
						}
					} else l = c.nodeName, !l || l.toLowerCase() !== "input" || c.type !== "checkbox" && c.type !== "radio" ? r && qt(r.elementType) && (v = cr) : v = _r;
					if (v &&= v(e, r)) {
						rr(o, v, n, i);
						break a;
					}
					y && y(e, c, r), e === "focusout" && r && c.type === "number" && r.memoizedProps.value != null && zt(c, "number", c.value);
				}
				switch (y = r ? gt(r) : window, e) {
					case "focusin":
						(nr(y) || y.contentEditable === "true") && (Or = y, kr = r, Ar = null);
						break;
					case "focusout":
						Ar = kr = Or = null;
						break;
					case "mousedown":
						jr = !0;
						break;
					case "contextmenu":
					case "mouseup":
					case "dragend":
						jr = !1, Mr(o, n, i);
						break;
					case "selectionchange": if (Dr) break;
					case "keydown":
					case "keyup": Mr(o, n, i);
				}
				var b;
				if (Wn) b: {
					switch (e) {
						case "compositionstart":
							var x = "onCompositionStart";
							break b;
						case "compositionend":
							x = "onCompositionEnd";
							break b;
						case "compositionupdate":
							x = "onCompositionUpdate";
							break b;
					}
					x = void 0;
				}
				else Qn ? Xn(e, n) && (x = "onCompositionEnd") : e === "keydown" && n.keyCode === 229 && (x = "onCompositionStart");
				x && (qn && n.locale !== "ko" && (Qn || x !== "onCompositionStart" ? x === "onCompositionEnd" && Qn && (b = pn()) : (un = i, dn = "value" in un ? un.value : un.textContent, Qn = !0)), y = Ed(r, x), 0 < y.length && (x = new jn(x, e, null, n, i), o.push({
					event: x,
					listeners: y
				}), b ? x.data = b : (b = Zn(n), b !== null && (x.data = b)))), (b = Kn ? $n(e, n) : er(e, n)) && (x = Ed(r, "onBeforeInput"), 0 < x.length && (y = new jn("onBeforeInput", "beforeinput", null, n, i), o.push({
					event: y,
					listeners: x
				}), y.data = b)), md(o, e, r, n, i);
			}
			yd(o, t);
		});
	}
	function Td(e, t, n) {
		return {
			instance: e,
			listener: t,
			currentTarget: n
		};
	}
	function Ed(e, t) {
		for (var n = t + "Capture", r = []; e !== null;) {
			var i = e, a = i.stateNode;
			if (i = i.tag, i !== 5 && i !== 26 && i !== 27 || a === null || (i = on(e, n), i != null && r.unshift(Td(e, i, a)), i = on(e, t), i != null && r.push(Td(e, i, a))), e.tag === 3) return r;
			e = e.return;
		}
		return [];
	}
	function Dd(e) {
		if (e === null) return null;
		do
			e = e.return;
		while (e && e.tag !== 5 && e.tag !== 27);
		return e || null;
	}
	function Od(e, t, n, r, i) {
		for (var a = t._reactName, o = []; n !== null && n !== r;) {
			var s = n, c = s.alternate, l = s.stateNode;
			if (s = s.tag, c !== null && c === r) break;
			s !== 5 && s !== 26 && s !== 27 || l === null || (c = l, i ? (l = on(n, a), l != null && o.unshift(Td(n, l, c))) : i || (l = on(n, a), l != null && o.push(Td(n, l, c)))), n = n.return;
		}
		o.length !== 0 && e.push({
			event: t,
			listeners: o
		});
	}
	var kd = /\r\n?/g, Ad = /\u0000|\uFFFD/g;
	function jd(e) {
		return (typeof e == "string" ? e : "" + e).replace(kd, "\n").replace(Ad, "");
	}
	function Md(e, t) {
		return t = jd(t), jd(e) === t;
	}
	function $(e, t, n, r, i, o) {
		switch (n) {
			case "children":
				typeof r == "string" ? t === "body" || t === "textarea" && r === "" || Ut(e, r) : (typeof r == "number" || typeof r == "bigint") && t !== "body" && Ut(e, "" + r);
				break;
			case "className":
				Ot(e, "class", r);
				break;
			case "tabIndex":
				Ot(e, "tabindex", r);
				break;
			case "dir":
			case "role":
			case "viewBox":
			case "width":
			case "height":
				Ot(e, n, r);
				break;
			case "style":
				Kt(e, r, o);
				break;
			case "data": if (t !== "object") {
				Ot(e, "data", r);
				break;
			}
			case "src":
			case "href":
				if (r === "" && (t !== "a" || n !== "href")) {
					e.removeAttribute(n);
					break;
				}
				if (r == null || typeof r == "function" || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = Xt("" + r), e.setAttribute(n, r);
				break;
			case "action":
			case "formAction":
				if (typeof r == "function") {
					e.setAttribute(n, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
					break;
				}
				if (typeof o == "function" && (n === "formAction" ? (t !== "input" && $(e, t, "name", i.name, i, null), $(e, t, "formEncType", i.formEncType, i, null), $(e, t, "formMethod", i.formMethod, i, null), $(e, t, "formTarget", i.formTarget, i, null)) : ($(e, t, "encType", i.encType, i, null), $(e, t, "method", i.method, i, null), $(e, t, "target", i.target, i, null))), r == null || typeof r == "symbol" || typeof r == "boolean") {
					e.removeAttribute(n);
					break;
				}
				r = Xt("" + r), e.setAttribute(n, r);
				break;
			case "onClick":
				r != null && (e.onclick = Zt);
				break;
			case "onScroll":
				r != null && Q("scroll", e);
				break;
			case "onScrollEnd":
				r != null && Q("scrollend", e);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(a(61));
					if (n = r.__html, n != null) {
						if (i.children != null) throw Error(a(60));
						e.innerHTML = n;
					}
				}
				break;
			case "multiple":
				e.multiple = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "muted":
				e.muted = r && typeof r != "function" && typeof r != "symbol";
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "defaultValue":
			case "defaultChecked":
			case "innerHTML":
			case "ref": break;
			case "autoFocus": break;
			case "xlinkHref":
				if (r == null || typeof r == "function" || typeof r == "boolean" || typeof r == "symbol") {
					e.removeAttribute("xlink:href");
					break;
				}
				n = Xt("" + r), e.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", n);
				break;
			case "contentEditable":
			case "spellCheck":
			case "draggable":
			case "value":
			case "autoReverse":
			case "externalResourcesRequired":
			case "focusable":
			case "preserveAlpha":
				r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "" + r) : e.removeAttribute(n);
				break;
			case "inert":
			case "allowFullScreen":
			case "async":
			case "autoPlay":
			case "controls":
			case "default":
			case "defer":
			case "disabled":
			case "disablePictureInPicture":
			case "disableRemotePlayback":
			case "formNoValidate":
			case "hidden":
			case "loop":
			case "noModule":
			case "noValidate":
			case "open":
			case "playsInline":
			case "readOnly":
			case "required":
			case "reversed":
			case "scoped":
			case "seamless":
			case "itemScope":
				r && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, "") : e.removeAttribute(n);
				break;
			case "capture":
			case "download":
				!0 === r ? e.setAttribute(n, "") : !1 !== r && r != null && typeof r != "function" && typeof r != "symbol" ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "cols":
			case "rows":
			case "size":
			case "span":
				r != null && typeof r != "function" && typeof r != "symbol" && !isNaN(r) && 1 <= r ? e.setAttribute(n, r) : e.removeAttribute(n);
				break;
			case "rowSpan":
			case "start":
				r == null || typeof r == "function" || typeof r == "symbol" || isNaN(r) ? e.removeAttribute(n) : e.setAttribute(n, r);
				break;
			case "popover":
				Q("beforetoggle", e), Q("toggle", e), Dt(e, "popover", r);
				break;
			case "xlinkActuate":
				B(e, "http://www.w3.org/1999/xlink", "xlink:actuate", r);
				break;
			case "xlinkArcrole":
				B(e, "http://www.w3.org/1999/xlink", "xlink:arcrole", r);
				break;
			case "xlinkRole":
				B(e, "http://www.w3.org/1999/xlink", "xlink:role", r);
				break;
			case "xlinkShow":
				B(e, "http://www.w3.org/1999/xlink", "xlink:show", r);
				break;
			case "xlinkTitle":
				B(e, "http://www.w3.org/1999/xlink", "xlink:title", r);
				break;
			case "xlinkType":
				B(e, "http://www.w3.org/1999/xlink", "xlink:type", r);
				break;
			case "xmlBase":
				B(e, "http://www.w3.org/XML/1998/namespace", "xml:base", r);
				break;
			case "xmlLang":
				B(e, "http://www.w3.org/XML/1998/namespace", "xml:lang", r);
				break;
			case "xmlSpace":
				B(e, "http://www.w3.org/XML/1998/namespace", "xml:space", r);
				break;
			case "is":
				Dt(e, "is", r);
				break;
			case "innerText":
			case "textContent": break;
			default: (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N") && (n = Jt.get(n) || n, Dt(e, n, r));
		}
	}
	function Nd(e, t, n, r, i, o) {
		switch (n) {
			case "style":
				Kt(e, r, o);
				break;
			case "dangerouslySetInnerHTML":
				if (r != null) {
					if (typeof r != "object" || !("__html" in r)) throw Error(a(61));
					if (n = r.__html, n != null) {
						if (i.children != null) throw Error(a(60));
						e.innerHTML = n;
					}
				}
				break;
			case "children":
				typeof r == "string" ? Ut(e, r) : (typeof r == "number" || typeof r == "bigint") && Ut(e, "" + r);
				break;
			case "onScroll":
				r != null && Q("scroll", e);
				break;
			case "onScrollEnd":
				r != null && Q("scrollend", e);
				break;
			case "onClick":
				r != null && (e.onclick = Zt);
				break;
			case "suppressContentEditableWarning":
			case "suppressHydrationWarning":
			case "innerHTML":
			case "ref": break;
			case "innerText":
			case "textContent": break;
			default: if (!bt.hasOwnProperty(n)) a: {
				if (n[0] === "o" && n[1] === "n" && (i = n.endsWith("Capture"), t = n.slice(2, i ? n.length - 7 : void 0), o = e[ot] || null, o = o == null ? null : o[n], typeof o == "function" && e.removeEventListener(t, o, i), typeof r == "function")) {
					typeof o != "function" && o !== null && (n in e ? e[n] = null : e.hasAttribute(n) && e.removeAttribute(n)), e.addEventListener(t, r, i);
					break a;
				}
				n in e ? e[n] = r : !0 === r ? e.setAttribute(n, "") : Dt(e, n, r);
			}
		}
	}
	function Pd(e, t, n) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "img":
				Q("error", e), Q("load", e);
				var r = !1, i = !1, o;
				for (o in n) if (n.hasOwnProperty(o)) {
					var s = n[o];
					if (s != null) switch (o) {
						case "src":
							r = !0;
							break;
						case "srcSet":
							i = !0;
							break;
						case "children":
						case "dangerouslySetInnerHTML": throw Error(a(137, t));
						default: $(e, t, o, s, n, null);
					}
				}
				i && $(e, t, "srcSet", n.srcSet, n, null), r && $(e, t, "src", n.src, n, null);
				return;
			case "input":
				Q("invalid", e);
				var c = o = s = i = null, l = null, u = null;
				for (r in n) if (n.hasOwnProperty(r)) {
					var d = n[r];
					if (d != null) switch (r) {
						case "name":
							i = d;
							break;
						case "type":
							s = d;
							break;
						case "checked":
							l = d;
							break;
						case "defaultChecked":
							u = d;
							break;
						case "value":
							o = d;
							break;
						case "defaultValue":
							c = d;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (d != null) throw Error(a(137, t));
							break;
						default: $(e, t, r, d, n, null);
					}
				}
				Rt(e, o, c, l, u, s, i, !1);
				return;
			case "select":
				for (i in Q("invalid", e), r = s = o = null, n) if (n.hasOwnProperty(i) && (c = n[i], c != null)) switch (i) {
					case "value":
						o = c;
						break;
					case "defaultValue":
						s = c;
						break;
					case "multiple": r = c;
					default: $(e, t, i, c, n, null);
				}
				t = o, n = s, e.multiple = !!r, t == null ? n != null && Bt(e, !!r, n, !0) : Bt(e, !!r, t, !1);
				return;
			case "textarea":
				for (s in Q("invalid", e), o = i = r = null, n) if (n.hasOwnProperty(s) && (c = n[s], c != null)) switch (s) {
					case "value":
						r = c;
						break;
					case "defaultValue":
						i = c;
						break;
					case "children":
						o = c;
						break;
					case "dangerouslySetInnerHTML":
						if (c != null) throw Error(a(91));
						break;
					default: $(e, t, s, c, n, null);
				}
				Ht(e, r, i, o);
				return;
			case "option":
				for (l in n) if (n.hasOwnProperty(l) && (r = n[l], r != null)) switch (l) {
					case "selected":
						e.selected = r && typeof r != "function" && typeof r != "symbol";
						break;
					default: $(e, t, l, r, n, null);
				}
				return;
			case "dialog":
				Q("beforetoggle", e), Q("toggle", e), Q("cancel", e), Q("close", e);
				break;
			case "iframe":
			case "object":
				Q("load", e);
				break;
			case "video":
			case "audio":
				for (r = 0; r < _d.length; r++) Q(_d[r], e);
				break;
			case "image":
				Q("error", e), Q("load", e);
				break;
			case "details":
				Q("toggle", e);
				break;
			case "embed":
			case "source":
			case "link": Q("error", e), Q("load", e);
			case "area":
			case "base":
			case "br":
			case "col":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "track":
			case "wbr":
			case "menuitem":
				for (u in n) if (n.hasOwnProperty(u) && (r = n[u], r != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML": throw Error(a(137, t));
					default: $(e, t, u, r, n, null);
				}
				return;
			default: if (qt(t)) {
				for (d in n) n.hasOwnProperty(d) && (r = n[d], r !== void 0 && Nd(e, t, d, r, n, void 0));
				return;
			}
		}
		for (c in n) n.hasOwnProperty(c) && (r = n[c], r != null && $(e, t, c, r, n, null));
	}
	function Fd(e, t, n, r) {
		switch (t) {
			case "div":
			case "span":
			case "svg":
			case "path":
			case "a":
			case "g":
			case "p":
			case "li": break;
			case "input":
				var i = null, o = null, s = null, c = null, l = null, u = null, d = null;
				for (m in n) {
					var f = n[m];
					if (n.hasOwnProperty(m) && f != null) switch (m) {
						case "checked": break;
						case "value": break;
						case "defaultValue": l = f;
						default: r.hasOwnProperty(m) || $(e, t, m, null, r, f);
					}
				}
				for (var p in r) {
					var m = r[p];
					if (f = n[p], r.hasOwnProperty(p) && (m != null || f != null)) switch (p) {
						case "type":
							o = m;
							break;
						case "name":
							i = m;
							break;
						case "checked":
							u = m;
							break;
						case "defaultChecked":
							d = m;
							break;
						case "value":
							s = m;
							break;
						case "defaultValue":
							c = m;
							break;
						case "children":
						case "dangerouslySetInnerHTML":
							if (m != null) throw Error(a(137, t));
							break;
						default: m !== f && $(e, t, p, m, r, f);
					}
				}
				Lt(e, s, c, l, u, d, o, i);
				return;
			case "select":
				for (o in m = s = c = p = null, n) if (l = n[o], n.hasOwnProperty(o) && l != null) switch (o) {
					case "value": break;
					case "multiple": m = l;
					default: r.hasOwnProperty(o) || $(e, t, o, null, r, l);
				}
				for (i in r) if (o = r[i], l = n[i], r.hasOwnProperty(i) && (o != null || l != null)) switch (i) {
					case "value":
						p = o;
						break;
					case "defaultValue":
						c = o;
						break;
					case "multiple": s = o;
					default: o !== l && $(e, t, i, o, r, l);
				}
				t = c, n = s, r = m, p == null ? !!r != !!n && (t == null ? Bt(e, !!n, n ? [] : "", !1) : Bt(e, !!n, t, !0)) : Bt(e, !!n, p, !1);
				return;
			case "textarea":
				for (c in m = p = null, n) if (i = n[c], n.hasOwnProperty(c) && i != null && !r.hasOwnProperty(c)) switch (c) {
					case "value": break;
					case "children": break;
					default: $(e, t, c, null, r, i);
				}
				for (s in r) if (i = r[s], o = n[s], r.hasOwnProperty(s) && (i != null || o != null)) switch (s) {
					case "value":
						p = i;
						break;
					case "defaultValue":
						m = i;
						break;
					case "children": break;
					case "dangerouslySetInnerHTML":
						if (i != null) throw Error(a(91));
						break;
					default: i !== o && $(e, t, s, i, r, o);
				}
				Vt(e, p, m);
				return;
			case "option":
				for (var h in n) if (p = n[h], n.hasOwnProperty(h) && p != null && !r.hasOwnProperty(h)) switch (h) {
					case "selected":
						e.selected = !1;
						break;
					default: $(e, t, h, null, r, p);
				}
				for (l in r) if (p = r[l], m = n[l], r.hasOwnProperty(l) && p !== m && (p != null || m != null)) switch (l) {
					case "selected":
						e.selected = p && typeof p != "function" && typeof p != "symbol";
						break;
					default: $(e, t, l, p, r, m);
				}
				return;
			case "img":
			case "link":
			case "area":
			case "base":
			case "br":
			case "col":
			case "embed":
			case "hr":
			case "keygen":
			case "meta":
			case "param":
			case "source":
			case "track":
			case "wbr":
			case "menuitem":
				for (var g in n) p = n[g], n.hasOwnProperty(g) && p != null && !r.hasOwnProperty(g) && $(e, t, g, null, r, p);
				for (u in r) if (p = r[u], m = n[u], r.hasOwnProperty(u) && p !== m && (p != null || m != null)) switch (u) {
					case "children":
					case "dangerouslySetInnerHTML":
						if (p != null) throw Error(a(137, t));
						break;
					default: $(e, t, u, p, r, m);
				}
				return;
			default: if (qt(t)) {
				for (var _ in n) p = n[_], n.hasOwnProperty(_) && p !== void 0 && !r.hasOwnProperty(_) && Nd(e, t, _, void 0, r, p);
				for (d in r) p = r[d], m = n[d], !r.hasOwnProperty(d) || p === m || p === void 0 && m === void 0 || Nd(e, t, d, p, r, m);
				return;
			}
		}
		for (var v in n) p = n[v], n.hasOwnProperty(v) && p != null && !r.hasOwnProperty(v) && $(e, t, v, null, r, p);
		for (f in r) p = r[f], m = n[f], !r.hasOwnProperty(f) || p === m || p == null && m == null || $(e, t, f, p, r, m);
	}
	function Id(e) {
		switch (e) {
			case "css":
			case "script":
			case "font":
			case "img":
			case "image":
			case "input":
			case "link": return !0;
			default: return !1;
		}
	}
	function Ld() {
		if (typeof performance.getEntriesByType == "function") {
			for (var e = 0, t = 0, n = performance.getEntriesByType("resource"), r = 0; r < n.length; r++) {
				var i = n[r], a = i.transferSize, o = i.initiatorType, s = i.duration;
				if (a && s && Id(o)) {
					for (o = 0, s = i.responseEnd, r += 1; r < n.length; r++) {
						var c = n[r], l = c.startTime;
						if (l > s) break;
						var u = c.transferSize, d = c.initiatorType;
						u && Id(d) && (c = c.responseEnd, o += u * (c < s ? 1 : (s - l) / (c - l)));
					}
					if (--r, t += 8 * (a + o) / (i.duration / 1e3), e++, 10 < e) break;
				}
			}
			if (0 < e) return t / e / 1e6;
		}
		return navigator.connection && (e = navigator.connection.downlink, typeof e == "number") ? e : 5;
	}
	var Rd = null, zd = null;
	function Bd(e) {
		return e.nodeType === 9 ? e : e.ownerDocument;
	}
	function Vd(e) {
		switch (e) {
			case "http://www.w3.org/2000/svg": return 1;
			case "http://www.w3.org/1998/Math/MathML": return 2;
			default: return 0;
		}
	}
	function Hd(e, t) {
		if (e === 0) switch (t) {
			case "svg": return 1;
			case "math": return 2;
			default: return 0;
		}
		return e === 1 && t === "foreignObject" ? 0 : e;
	}
	function Ud(e, t) {
		return e === "textarea" || e === "noscript" || typeof t.children == "string" || typeof t.children == "number" || typeof t.children == "bigint" || typeof t.dangerouslySetInnerHTML == "object" && t.dangerouslySetInnerHTML !== null && t.dangerouslySetInnerHTML.__html != null;
	}
	var Wd = null;
	function Gd() {
		var e = window.event;
		return e && e.type === "popstate" ? e !== Wd && (Wd = e, !0) : (Wd = null, !1);
	}
	var Kd = typeof setTimeout == "function" ? setTimeout : void 0, qd = typeof clearTimeout == "function" ? clearTimeout : void 0, Jd = typeof Promise == "function" ? Promise : void 0, Yd = typeof queueMicrotask == "function" ? queueMicrotask : Jd === void 0 ? Kd : function(e) {
		return Jd.resolve(null).then(e).catch(Xd);
	};
	function Xd(e) {
		setTimeout(function() {
			throw e;
		});
	}
	function Zd(e) {
		return e === "head";
	}
	function Qd(e, t) {
		var n = t, r = 0;
		do {
			var i = n.nextSibling;
			if (e.removeChild(n), i && i.nodeType === 8) {
				if (n = i.data, n === "/$" || n === "/&") {
					if (r === 0) {
						e.removeChild(i), Np(t);
						return;
					}
					r--;
				} else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&") r++;
				else if (n === "html") pf(e.ownerDocument.documentElement);
				else if (n === "head") {
					n = e.ownerDocument.head, pf(n);
					for (var a = n.firstChild; a;) {
						var o = a.nextSibling, s = a.nodeName;
						a[ft] || s === "SCRIPT" || s === "STYLE" || s === "LINK" && a.rel.toLowerCase() === "stylesheet" || n.removeChild(a), a = o;
					}
				} else n === "body" && pf(e.ownerDocument.body);
			}
			n = i;
		} while (n);
		Np(t);
	}
	function $d(e, t) {
		var n = e;
		e = 0;
		do {
			var r = n.nextSibling;
			if (n.nodeType === 1 ? t ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (t ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), r && r.nodeType === 8) {
				if (n = r.data, n === "/$") {
					if (e === 0) break;
					e--;
				} else n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || e++;
			}
			n = r;
		} while (n);
	}
	function ef(e) {
		var t = e.firstChild;
		for (t && t.nodeType === 10 && (t = t.nextSibling); t;) {
			var n = t;
			switch (t = t.nextSibling, n.nodeName) {
				case "HTML":
				case "HEAD":
				case "BODY":
					ef(n), pt(n);
					continue;
				case "SCRIPT":
				case "STYLE": continue;
				case "LINK": if (n.rel.toLowerCase() === "stylesheet") continue;
			}
			e.removeChild(n);
		}
	}
	function tf(e, t, n, r) {
		for (; e.nodeType === 1;) {
			var i = n;
			if (e.nodeName.toLowerCase() !== t.toLowerCase()) {
				if (!r && (e.nodeName !== "INPUT" || e.type !== "hidden")) break;
			} else if (!r) {
				if (t === "input" && e.type === "hidden") {
					var a = i.name == null ? null : "" + i.name;
					if (i.type === "hidden" && e.getAttribute("name") === a) return e;
				} else return e;
			} else if (!e[ft]) switch (t) {
				case "meta":
					if (!e.hasAttribute("itemprop")) break;
					return e;
				case "link":
					if (a = e.getAttribute("rel"), a === "stylesheet" && e.hasAttribute("data-precedence") || a !== i.rel || e.getAttribute("href") !== (i.href == null || i.href === "" ? null : i.href) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin) || e.getAttribute("title") !== (i.title == null ? null : i.title)) break;
					return e;
				case "style":
					if (e.hasAttribute("data-precedence")) break;
					return e;
				case "script":
					if (a = e.getAttribute("src"), (a !== (i.src == null ? null : i.src) || e.getAttribute("type") !== (i.type == null ? null : i.type) || e.getAttribute("crossorigin") !== (i.crossOrigin == null ? null : i.crossOrigin)) && a && e.hasAttribute("async") && !e.hasAttribute("itemprop")) break;
					return e;
				default: return e;
			}
			if (e = cf(e.nextSibling), e === null) break;
		}
		return null;
	}
	function nf(e, t, n) {
		if (t === "") return null;
		for (; e.nodeType !== 3;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !n || (e = cf(e.nextSibling), e === null)) return null;
		return e;
	}
	function rf(e, t) {
		for (; e.nodeType !== 8;) if ((e.nodeType !== 1 || e.nodeName !== "INPUT" || e.type !== "hidden") && !t || (e = cf(e.nextSibling), e === null)) return null;
		return e;
	}
	function af(e) {
		return e.data === "$?" || e.data === "$~";
	}
	function of(e) {
		return e.data === "$!" || e.data === "$?" && e.ownerDocument.readyState !== "loading";
	}
	function sf(e, t) {
		var n = e.ownerDocument;
		if (e.data === "$~") e._reactRetry = t;
		else if (e.data !== "$?" || n.readyState !== "loading") t();
		else {
			var r = function() {
				t(), n.removeEventListener("DOMContentLoaded", r);
			};
			n.addEventListener("DOMContentLoaded", r), e._reactRetry = r;
		}
	}
	function cf(e) {
		for (; e != null; e = e.nextSibling) {
			var t = e.nodeType;
			if (t === 1 || t === 3) break;
			if (t === 8) {
				if (t = e.data, t === "$" || t === "$!" || t === "$?" || t === "$~" || t === "&" || t === "F!" || t === "F") break;
				if (t === "/$" || t === "/&") return null;
			}
		}
		return e;
	}
	var lf = null;
	function uf(e) {
		e = e.nextSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "/$" || n === "/&") {
					if (t === 0) return cf(e.nextSibling);
					t--;
				} else n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || t++;
			}
			e = e.nextSibling;
		}
		return null;
	}
	function df(e) {
		e = e.previousSibling;
		for (var t = 0; e;) {
			if (e.nodeType === 8) {
				var n = e.data;
				if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
					if (t === 0) return e;
					t--;
				} else n !== "/$" && n !== "/&" || t++;
			}
			e = e.previousSibling;
		}
		return null;
	}
	function ff(e, t, n) {
		switch (t = Bd(n), e) {
			case "html":
				if (e = t.documentElement, !e) throw Error(a(452));
				return e;
			case "head":
				if (e = t.head, !e) throw Error(a(453));
				return e;
			case "body":
				if (e = t.body, !e) throw Error(a(454));
				return e;
			default: throw Error(a(451));
		}
	}
	function pf(e) {
		for (var t = e.attributes; t.length;) e.removeAttributeNode(t[0]);
		pt(e);
	}
	var mf = /* @__PURE__ */ new Map(), hf = /* @__PURE__ */ new Set();
	function gf(e) {
		return typeof e.getRootNode == "function" ? e.getRootNode() : e.nodeType === 9 ? e : e.ownerDocument;
	}
	var _f = k.d;
	k.d = {
		f: vf,
		r: yf,
		D: Sf,
		C: Cf,
		L: wf,
		m: Tf,
		X: Df,
		S: Ef,
		M: Of
	};
	function vf() {
		var e = _f.f(), t = bu();
		return e || t;
	}
	function yf(e) {
		var t = ht(e);
		t !== null && t.tag === 5 && t.type === "form" ? Cs(t) : _f.r(e);
	}
	var bf = typeof document > "u" ? null : document;
	function xf(e, t, n) {
		var r = bf;
		if (r && typeof t == "string" && t) {
			var i = It(t);
			i = "link[rel=\"" + e + "\"][href=\"" + i + "\"]", typeof n == "string" && (i += "[crossorigin=\"" + n + "\"]"), hf.has(i) || (hf.add(i), e = {
				rel: e,
				crossOrigin: n,
				href: t
			}, r.querySelector(i) === null && (t = r.createElement("link"), Pd(t, "link", e), vt(t), r.head.appendChild(t)));
		}
	}
	function Sf(e) {
		_f.D(e), xf("dns-prefetch", e, null);
	}
	function Cf(e, t) {
		_f.C(e, t), xf("preconnect", e, t);
	}
	function wf(e, t, n) {
		_f.L(e, t, n);
		var r = bf;
		if (r && e && t) {
			var i = "link[rel=\"preload\"][as=\"" + It(t) + "\"]";
			t === "image" && n && n.imageSrcSet ? (i += "[imagesrcset=\"" + It(n.imageSrcSet) + "\"]", typeof n.imageSizes == "string" && (i += "[imagesizes=\"" + It(n.imageSizes) + "\"]")) : i += "[href=\"" + It(e) + "\"]";
			var a = i;
			switch (t) {
				case "style":
					a = Af(e);
					break;
				case "script": a = Pf(e);
			}
			mf.has(a) || (e = p({
				rel: "preload",
				href: t === "image" && n && n.imageSrcSet ? void 0 : e,
				as: t
			}, n), mf.set(a, e), r.querySelector(i) !== null || t === "style" && r.querySelector(jf(a)) || t === "script" && r.querySelector(Ff(a)) || (t = r.createElement("link"), Pd(t, "link", e), vt(t), r.head.appendChild(t)));
		}
	}
	function Tf(e, t) {
		_f.m(e, t);
		var n = bf;
		if (n && e) {
			var r = t && typeof t.as == "string" ? t.as : "script", i = "link[rel=\"modulepreload\"][as=\"" + It(r) + "\"][href=\"" + It(e) + "\"]", a = i;
			switch (r) {
				case "audioworklet":
				case "paintworklet":
				case "serviceworker":
				case "sharedworker":
				case "worker":
				case "script": a = Pf(e);
			}
			if (!mf.has(a) && (e = p({
				rel: "modulepreload",
				href: e
			}, t), mf.set(a, e), n.querySelector(i) === null)) {
				switch (r) {
					case "audioworklet":
					case "paintworklet":
					case "serviceworker":
					case "sharedworker":
					case "worker":
					case "script": if (n.querySelector(Ff(a))) return;
				}
				r = n.createElement("link"), Pd(r, "link", e), vt(r), n.head.appendChild(r);
			}
		}
	}
	function Ef(e, t, n) {
		_f.S(e, t, n);
		var r = bf;
		if (r && e) {
			var i = _t(r).hoistableStyles, a = Af(e);
			t ||= "default";
			var o = i.get(a);
			if (!o) {
				var s = {
					loading: 0,
					preload: null
				};
				if (o = r.querySelector(jf(a))) s.loading = 5;
				else {
					e = p({
						rel: "stylesheet",
						href: e,
						"data-precedence": t
					}, n), (n = mf.get(a)) && Rf(e, n);
					var c = o = r.createElement("link");
					vt(c), Pd(c, "link", e), c._p = new Promise(function(e, t) {
						c.onload = e, c.onerror = t;
					}), c.addEventListener("load", function() {
						s.loading |= 1;
					}), c.addEventListener("error", function() {
						s.loading |= 2;
					}), s.loading |= 4, Lf(o, t, r);
				}
				o = {
					type: "stylesheet",
					instance: o,
					count: 1,
					state: s
				}, i.set(a, o);
			}
		}
	}
	function Df(e, t) {
		_f.X(e, t);
		var n = bf;
		if (n && e) {
			var r = _t(n).hoistableScripts, i = Pf(e), a = r.get(i);
			a || (a = n.querySelector(Ff(i)), a || (e = p({
				src: e,
				async: !0
			}, t), (t = mf.get(i)) && zf(e, t), a = n.createElement("script"), vt(a), Pd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function Of(e, t) {
		_f.M(e, t);
		var n = bf;
		if (n && e) {
			var r = _t(n).hoistableScripts, i = Pf(e), a = r.get(i);
			a || (a = n.querySelector(Ff(i)), a || (e = p({
				src: e,
				async: !0,
				type: "module"
			}, t), (t = mf.get(i)) && zf(e, t), a = n.createElement("script"), vt(a), Pd(a, "link", e), n.head.appendChild(a)), a = {
				type: "script",
				instance: a,
				count: 1,
				state: null
			}, r.set(i, a));
		}
	}
	function kf(e, t, n, r) {
		var i = (i = P.current) ? gf(i) : null;
		if (!i) throw Error(a(446));
		switch (e) {
			case "meta":
			case "title": return null;
			case "style": return typeof n.precedence == "string" && typeof n.href == "string" ? (t = Af(n.href), n = _t(i).hoistableStyles, r = n.get(t), r || (r = {
				type: "style",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			case "link":
				if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
					e = Af(n.href);
					var o = _t(i).hoistableStyles, s = o.get(e);
					if (s || (i = i.ownerDocument || i, s = {
						type: "stylesheet",
						instance: null,
						count: 0,
						state: {
							loading: 0,
							preload: null
						}
					}, o.set(e, s), (o = i.querySelector(jf(e))) && !o._p && (s.instance = o, s.state.loading = 5), mf.has(e) || (n = {
						rel: "preload",
						as: "style",
						href: n.href,
						crossOrigin: n.crossOrigin,
						integrity: n.integrity,
						media: n.media,
						hrefLang: n.hrefLang,
						referrerPolicy: n.referrerPolicy
					}, mf.set(e, n), o || Nf(i, e, n, s.state))), t && r === null) throw Error(a(528, ""));
					return s;
				}
				if (t && r !== null) throw Error(a(529, ""));
				return null;
			case "script": return t = n.async, n = n.src, typeof n == "string" && t && typeof t != "function" && typeof t != "symbol" ? (t = Pf(n), n = _t(i).hoistableScripts, r = n.get(t), r || (r = {
				type: "script",
				instance: null,
				count: 0,
				state: null
			}, n.set(t, r)), r) : {
				type: "void",
				instance: null,
				count: 0,
				state: null
			};
			default: throw Error(a(444, e));
		}
	}
	function Af(e) {
		return "href=\"" + It(e) + "\"";
	}
	function jf(e) {
		return "link[rel=\"stylesheet\"][" + e + "]";
	}
	function Mf(e) {
		return p({}, e, {
			"data-precedence": e.precedence,
			precedence: null
		});
	}
	function Nf(e, t, n, r) {
		e.querySelector("link[rel=\"preload\"][as=\"style\"][" + t + "]") ? r.loading = 1 : (t = e.createElement("link"), r.preload = t, t.addEventListener("load", function() {
			return r.loading |= 1;
		}), t.addEventListener("error", function() {
			return r.loading |= 2;
		}), Pd(t, "link", n), vt(t), e.head.appendChild(t));
	}
	function Pf(e) {
		return "[src=\"" + It(e) + "\"]";
	}
	function Ff(e) {
		return "script[async]" + e;
	}
	function If(e, t, n) {
		if (t.count++, t.instance === null) switch (t.type) {
			case "style":
				var r = e.querySelector("style[data-href~=\"" + It(n.href) + "\"]");
				if (r) return t.instance = r, vt(r), r;
				var i = p({}, n, {
					"data-href": n.href,
					"data-precedence": n.precedence,
					href: null,
					precedence: null
				});
				return r = (e.ownerDocument || e).createElement("style"), vt(r), Pd(r, "style", i), Lf(r, n.precedence, e), t.instance = r;
			case "stylesheet":
				i = Af(n.href);
				var o = e.querySelector(jf(i));
				if (o) return t.state.loading |= 4, t.instance = o, vt(o), o;
				r = Mf(n), (i = mf.get(i)) && Rf(r, i), o = (e.ownerDocument || e).createElement("link"), vt(o);
				var s = o;
				return s._p = new Promise(function(e, t) {
					s.onload = e, s.onerror = t;
				}), Pd(o, "link", r), t.state.loading |= 4, Lf(o, n.precedence, e), t.instance = o;
			case "script": return o = Pf(n.src), (i = e.querySelector(Ff(o))) ? (t.instance = i, vt(i), i) : (r = n, (i = mf.get(o)) && (r = p({}, n), zf(r, i)), e = e.ownerDocument || e, i = e.createElement("script"), vt(i), Pd(i, "link", r), e.head.appendChild(i), t.instance = i);
			case "void": return null;
			default: throw Error(a(443, t.type));
		}
		else t.type === "stylesheet" && !(t.state.loading & 4) && (r = t.instance, t.state.loading |= 4, Lf(r, n.precedence, e));
		return t.instance;
	}
	function Lf(e, t, n) {
		for (var r = n.querySelectorAll("link[rel=\"stylesheet\"][data-precedence],style[data-precedence]"), i = r.length ? r[r.length - 1] : null, a = i, o = 0; o < r.length; o++) {
			var s = r[o];
			if (s.dataset.precedence === t) a = s;
			else if (a !== i) break;
		}
		a ? a.parentNode.insertBefore(e, a.nextSibling) : (t = n.nodeType === 9 ? n.head : n, t.insertBefore(e, t.firstChild));
	}
	function Rf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.title ??= t.title;
	}
	function zf(e, t) {
		e.crossOrigin ??= t.crossOrigin, e.referrerPolicy ??= t.referrerPolicy, e.integrity ??= t.integrity;
	}
	var Bf = null;
	function Vf(e, t, n) {
		if (Bf === null) {
			var r = /* @__PURE__ */ new Map(), i = Bf = /* @__PURE__ */ new Map();
			i.set(n, r);
		} else i = Bf, r = i.get(n), r || (r = /* @__PURE__ */ new Map(), i.set(n, r));
		if (r.has(e)) return r;
		for (r.set(e, null), n = n.getElementsByTagName(e), i = 0; i < n.length; i++) {
			var a = n[i];
			if (!(a[ft] || a[at] || e === "link" && a.getAttribute("rel") === "stylesheet") && a.namespaceURI !== "http://www.w3.org/2000/svg") {
				var o = a.getAttribute(t) || "";
				o = e + o;
				var s = r.get(o);
				s ? s.push(a) : r.set(o, [a]);
			}
		}
		return r;
	}
	function Hf(e, t, n) {
		e = e.ownerDocument || e, e.head.insertBefore(n, t === "title" ? e.querySelector("head > title") : null);
	}
	function Uf(e, t, n) {
		if (n === 1 || t.itemProp != null) return !1;
		switch (e) {
			case "meta":
			case "title": return !0;
			case "style":
				if (typeof t.precedence != "string" || typeof t.href != "string" || t.href === "") break;
				return !0;
			case "link":
				if (typeof t.rel != "string" || typeof t.href != "string" || t.href === "" || t.onLoad || t.onError) break;
				switch (t.rel) {
					case "stylesheet": return e = t.disabled, typeof t.precedence == "string" && e == null;
					default: return !0;
				}
			case "script": if (t.async && typeof t.async != "function" && typeof t.async != "symbol" && !t.onLoad && !t.onError && t.src && typeof t.src == "string") return !0;
		}
		return !1;
	}
	function Wf(e) {
		return !(e.type === "stylesheet" && !(e.state.loading & 3));
	}
	function Gf(e, t, n, r) {
		if (n.type === "stylesheet" && (typeof r.media != "string" || !1 !== matchMedia(r.media).matches) && !(n.state.loading & 4)) {
			if (n.instance === null) {
				var i = Af(r.href), a = t.querySelector(jf(i));
				if (a) {
					t = a._p, typeof t == "object" && t && typeof t.then == "function" && (e.count++, e = Jf.bind(e), t.then(e, e)), n.state.loading |= 4, n.instance = a, vt(a);
					return;
				}
				a = t.ownerDocument || t, r = Mf(r), (i = mf.get(i)) && Rf(r, i), a = a.createElement("link"), vt(a);
				var o = a;
				o._p = new Promise(function(e, t) {
					o.onload = e, o.onerror = t;
				}), Pd(a, "link", r), n.instance = a;
			}
			e.stylesheets === null && (e.stylesheets = /* @__PURE__ */ new Map()), e.stylesheets.set(n, t), (t = n.state.preload) && !(n.state.loading & 3) && (e.count++, n = Jf.bind(e), t.addEventListener("load", n), t.addEventListener("error", n));
		}
	}
	var Kf = 0;
	function qf(e, t) {
		return e.stylesheets && e.count === 0 && Xf(e, e.stylesheets), 0 < e.count || 0 < e.imgCount ? function(n) {
			var r = setTimeout(function() {
				if (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, 6e4 + t);
			0 < e.imgBytes && Kf === 0 && (Kf = 62500 * Ld());
			var i = setTimeout(function() {
				if (e.waitingForImages = !1, e.count === 0 && (e.stylesheets && Xf(e, e.stylesheets), e.unsuspend)) {
					var t = e.unsuspend;
					e.unsuspend = null, t();
				}
			}, (e.imgBytes > Kf ? 50 : 800) + t);
			return e.unsuspend = n, function() {
				e.unsuspend = null, clearTimeout(r), clearTimeout(i);
			};
		} : null;
	}
	function Jf() {
		if (this.count--, this.count === 0 && (this.imgCount === 0 || !this.waitingForImages)) {
			if (this.stylesheets) Xf(this, this.stylesheets);
			else if (this.unsuspend) {
				var e = this.unsuspend;
				this.unsuspend = null, e();
			}
		}
	}
	var Yf = null;
	function Xf(e, t) {
		e.stylesheets = null, e.unsuspend !== null && (e.count++, Yf = /* @__PURE__ */ new Map(), t.forEach(Zf, e), Yf = null, Jf.call(e));
	}
	function Zf(e, t) {
		if (!(t.state.loading & 4)) {
			var n = Yf.get(e);
			if (n) var r = n.get(null);
			else {
				n = /* @__PURE__ */ new Map(), Yf.set(e, n);
				for (var i = e.querySelectorAll("link[data-precedence],style[data-precedence]"), a = 0; a < i.length; a++) {
					var o = i[a];
					(o.nodeName === "LINK" || o.getAttribute("media") !== "not all") && (n.set(o.dataset.precedence, o), r = o);
				}
				r && n.set(null, r);
			}
			i = t.instance, o = i.getAttribute("data-precedence"), a = n.get(o) || r, a === r && n.set(null, i), n.set(o, i), this.count++, r = Jf.bind(this), i.addEventListener("load", r), i.addEventListener("error", r), a ? a.parentNode.insertBefore(i, a.nextSibling) : (e = e.nodeType === 9 ? e.head : e, e.insertBefore(i, e.firstChild)), t.state.loading |= 4;
		}
	}
	var Qf = {
		$$typeof: x,
		Provider: null,
		Consumer: null,
		_currentValue: A,
		_currentValue2: A,
		_threadCount: 0
	};
	function $f(e, t, n, r, i, a, o, s, c) {
		this.tag = 1, this.containerInfo = e, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = Je(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = Je(0), this.hiddenUpdates = Je(null), this.identifierPrefix = r, this.onUncaughtError = i, this.onCaughtError = a, this.onRecoverableError = o, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = c, this.incompleteTransitions = /* @__PURE__ */ new Map();
	}
	function ep(e, t, n, r, i, a, o, s, c, l, u, d) {
		return e = new $f(e, t, n, o, c, l, u, d, s), t = 1, !0 === a && (t |= 24), a = oi(3, null, null, t), e.current = a, a.stateNode = e, t = ra(), t.refCount++, e.pooledCache = t, t.refCount++, a.memoizedState = {
			element: r,
			isDehydrated: n,
			cache: t
		}, Fa(a), e;
	}
	function tp(e) {
		return e ? (e = ii, e) : ii;
	}
	function np(e, t, n, r, i, a) {
		i = tp(i), r.context === null ? r.context = i : r.pendingContext = i, r = La(t), r.payload = { element: n }, a = a === void 0 ? null : a, a !== null && (r.callback = a), n = Ra(e, r, t), n !== null && (hu(n, e, t), za(n, e, t));
	}
	function rp(e, t) {
		if (e = e.memoizedState, e !== null && e.dehydrated !== null) {
			var n = e.retryLane;
			e.retryLane = n !== 0 && n < t ? n : t;
		}
	}
	function ip(e, t) {
		rp(e, t), (e = e.alternate) && rp(e, t);
	}
	function ap(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = ti(e, 67108864);
			t !== null && hu(t, e, 67108864), ip(e, 67108864);
		}
	}
	function op(e) {
		if (e.tag === 13 || e.tag === 31) {
			var t = pu();
			t = et(t);
			var n = ti(e, t);
			n !== null && hu(n, e, t), ip(e, t);
		}
	}
	var sp = !0;
	function cp(e, t, n, r) {
		var i = O.T;
		O.T = null;
		var a = k.p;
		try {
			k.p = 2, up(e, t, n, r);
		} finally {
			k.p = a, O.T = i;
		}
	}
	function lp(e, t, n, r) {
		var i = O.T;
		O.T = null;
		var a = k.p;
		try {
			k.p = 8, up(e, t, n, r);
		} finally {
			k.p = a, O.T = i;
		}
	}
	function up(e, t, n, r) {
		if (sp) {
			var i = dp(r);
			if (i === null) wd(e, t, r, fp, n), Cp(e, r);
			else if (Tp(i, e, t, n, r)) r.stopPropagation();
			else if (Cp(e, r), t & 4 && -1 < Sp.indexOf(e)) {
				for (; i !== null;) {
					var a = ht(i);
					if (a !== null) switch (a.tag) {
						case 3:
							if (a = a.stateNode, a.current.memoizedState.isDehydrated) {
								var o = Ue(a.pendingLanes);
								if (o !== 0) {
									var s = a;
									for (s.pendingLanes |= 2, s.entangledLanes |= 2; o;) {
										var c = 1 << 31 - Ie(o);
										s.entanglements[1] |= c, o &= ~c;
									}
									rd(a), !(q & 6) && (tu = we() + 500, id(0, !1));
								}
							}
							break;
						case 31:
						case 13: s = ti(a, 2), s !== null && hu(s, a, 2), bu(), ip(a, 2);
					}
					if (a = dp(r), a === null && wd(e, t, r, fp, n), a === i) break;
					i = a;
				}
				i !== null && r.stopPropagation();
			} else wd(e, t, r, null, n);
		}
	}
	function dp(e) {
		return e = $t(e), pp(e);
	}
	var fp = null;
	function pp(e) {
		if (fp = null, e = mt(e), e !== null) {
			var t = s(e);
			if (t === null) e = null;
			else {
				var n = t.tag;
				if (n === 13) {
					if (e = c(t), e !== null) return e;
					e = null;
				} else if (n === 31) {
					if (e = l(t), e !== null) return e;
					e = null;
				} else if (n === 3) {
					if (t.stateNode.current.memoizedState.isDehydrated) return t.tag === 3 ? t.stateNode.containerInfo : null;
					e = null;
				} else t !== e && (e = null);
			}
		}
		return fp = e, null;
	}
	function mp(e) {
		switch (e) {
			case "beforetoggle":
			case "cancel":
			case "click":
			case "close":
			case "contextmenu":
			case "copy":
			case "cut":
			case "auxclick":
			case "dblclick":
			case "dragend":
			case "dragstart":
			case "drop":
			case "focusin":
			case "focusout":
			case "input":
			case "invalid":
			case "keydown":
			case "keypress":
			case "keyup":
			case "mousedown":
			case "mouseup":
			case "paste":
			case "pause":
			case "play":
			case "pointercancel":
			case "pointerdown":
			case "pointerup":
			case "ratechange":
			case "reset":
			case "resize":
			case "seeked":
			case "submit":
			case "toggle":
			case "touchcancel":
			case "touchend":
			case "touchstart":
			case "volumechange":
			case "change":
			case "selectionchange":
			case "textInput":
			case "compositionstart":
			case "compositionend":
			case "compositionupdate":
			case "beforeblur":
			case "afterblur":
			case "beforeinput":
			case "blur":
			case "fullscreenchange":
			case "focus":
			case "hashchange":
			case "popstate":
			case "select":
			case "selectstart": return 2;
			case "drag":
			case "dragenter":
			case "dragexit":
			case "dragleave":
			case "dragover":
			case "mousemove":
			case "mouseout":
			case "mouseover":
			case "pointermove":
			case "pointerout":
			case "pointerover":
			case "scroll":
			case "touchmove":
			case "wheel":
			case "mouseenter":
			case "mouseleave":
			case "pointerenter":
			case "pointerleave": return 8;
			case "message": switch (Te()) {
				case Ee: return 2;
				case De: return 8;
				case Oe:
				case ke: return 32;
				case Ae: return 268435456;
				default: return 32;
			}
			default: return 32;
		}
	}
	var hp = !1, gp = null, _p = null, vp = null, yp = /* @__PURE__ */ new Map(), bp = /* @__PURE__ */ new Map(), xp = [], Sp = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
	function Cp(e, t) {
		switch (e) {
			case "focusin":
			case "focusout":
				gp = null;
				break;
			case "dragenter":
			case "dragleave":
				_p = null;
				break;
			case "mouseover":
			case "mouseout":
				vp = null;
				break;
			case "pointerover":
			case "pointerout":
				yp.delete(t.pointerId);
				break;
			case "gotpointercapture":
			case "lostpointercapture": bp.delete(t.pointerId);
		}
	}
	function wp(e, t, n, r, i, a) {
		return e === null || e.nativeEvent !== a ? (e = {
			blockedOn: t,
			domEventName: n,
			eventSystemFlags: r,
			nativeEvent: a,
			targetContainers: [i]
		}, t !== null && (t = ht(t), t !== null && ap(t)), e) : (e.eventSystemFlags |= r, t = e.targetContainers, i !== null && t.indexOf(i) === -1 && t.push(i), e);
	}
	function Tp(e, t, n, r, i) {
		switch (t) {
			case "focusin": return gp = wp(gp, e, t, n, r, i), !0;
			case "dragenter": return _p = wp(_p, e, t, n, r, i), !0;
			case "mouseover": return vp = wp(vp, e, t, n, r, i), !0;
			case "pointerover":
				var a = i.pointerId;
				return yp.set(a, wp(yp.get(a) || null, e, t, n, r, i)), !0;
			case "gotpointercapture": return a = i.pointerId, bp.set(a, wp(bp.get(a) || null, e, t, n, r, i)), !0;
		}
		return !1;
	}
	function Ep(e) {
		var t = mt(e.target);
		if (t !== null) {
			var n = s(t);
			if (n !== null) {
				if (t = n.tag, t === 13) {
					if (t = c(n), t !== null) {
						e.blockedOn = t, rt(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 31) {
					if (t = l(n), t !== null) {
						e.blockedOn = t, rt(e.priority, function() {
							op(n);
						});
						return;
					}
				} else if (t === 3 && n.stateNode.current.memoizedState.isDehydrated) {
					e.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
					return;
				}
			}
		}
		e.blockedOn = null;
	}
	function Dp(e) {
		if (e.blockedOn !== null) return !1;
		for (var t = e.targetContainers; 0 < t.length;) {
			var n = dp(e.nativeEvent);
			if (n === null) {
				n = e.nativeEvent;
				var r = new n.constructor(n.type, n);
				Qt = r, n.target.dispatchEvent(r), Qt = null;
			} else return t = ht(n), t !== null && ap(t), e.blockedOn = n, !1;
			t.shift();
		}
		return !0;
	}
	function Op(e, t, n) {
		Dp(e) && n.delete(t);
	}
	function kp() {
		hp = !1, gp !== null && Dp(gp) && (gp = null), _p !== null && Dp(_p) && (_p = null), vp !== null && Dp(vp) && (vp = null), yp.forEach(Op), bp.forEach(Op);
	}
	function Ap(e, t) {
		e.blockedOn === t && (e.blockedOn = null, hp || (hp = !0, n.unstable_scheduleCallback(n.unstable_NormalPriority, kp)));
	}
	var jp = null;
	function Mp(e) {
		jp !== e && (jp = e, n.unstable_scheduleCallback(n.unstable_NormalPriority, function() {
			jp === e && (jp = null);
			for (var t = 0; t < e.length; t += 3) {
				var n = e[t], r = e[t + 1], i = e[t + 2];
				if (typeof r != "function") {
					if (pp(r || n) === null) continue;
					break;
				}
				var a = ht(n);
				a !== null && (e.splice(t, 3), t -= 3, xs(a, {
					pending: !0,
					data: i,
					method: n.method,
					action: r
				}, r, i));
			}
		}));
	}
	function Np(e) {
		function t(t) {
			return Ap(t, e);
		}
		gp !== null && Ap(gp, e), _p !== null && Ap(_p, e), vp !== null && Ap(vp, e), yp.forEach(t), bp.forEach(t);
		for (var n = 0; n < xp.length; n++) {
			var r = xp[n];
			r.blockedOn === e && (r.blockedOn = null);
		}
		for (; 0 < xp.length && (n = xp[0], n.blockedOn === null);) Ep(n), n.blockedOn === null && xp.shift();
		if (n = (e.ownerDocument || e).$$reactFormReplay, n != null) for (r = 0; r < n.length; r += 3) {
			var i = n[r], a = n[r + 1], o = i[ot] || null;
			if (typeof a == "function") o || Mp(n);
			else if (o) {
				var s = null;
				if (a && a.hasAttribute("formAction")) {
					if (i = a, o = a[ot] || null) s = o.formAction;
					else if (pp(i) !== null) continue;
				} else s = o.action;
				typeof s == "function" ? n[r + 1] = s : (n.splice(r, 3), r -= 3), Mp(n);
			}
		}
	}
	function Pp() {
		function e(e) {
			e.canIntercept && e.info === "react-transition" && e.intercept({
				handler: function() {
					return new Promise(function(e) {
						return i = e;
					});
				},
				focusReset: "manual",
				scroll: "manual"
			});
		}
		function t() {
			i !== null && (i(), i = null), r || setTimeout(n, 20);
		}
		function n() {
			if (!r && !navigation.transition) {
				var e = navigation.currentEntry;
				e && e.url != null && navigation.navigate(e.url, {
					state: e.getState(),
					info: "react-transition",
					history: "replace"
				});
			}
		}
		if (typeof navigation == "object") {
			var r = !1, i = null;
			return navigation.addEventListener("navigate", e), navigation.addEventListener("navigatesuccess", t), navigation.addEventListener("navigateerror", t), setTimeout(n, 100), function() {
				r = !0, navigation.removeEventListener("navigate", e), navigation.removeEventListener("navigatesuccess", t), navigation.removeEventListener("navigateerror", t), i !== null && (i(), i = null);
			};
		}
	}
	function Fp(e) {
		this._internalRoot = e;
	}
	Ip.prototype.render = Fp.prototype.render = function(e) {
		var t = this._internalRoot;
		if (t === null) throw Error(a(409));
		var n = t.current;
		np(n, pu(), e, t, null, null);
	}, Ip.prototype.unmount = Fp.prototype.unmount = function() {
		var e = this._internalRoot;
		if (e !== null) {
			this._internalRoot = null;
			var t = e.containerInfo;
			np(e.current, 2, null, e, null, null), bu(), t[st] = null;
		}
	};
	function Ip(e) {
		this._internalRoot = e;
	}
	Ip.prototype.unstable_scheduleHydration = function(e) {
		if (e) {
			var t = nt();
			e = {
				blockedOn: null,
				target: e,
				priority: t
			};
			for (var n = 0; n < xp.length && t !== 0 && t < xp[n].priority; n++);
			xp.splice(n, 0, e), n === 0 && Ep(e);
		}
	};
	var Lp = r.version;
	if (Lp !== "19.2.8") throw Error(a(527, Lp, "19.2.8"));
	k.findDOMNode = function(e) {
		var t = e._reactInternals;
		if (t === void 0) throw typeof e.render == "function" ? Error(a(188)) : (e = Object.keys(e).join(","), Error(a(268, e)));
		return e = d(t), e = e === null ? null : f(e), e = e === null ? null : e.stateNode, e;
	};
	var Rp = {
		bundleType: 0,
		version: "19.2.8",
		rendererPackageName: "react-dom",
		currentDispatcherRef: O,
		reconcilerVersion: "19.2.8"
	};
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
		var zp = __REACT_DEVTOOLS_GLOBAL_HOOK__;
		if (!zp.isDisabled && zp.supportsFiber) try {
			Ne = zp.inject(Rp), Pe = zp;
		} catch {}
	}
	t.createRoot = function(e, t) {
		if (!o(e)) throw Error(a(299));
		var n = !1, r = "", i = Ws, s = Gs, c = Ks;
		return t != null && (!0 === t.unstable_strictMode && (n = !0), t.identifierPrefix !== void 0 && (r = t.identifierPrefix), t.onUncaughtError !== void 0 && (i = t.onUncaughtError), t.onCaughtError !== void 0 && (s = t.onCaughtError), t.onRecoverableError !== void 0 && (c = t.onRecoverableError)), t = ep(e, 1, !1, null, null, n, r, null, i, s, c, Pp), e[st] = t.current, Sd(e), new Fp(t);
	};
})), fe = /* @__PURE__ */ y(((e, t) => {
	function n() {
		if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function")) try {
			__REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(n);
		} catch (e) {
			console.error(e);
		}
	}
	n(), t.exports = P();
})), F = /* @__PURE__ */ n(e(), 1), I = t(), pe = F.createContext(void 0), me = (e) => {
	let t = F.useContext(pe);
	if (e) return e;
	if (!t) throw Error("No QueryClient set, use QueryClientProvider to set one");
	return t;
}, he = ({ client: e, children: t }) => (F.useEffect(() => (e.mount(), () => {
	e.unmount();
}), [e]), /* @__PURE__ */ (0, I.jsx)(pe.Provider, {
	value: e,
	children: t
})), ge = {
	setTimeout: (e, t) => setTimeout(e, t),
	clearTimeout: (e) => clearTimeout(e),
	setInterval: (e, t) => setInterval(e, t),
	clearInterval: (e) => clearInterval(e)
}, _e = new class {
	#e = ge;
	setTimeoutProvider(e) {
		this.#e = e;
	}
	setTimeout(e, t) {
		return this.#e.setTimeout(e, t);
	}
	clearTimeout(e) {
		this.#e.clearTimeout(e);
	}
	setInterval(e, t) {
		return this.#e.setInterval(e, t);
	}
	clearInterval(e) {
		this.#e.clearInterval(e);
	}
}();
function ve(e) {
	setTimeout(e, 0);
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/utils.js
var ye = typeof window > "u" || "Deno" in globalThis;
function L() {}
function be(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function xe(e) {
	return typeof e == "number" && e >= 0 && e !== Infinity;
}
function Se(e, t) {
	return Math.max(e + (t || 0) - Date.now(), 0);
}
function R(e, t) {
	return typeof e == "function" ? e(t) : e;
}
function Ce(e, t) {
	let { type: n = "all", exact: r, fetchStatus: i, predicate: a, queryKey: o, stale: s } = e;
	if (o) {
		if (r) {
			if (t.queryHash !== we(o, t.options)) return !1;
		} else if (!Ee(t.queryKey, o)) return !1;
	}
	if (n !== "all") {
		let e = t.isActive();
		if (n === "active" && !e || n === "inactive" && e) return !1;
	}
	return !(typeof s == "boolean" && t.isStale() !== s || i && i !== t.state.fetchStatus || a && !a(t));
}
function z(e, t) {
	let { exact: n, status: r, predicate: i, mutationKey: a } = e;
	if (a) {
		if (!t.options.mutationKey) return !1;
		if (n) {
			if (Te(t.options.mutationKey) !== Te(a)) return !1;
		} else if (!Ee(t.options.mutationKey, a)) return !1;
	}
	return !(r && t.state.status !== r || i && !i(t));
}
function we(e, t) {
	return (t?.queryKeyHashFn || Te)(e);
}
function Te(e) {
	return JSON.stringify(e, (e, t) => je(t) ? Object.keys(t).sort().reduce((e, n) => (e[n] = t[n], e), {}) : t);
}
function Ee(e, t) {
	if (e === t) return !0;
	if (typeof e != typeof t) return !1;
	if (e && t && typeof e == "object" && typeof t == "object") {
		if (Array.isArray(e) && Array.isArray(t)) {
			for (let n = 0; n < t.length; n++) if (!Ee(e[n], t[n])) return !1;
			return !0;
		}
		let n = Object.keys(t);
		for (let r of n) if (!Ee(e[r], t[r])) return !1;
		return !0;
	}
	return !1;
}
var De = Object.prototype.hasOwnProperty;
function Oe(e, t, n = 0) {
	if (e === t) return e;
	if (n > 500) return t;
	let r = Ae(e) && Ae(t);
	if (!r && !(je(e) && je(t))) return t;
	let i = (r ? e : Object.keys(e)).length, a = r ? t : Object.keys(t), o = a.length, s = r ? Array(o) : {}, c = 0;
	for (let l = 0; l < o; l++) {
		let o = r ? l : a[l], u = e[o], d = t[o];
		if (u === d) {
			s[o] = u, (r ? l < i : De.call(e, o)) && c++;
			continue;
		}
		if (u === null || d === null || typeof u != "object" || typeof d != "object") {
			s[o] = d;
			continue;
		}
		let f = Oe(u, d, n + 1);
		s[o] = f, f === u && c++;
	}
	return i === o && c === i ? e : s;
}
function ke(e, t) {
	if (!t || Object.keys(e).length !== Object.keys(t).length) return !1;
	for (let n in e) if (e[n] !== t[n]) return !1;
	return !0;
}
function Ae(e) {
	return Array.isArray(e) && e.length === Object.keys(e).length;
}
function je(e) {
	if (!Me(e)) return !1;
	let t = e.constructor;
	if (t === void 0) return !0;
	let n = t.prototype;
	return !(!Me(n) || !n.hasOwnProperty("isPrototypeOf") || Object.getPrototypeOf(e) !== Object.prototype);
}
function Me(e) {
	return Object.prototype.toString.call(e) === "[object Object]";
}
function Ne(e) {
	return new Promise((t) => {
		_e.setTimeout(t, e);
	});
}
function Pe(e, t, n) {
	return typeof n.structuralSharing == "function" ? n.structuralSharing(e, t) : n.structuralSharing === !1 ? t : Oe(e, t);
}
function Fe(e, t, n = 0) {
	let r = [...e, t];
	return n && r.length > n ? r.slice(1) : r;
}
function Ie(e, t, n = 0) {
	let r = [t, ...e];
	return n && r.length > n ? r.slice(0, -1) : r;
}
var Le = Symbol();
function Re(e, t) {
	return !e.queryFn && t?.initialPromise ? () => t.initialPromise : !e.queryFn || e.queryFn === Le ? () => Promise.reject(/* @__PURE__ */ Error(`Missing queryFn: '${e.queryHash}'`)) : e.queryFn;
}
function ze(e, t) {
	return typeof e == "function" ? e(...t) : !!e;
}
function Be(e, t, n) {
	let r = !1, i;
	return Object.defineProperty(e, "signal", {
		enumerable: !0,
		get: () => (i ??= t(), r ? i : (r = !0, i.aborted ? n() : i.addEventListener("abort", n, { once: !0 }), i))
	}), e;
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/environmentManager.js
var Ve = () => ye, He = () => Ve(), Ue = class {
	constructor() {
		this.listeners = /* @__PURE__ */ new Set(), this.subscribe = this.subscribe.bind(this);
	}
	subscribe(e) {
		return this.listeners.add(e), this.onSubscribe(), () => {
			this.listeners.delete(e), this.onUnsubscribe();
		};
	}
	hasListeners() {
		return this.listeners.size > 0;
	}
	onSubscribe() {}
	onUnsubscribe() {}
}, We = new class extends Ue {
	#e;
	#t;
	#n;
	constructor() {
		super(), this.#n = (e) => {
			if (typeof window < "u" && window.addEventListener) {
				let t = () => e();
				return window.addEventListener("visibilitychange", t, !1), () => {
					window.removeEventListener("visibilitychange", t);
				};
			}
		};
	}
	onSubscribe() {
		this.#t || this.setEventListener(this.#n);
	}
	onUnsubscribe() {
		this.hasListeners() || (this.#t?.(), this.#t = void 0);
	}
	setEventListener(e) {
		this.#n = e, this.#t?.(), this.#t = e((e) => {
			typeof e == "boolean" ? this.setFocused(e) : this.onFocus();
		});
	}
	setFocused(e) {
		this.#e !== e && (this.#e = e, this.onFocus());
	}
	onFocus() {
		let e = this.isFocused();
		this.listeners.forEach((t) => {
			t(e);
		});
	}
	isFocused() {
		return typeof this.#e == "boolean" ? this.#e : globalThis.document?.visibilityState !== "hidden";
	}
}(), Ge = ve;
function Ke() {
	let e = [], t = 0, n = (e) => {
		e();
	}, r = (e) => {
		e();
	}, i = Ge, a = (r) => {
		t ? e.push(r) : i(() => {
			n(r);
		});
	}, o = () => {
		let t = e;
		e = [], t.length && i(() => {
			r(() => {
				t.forEach((e) => {
					n(e);
				});
			});
		});
	};
	return {
		batch: (e) => {
			let n;
			t++;
			try {
				n = e();
			} finally {
				t--, t || o();
			}
			return n;
		},
		batchCalls: (e) => (...t) => {
			a(() => {
				e(...t);
			});
		},
		schedule: a,
		setNotifyFunction: (e) => {
			n = e;
		},
		setBatchNotifyFunction: (e) => {
			r = e;
		},
		setScheduler: (e) => {
			i = e;
		}
	};
}
var qe = Ke(), Je = new class extends Ue {
	#e = !0;
	#t;
	#n;
	constructor() {
		super(), this.#n = (e) => {
			if (typeof window < "u" && window.addEventListener) {
				let t = () => e(!0), n = () => e(!1);
				return window.addEventListener("online", t, !1), window.addEventListener("offline", n, !1), () => {
					window.removeEventListener("online", t), window.removeEventListener("offline", n);
				};
			}
		};
	}
	onSubscribe() {
		this.#t || this.setEventListener(this.#n);
	}
	onUnsubscribe() {
		this.hasListeners() || (this.#t?.(), this.#t = void 0);
	}
	setEventListener(e) {
		this.#n = e, this.#t?.(), this.#t = e(this.setOnline.bind(this));
	}
	setOnline(e) {
		this.#e !== e && (this.#e = e, this.listeners.forEach((t) => {
			t(e);
		}));
	}
	isOnline() {
		return this.#e;
	}
}();
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/retryer.js
function Ye(e) {
	return Math.min(1e3 * 2 ** e, 3e4);
}
function Xe(e) {
	return (e ?? "online") !== "online" || Je.isOnline();
}
var Ze = class extends Error {
	constructor(e) {
		super("CancelledError"), this.revert = e?.revert, this.silent = e?.silent;
	}
};
function Qe(e) {
	let t = !1, n = 0, r, i = "pending", a, o, s = new Promise((e, t) => {
		a = e, o = t;
	});
	s.catch(L);
	let c = () => i !== "pending", l = (t) => {
		if (!c()) {
			let n = new Ze(t);
			h(n), e.onCancel?.(n);
		}
	}, u = () => {
		t = !0;
	}, d = () => {
		t = !1;
	}, f = () => We.isFocused() && (e.networkMode === "always" || Je.isOnline()) && e.canRun(), p = () => Xe(e.networkMode) && e.canRun(), m = (e) => {
		c() || (r?.(), i = "resolved", a(e));
	}, h = (e) => {
		c() || (r?.(), i = "rejected", o(e));
	}, g = () => new Promise((t) => {
		r = (e) => {
			(c() || f()) && t(e);
		}, e.onPause?.();
	}).then(() => {
		r = void 0, c() || e.onContinue?.();
	}), _ = () => {
		if (c()) return;
		let r, i = n === 0 ? e.initialPromise : void 0;
		try {
			r = i ?? e.fn();
		} catch (e) {
			r = Promise.reject(e);
		}
		Promise.resolve(r).then(m).catch((r) => {
			if (c()) return;
			let i = e.retry ?? (He() ? 0 : 3), a = e.retryDelay ?? Ye, o = typeof a == "function" ? a(n, r) : a, s = i === !0 || typeof i == "number" && n < i || typeof i == "function" && i(n, r);
			if (t || !s) {
				h(r);
				return;
			}
			n++, e.onFail?.(n, r), Ne(o).then(() => f() ? void 0 : g()).then(() => {
				t ? h(r) : _();
			});
		});
	};
	return {
		promise: s,
		status: () => i,
		cancel: l,
		continue: () => (r?.(), s),
		cancelRetry: u,
		continueRetry: d,
		canStart: p,
		start: () => (p() ? _() : g().then(_), s)
	};
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/removable.js
var $e = class {
	#e;
	destroy() {
		this.clearGcTimeout();
	}
	scheduleGc() {
		this.clearGcTimeout(), xe(this.gcTime) && (this.#e = _e.setTimeout(() => {
			this.optionalRemove();
		}, this.gcTime));
	}
	updateGcTime(e) {
		this.gcTime = Math.max(this.gcTime || 0, e ?? (He() ? Infinity : 3e5));
	}
	clearGcTimeout() {
		this.#e !== void 0 && (_e.clearTimeout(this.#e), this.#e = void 0);
	}
};
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/infiniteQueryBehavior.js
function et(e) {
	return { onFetch: (t, n) => {
		let r = t.options, i = t.fetchOptions?.meta?.fetchMore?.direction, a = t.state.data?.pages || [], o = t.state.data?.pageParams || [], s = {
			pages: [],
			pageParams: []
		}, c = 0, l = async () => {
			let n = !1, l = (e) => {
				Be(e, () => t.signal, () => n = !0);
			}, u = Re(t.options, t.fetchOptions), d = async (e, r, i) => {
				if (n) return Promise.reject(t.signal.reason);
				if (r == null && e.pages.length) return Promise.resolve(e);
				let a = (() => {
					let e = {
						client: t.client,
						queryKey: t.queryKey,
						pageParam: r,
						direction: i ? "backward" : "forward",
						meta: t.options.meta
					};
					return l(e), e;
				})(), o = await u(a), { maxPages: s } = t.options, c = i ? Ie : Fe;
				return {
					pages: c(e.pages, o, s),
					pageParams: c(e.pageParams, r, s)
				};
			};
			if (i && a.length) {
				let e = i === "backward", t = e ? nt : tt, n = {
					pages: a,
					pageParams: o
				};
				s = await d(n, t(r, n), e);
			} else {
				let t = e ?? a.length;
				do {
					let e = c === 0 ? o[0] ?? r.initialPageParam : tt(r, s);
					if (c > 0 && e == null) break;
					s = await d(s, e), c++;
				} while (c < t);
			}
			return s;
		};
		t.fetchFn = t.options.persister ? () => t.options.persister?.(l, {
			client: t.client,
			queryKey: t.queryKey,
			meta: t.options.meta,
			signal: t.signal
		}, n) : l;
	} };
}
function tt(e, { pages: t, pageParams: n }) {
	let r = t.length - 1;
	return t.length > 0 ? e.getNextPageParam(t[r], t, n[r], n) : void 0;
}
function nt(e, { pages: t, pageParams: n }) {
	return t.length > 0 ? e.getPreviousPageParam?.(t[0], t, n[0], n) : void 0;
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/query.js
var rt = class extends $e {
	#e;
	#t;
	#n;
	#r;
	#i;
	#a;
	#o;
	#s;
	constructor(e) {
		super(), this.#s = !1, this.#o = e.defaultOptions, this.setOptions(e.options), this.observers = [], this.#i = e.client, this.#r = this.#i.getQueryCache(), this.queryKey = e.queryKey, this.queryHash = e.queryHash, this.#t = ot(this.options), this.state = e.state ?? this.#t, this.scheduleGc();
	}
	get meta() {
		return this.options.meta;
	}
	get queryType() {
		return this.#e;
	}
	get promise() {
		return this.#a?.promise;
	}
	setOptions(e) {
		if (this.options = {
			...this.#o,
			...e
		}, e?._type && (this.#e = e._type), this.updateGcTime(this.options.gcTime), this.state && this.state.data === void 0) {
			let e = ot(this.options);
			e.data !== void 0 && (this.setState(at(e.data, e.dataUpdatedAt)), this.#t = e);
		}
	}
	optionalRemove() {
		!this.observers.length && this.state.fetchStatus === "idle" && this.#r.remove(this);
	}
	setData(e, t) {
		let n = Pe(this.state.data, e, this.options);
		return this.#c({
			data: n,
			type: "success",
			dataUpdatedAt: t?.updatedAt,
			manual: t?.manual
		}), n;
	}
	setState(e) {
		this.#c({
			type: "setState",
			state: e
		});
	}
	cancel(e) {
		let t = this.#a?.promise;
		return this.#a?.cancel(e), t ? t.then(L).catch(L) : Promise.resolve();
	}
	destroy() {
		super.destroy(), this.cancel({ silent: !0 });
	}
	get resetState() {
		return this.#t;
	}
	reset() {
		this.destroy(), this.setState(this.resetState);
	}
	isActive() {
		return this.observers.some((e) => R(e.options.enabled, this) !== !1);
	}
	isDisabled() {
		return this.getObserversCount() > 0 ? !this.isActive() : this.options.queryFn === Le || !this.isFetched();
	}
	isFetched() {
		return this.state.dataUpdateCount + this.state.errorUpdateCount > 0;
	}
	isStatic() {
		return this.getObserversCount() > 0 && this.observers.some((e) => R(e.options.staleTime, this) === "static");
	}
	isStale() {
		return this.getObserversCount() > 0 ? this.observers.some((e) => e.getCurrentResult().isStale) : this.state.data === void 0 || this.state.isInvalidated;
	}
	isStaleByTime(e = 0) {
		return this.state.data === void 0 ? !0 : e === "static" ? !1 : this.state.isInvalidated ? !0 : !Se(this.state.dataUpdatedAt, e);
	}
	onFocus() {
		this.observers.find((e) => e.shouldFetchOnWindowFocus())?.refetch({ cancelRefetch: !1 }), this.#a?.continue();
	}
	onOnline() {
		this.observers.find((e) => e.shouldFetchOnReconnect())?.refetch({ cancelRefetch: !1 }), this.#a?.continue();
	}
	addObserver(e) {
		this.observers.includes(e) || (this.observers.push(e), this.clearGcTimeout(), this.#r.notify({
			type: "observerAdded",
			query: this,
			observer: e
		}));
	}
	removeObserver(e) {
		let t = this.observers.indexOf(e);
		t !== -1 && (this.observers.splice(t, 1), this.observers.length || (this.#a && (this.#s || this.state.fetchStatus === "paused" && this.state.status === "pending" ? this.#a.cancel({ revert: !0 }) : this.#a.cancelRetry()), this.scheduleGc()), this.#r.notify({
			type: "observerRemoved",
			query: this,
			observer: e
		}));
	}
	getObserversCount() {
		return this.observers.length;
	}
	invalidate() {
		this.state.isInvalidated || this.#c({ type: "invalidate" });
	}
	async fetch(e, t) {
		if (this.state.fetchStatus !== "idle" && this.#a?.status() !== "rejected") {
			if (this.state.data !== void 0 && t?.cancelRefetch) this.cancel({ silent: !0 });
			else if (this.#a) return this.#a.continueRetry(), this.#a.promise;
		}
		if (e && this.setOptions(e), !this.options.queryFn) {
			let e = this.observers.find((e) => e.options.queryFn);
			e && this.setOptions(e.options);
		}
		let n = new AbortController(), r = (e) => {
			Object.defineProperty(e, "signal", {
				enumerable: !0,
				get: () => (this.#s = !0, n.signal)
			});
		}, i = () => {
			let e = Re(this.options, t), n = (() => {
				let e = {
					client: this.#i,
					queryKey: this.queryKey,
					meta: this.meta
				};
				return r(e), e;
			})();
			return this.#s = !1, this.options.persister ? this.options.persister(e, n, this) : e(n);
		}, a = (() => {
			let e = {
				fetchOptions: t,
				options: this.options,
				queryKey: this.queryKey,
				client: this.#i,
				state: this.state,
				fetchFn: i
			};
			return r(e), e;
		})();
		(this.#e === "infinite" ? et(this.options.pages) : this.options.behavior)?.onFetch(a, this), this.#n = this.state, (this.state.fetchStatus === "idle" || this.state.fetchMeta !== a.fetchOptions?.meta) && this.#c({
			type: "fetch",
			meta: a.fetchOptions?.meta
		});
		let o = this.#a = Qe({
			initialPromise: t?.initialPromise,
			fn: a.fetchFn,
			onCancel: (e) => {
				e instanceof Ze && e.revert && this.setState({
					...this.#n,
					fetchStatus: "idle"
				}), n.abort();
			},
			onFail: (e, t) => {
				this.#c({
					type: "failed",
					failureCount: e,
					error: t
				});
			},
			onPause: () => {
				this.#c({ type: "pause" });
			},
			onContinue: () => {
				this.#c({ type: "continue" });
			},
			retry: a.options.retry,
			retryDelay: a.options.retryDelay,
			networkMode: a.options.networkMode,
			canRun: () => !0
		});
		try {
			let e = await o.start();
			if (e === void 0) throw Error(`${this.queryHash} data is undefined`);
			return this.setData(e), this.#r.config.onSuccess?.(e, this), this.#r.config.onSettled?.(e, this.state.error, this), e;
		} catch (e) {
			if (e instanceof Ze) {
				if (e.silent) return this.#a.promise;
				if (e.revert) {
					if (this.state.data === void 0) throw e;
					return this.state.data;
				}
			}
			throw this.#c({
				type: "error",
				error: e
			}), this.#r.config.onError?.(e, this), this.#r.config.onSettled?.(this.state.data, e, this), e;
		} finally {
			this.#a === o && (this.#a = void 0), this.scheduleGc();
		}
	}
	#c(e) {
		let t = (t) => {
			switch (e.type) {
				case "failed": return {
					...t,
					fetchFailureCount: e.failureCount,
					fetchFailureReason: e.error
				};
				case "pause": return {
					...t,
					fetchStatus: "paused"
				};
				case "continue": return {
					...t,
					fetchStatus: "fetching"
				};
				case "fetch": return {
					...t,
					...it(t.data, this.options),
					fetchMeta: e.meta ?? null
				};
				case "success":
					let n = {
						...t,
						...at(e.data, e.dataUpdatedAt),
						dataUpdateCount: t.dataUpdateCount + 1,
						...!e.manual && {
							fetchStatus: "idle",
							fetchFailureCount: 0,
							fetchFailureReason: null
						}
					};
					return this.#n = e.manual ? n : void 0, n;
				case "error":
					let r = e.error;
					return {
						...t,
						error: r,
						errorUpdateCount: t.errorUpdateCount + 1,
						errorUpdatedAt: Date.now(),
						fetchFailureCount: t.fetchFailureCount + 1,
						fetchFailureReason: r,
						fetchStatus: "idle",
						status: "error",
						isInvalidated: !0
					};
				case "invalidate": return {
					...t,
					isInvalidated: !0
				};
				case "setState": return {
					...t,
					...e.state
				};
			}
		};
		this.state = t(this.state), qe.batch(() => {
			this.observers.slice().forEach((e) => {
				e.onQueryUpdate();
			}), this.#r.notify({
				query: this,
				type: "updated",
				action: e
			});
		});
	}
};
function it(e, t) {
	return {
		fetchFailureCount: 0,
		fetchFailureReason: null,
		fetchStatus: Xe(t.networkMode) ? "fetching" : "paused",
		...e === void 0 && {
			error: null,
			status: "pending"
		}
	};
}
function at(e, t) {
	return {
		data: e,
		dataUpdatedAt: t ?? Date.now(),
		error: null,
		isInvalidated: !1,
		status: "success"
	};
}
function ot(e) {
	let t = typeof e.initialData == "function" ? e.initialData() : e.initialData, n = t !== void 0, r = n ? typeof e.initialDataUpdatedAt == "function" ? e.initialDataUpdatedAt() : e.initialDataUpdatedAt : 0;
	return {
		data: t,
		dataUpdateCount: 0,
		dataUpdatedAt: n ? r ?? Date.now() : 0,
		error: null,
		errorUpdateCount: 0,
		errorUpdatedAt: 0,
		fetchFailureCount: 0,
		fetchFailureReason: null,
		fetchMeta: null,
		isInvalidated: !1,
		status: n ? "success" : "pending",
		fetchStatus: "idle"
	};
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/queryObserver.js
var st = class extends Ue {
	#e;
	#t = void 0;
	#n = void 0;
	#r = void 0;
	#i;
	#a;
	#o;
	#s;
	#c;
	#l;
	#u;
	#d;
	#f;
	#p = /* @__PURE__ */ new Set();
	constructor(e, t) {
		super(), this.options = t, this.#e = e, this.#o = null, this.bindMethods(), this.setOptions(t);
	}
	bindMethods() {
		this.refetch = this.refetch.bind(this);
	}
	onSubscribe() {
		this.listeners.size === 1 && (this.#t.addObserver(this), lt(this.#t, this.options) ? this.#m() : this.updateResult(), this.#y());
	}
	onUnsubscribe() {
		this.hasListeners() || this.destroy();
	}
	shouldFetchOnReconnect() {
		return ut(this.#t, this.options, this.options.refetchOnReconnect);
	}
	shouldFetchOnWindowFocus() {
		return ut(this.#t, this.options, this.options.refetchOnWindowFocus);
	}
	destroy() {
		this.listeners = /* @__PURE__ */ new Set(), this.#b(), this.#x(), this.#t.removeObserver(this);
	}
	setOptions(e) {
		let t = this.options, n = this.#t;
		if (this.options = this.#e.defaultQueryOptions(e), this.options.enabled !== void 0 && typeof this.options.enabled != "boolean" && typeof this.options.enabled != "function" && typeof R(this.options.enabled, this.#t) != "boolean") throw Error("Expected enabled to be a boolean or a callback that returns a boolean");
		this.#S(), this.#t.setOptions(this.options), t._defaulted && !ke(this.options, t) && this.#e.getQueryCache().notify({
			type: "observerOptionsUpdated",
			query: this.#t,
			observer: this
		});
		let r = this.hasListeners();
		r && dt(this.#t, n, this.options, t) && this.#m(), this.updateResult(), r && (this.#t !== n || R(this.options.enabled, this.#t) !== R(t.enabled, this.#t) || R(this.options.staleTime, this.#t) !== R(t.staleTime, this.#t)) && this.#g();
		let i = this.#_();
		r && (this.#t !== n || R(this.options.enabled, this.#t) !== R(t.enabled, this.#t) || i !== this.#f) && this.#v(i);
	}
	getOptimisticResult(e) {
		let t = this.#e.getQueryCache().build(this.#e, e), n = this.createResult(t, e);
		return ke(this.getCurrentResult(), n) || (this.#r = n, this.#a = this.options, this.#i = this.#t.state), n;
	}
	getCurrentResult() {
		return this.#r;
	}
	trackResult(e, t) {
		return new Proxy(e, { get: (e, n) => (this.trackProp(n), t?.(n), Reflect.get(e, n)) });
	}
	trackProp(e) {
		this.#p.add(e);
	}
	getCurrentQuery() {
		return this.#t;
	}
	refetch({ ...e } = {}) {
		return this.fetch({ ...e });
	}
	fetchOptimistic(e) {
		let t = this.#e.defaultQueryOptions(e), n = this.#e.getQueryCache().build(this.#e, t), r = () => {}, i, a = new Promise((e) => {
			i = e, r = this.#e.getQueryCache().subscribe((i) => {
				i.type === "updated" && i.query.queryHash === n.queryHash && n.state.data !== void 0 && (r(), e(this.createResult(n, t)));
			});
		});
		return Promise.race([n.fetch().then(() => {
			let e = this.createResult(n, t);
			return i?.(e), e;
		}).finally(() => {
			r();
		}), a]);
	}
	fetch(e) {
		return this.#m({
			...e,
			cancelRefetch: e.cancelRefetch ?? !0
		}).then(() => (this.updateResult(), this.#r));
	}
	#m(e) {
		this.#S();
		let t = this.#t.fetch(this.options, e);
		return e?.throwOnError || (t = t.catch(L)), t;
	}
	#h(e) {
		return !He() && R(this.options.enabled, this.#t) !== !1 && xe(e);
	}
	#g() {
		this.#b();
		let e = R(this.options.staleTime, this.#t);
		if (this.#r.isStale || !this.#h(e)) return;
		let t = Se(this.#r.dataUpdatedAt, e) + 1;
		this.#u = _e.setTimeout(() => {
			this.#r.isStale || this.updateResult();
		}, t);
	}
	#_() {
		return (typeof this.options.refetchInterval == "function" ? this.options.refetchInterval(this.#t) : this.options.refetchInterval) ?? !1;
	}
	#v(e) {
		this.#x(), this.#f = e, this.#f !== 0 && this.#h(this.#f) && (this.#d = _e.setInterval(() => {
			(this.options.refetchIntervalInBackground || We.isFocused()) && this.#m();
		}, this.#f));
	}
	#y() {
		this.#g(), this.#v(this.#_());
	}
	#b() {
		this.#u !== void 0 && (_e.clearTimeout(this.#u), this.#u = void 0);
	}
	#x() {
		this.#d !== void 0 && (_e.clearInterval(this.#d), this.#d = void 0);
	}
	createResult(e, t) {
		let n = this.#t, r = this.options, i = this.#r, a = this.#i, o = this.#a, s = e === n ? this.#n : e.state, { state: c } = e, l = { ...c }, u = !1, d;
		if (t._optimisticResults) {
			let i = this.hasListeners(), a = !i && lt(e, t), o = i && dt(e, n, t, r);
			(a || o) && (l = {
				...l,
				...it(c.data, e.options)
			}), t._optimisticResults === "isRestoring" && (l.fetchStatus = "idle");
		}
		let { error: f, errorUpdatedAt: p, status: m } = l;
		d = l.data;
		let h = !1;
		if (t.placeholderData !== void 0 && d === void 0 && m === "pending") {
			let e;
			i?.isPlaceholderData && t.placeholderData === o?.placeholderData ? (e = i.data, h = !0) : e = typeof t.placeholderData == "function" ? t.placeholderData(this.#l?.state.data, this.#l) : t.placeholderData, e !== void 0 && (m = "success", d = Pe(i?.data, e, t), u = !0);
		}
		if (t.select && d !== void 0 && !h) {
			if (i && d === a?.data && t.select === this.#s) d = this.#c;
			else try {
				this.#s = t.select, d = t.select(d), d = Pe(i?.data, d, t), this.#c = d, this.#o = null;
			} catch (e) {
				this.#o = e;
			}
		} else d === void 0 && (this.#o = null);
		this.#o && (f = this.#o, d = this.#c, p = Date.now(), m = "error", u = !1);
		let g = l.fetchStatus === "fetching", _ = m === "pending", v = m === "error", y = _ && g, b = d !== void 0;
		return {
			status: m,
			fetchStatus: l.fetchStatus,
			isPending: _,
			isSuccess: m === "success",
			isError: v,
			isInitialLoading: y,
			isLoading: y,
			data: d,
			dataUpdatedAt: l.dataUpdatedAt,
			error: f,
			errorUpdatedAt: p,
			failureCount: l.fetchFailureCount,
			failureReason: l.fetchFailureReason,
			errorUpdateCount: l.errorUpdateCount,
			isFetched: e.isFetched(),
			isFetchedAfterMount: l.dataUpdateCount > s.dataUpdateCount || l.errorUpdateCount > s.errorUpdateCount,
			isFetching: g,
			isRefetching: g && !_,
			isLoadingError: v && !b,
			isPaused: l.fetchStatus === "paused",
			isPlaceholderData: u,
			isRefetchError: v && b,
			isStale: ft(e, t),
			refetch: this.refetch,
			isEnabled: R(t.enabled, e) !== !1
		};
	}
	updateResult() {
		let e = this.#r, t = this.createResult(this.#t, this.options);
		if (this.#i = this.#t.state, this.#a = this.options, this.#i.data !== void 0 && (this.#l = this.#t), ke(t, e)) return;
		this.#r = t;
		let n = (() => {
			if (!e) return !0;
			let { notifyOnChangeProps: t } = this.options, n = typeof t == "function" ? t() : t;
			if (n === "all" || !n && !this.#p.size) return !0;
			let r = new Set(n ?? this.#p);
			return this.options.throwOnError && r.add("error"), Object.keys(this.#r).some((t) => {
				let n = t;
				return this.#r[n] !== e[n] && r.has(n);
			});
		})();
		qe.batch(() => {
			n && this.listeners.forEach((e) => {
				e(this.#r);
			}), this.#e.getQueryCache().notify({
				query: this.#t,
				type: "observerResultsUpdated"
			});
		});
	}
	#S() {
		let e = this.#e.getQueryCache().build(this.#e, this.options);
		if (e === this.#t) return;
		let t = this.#t;
		this.#t = e, this.#n = e.state, this.hasListeners() && (t?.removeObserver(this), e.addObserver(this));
	}
	onQueryUpdate() {
		this.updateResult(), this.hasListeners() && this.#y();
	}
};
function ct(e, t) {
	return R(t.enabled, e) !== !1 && e.state.data === void 0 && (e.state.status !== "error" || R(t.retryOnMount, e) !== !1);
}
function lt(e, t) {
	return ct(e, t) || e.state.data !== void 0 && ut(e, t, t.refetchOnMount);
}
function ut(e, t, n) {
	if (R(t.enabled, e) !== !1 && R(t.staleTime, e) !== "static") {
		let r = typeof n == "function" ? n(e) : n;
		return r === "always" || r !== !1 && ft(e, t);
	}
	return !1;
}
function dt(e, t, n, r) {
	return (e !== t || R(r.enabled, e) === !1) && (!n.suspense || e.state.status !== "error") && ft(e, n);
}
function ft(e, t) {
	return R(t.enabled, e) !== !1 && e.isStaleByTime(R(t.staleTime, e));
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/mutation.js
var pt = class extends $e {
	#e;
	#t;
	#n;
	#r;
	constructor(e) {
		super(), this.#e = e.client, this.mutationId = e.mutationId, this.#n = e.mutationCache, this.#t = [], this.state = e.state || mt(), this.setOptions(e.options), this.scheduleGc();
	}
	setOptions(e) {
		this.options = e, this.updateGcTime(this.options.gcTime);
	}
	get meta() {
		return this.options.meta;
	}
	addObserver(e) {
		this.#t.includes(e) || (this.#t.push(e), this.clearGcTimeout(), this.#n.notify({
			type: "observerAdded",
			mutation: this,
			observer: e
		}));
	}
	removeObserver(e) {
		this.#t = this.#t.filter((t) => t !== e), this.scheduleGc(), this.#n.notify({
			type: "observerRemoved",
			mutation: this,
			observer: e
		});
	}
	optionalRemove() {
		this.#t.length || (this.state.status === "pending" ? this.scheduleGc() : this.#n.remove(this));
	}
	continue() {
		return this.#r?.continue() ?? (this.state.status === "pending" ? this.execute(this.state.variables) : Promise.resolve());
	}
	async execute(e) {
		let t = () => {
			this.#i({ type: "continue" });
		}, n = {
			client: this.#e,
			meta: this.options.meta,
			mutationKey: this.options.mutationKey
		}, r = this.#r = Qe({
			fn: () => this.options.mutationFn ? this.options.mutationFn(e, n) : Promise.reject(/* @__PURE__ */ Error("No mutationFn found")),
			onFail: (e, t) => {
				this.#i({
					type: "failed",
					failureCount: e,
					error: t
				});
			},
			onPause: () => {
				this.#i({ type: "pause" });
			},
			onContinue: t,
			retry: this.options.retry ?? 0,
			retryDelay: this.options.retryDelay,
			networkMode: this.options.networkMode,
			canRun: () => this.#n.canRun(this)
		}), i = this.state.status === "pending", a = !r.canStart();
		try {
			if (i) t();
			else {
				this.#i({
					type: "pending",
					variables: e,
					isPaused: a
				}), this.#n.config.onMutate && await this.#n.config.onMutate(e, this, n);
				let t = await this.options.onMutate?.(e, n);
				t !== this.state.context && this.#i({
					type: "pending",
					context: t,
					variables: e,
					isPaused: a
				});
			}
			let o = await r.start();
			return await this.#n.config.onSuccess?.(o, e, this.state.context, this, n), await this.options.onSuccess?.(o, e, this.state.context, n), await this.#n.config.onSettled?.(o, null, this.state.variables, this.state.context, this, n), await this.options.onSettled?.(o, null, e, this.state.context, n), this.#i({
				type: "success",
				data: o
			}), o;
		} catch (t) {
			try {
				await this.#n.config.onError?.(t, e, this.state.context, this, n);
			} catch (e) {
				Promise.reject(e);
			}
			try {
				await this.options.onError?.(t, e, this.state.context, n);
			} catch (e) {
				Promise.reject(e);
			}
			try {
				await this.#n.config.onSettled?.(void 0, t, this.state.variables, this.state.context, this, n);
			} catch (e) {
				Promise.reject(e);
			}
			try {
				await this.options.onSettled?.(void 0, t, e, this.state.context, n);
			} catch (e) {
				Promise.reject(e);
			}
			throw this.#i({
				type: "error",
				error: t
			}), t;
		} finally {
			this.#r === r && (this.#r = void 0), this.#n.runNext(this);
		}
	}
	#i(e) {
		let t = (t) => {
			switch (e.type) {
				case "failed": return {
					...t,
					failureCount: e.failureCount,
					failureReason: e.error
				};
				case "pause": return {
					...t,
					isPaused: !0
				};
				case "continue": return {
					...t,
					isPaused: !1
				};
				case "pending": return {
					...t,
					context: e.context,
					data: void 0,
					failureCount: 0,
					failureReason: null,
					error: null,
					isPaused: e.isPaused,
					status: "pending",
					variables: e.variables,
					submittedAt: Date.now()
				};
				case "success": return {
					...t,
					data: e.data,
					failureCount: 0,
					failureReason: null,
					error: null,
					status: "success",
					isPaused: !1
				};
				case "error": return {
					...t,
					data: void 0,
					error: e.error,
					failureCount: t.failureCount + 1,
					failureReason: e.error,
					isPaused: !1,
					status: "error"
				};
			}
		};
		this.state = t(this.state), qe.batch(() => {
			this.#t.forEach((t) => {
				t.onMutationUpdate(e);
			}), this.#n.notify({
				mutation: this,
				type: "updated",
				action: e
			});
		});
	}
};
function mt() {
	return {
		context: void 0,
		data: void 0,
		error: null,
		failureCount: 0,
		failureReason: null,
		isPaused: !1,
		status: "idle",
		variables: void 0,
		submittedAt: 0
	};
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/mutationCache.js
var ht = class extends Ue {
	#e;
	#t;
	#n;
	constructor(e = {}) {
		super(), this.config = e, this.#e = /* @__PURE__ */ new Set(), this.#t = /* @__PURE__ */ new Map(), this.#n = 0;
	}
	build(e, t, n) {
		let r = new pt({
			client: e,
			mutationCache: this,
			mutationId: ++this.#n,
			options: e.defaultMutationOptions(t),
			state: n
		});
		return this.add(r), r;
	}
	add(e) {
		this.#e.add(e);
		let t = gt(e);
		if (typeof t == "string") {
			let n = this.#t.get(t);
			n ? n.push(e) : this.#t.set(t, [e]);
		}
		this.notify({
			type: "added",
			mutation: e
		});
	}
	remove(e) {
		if (this.#e.delete(e)) {
			let t = gt(e);
			if (typeof t == "string") {
				let n = this.#t.get(t);
				if (n) {
					if (n.length > 1) {
						let t = n.indexOf(e);
						t !== -1 && n.splice(t, 1);
					} else n[0] === e && this.#t.delete(t);
				}
			}
		}
		this.notify({
			type: "removed",
			mutation: e
		});
	}
	canRun(e) {
		let t = gt(e);
		if (typeof t == "string") {
			let n = this.#t.get(t)?.find((e) => e.state.status === "pending");
			return !n || n === e;
		}
		return !0;
	}
	runNext(e) {
		let t = gt(e);
		return typeof t == "string" ? (this.#t.get(t)?.find((t) => t !== e && t.state.isPaused))?.continue() ?? Promise.resolve() : Promise.resolve();
	}
	clear() {
		qe.batch(() => {
			this.#e.forEach((e) => {
				this.notify({
					type: "removed",
					mutation: e
				});
			}), this.#e.clear(), this.#t.clear();
		});
	}
	getAll() {
		return Array.from(this.#e);
	}
	find(e) {
		let t = {
			exact: !0,
			...e
		};
		return this.getAll().find((e) => z(t, e));
	}
	findAll(e = {}) {
		return this.getAll().filter((t) => z(e, t));
	}
	notify(e) {
		qe.batch(() => {
			this.listeners.forEach((t) => {
				t(e);
			});
		});
	}
	resumePausedMutations() {
		let e = this.getAll().filter((e) => e.state.isPaused);
		return qe.batch(() => Promise.all(e.map((e) => e.continue().catch(L))));
	}
};
function gt(e) {
	return e.options.scope?.id;
}
//#endregion
//#region node_modules/@tanstack/query-core/build/modern/queryCache.js
var _t = class extends Ue {
	#e;
	constructor(e = {}) {
		super(), this.config = e, this.#e = /* @__PURE__ */ new Map();
	}
	build(e, t, n) {
		let r = t.queryKey, i = t.queryHash ?? we(r, t), a = this.get(i);
		return a || (a = new rt({
			client: e,
			queryKey: r,
			queryHash: i,
			options: e.defaultQueryOptions(t),
			state: n,
			defaultOptions: e.getQueryDefaults(r)
		}), this.add(a)), a;
	}
	add(e) {
		this.#e.has(e.queryHash) || (this.#e.set(e.queryHash, e), this.notify({
			type: "added",
			query: e
		}));
	}
	remove(e) {
		let t = this.#e.get(e.queryHash);
		t && (e.destroy(), t === e && this.#e.delete(e.queryHash), this.notify({
			type: "removed",
			query: e
		}));
	}
	clear() {
		qe.batch(() => {
			this.getAll().forEach((e) => {
				this.remove(e);
			});
		});
	}
	get(e) {
		return this.#e.get(e);
	}
	getAll() {
		return [...this.#e.values()];
	}
	find(e) {
		let t = {
			exact: !0,
			...e
		};
		return this.getAll().find((e) => Ce(t, e));
	}
	findAll(e = {}) {
		let t = this.getAll();
		return Object.keys(e).length > 0 ? t.filter((t) => Ce(e, t)) : t;
	}
	notify(e) {
		qe.batch(() => {
			this.listeners.forEach((t) => {
				t(e);
			});
		});
	}
	onFocus() {
		qe.batch(() => {
			this.getAll().forEach((e) => {
				e.onFocus();
			});
		});
	}
	onOnline() {
		qe.batch(() => {
			this.getAll().forEach((e) => {
				e.onOnline();
			});
		});
	}
}, vt = class {
	#e;
	#t;
	#n;
	#r;
	#i;
	#a;
	#o;
	#s;
	constructor(e = {}) {
		this.#e = e.queryCache || new _t(), this.#t = e.mutationCache || new ht(), this.#n = e.defaultOptions || {}, this.#r = /* @__PURE__ */ new Map(), this.#i = /* @__PURE__ */ new Map(), this.#a = 0;
	}
	mount() {
		this.#a++, this.#a === 1 && (this.#o = We.subscribe(async (e) => {
			e && (await this.resumePausedMutations(), this.#e.onFocus());
		}), this.#s = Je.subscribe(async (e) => {
			e && (await this.resumePausedMutations(), this.#e.onOnline());
		}));
	}
	unmount() {
		this.#a--, this.#a === 0 && (this.#o?.(), this.#o = void 0, this.#s?.(), this.#s = void 0);
	}
	isFetching(e) {
		return this.#e.findAll({
			...e,
			fetchStatus: "fetching"
		}).length;
	}
	isMutating(e) {
		return this.#t.findAll({
			...e,
			status: "pending"
		}).length;
	}
	getQueryData(e) {
		let t = this.defaultQueryOptions({ queryKey: e });
		return this.#e.get(t.queryHash)?.state.data;
	}
	ensureQueryData(e) {
		let t = this.defaultQueryOptions(e), n = this.#e.build(this, t), r = n.state.data;
		return r === void 0 ? this.fetchQuery(e) : (e.revalidateIfStale && n.isStaleByTime(R(t.staleTime, n)) && this.prefetchQuery(t), Promise.resolve(r));
	}
	getQueriesData(e) {
		return this.#e.findAll(e).map(({ queryKey: e, state: t }) => [e, t.data]);
	}
	setQueryData(e, t, n) {
		let r = this.defaultQueryOptions({ queryKey: e }), i = this.#e.get(r.queryHash)?.state.data, a = be(t, i);
		if (a !== void 0) return this.#e.build(this, r).setData(a, {
			...n,
			manual: !0
		});
	}
	setQueriesData(e, t, n) {
		return qe.batch(() => this.#e.findAll(e).map(({ queryKey: e }) => [e, this.setQueryData(e, t, n)]));
	}
	getQueryState(e) {
		let t = this.defaultQueryOptions({ queryKey: e });
		return this.#e.get(t.queryHash)?.state;
	}
	removeQueries(e) {
		let t = this.#e;
		qe.batch(() => {
			t.findAll(e).forEach((e) => {
				t.remove(e);
			});
		});
	}
	resetQueries(e, t) {
		let n = this.#e;
		return qe.batch(() => {
			let r = n.findAll(e), i = new Set(r);
			return r.forEach((e) => {
				e.reset();
			}), this.refetchQueries({
				type: "active",
				predicate: (e) => i.has(e)
			}, t);
		});
	}
	cancelQueries(e, t = {}) {
		let n = {
			revert: !0,
			...t
		}, r = qe.batch(() => this.#e.findAll(e).map((e) => e.cancel(n)));
		return Promise.all(r).then(L).catch(L);
	}
	invalidateQueries(e, t = {}) {
		return qe.batch(() => (this.#e.findAll(e).forEach((e) => {
			e.invalidate();
		}), e?.refetchType === "none" ? Promise.resolve() : this.refetchQueries({
			...e,
			type: e?.refetchType ?? e?.type ?? "active"
		}, t)));
	}
	refetchQueries(e, t = {}) {
		let n = {
			...t,
			cancelRefetch: t.cancelRefetch ?? !0
		}, r = qe.batch(() => this.#e.findAll(e).filter((e) => !e.isDisabled() && !e.isStatic()).map((e) => {
			let t = e.fetch(void 0, n);
			return n.throwOnError || (t = t.catch(L)), e.state.fetchStatus === "paused" ? Promise.resolve() : t;
		}));
		return Promise.all(r).then(L);
	}
	async query(e) {
		let t = this.defaultQueryOptions(e);
		t.retry === void 0 && (t.retry = !1);
		let n = this.#e.build(this, t), r = n.isStaleByTime(R(t.staleTime, n)) ? await n.fetch(t) : n.state.data, i = t.select;
		return i ? i(r) : r;
	}
	fetchQuery(e) {
		let t = this.defaultQueryOptions(e);
		t.retry === void 0 && (t.retry = !1);
		let n = this.#e.build(this, t);
		return n.isStaleByTime(R(t.staleTime, n)) ? n.fetch(t) : Promise.resolve(n.state.data);
	}
	prefetchQuery(e) {
		return this.fetchQuery(e).then(L).catch(L);
	}
	infiniteQuery(e) {
		return e._type = "infinite", this.query(e);
	}
	fetchInfiniteQuery(e) {
		return e._type = "infinite", this.fetchQuery(e);
	}
	prefetchInfiniteQuery(e) {
		return this.fetchInfiniteQuery(e).then(L).catch(L);
	}
	ensureInfiniteQueryData(e) {
		return e._type = "infinite", this.ensureQueryData(e);
	}
	resumePausedMutations() {
		return Je.isOnline() ? this.#t.resumePausedMutations() : Promise.resolve();
	}
	getQueryCache() {
		return this.#e;
	}
	getMutationCache() {
		return this.#t;
	}
	getDefaultOptions() {
		return this.#n;
	}
	setDefaultOptions(e) {
		this.#n = e;
	}
	setQueryDefaults(e, t) {
		this.#r.set(Te(e), {
			queryKey: e,
			defaultOptions: t
		});
	}
	getQueryDefaults(e) {
		let t = [...this.#r.values()], n = {};
		return t.forEach((t) => {
			Ee(e, t.queryKey) && Object.assign(n, t.defaultOptions);
		}), n;
	}
	setMutationDefaults(e, t) {
		this.#i.set(Te(e), {
			mutationKey: e,
			defaultOptions: t
		});
	}
	getMutationDefaults(e) {
		let t = [...this.#i.values()], n = {};
		return t.forEach((t) => {
			Ee(e, t.mutationKey) && Object.assign(n, t.defaultOptions);
		}), n;
	}
	defaultQueryOptions(e) {
		if (e._defaulted) return e;
		let t = {
			...this.#n.queries,
			...this.getQueryDefaults(e.queryKey),
			...e,
			_defaulted: !0
		};
		return t.queryHash ||= we(t.queryKey, t), t.refetchOnReconnect === void 0 && (t.refetchOnReconnect = t.networkMode !== "always"), t.throwOnError === void 0 && (t.throwOnError = !!t.suspense), !t.networkMode && t.persister && (t.networkMode = "offlineFirst"), t.queryFn === Le && (t.enabled = !1), t;
	}
	defaultMutationOptions(e) {
		return e?._defaulted ? e : {
			...this.#n.mutations,
			...e?.mutationKey && this.getMutationDefaults(e.mutationKey),
			...e,
			_defaulted: !0
		};
	}
	clear() {
		this.#e.clear(), this.#t.clear();
	}
}, yt = F.createContext(!1), bt = () => F.useContext(yt);
yt.Provider;
//#endregion
//#region node_modules/@tanstack/react-query/build/modern/QueryErrorResetBoundary.js
function xt() {
	let e = !1;
	return {
		clearReset: () => {
			e = !1;
		},
		reset: () => {
			e = !0;
		},
		isReset: () => e
	};
}
var St = F.createContext(xt()), Ct = () => F.useContext(St), wt = (e, t, n) => {
	let r = n?.state.error && typeof e.throwOnError == "function" ? ze(e.throwOnError, [n.state.error, n]) : e.throwOnError;
	(e.suspense || r) && (t.isReset() || (e.retryOnMount = !1));
}, Tt = (e) => {
	F.useEffect(() => {
		e.clearReset();
	}, [e]);
}, Et = ({ result: e, errorResetBoundary: t, throwOnError: n, query: r, suspense: i }) => e.isError && !t.isReset() && !e.isFetching && r && (i && e.data === void 0 || ze(n, [e.error, r])), Dt = (e) => {
	if (e.suspense) {
		let t = 1e3, n = (e) => e === "static" ? e : Math.max(e ?? t, t), r = e.staleTime;
		e.staleTime = typeof r == "function" ? (...e) => n(r(...e)) : n(r), typeof e.gcTime == "number" && (e.gcTime = Math.max(e.gcTime, t));
	}
}, Ot = (e, t) => e?.suspense && t.isPending, B = (e, t, n) => t.fetchOptimistic(e).catch(() => {
	n.clearReset();
});
//#endregion
//#region node_modules/@tanstack/react-query/build/modern/useBaseQuery.js
function kt(e, t, n) {
	let r = bt(), i = Ct(), a = me(n), o = a.defaultQueryOptions(e), s = a.getQueryCache().get(o.queryHash), c = e.subscribed !== !1;
	o._optimisticResults = r ? "isRestoring" : c ? "optimistic" : void 0, Dt(o), wt(o, i, s), Tt(i);
	let [l] = F.useState(() => new t(a, o)), u = l.getOptimisticResult(o), d = !r && c;
	if (F.useSyncExternalStore(F.useCallback((e) => {
		let t = d ? l.subscribe(qe.batchCalls(e)) : L;
		return l.updateResult(), t;
	}, [l, d]), () => l.getCurrentResult(), () => l.getCurrentResult()), F.useEffect(() => {
		l.setOptions(o);
	}, [o, l]), Ot(o, u)) throw B(o, l, i);
	if (Et({
		result: u,
		errorResetBoundary: i,
		throwOnError: o.throwOnError,
		query: s,
		suspense: o.suspense
	})) throw u.error;
	return o.notifyOnChangeProps ? u : l.trackResult(u);
}
//#endregion
//#region node_modules/@tanstack/react-query/build/modern/useQuery.js
function At(e, t) {
	return kt(e, st, t);
}
//#endregion
//#region node_modules/sonner/dist/index.mjs
var jt = fe(), Mt = /* @__PURE__ */ n(N(), 1);
function Nt(e) {
	if (!e || typeof document > "u") return;
	let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
	n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
var Pt = (e) => {
	switch (e) {
		case "success": return Lt;
		case "info": return zt;
		case "warning": return Rt;
		case "error": return Bt;
		default: return null;
	}
}, Ft = Array(12).fill(0), It = ({ visible: e, className: t }) => /*#__PURE__*/ F.createElement("div", {
	className: ["sonner-loading-wrapper", t].filter(Boolean).join(" "),
	"data-visible": e
}, /*#__PURE__*/ F.createElement("div", { className: "sonner-spinner" }, Ft.map((e, t) => /*#__PURE__*/ F.createElement("div", {
	className: "sonner-loading-bar",
	key: `spinner-bar-${t}`
})))), Lt = /*#__PURE__*/ F.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	height: "20",
	width: "20",
	"aria-hidden": "true"
}, /*#__PURE__*/ F.createElement("path", {
	fillRule: "evenodd",
	d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
	clipRule: "evenodd"
})), Rt = /*#__PURE__*/ F.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	height: "20",
	width: "20",
	"aria-hidden": "true"
}, /*#__PURE__*/ F.createElement("path", {
	fillRule: "evenodd",
	d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
	clipRule: "evenodd"
})), zt = /*#__PURE__*/ F.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	height: "20",
	width: "20",
	"aria-hidden": "true"
}, /*#__PURE__*/ F.createElement("path", {
	fillRule: "evenodd",
	d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
	clipRule: "evenodd"
})), Bt = /*#__PURE__*/ F.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 20 20",
	fill: "currentColor",
	height: "20",
	width: "20",
	"aria-hidden": "true"
}, /*#__PURE__*/ F.createElement("path", {
	fillRule: "evenodd",
	d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
	clipRule: "evenodd"
})), Vt = /*#__PURE__*/ F.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "12",
	height: "12",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: "1.5",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	"aria-hidden": "true"
}, /*#__PURE__*/ F.createElement("line", {
	x1: "18",
	y1: "6",
	x2: "6",
	y2: "18"
}), /*#__PURE__*/ F.createElement("line", {
	x1: "6",
	y1: "6",
	x2: "18",
	y2: "18"
})), Ht = () => {
	let [e, t] = F.useState(document.hidden);
	return F.useEffect(() => {
		let e = () => {
			t(document.hidden);
		};
		return document.addEventListener("visibilitychange", e), () => document.removeEventListener("visibilitychange", e);
	}, []), e;
}, Ut = 1, Wt = 100, Gt = (e) => typeof e?.id == "number" || e?.id?.length > 0 ? e.id : Ut++, Kt = new class {
	constructor() {
		this.subscribe = (e) => (this.subscribers.push(e), this.getActiveToasts().forEach((t) => e(t)), () => {
			let t = this.subscribers.indexOf(e);
			this.subscribers.splice(t, 1);
		}), this.publish = (e) => {
			this.subscribers.forEach((t) => t(e));
		}, this.addToast = (e) => {
			this.publish(e), this.toasts = [...this.toasts, e], this.trimHistory();
		}, this.trimHistory = () => {
			let e = this.toasts.length - Wt;
			e <= 0 || (this.toasts = this.toasts.filter((t) => e > 0 && this.dismissedToasts.has(t.id) ? (this.dismissedToasts.delete(t.id), e--, !1) : !0));
		}, this.create = (e) => {
			let { message: t, ...n } = e, r = Gt(e), i = this.pendingDismissals.get(r);
			i !== void 0 && (cancelAnimationFrame(i), this.pendingDismissals.delete(r), this.dismissedToasts.delete(r));
			let a = this.dismissedToasts.has(r), o = e.dismissible === void 0 || e.dismissible;
			return a && (this.dismissedToasts.delete(r), this.toasts = this.toasts.filter((e) => e.id !== r)), !a && this.toasts.find((e) => e.id === r) ? this.toasts = this.toasts.map((n) => n.id === r ? (this.publish({
				...n,
				...e,
				id: r,
				title: t
			}), {
				...n,
				...e,
				id: r,
				dismissible: o,
				title: t
			}) : n) : this.addToast({
				title: t,
				...n,
				dismissible: o,
				id: r
			}), r;
		}, this.dismiss = (e) => {
			if (e == null) return this.getActiveToasts().forEach((e) => {
				this.dismissedToasts.add(e.id), this.subscribers.forEach((t) => t({
					id: e.id,
					dismiss: !0
				}));
			}), e;
			this.dismissedToasts.add(e);
			let t = this.pendingDismissals.get(e);
			return t !== void 0 && cancelAnimationFrame(t), this.pendingDismissals.set(e, requestAnimationFrame(() => {
				this.pendingDismissals.delete(e), this.subscribers.forEach((t) => t({
					id: e,
					dismiss: !0
				}));
			})), e;
		}, this.message = (e, t) => this.create({
			...t,
			message: e,
			type: void 0
		}), this.error = (e, t) => this.create({
			...t,
			message: e,
			type: "error"
		}), this.success = (e, t) => this.create({
			...t,
			type: "success",
			message: e
		}), this.info = (e, t) => this.create({
			...t,
			type: "info",
			message: e
		}), this.warning = (e, t) => this.create({
			...t,
			type: "warning",
			message: e
		}), this.loading = (e, t) => this.create({
			...t,
			type: "loading",
			message: e
		}), this.promise = (e, t) => {
			if (!t) return;
			let n;
			t.loading !== void 0 && (n = this.create({
				...t,
				promise: e,
				type: "loading",
				message: t.loading,
				description: typeof t.description == "function" ? void 0 : t.description
			}));
			let r = Promise.resolve(e instanceof Function ? e() : e), i = n !== void 0, a, o = r.then(async (e) => {
				if (a = ["resolve", e], F.isValidElement(e)) i = !1, this.create({
					id: n,
					type: "default",
					message: e
				});
				else if (Jt(e) && !e.ok) {
					i = !1;
					let r = typeof t.error == "function" ? await t.error(`HTTP error! status: ${e.status}`) : t.error, a = typeof t.description == "function" ? await t.description(`HTTP error! status: ${e.status}`) : t.description, o = typeof r == "object" && !F.isValidElement(r) ? r : { message: r };
					this.create({
						id: n,
						type: "error",
						description: a,
						...o
					});
				} else if (e instanceof Error) {
					i = !1;
					let r = typeof t.error == "function" ? await t.error(e) : t.error, a = typeof t.description == "function" ? await t.description(e) : t.description, o = typeof r == "object" && !F.isValidElement(r) ? r : { message: r };
					this.create({
						id: n,
						type: "error",
						description: a,
						...o
					});
				} else if (t.success !== void 0) {
					i = !1;
					let r = typeof t.success == "function" ? await t.success(e) : t.success, a = typeof t.description == "function" ? await t.description(e) : t.description, o = typeof r == "object" && !F.isValidElement(r) ? r : { message: r };
					this.create({
						id: n,
						type: "success",
						description: a,
						...o
					});
				}
			}).catch(async (e) => {
				if (a = ["reject", e], t.error !== void 0) {
					i = !1;
					let r = typeof t.error == "function" ? await t.error(e) : t.error, a = typeof t.description == "function" ? await t.description(e) : t.description, o = typeof r == "object" && !F.isValidElement(r) ? r : { message: r };
					this.create({
						id: n,
						type: "error",
						description: a,
						...o
					});
				}
			}).finally(() => {
				i && (this.dismiss(n), n = void 0), t.finally == null || t.finally.call(t);
			}), s = () => new Promise((e, t) => o.then(() => a[0] === "reject" ? t(a[1]) : e(a[1])).catch(t));
			return typeof n != "string" && typeof n != "number" ? { unwrap: s } : Object.assign(n, { unwrap: s });
		}, this.custom = (e, t) => {
			let n = Gt(t);
			return this.create({
				...t,
				jsx: e(n),
				id: n,
				type: void 0
			}), n;
		}, this.getActiveToasts = () => this.toasts.filter((e) => !this.dismissedToasts.has(e.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set(), this.pendingDismissals = /* @__PURE__ */ new Map();
	}
}(), qt = (e, t) => Kt.message(e, t), Jt = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", Yt = Object.assign(qt, {
	success: Kt.success,
	info: Kt.info,
	warning: Kt.warning,
	error: Kt.error,
	custom: Kt.custom,
	message: Kt.message,
	promise: Kt.promise,
	dismiss: Kt.dismiss,
	loading: Kt.loading
}, {
	getHistory: () => Kt.toasts,
	getToasts: () => Kt.getActiveToasts()
});
Nt("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px;flex:1;min-width:0}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--normal-text);background:var(--normal-bg);border:1px solid var(--normal-border);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{-webkit-user-select:none;user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function Xt(e) {
	return e.label !== void 0;
}
var Zt = 3, Qt = "24px", $t = "16px", en = 4e3, tn = 356, nn = 14, rn = 45, an = 200;
function on(...e) {
	return e.filter(Boolean).join(" ");
}
function sn(e) {
	let [t, n] = e.split("-"), r = [];
	return t && r.push(t), n && r.push(n), r;
}
var cn = (e) => {
	let { invert: t, toast: n, unstyled: r, interacting: i, setHeights: a, visibleToasts: o, heights: s, index: c, toasts: l, expanded: u, removeToast: d, defaultRichColors: f, closeButton: p, style: m, cancelButtonStyle: h, actionButtonStyle: g, className: _ = "", descriptionClassName: v = "", duration: y, position: b, gap: x, expandByDefault: S, classNames: C, icons: w, closeButtonAriaLabel: T = "Close toast" } = e, [E, ee] = F.useState(null), [te, D] = F.useState(null), [ne, re] = F.useState(!1), [ie, ae] = F.useState(!1), [O, k] = F.useState(!1), [A, oe] = F.useState(!1), [se, ce] = F.useState(!1), [le, j] = F.useState(0), [ue, de] = F.useState(0), M = F.useRef(n.duration || y || en), N = F.useRef(null), P = F.useRef(null), fe = c === 0, I = c + 1 <= o, pe = n.type, me = pe ?? "default", he = n.dismissible !== !1, ge = n.className || "", _e = n.descriptionClassName || "", ve = F.useMemo(() => s.findIndex((e) => e.toastId === n.id) || 0, [s, n.id]), ye = F.useMemo(() => n.closeButton ?? p, [n.closeButton, p]), L = F.useMemo(() => n.duration || y || en, [n.duration, y]), be = F.useRef(0), xe = F.useRef(0), Se = F.useRef(0), R = F.useRef(null), [Ce, z] = b.split("-"), we = F.useMemo(() => s.reduce((e, t, n) => n >= ve ? e : e + t.height, 0), [s, ve]), Te = Ht(), Ee = F.useMemo(() => e.swipeDirections ?? sn(b), [e.swipeDirections, b]), De = n.invert || t, Oe = pe === "loading";
	xe.current = F.useMemo(() => ve * x + we, [ve, we]), F.useEffect(() => {
		M.current = L;
	}, [L]), F.useEffect(() => {
		re(!0);
	}, []), F.useEffect(() => {
		let e = P.current;
		if (e) {
			let t = e.getBoundingClientRect().height;
			return de(t), a((e) => [{
				toastId: n.id,
				height: t,
				position: n.position
			}, ...e]), () => a((e) => e.filter((e) => e.toastId !== n.id));
		}
	}, [a, n.id]), F.useLayoutEffect(() => {
		if (!ne) return;
		let e = P.current, t = e.style.height;
		e.style.height = "auto";
		let r = e.getBoundingClientRect().height;
		e.style.height = t, de(r), a((e) => e.find((e) => e.toastId === n.id) ? e.map((e) => e.toastId === n.id ? {
			...e,
			height: r
		} : e) : [{
			toastId: n.id,
			height: r,
			position: n.position
		}, ...e]);
	}, [
		ne,
		n.title,
		n.description,
		a,
		n.id,
		n.jsx,
		n.action,
		n.cancel
	]);
	let ke = F.useCallback(() => {
		ae(!0), j(xe.current), a((e) => e.filter((e) => e.toastId !== n.id)), setTimeout(() => {
			d(n);
		}, an);
	}, [
		n,
		d,
		a,
		xe
	]);
	F.useEffect(() => {
		if (n.promise && pe === "loading" || n.duration === Infinity || n.type === "loading") return;
		let e;
		return u || i || Te ? (() => {
			if (Se.current < be.current) {
				let e = (/* @__PURE__ */ new Date()).getTime() - be.current;
				M.current -= e;
			}
			Se.current = (/* @__PURE__ */ new Date()).getTime();
		})() : M.current !== Infinity && (be.current = (/* @__PURE__ */ new Date()).getTime(), e = setTimeout(() => {
			n.onAutoClose == null || n.onAutoClose.call(n, n), ke();
		}, M.current)), () => clearTimeout(e);
	}, [
		u,
		i,
		n,
		pe,
		Te,
		ke
	]), F.useEffect(() => {
		n.delete && (ke(), n.onDismiss == null || n.onDismiss.call(n, n));
	}, [ke, n.delete]);
	function Ae() {
		return w?.loading ? /*#__PURE__*/ F.createElement("div", {
			className: on(C?.loader, n?.classNames?.loader, "sonner-loader"),
			"data-visible": pe === "loading"
		}, w.loading) : /*#__PURE__*/ F.createElement(It, {
			className: on(C?.loader, n?.classNames?.loader),
			visible: pe === "loading"
		});
	}
	let je = n.icon || w?.[pe] || Pt(pe);
	return /*#__PURE__*/ F.createElement("li", {
		tabIndex: 0,
		ref: P,
		className: on(_, ge, C?.toast, n?.classNames?.toast, C?.[me], n?.classNames?.[me]),
		"data-sonner-toast": "",
		"data-rich-colors": n.richColors ?? f,
		"data-styled": !(n.jsx || n.unstyled || r),
		"data-mounted": ne,
		"data-promise": !!n.promise,
		"data-swiped": se,
		"data-removed": ie,
		"data-visible": I,
		"data-y-position": Ce,
		"data-x-position": z,
		"data-index": c,
		"data-front": fe,
		"data-swiping": O,
		"data-dismissible": he,
		"data-type": pe,
		"data-invert": De,
		"data-swipe-out": A,
		"data-swipe-direction": te,
		"data-expanded": !!(u || S && ne),
		"data-testid": n.testId,
		style: {
			"--index": c,
			"--toasts-before": c,
			"--z-index": l.length - c,
			"--offset": `${ie ? le : xe.current}px`,
			"--initial-height": S ? "auto" : `${ue}px`,
			...m,
			...n.style
		},
		onDragEnd: () => {
			k(!1), ee(null), R.current = null;
		},
		onPointerDown: (e) => {
			e.button !== 2 && !Oe && he && (N.current = /* @__PURE__ */ new Date(), j(xe.current), e.target.setPointerCapture(e.pointerId), e.target.tagName !== "BUTTON" && (k(!0), R.current = {
				x: e.clientX,
				y: e.clientY
			}));
		},
		onPointerUp: () => {
			if (A || !he) return;
			R.current = null;
			let e = Number(P.current?.style.getPropertyValue("--swipe-amount-x").replace("px", "") || 0), t = Number(P.current?.style.getPropertyValue("--swipe-amount-y").replace("px", "") || 0), r = (/* @__PURE__ */ new Date()).getTime() - N.current?.getTime(), i = E === "x" ? e : t, a = Math.abs(i) / r;
			if ((E === "x" ? Ee.includes(e > 0 ? "right" : "left") : Ee.includes(t > 0 ? "bottom" : "top")) && (Math.abs(i) >= rn || a > .11)) {
				j(xe.current), n.onDismiss == null || n.onDismiss.call(n, n), D(E === "x" ? e > 0 ? "right" : "left" : t > 0 ? "down" : "up"), ke(), oe(!0);
				return;
			}
			var o, s;
			(o = P.current) == null || o.style.setProperty("--swipe-amount-x", "0px"), (s = P.current) == null || s.style.setProperty("--swipe-amount-y", "0px"), ce(!1), k(!1), ee(null);
		},
		onPointerMove: (e) => {
			var t, n;
			if (!R.current || !he || window.getSelection()?.toString().length > 0) return;
			let r = e.clientY - R.current.y, i = e.clientX - R.current.x;
			!E && (Math.abs(i) > 1 || Math.abs(r) > 1) && ee(Math.abs(i) > Math.abs(r) ? "x" : "y");
			let a = {
				x: 0,
				y: 0
			}, o = (e) => 1 / (1.5 + Math.abs(e) / 20);
			if (E === "y") {
				if (Ee.includes("top") || Ee.includes("bottom")) {
					if (Ee.includes("top") && r < 0 || Ee.includes("bottom") && r > 0) a.y = r;
					else {
						let e = r * o(r);
						a.y = Math.abs(e) < Math.abs(r) ? e : r;
					}
				}
			} else if (E === "x" && (Ee.includes("left") || Ee.includes("right"))) {
				if (Ee.includes("left") && i < 0 || Ee.includes("right") && i > 0) a.x = i;
				else {
					let e = i * o(i);
					a.x = Math.abs(e) < Math.abs(i) ? e : i;
				}
			}
			(Math.abs(a.x) > 0 || Math.abs(a.y) > 0) && ce(!0), (t = P.current) == null || t.style.setProperty("--swipe-amount-x", `${a.x}px`), (n = P.current) == null || n.style.setProperty("--swipe-amount-y", `${a.y}px`);
		}
	}, ye && !n.jsx && pe !== "loading" ? /*#__PURE__*/ F.createElement("button", {
		"aria-label": T,
		"data-disabled": Oe,
		"data-close-button": !0,
		onClick: Oe || !he ? () => {} : () => {
			ke(), n.onDismiss == null || n.onDismiss.call(n, n);
		},
		className: on(C?.closeButton, n?.classNames?.closeButton)
	}, w?.close ?? Vt) : null, (pe || n.icon || n.promise) && n.icon !== null && (w?.[pe] !== null || n.icon) ? /*#__PURE__*/ F.createElement("div", {
		"data-icon": "",
		className: on(C?.icon, n?.classNames?.icon)
	}, pe === "loading" ? n.icon || Ae() : n.promise ? Ae() : null, pe === "loading" ? null : je) : null, /*#__PURE__*/ F.createElement("div", {
		"data-content": "",
		className: on(C?.content, n?.classNames?.content)
	}, /*#__PURE__*/ F.createElement("div", {
		"data-title": "",
		className: on(C?.title, n?.classNames?.title)
	}, n.jsx ? n.jsx : typeof n.title == "function" ? n.title() : n.title), n.description ? /*#__PURE__*/ F.createElement("div", {
		"data-description": "",
		className: on(v, _e, C?.description, n?.classNames?.description)
	}, typeof n.description == "function" ? n.description() : n.description) : null), /*#__PURE__*/ F.isValidElement(n.cancel) ? n.cancel : n.cancel && Xt(n.cancel) ? /*#__PURE__*/ F.createElement("button", {
		"data-button": !0,
		"data-cancel": !0,
		style: n.cancelButtonStyle || h,
		onClick: (e) => {
			Xt(n.cancel) && he && (n.cancel.onClick == null || n.cancel.onClick.call(n.cancel, e), ke());
		},
		className: on(C?.cancelButton, n?.classNames?.cancelButton)
	}, n.cancel.label) : null, /*#__PURE__*/ F.isValidElement(n.action) ? n.action : n.action && Xt(n.action) ? /*#__PURE__*/ F.createElement("button", {
		"data-button": !0,
		"data-action": !0,
		style: n.actionButtonStyle || g,
		onClick: (e) => {
			Xt(n.action) && (n.action.onClick == null || n.action.onClick.call(n.action, e), !e.defaultPrevented && ke());
		},
		className: on(C?.actionButton, n?.classNames?.actionButton)
	}, n.action.label) : null);
};
function ln() {
	if (typeof window > "u" || typeof document > "u") return "ltr";
	let e = document.documentElement.getAttribute("dir");
	return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function un(e, t) {
	let n = {};
	return [e, t].forEach((e, t) => {
		let r = t === 1, i = r ? "--mobile-offset" : "--offset", a = r ? $t : Qt;
		function o(e) {
			[
				"top",
				"right",
				"bottom",
				"left"
			].forEach((t) => {
				n[`${i}-${t}`] = typeof e == "number" ? `${e}px` : e;
			});
		}
		typeof e == "number" || typeof e == "string" ? o(e) : typeof e == "object" ? [
			"top",
			"right",
			"bottom",
			"left"
		].forEach((t) => {
			e[t] === void 0 ? n[`${i}-${t}`] = a : n[`${i}-${t}`] = typeof e[t] == "number" ? `${e[t]}px` : e[t];
		}) : o(a);
	}), n;
}
var dn = /*#__PURE__*/ F.forwardRef(function(e, t) {
	let { id: n, invert: r, position: i = "bottom-right", hotkey: a = ["altKey", "KeyT"], expand: o, closeButton: s, className: c, offset: l, mobileOffset: u, theme: d = "light", richColors: f, duration: p, style: m, visibleToasts: h = Zt, toastOptions: g, dir: _ = ln(), gap: v = nn, icons: y, customAriaLabel: b, containerAriaLabel: x = "Notifications" } = e, [S, C] = F.useState([]), w = F.useMemo(() => n ? S.filter((e) => e.toasterId === n) : S.filter((e) => !e.toasterId), [S, n]), T = F.useMemo(() => Array.from(new Set([i].concat(w.filter((e) => e.position).map((e) => e.position)))), [w, i]), [E, ee] = F.useState([]), [te, D] = F.useState(!1), [ne, re] = F.useState(!1), [ie, ae] = F.useState(d === "system" ? typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light" : d), O = F.useRef(null), k = a.join("+").replace(/Key/g, "").replace(/Digit/g, ""), A = F.useRef(null), oe = F.useRef(!1), se = F.useCallback((e) => {
		C((t) => (t.find((t) => t.id === e.id)?.delete || Kt.dismiss(e.id), t.filter(({ id: t }) => t !== e.id)));
	}, []);
	return F.useEffect(() => Kt.subscribe((e) => {
		if (e.dismiss) {
			requestAnimationFrame(() => {
				C((t) => t.map((t) => t.id === e.id ? {
					...t,
					delete: !0
				} : t));
			});
			return;
		}
		setTimeout(() => {
			Mt.flushSync(() => {
				C((t) => {
					let n = t.findIndex((t) => t.id === e.id);
					return n === -1 ? [e, ...t] : [
						...t.slice(0, n),
						{
							...t[n],
							...e
						},
						...t.slice(n + 1)
					];
				});
			});
		});
	}), []), F.useEffect(() => {
		if (d !== "system") {
			ae(d);
			return;
		}
		if (d === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? ae("dark") : ae("light")), typeof window > "u") return;
		let e = window.matchMedia("(prefers-color-scheme: dark)");
		try {
			e.addEventListener("change", ({ matches: e }) => {
				ae(e ? "dark" : "light");
			});
		} catch {
			e.addListener(({ matches: e }) => {
				try {
					ae(e ? "dark" : "light");
				} catch (e) {
					console.error(e);
				}
			});
		}
	}, [d]), F.useEffect(() => {
		S.length <= 1 && D(!1);
	}, [S]), F.useEffect(() => {
		let e = (e) => {
			if (a.length > 0 && a.every((t) => e[t] || e.code === t)) {
				var t;
				D(!0), (t = O.current) == null || t.focus();
			}
			e.code === "Escape" && (document.activeElement === O.current || O.current?.contains(document.activeElement)) && D(!1);
		};
		return document.addEventListener("keydown", e), () => document.removeEventListener("keydown", e);
	}, [a]), F.useEffect(() => {
		if (O.current) return () => {
			A.current && (A.current.focus({ preventScroll: !0 }), A.current = null, oe.current = !1);
		};
	}, [O.current]), /*#__PURE__*/ F.createElement("section", {
		ref: t,
		"aria-label": b ?? `${x} ${k}`,
		tabIndex: -1,
		"aria-live": "polite",
		"aria-relevant": "additions text",
		"aria-atomic": "false",
		suppressHydrationWarning: !0,
		"data-react-aria-top-layer": !0
	}, T.map((t, n) => {
		let [i, a] = t.split("-");
		return w.length ? /*#__PURE__*/ F.createElement("ol", {
			key: t,
			dir: _ === "auto" ? ln() : _,
			tabIndex: -1,
			ref: O,
			className: c,
			"data-sonner-toaster": !0,
			"data-sonner-theme": ie,
			"data-y-position": i,
			"data-x-position": a,
			style: {
				"--front-toast-height": `${E[0]?.height || 0}px`,
				"--width": `${tn}px`,
				"--gap": `${v}px`,
				...m,
				...un(l, u)
			},
			onBlur: (e) => {
				oe.current && !e.currentTarget.contains(e.relatedTarget) && (oe.current = !1, A.current &&= (A.current.focus({ preventScroll: !0 }), null));
			},
			onFocus: (e) => {
				e.target instanceof HTMLElement && e.target.dataset.dismissible === "false" || oe.current || (oe.current = !0, A.current = e.relatedTarget);
			},
			onMouseEnter: () => D(!0),
			onMouseMove: () => D(!0),
			onMouseLeave: () => {
				ne || D(!1);
			},
			onDragEnd: () => D(!1),
			onPointerDown: (e) => {
				e.target instanceof HTMLElement && e.target.dataset.dismissible === "false" || re(!0);
			},
			onPointerUp: () => re(!1)
		}, w.filter((e) => !e.position && n === 0 || e.position === t).map((n, i) => /*#__PURE__*/ F.createElement(cn, {
			key: n.id,
			icons: y,
			index: i,
			toast: n,
			defaultRichColors: f,
			duration: g?.duration ?? p,
			className: g?.className,
			descriptionClassName: g?.descriptionClassName,
			invert: r,
			visibleToasts: h,
			closeButton: g?.closeButton ?? s,
			interacting: ne,
			position: t,
			style: g?.style,
			unstyled: g?.unstyled,
			classNames: g?.classNames,
			cancelButtonStyle: g?.cancelButtonStyle,
			actionButtonStyle: g?.actionButtonStyle,
			closeButtonAriaLabel: g?.closeButtonAriaLabel,
			removeToast: se,
			toasts: w.filter((e) => e.position == n.position),
			heights: E.filter((e) => e.position == n.position),
			setHeights: ee,
			expandByDefault: o,
			gap: v,
			expanded: te,
			swipeDirections: e.swipeDirections
		}))) : null;
	}));
}), fn = {
	BASE_URL: "./",
	DEV: !1,
	MODE: "production",
	PROD: !0,
	SSR: !1,
	VITE_LOVABLE_CONNECTOR_MAPBOX_PUBLIC_TOKEN: "pk.eyJ1IjoiYWxleGt1cnRzc29uIiwiYSI6ImNtc2xqaXllYzBzeXkyeHM2djJ0cWxuZGcifQ.0rJBn3aWFifsywR-PYzqaw",
	VITE_PREVIEW_EMAIL_GATE: "true",
	VITE_PREVIEW_FUNCTION_URL: "https://previewapi-thgnkdml6q-ew.a.run.app"
}.VITE_PREVIEW_FUNCTION_URL?.replace(/\/$/, "") ?? "", pn = null, mn = () => pn;
function hn(e) {
	pn = {
		designId: e.designId,
		token: e.token
	};
	try {
		let t = JSON.parse(sessionStorage.getItem("dp.preview.sessions.v1") || "{}");
		t[e.designId] = {
			token: e.token,
			expiresAt: Date.now() + 12096e5
		}, sessionStorage.setItem("dp.preview.sessions.v1", JSON.stringify(t));
	} catch {}
}
var gn = null, _n = /* @__PURE__ */ new Map(), vn = /* @__PURE__ */ new Map();
async function yn(e) {
	let t = JSON.stringify(e), n = vn.get(t);
	if (n) return pn = n, {
		ok: !0,
		...n
	};
	(!gn || gn.key !== t) && (gn = {
		key: t,
		submissionId: crypto.randomUUID(),
		token: Array.from(crypto.getRandomValues(/* @__PURE__ */ new Uint8Array(32)), (e) => e.toString(16).padStart(2, "0")).join("")
	});
	let r = await fetch(`${fn}/api/previews`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify({
			...e,
			submissionId: gn.submissionId,
			token: gn.token
		})
	});
	if (!r.ok) {
		let e = await r.json().catch(() => ({}));
		throw Error(e.error ?? "preview_save_failed");
	}
	let i = await r.json();
	pn = {
		designId: i.designId,
		token: i.token
	}, vn.set(t, pn), gn = null;
	try {
		let e = JSON.parse(sessionStorage.getItem("dp.preview.sessions.v1") ?? "{}");
		e[i.designId] = {
			token: i.token,
			expiresAt: Date.now() + 12096e5
		}, sessionStorage.setItem("dp.preview.sessions.v1", JSON.stringify(e));
	} catch {}
	return i;
}
async function bn(e, t = "GET", n) {
	if (!pn) throw Error("preview_session_required");
	let r = await fetch(`${fn}/api/previews/${pn.designId}/${e}`, {
		method: t,
		headers: {
			"X-Preview-Token": pn.token,
			...n ? { "Content-Type": "application/json" } : {}
		},
		...n ? { body: JSON.stringify(n) } : {}
	});
	if (!r.ok) {
		let e = await r.json();
		throw Error(e.error ?? "request_failed");
	}
	return r;
}
async function xn() {
	let e = await (await bn("status")).json();
	return e.status === "ready" && await Promise.all(["flat", "wall"].map(async (t) => {
		let n = `${e.id}:${t}`;
		_n.has(n) || _n.set(n, URL.createObjectURL(await (await bn(`image?kind=${t}`)).blob()));
	})), e;
}
var Sn = (e, t) => _n.get(`${e}:${t === "room" ? "wall" : t}`) ?? _n.get(`${e}:flat`) ?? null, Cn = () => pn?.designId ?? "", wn = "https://dearplace.lovable.app/api/public/leads", Tn = "dp.lovable.preview-lead.v1", En = null, Dn = "dp.lovable.preview-lead.v2";
function On(e) {
	return e && typeof e.email == "string" && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.email) && typeof e.token == "string" && !!e.token && typeof e.sessionId == "string" && !!e.sessionId;
}
function kn(e) {
	En = e;
	try {
		sessionStorage.setItem(Tn, JSON.stringify(e));
	} catch {}
	try {
		localStorage.setItem(Dn, JSON.stringify({
			...e,
			expiresAt: Date.now() + 2592e6
		}));
	} catch {}
}
function An() {
	if (En) return En;
	try {
		let e = JSON.parse(localStorage.getItem(Dn) || "null");
		if (On(e) && e.expiresAt > Date.now()) return En = e;
	} catch {}
	try {
		let e = JSON.parse(sessionStorage.getItem(Tn) || "null");
		if (On(e)) return kn(e), e;
	} catch {}
	return null;
}
function jn() {
	return An()?.email ?? "";
}
function Mn(e) {
	let t = An()?.sessionId;
	return typeof t != "string" || !t || t.length > 128 ? e : {
		...e,
		items: e.items.map((e) => ({
			...e,
			properties: {
				...e.properties,
				_dp_session_id: t
			}
		}))
	};
}
async function Nn(e, t) {
	let n = await fetch(`${wn}/${e}`, {
		method: "POST",
		headers: { "Content-Type": "application/json" },
		body: JSON.stringify(t),
		signal: AbortSignal.timeout(25e3)
	}), r = await n.json().catch(() => ({}));
	if (!n.ok || r.ok !== !0) throw Error("preview_email_unavailable");
	return r;
}
async function Pn(e, t, n) {
	if (e = e.trim().toLowerCase(), !mn()) throw Error("preview_session_required");
	let r = await (await bn("share-links", "POST", { language: t })).json(), i = An();
	if (!i || i.email !== e) {
		let r = i?.sessionId ?? crypto.randomUUID(), a = await Nn("create", {
			email: e,
			language: t,
			session_id: r,
			design: n
		});
		if (typeof a.token != "string") throw Error("preview_email_unavailable");
		i = {
			email: e,
			token: a.token,
			sessionId: r
		}, kn(i);
	}
	kn(i), D("preview_email_saved", {
		source: "preview_dialog",
		model_id: r.model_id,
		design_id: mn()?.designId
	});
	try {
		document.dispatchEvent(new Event("dp:preview-email-saved"));
	} catch {}
	await Nn("update", {
		email: e,
		token: i.token,
		design: {
			...n,
			...r
		}
	});
	let a = await Nn("preview", {
		email: e,
		token: i.token,
		model_id: r.model_id
	});
	if (!["accepted", "already_sent"].includes(a.status)) throw Error("preview_email_unavailable");
}
var Fn = /* @__PURE__ */ new Map();
function In(e, t, n) {
	let r = An();
	if (!r) return Promise.resolve();
	let i = r.sessionId + ":" + e, a = Fn.get(i);
	if (a) return a;
	let o = Pn(r.email, t, n).catch((e) => {
		throw Fn.delete(i), e;
	});
	return Fn.set(i, o), o;
}
async function Ln() {
	let e = An();
	e && await Nn("cart", {
		email: e.email,
		token: e.token,
		cart_url: new URL("cart", window.location.origin + "/").href
	});
}
//#endregion
//#region src/lib/preview-return.ts
var Rn = null, zn = null, Bn = () => zn;
function Vn(e) {
	try {
		let t = JSON.parse(e), n = t.params;
		return !n || !Number.isFinite(n.lat) || Math.abs(n.lat) > 85 || !Number.isFinite(n.lon) || Math.abs(n.lon) > 180 || !Number.isFinite(n.scale) || n.scale <= 0 || typeof t.name != "string" ? null : {
			params: n,
			name: t.name.slice(0, 120)
		};
	} catch {
		return null;
	}
}
function Hn() {
	return !!(Rn || window.__dpPreviewReturn || window.location.hash.startsWith("#preview="));
}
function Un() {
	if (Rn) return Rn;
	let e = window.__dpPreviewReturn || window.location.hash.slice(1);
	delete window.__dpPreviewReturn, window.location.hash.startsWith("#preview=") && history.replaceState(null, "", location.pathname + location.search);
	let t = new URLSearchParams(e);
	zn = Vn(t.get("recreate") ?? "");
	let n = t.get("preview") ?? "", r = /^([a-f0-9-]{36})\.(r1\.\d{10}\.[a-f0-9]{64})$/.exec(n);
	return Rn = (async () => {
		if (!r) throw Error("invalid_preview_link");
		let e = await fetch(`${fn}/api/previews/${r[1]}/restore`, {
			headers: { "X-Preview-Token": r[2] },
			signal: AbortSignal.timeout(2e4)
		});
		if (!e.ok) throw Error(e.status === 404 || e.status === 410 ? "preview_link_expired" : "preview_link_unavailable");
		let t = await e.json();
		if (t.version !== 1 || t.designId !== r[1] || !t.modelId || !t.params || t.expiresAt <= Date.now()) throw Error("invalid_preview_link");
		return {
			...t,
			token: r[2]
		};
	})(), Rn;
}
//#endregion
//#region src/lib/preview-email.ts
var Wn = {
	BASE_URL: "./",
	DEV: !1,
	MODE: "production",
	PROD: !0,
	SSR: !1,
	VITE_LOVABLE_CONNECTOR_MAPBOX_PUBLIC_TOKEN: "pk.eyJ1IjoiYWxleGt1cnRzc29uIiwiYSI6ImNtc2xqaXllYzBzeXkyeHM2djJ0cWxuZGcifQ.0rJBn3aWFifsywR-PYzqaw",
	VITE_PREVIEW_EMAIL_GATE: "true",
	VITE_PREVIEW_FUNCTION_URL: "https://previewapi-thgnkdml6q-ew.a.run.app"
}.VITE_PREVIEW_EMAIL_GATE === "true", Gn = (e) => `dp.preview.email-unlocked.v2:${e}`;
function Kn(e) {
	try {
		return Number(sessionStorage.getItem(Gn(e))) > Date.now();
	} catch {
		return !1;
	}
}
function qn(e) {
	try {
		sessionStorage.setItem(Gn(e), String(Date.now() + 6048e5));
	} catch {}
}
//#endregion
//#region src/lib/variant-options.ts
var Jn = {
	Size: ["size", "storlek"],
	Base: [
		"base",
		"bas",
		"utförande",
		"utforande"
	],
	Color: [
		"color",
		"colour",
		"färg",
		"farg"
	]
}, Yn = {
	White: ["white", "vit"],
	Black: ["black", "svart"],
	Polar: ["polar", "polär"],
	Pastell: ["pastell", "pastel"],
	Vit: ["vit", "white"],
	"Frame-White": ["träram · vit", "träram vit"],
	"Frame-Black": ["träram · svart", "träram svart"],
	"Frame-Oak": [
		"oak",
		"ek",
		"träram · ek",
		"träram ek"
	]
};
function Xn(e, t) {
	let n = Jn[t];
	return e.selectedOptions.find((e) => n.includes(e.name.trim().toLowerCase()))?.value;
}
function Zn(e, t) {
	if (!t) return !1;
	let n = t.trim().toLowerCase(), r = e.trim().toLowerCase();
	return n === r || Object.entries(Yn).some(([e, t]) => {
		let i = [e.toLowerCase(), ...t];
		return i.includes(r) && i.includes(n);
	});
}
function Qn(e, t) {
	if (e) return t.find((t) => Zn(t, e));
}
//#endregion
//#region src/lib/preview-recovery.ts
var $n = "dp.preview.latest.v1", er = 12096e5;
function tr(e) {
	try {
		localStorage.setItem($n, JSON.stringify({
			...e,
			version: 1,
			expiresAt: Date.now() + er
		}));
	} catch {}
}
function nr() {
	try {
		let e = JSON.parse(localStorage.getItem($n) || "null");
		return e && (!Number.isFinite(e.expiresAt) || e.expiresAt <= Date.now()) ? (localStorage.removeItem($n), null) : !e || e.version !== 1 || !Number.isFinite(e.expiresAt) || e.expiresAt <= Date.now() || ![
			e.designId,
			e.token,
			e.modelId,
			e.size,
			e.styleId,
			e.frameColor
		].every((e) => typeof e == "string" && e.length > 0 && e.length < 256) || typeof e.place?.name != "string" || e.place.name.length > 200 || !Array.isArray(e.place.center) || e.place.center.length !== 2 || !e.place.center.every(Number.isFinite) || Math.abs(e.place.center[0]) > 180 || Math.abs(e.place.center[1]) > 90 || !Number.isFinite(e.zoomFactor) || e.zoomFactor < 1 || e.zoomFactor > 1.5 || !e.params || ![20, 25].includes(e.params.sizeCm) || !Number.isFinite(e.params.scale) || e.params.scale <= 0 || !Number.isFinite(e.params.lat) || !Number.isFinite(e.params.lon) || Math.abs(e.params.lat - e.place.center[1]) > 1e-5 || Math.abs(e.params.lon - e.place.center[0]) > 1e-5 || typeof e.params.color != "string" || typeof e.params.frame != "string" || e.params.placement !== "proud" ? null : e;
	} catch {
		return null;
	}
}
var rr = C("arrow-right", [["path", {
	d: "M5 12h14",
	key: "1ays0h"
}], ["path", {
	d: "m12 5 7 7-7 7",
	key: "xquz4c"
}]]), ir = C("check", [["path", {
	d: "M20 6 9 17l-5-5",
	key: "1gmf2c"
}]]), ar = C("chevron-down", [["path", {
	d: "m6 9 6 6 6-6",
	key: "qrunsl"
}]]), or = C("eye", [["path", {
	d: "M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0",
	key: "1nclc0"
}], ["circle", {
	cx: "12",
	cy: "12",
	r: "3",
	key: "1v7zrd"
}]]), sr = C("factory", [
	["path", {
		d: "M12 16h.01",
		key: "1drbdi"
	}],
	["path", {
		d: "M16 16h.01",
		key: "1f9h7w"
	}],
	["path", {
		d: "M3 19a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8.5a.5.5 0 0 0-.769-.422l-4.462 2.844A.5.5 0 0 1 15 10.5v-2a.5.5 0 0 0-.769-.422L9.77 10.922A.5.5 0 0 1 9 10.5V5a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2z",
		key: "1iv0i2"
	}],
	["path", {
		d: "M8 16h.01",
		key: "18s6g9"
	}]
]), cr = C("images", [
	["path", {
		d: "m22 11-1.296-1.296a2.4 2.4 0 0 0-3.408 0L11 16",
		key: "9kzy35"
	}],
	["path", {
		d: "M4 8a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2",
		key: "1t0f0t"
	}],
	["circle", {
		cx: "13",
		cy: "7",
		r: "1",
		fill: "currentColor",
		key: "1obus6"
	}],
	["rect", {
		x: "8",
		y: "2",
		width: "14",
		height: "14",
		rx: "2",
		key: "1gvhby"
	}]
]), lr = C("image", [
	["rect", {
		width: "18",
		height: "18",
		x: "3",
		y: "3",
		rx: "2",
		ry: "2",
		key: "1m3agn"
	}],
	["circle", {
		cx: "9",
		cy: "9",
		r: "2",
		key: "af1f0g"
	}],
	["path", {
		d: "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21",
		key: "1xmnt7"
	}]
]), ur = C("map-pin", [["path", {
	d: "M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0",
	key: "1r0f0z"
}], ["circle", {
	cx: "12",
	cy: "10",
	r: "3",
	key: "ilqhr7"
}]]), dr = C("play", [["path", {
	d: "M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z",
	key: "10ikf1"
}]]), fr = C("rotate-ccw", [["path", {
	d: "M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8",
	key: "1357e3"
}], ["path", {
	d: "M3 3v5h5",
	key: "1xhq8a"
}]]), pr = C("search", [["path", {
	d: "m21 21-4.34-4.34",
	key: "14j7rj"
}], ["circle", {
	cx: "11",
	cy: "11",
	r: "8",
	key: "4ej97u"
}]]), mr = C("share-2", [
	["circle", {
		cx: "18",
		cy: "5",
		r: "3",
		key: "gq8acd"
	}],
	["circle", {
		cx: "6",
		cy: "12",
		r: "3",
		key: "w7nqdw"
	}],
	["circle", {
		cx: "18",
		cy: "19",
		r: "3",
		key: "1xt0gg"
	}],
	["line", {
		x1: "8.59",
		x2: "15.42",
		y1: "13.51",
		y2: "17.49",
		key: "47mynk"
	}],
	["line", {
		x1: "15.41",
		x2: "8.59",
		y1: "6.51",
		y2: "10.49",
		key: "1n3mei"
	}]
]), hr = C("shield-alert", [
	["path", {
		d: "M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z",
		key: "oel41y"
	}],
	["path", {
		d: "M12 8v4",
		key: "1got3b"
	}],
	["path", {
		d: "M12 16h.01",
		key: "1drbdi"
	}]
]), gr = C("shopping-bag", [
	["path", {
		d: "M16 10a4 4 0 0 1-8 0",
		key: "1ltviw"
	}],
	["path", {
		d: "M3.103 6.034h17.794",
		key: "awc11p"
	}],
	["path", {
		d: "M3.4 5.467a2 2 0 0 0-.4 1.2V20a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6.667a2 2 0 0 0-.4-1.2l-2-2.667A2 2 0 0 0 17 2H7a2 2 0 0 0-1.6.8z",
		key: "o988cm"
	}]
]), _r = C("sparkles", [
	["path", {
		d: "M11.017 2.814a1 1 0 0 1 1.966 0l1.051 5.558a2 2 0 0 0 1.594 1.594l5.558 1.051a1 1 0 0 1 0 1.966l-5.558 1.051a2 2 0 0 0-1.594 1.594l-1.051 5.558a1 1 0 0 1-1.966 0l-1.051-5.558a2 2 0 0 0-1.594-1.594l-5.558-1.051a1 1 0 0 1 0-1.966l5.558-1.051a2 2 0 0 0 1.594-1.594z",
		key: "1s2grr"
	}],
	["path", {
		d: "M20 2v4",
		key: "1rf3ol"
	}],
	["path", {
		d: "M22 4h-4",
		key: "gwowj6"
	}],
	["circle", {
		cx: "4",
		cy: "20",
		r: "2",
		key: "6kqj1y"
	}]
]), vr = C("x", [["path", {
	d: "M18 6 6 18",
	key: "1bl5f8"
}], ["path", {
	d: "m6 6 12 12",
	key: "d8bk6v"
}]]), yr = C("zoom-in", [
	["circle", {
		cx: "11",
		cy: "11",
		r: "8",
		key: "4ej97u"
	}],
	["line", {
		x1: "21",
		x2: "16.65",
		y1: "21",
		y2: "16.65",
		key: "13gj7c"
	}],
	["line", {
		x1: "11",
		x2: "11",
		y1: "8",
		y2: "14",
		key: "1vmskp"
	}],
	["line", {
		x1: "8",
		x2: "14",
		y1: "11",
		y2: "11",
		key: "durymu"
	}]
]);
//#endregion
//#region node_modules/clsx/dist/clsx.mjs
function br(e) {
	var t, n, r = "";
	if (typeof e == "string" || typeof e == "number") r += e;
	else if (typeof e == "object") {
		if (Array.isArray(e)) {
			var i = e.length;
			for (t = 0; t < i; t++) e[t] && (n = br(e[t])) && (r && (r += " "), r += n);
		} else for (n in e) e[n] && (r && (r += " "), r += n);
	}
	return r;
}
function xr() {
	for (var e, t, n = 0, r = "", i = arguments.length; n < i; n++) (e = arguments[n]) && (t = br(e)) && (r && (r += " "), r += t);
	return r;
}
//#endregion
//#region node_modules/tailwind-merge/dist/bundle-mjs.mjs
var Sr = (e, t) => {
	let n = Array(e.length + t.length);
	for (let t = 0; t < e.length; t++) n[t] = e[t];
	for (let r = 0; r < t.length; r++) n[e.length + r] = t[r];
	return n;
}, Cr = (e, t) => ({
	classGroupId: e,
	validator: t
}), wr = (e = /* @__PURE__ */ new Map(), t = null, n) => ({
	nextPart: e,
	validators: t,
	classGroupId: n
}), Tr = "-", Er = [], Dr = "arbitrary..", Or = (e) => {
	let t = jr(e), { conflictingClassGroups: n, conflictingClassGroupModifiers: r } = e;
	return {
		getClassGroupId: (e) => {
			if (e.startsWith("[") && e.endsWith("]")) return Ar(e);
			let n = e.split(Tr);
			return kr(n, +(n[0] === "" && n.length > 1), t);
		},
		getConflictingClassGroupIds: (e, t) => {
			if (t) {
				let t = r[e], i = n[e];
				return t ? i ? Sr(i, t) : t : i || Er;
			}
			return n[e] || Er;
		}
	};
}, kr = (e, t, n) => {
	if (e.length - t === 0) return n.classGroupId;
	let r = e[t], i = n.nextPart.get(r);
	if (i) {
		let n = kr(e, t + 1, i);
		if (n) return n;
	}
	let a = n.validators;
	if (a === null) return;
	let o = t === 0 ? e.join(Tr) : e.slice(t).join(Tr), s = a.length;
	for (let e = 0; e < s; e++) {
		let t = a[e];
		if (t.validator(o)) return t.classGroupId;
	}
}, Ar = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
	let t = e.slice(1, -1), n = t.indexOf(":"), r = t.slice(0, n);
	return r ? Dr + r : void 0;
})(), jr = (e) => {
	let { theme: t, classGroups: n } = e;
	return Mr(n, t);
}, Mr = (e, t) => {
	let n = wr();
	for (let r in e) {
		let i = e[r];
		Nr(i, n, r, t);
	}
	return n;
}, Nr = (e, t, n, r) => {
	let i = e.length;
	for (let a = 0; a < i; a++) {
		let i = e[a];
		Pr(i, t, n, r);
	}
}, Pr = (e, t, n, r) => {
	if (typeof e == "string") {
		Fr(e, t, n);
		return;
	}
	if (typeof e == "function") {
		Ir(e, t, n, r);
		return;
	}
	Lr(e, t, n, r);
}, Fr = (e, t, n) => {
	let r = e === "" ? t : Rr(t, e);
	r.classGroupId = n;
}, Ir = (e, t, n, r) => {
	if (zr(e)) {
		Nr(e(r), t, n, r);
		return;
	}
	t.validators === null && (t.validators = []), t.validators.push(Cr(n, e));
}, Lr = (e, t, n, r) => {
	let i = Object.entries(e), a = i.length;
	for (let e = 0; e < a; e++) {
		let [a, o] = i[e];
		Nr(o, Rr(t, a), n, r);
	}
}, Rr = (e, t) => {
	let n = e, r = t.split(Tr), i = r.length;
	for (let e = 0; e < i; e++) {
		let t = r[e], i = n.nextPart.get(t);
		i || (i = wr(), n.nextPart.set(t, i)), n = i;
	}
	return n;
}, zr = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, Br = (e) => {
	if (e < 1) return {
		get: () => void 0,
		set: () => {}
	};
	let t = 0, n = Object.create(null), r = Object.create(null), i = (i, a) => {
		n[i] = a, t++, t > e && (t = 0, r = n, n = Object.create(null));
	};
	return {
		get(e) {
			let t = n[e];
			if (t !== void 0) return t;
			if ((t = r[e]) !== void 0) return i(e, t), t;
		},
		set(e, t) {
			e in n ? n[e] = t : i(e, t);
		}
	};
}, Vr = "!", Hr = ":", Ur = [], Wr = (e, t, n, r, i) => ({
	modifiers: e,
	hasImportantModifier: t,
	baseClassName: n,
	maybePostfixModifierPosition: r,
	isExternal: i
}), Gr = (e) => {
	let { prefix: t, experimentalParseClassName: n } = e, r = (e) => {
		let t = [], n = 0, r = 0, i = 0, a, o = e.length;
		for (let s = 0; s < o; s++) {
			let o = e[s];
			if (n === 0 && r === 0) {
				if (o === Hr) {
					t.push(e.slice(i, s)), i = s + 1;
					continue;
				}
				if (o === "/") {
					a = s;
					continue;
				}
			}
			o === "[" ? n++ : o === "]" ? n-- : o === "(" ? r++ : o === ")" && r--;
		}
		let s = t.length === 0 ? e : e.slice(i), c = s, l = !1;
		s.endsWith(Vr) ? (c = s.slice(0, -1), l = !0) : s.startsWith(Vr) && (c = s.slice(1), l = !0);
		let u = a && a > i ? a - i : void 0;
		return Wr(t, l, c, u);
	};
	if (t) {
		let e = t + Hr, n = r;
		r = (t) => t.startsWith(e) ? n(t.slice(e.length)) : Wr(Ur, !1, t, void 0, !0);
	}
	if (n) {
		let e = r;
		r = (t) => n({
			className: t,
			parseClassName: e
		});
	}
	return r;
}, Kr = (e) => {
	let t = /* @__PURE__ */ new Map();
	return e.orderSensitiveModifiers.forEach((e, n) => {
		t.set(e, 1e6 + n);
	}), (e) => {
		let n = [], r = [];
		for (let i = 0; i < e.length; i++) {
			let a = e[i], o = a[0] === "[", s = t.has(a);
			o || s ? (r.length > 0 && (r.sort(), n.push(...r), r = []), n.push(a)) : r.push(a);
		}
		return r.length > 0 && (r.sort(), n.push(...r)), n;
	};
}, qr = (e) => ({
	cache: Br(e.cacheSize),
	parseClassName: Gr(e),
	sortModifiers: Kr(e),
	postfixLookupClassGroupIds: Jr(e),
	...Or(e)
}), Jr = (e) => {
	let t = Object.create(null), n = e.postfixLookupClassGroups;
	if (n) for (let e = 0; e < n.length; e++) t[n[e]] = !0;
	return t;
}, Yr = /\s+/, Xr = (e, t) => {
	let { parseClassName: n, getClassGroupId: r, getConflictingClassGroupIds: i, sortModifiers: a, postfixLookupClassGroupIds: o } = t, s = [], c = e.trim().split(Yr), l = "";
	for (let e = c.length - 1; e >= 0; --e) {
		let t = c[e], { isExternal: u, modifiers: d, hasImportantModifier: f, baseClassName: p, maybePostfixModifierPosition: m } = n(t);
		if (u) {
			l = t + (l.length > 0 ? " " + l : l);
			continue;
		}
		let h = !!m, g;
		if (h) {
			g = r(p.substring(0, m));
			let e = g && o[g] ? r(p) : void 0;
			e && e !== g && (g = e, h = !1);
		} else g = r(p);
		if (!g) {
			if (!h) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			if (g = r(p), !g) {
				l = t + (l.length > 0 ? " " + l : l);
				continue;
			}
			h = !1;
		}
		let _ = d.length === 0 ? "" : d.length === 1 ? d[0] : a(d).join(":"), v = f ? _ + Vr : _, y = v + g;
		if (s.indexOf(y) > -1) continue;
		s.push(y);
		let b = i(g, h);
		for (let e = 0; e < b.length; ++e) {
			let t = b[e];
			s.push(v + t);
		}
		l = t + (l.length > 0 ? " " + l : l);
	}
	return l;
}, Zr = (...e) => {
	let t = 0, n, r, i = "";
	for (; t < e.length;) (n = e[t++]) && (r = Qr(n)) && (i && (i += " "), i += r);
	return i;
}, Qr = (e) => {
	if (typeof e == "string") return e;
	let t, n = "";
	for (let r = 0; r < e.length; r++) e[r] && (t = Qr(e[r])) && (n && (n += " "), n += t);
	return n;
}, $r = (e, ...t) => {
	let n, r, i, a, o = (o) => (n = qr(t.reduce((e, t) => t(e), e())), r = n.cache.get, i = n.cache.set, a = s, s(o)), s = (e) => {
		let t = r(e);
		if (t) return t;
		let a = Xr(e, n);
		return i(e, a), a;
	};
	return a = o, (...e) => a(Zr(...e));
}, ei = [], ti = (e) => {
	let t = (t) => t[e] || ei;
	return t.isThemeGetter = !0, t;
}, ni = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, ri = /^\((?:(\w[\w-]*):)?(.+)\)$/i, ii = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, ai = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, oi = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, si = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, ci = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, li = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ui = (e) => ii.test(e), V = (e) => !!e && !Number.isNaN(Number(e)), di = (e) => !!e && Number.isInteger(Number(e)), fi = (e) => e.endsWith("%") && V(e.slice(0, -1)), pi = (e) => ai.test(e), mi = () => !0, hi = (e) => oi.test(e) && !si.test(e), gi = () => !1, _i = (e) => ci.test(e), vi = (e) => li.test(e), yi = (e) => !H(e) && !U(e), bi = (e) => e.startsWith("@container") && (e[10] === "/" && e[11] !== void 0 || e[11] === "s" && e[16] !== void 0 && e.startsWith("-size/", 10) || e[11] === "n" && e[18] !== void 0 && e.startsWith("-normal/", 10)), xi = (e) => Fi(e, zi, gi), H = (e) => ni.test(e), Si = (e) => Fi(e, Bi, hi), Ci = (e) => Fi(e, Vi, V), wi = (e) => Fi(e, Ui, mi), Ti = (e) => Fi(e, Hi, gi), Ei = (e) => Fi(e, Li, gi), Di = (e) => Fi(e, Ri, vi), Oi = (e) => Fi(e, Wi, _i), U = (e) => ri.test(e), ki = (e) => Ii(e, Bi), W = (e) => Ii(e, Hi), Ai = (e) => Ii(e, Li), ji = (e) => Ii(e, zi), Mi = (e) => Ii(e, Ri), Ni = (e) => Ii(e, Wi, !0), Pi = (e) => Ii(e, Ui, !0), Fi = (e, t, n) => {
	let r = ni.exec(e);
	return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, Ii = (e, t, n = !1) => {
	let r = ri.exec(e);
	return r ? r[1] ? t(r[1]) : n : !1;
}, Li = (e) => e === "position" || e === "percentage", Ri = (e) => e === "image" || e === "url", zi = (e) => e === "length" || e === "size" || e === "bg-size", Bi = (e) => e === "length", Vi = (e) => e === "number", Hi = (e) => e === "family-name", Ui = (e) => e === "number" || e === "weight", Wi = (e) => e === "shadow", Gi = /*#__PURE__*/ $r(() => {
	let e = ti("color"), t = ti("font"), n = ti("text"), r = ti("font-weight"), i = ti("tracking"), a = ti("leading"), o = ti("breakpoint"), s = ti("container"), c = ti("spacing"), l = ti("radius"), u = ti("shadow"), d = ti("inset-shadow"), f = ti("text-shadow"), p = ti("drop-shadow"), m = ti("blur"), h = ti("perspective"), g = ti("aspect"), _ = ti("ease"), v = ti("animate"), y = () => [
		"auto",
		"avoid",
		"all",
		"avoid-page",
		"page",
		"left",
		"right",
		"column"
	], b = () => [
		"center",
		"top",
		"bottom",
		"left",
		"right",
		"top-left",
		"left-top",
		"top-right",
		"right-top",
		"bottom-right",
		"right-bottom",
		"bottom-left",
		"left-bottom"
	], x = () => [
		...b(),
		U,
		H
	], S = () => [
		"auto",
		"hidden",
		"clip",
		"visible",
		"scroll"
	], C = () => [
		"auto",
		"contain",
		"none"
	], w = () => [
		U,
		H,
		c
	], T = () => [
		ui,
		"full",
		"auto",
		...w()
	], E = () => [
		di,
		"none",
		"subgrid",
		U,
		H
	], ee = () => [
		"auto",
		{ span: [
			"full",
			di,
			U,
			H
		] },
		di,
		U,
		H
	], te = () => [
		di,
		"auto",
		U,
		H
	], D = () => [
		"auto",
		"min",
		"max",
		"fr",
		U,
		H
	], ne = () => [
		"start",
		"end",
		"center",
		"between",
		"around",
		"evenly",
		"stretch",
		"baseline",
		"center-safe",
		"end-safe"
	], re = () => [
		"start",
		"end",
		"center",
		"stretch",
		"center-safe",
		"end-safe"
	], ie = () => ["auto", ...w()], ae = () => [
		ui,
		"auto",
		"full",
		"dvw",
		"dvh",
		"lvw",
		"lvh",
		"svw",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], O = () => [
		ui,
		"screen",
		"full",
		"dvw",
		"lvw",
		"svw",
		"min",
		"max",
		"fit",
		...w()
	], k = () => [
		ui,
		"screen",
		"full",
		"lh",
		"dvh",
		"lvh",
		"svh",
		"min",
		"max",
		"fit",
		...w()
	], A = () => [
		e,
		U,
		H
	], oe = () => [
		...b(),
		Ai,
		Ei,
		{ position: [U, H] }
	], se = () => ["no-repeat", { repeat: [
		"",
		"x",
		"y",
		"space",
		"round"
	] }], ce = () => [
		"auto",
		"cover",
		"contain",
		ji,
		xi,
		{ size: [U, H] }
	], le = () => [
		fi,
		ki,
		Si
	], j = () => [
		"",
		"none",
		"full",
		l,
		U,
		H
	], ue = () => [
		"",
		V,
		ki,
		Si
	], de = () => [
		"solid",
		"dashed",
		"dotted",
		"double"
	], M = () => [
		"normal",
		"multiply",
		"screen",
		"overlay",
		"darken",
		"lighten",
		"color-dodge",
		"color-burn",
		"hard-light",
		"soft-light",
		"difference",
		"exclusion",
		"hue",
		"saturation",
		"color",
		"luminosity"
	], N = () => [
		V,
		fi,
		Ai,
		Ei
	], P = () => [
		"",
		"none",
		m,
		U,
		H
	], fe = () => [
		"none",
		V,
		U,
		H
	], F = () => [
		"none",
		V,
		U,
		H
	], I = () => [
		V,
		U,
		H
	], pe = () => [
		ui,
		"full",
		...w()
	];
	return {
		cacheSize: 500,
		theme: {
			animate: [
				"spin",
				"ping",
				"pulse",
				"bounce"
			],
			aspect: ["video"],
			blur: [pi],
			breakpoint: [pi],
			color: [mi],
			container: [pi],
			"drop-shadow": [pi],
			ease: [
				"in",
				"out",
				"in-out"
			],
			font: [yi],
			"font-weight": [
				"thin",
				"extralight",
				"light",
				"normal",
				"medium",
				"semibold",
				"bold",
				"extrabold",
				"black"
			],
			"inset-shadow": [pi],
			leading: [
				"none",
				"tight",
				"snug",
				"normal",
				"relaxed",
				"loose"
			],
			perspective: [
				"dramatic",
				"near",
				"normal",
				"midrange",
				"distant",
				"none"
			],
			radius: [pi],
			shadow: [pi],
			spacing: ["px", V],
			text: [pi],
			"text-shadow": [pi],
			tracking: [
				"tighter",
				"tight",
				"normal",
				"wide",
				"wider",
				"widest"
			]
		},
		classGroups: {
			aspect: [{ aspect: [
				"auto",
				"square",
				ui,
				H,
				U,
				g
			] }],
			container: ["container"],
			"container-type": [{ "@container": [
				"",
				"normal",
				"size",
				U,
				H
			] }],
			"container-named": [bi],
			columns: [{ columns: [
				V,
				H,
				U,
				s
			] }],
			"break-after": [{ "break-after": y() }],
			"break-before": [{ "break-before": y() }],
			"break-inside": [{ "break-inside": [
				"auto",
				"avoid",
				"avoid-page",
				"avoid-column"
			] }],
			"box-decoration": [{ "box-decoration": ["slice", "clone"] }],
			box: [{ box: ["border", "content"] }],
			display: [
				"block",
				"inline-block",
				"inline",
				"flex",
				"inline-flex",
				"table",
				"inline-table",
				"table-caption",
				"table-cell",
				"table-column",
				"table-column-group",
				"table-footer-group",
				"table-header-group",
				"table-row-group",
				"table-row",
				"flow-root",
				"grid",
				"inline-grid",
				"contents",
				"list-item",
				"hidden"
			],
			sr: ["sr-only", "not-sr-only"],
			float: [{ float: [
				"right",
				"left",
				"none",
				"start",
				"end"
			] }],
			clear: [{ clear: [
				"left",
				"right",
				"both",
				"none",
				"start",
				"end"
			] }],
			isolation: ["isolate", "isolation-auto"],
			"object-fit": [{ object: [
				"contain",
				"cover",
				"fill",
				"none",
				"scale-down"
			] }],
			"object-position": [{ object: x() }],
			overflow: [{ overflow: S() }],
			"overflow-x": [{ "overflow-x": S() }],
			"overflow-y": [{ "overflow-y": S() }],
			overscroll: [{ overscroll: C() }],
			"overscroll-x": [{ "overscroll-x": C() }],
			"overscroll-y": [{ "overscroll-y": C() }],
			position: [
				"static",
				"fixed",
				"absolute",
				"relative",
				"sticky"
			],
			inset: [{ inset: T() }],
			"inset-x": [{ "inset-x": T() }],
			"inset-y": [{ "inset-y": T() }],
			start: [{
				"inset-s": T(),
				start: T()
			}],
			end: [{
				"inset-e": T(),
				end: T()
			}],
			"inset-bs": [{ "inset-bs": T() }],
			"inset-be": [{ "inset-be": T() }],
			top: [{ top: T() }],
			right: [{ right: T() }],
			bottom: [{ bottom: T() }],
			left: [{ left: T() }],
			visibility: [
				"visible",
				"invisible",
				"collapse"
			],
			z: [{ z: [
				di,
				"auto",
				U,
				H
			] }],
			basis: [{ basis: [
				ui,
				"full",
				"auto",
				s,
				...w()
			] }],
			"flex-direction": [{ flex: [
				"row",
				"row-reverse",
				"col",
				"col-reverse"
			] }],
			"flex-wrap": [{ flex: [
				"nowrap",
				"wrap",
				"wrap-reverse"
			] }],
			flex: [{ flex: [
				V,
				ui,
				"auto",
				"initial",
				"none",
				H
			] }],
			grow: [{ grow: [
				"",
				V,
				U,
				H
			] }],
			shrink: [{ shrink: [
				"",
				V,
				U,
				H
			] }],
			order: [{ order: [
				di,
				"first",
				"last",
				"none",
				U,
				H
			] }],
			"grid-cols": [{ "grid-cols": E() }],
			"col-start-end": [{ col: ee() }],
			"col-start": [{ "col-start": te() }],
			"col-end": [{ "col-end": te() }],
			"grid-rows": [{ "grid-rows": E() }],
			"row-start-end": [{ row: ee() }],
			"row-start": [{ "row-start": te() }],
			"row-end": [{ "row-end": te() }],
			"grid-flow": [{ "grid-flow": [
				"row",
				"col",
				"dense",
				"row-dense",
				"col-dense"
			] }],
			"auto-cols": [{ "auto-cols": D() }],
			"auto-rows": [{ "auto-rows": D() }],
			gap: [{ gap: w() }],
			"gap-x": [{ "gap-x": w() }],
			"gap-y": [{ "gap-y": w() }],
			"justify-content": [{ justify: [...ne(), "normal"] }],
			"justify-items": [{ "justify-items": [...re(), "normal"] }],
			"justify-self": [{ "justify-self": ["auto", ...re()] }],
			"align-content": [{ content: ["normal", ...ne()] }],
			"align-items": [{ items: [...re(), { baseline: ["", "last"] }] }],
			"align-self": [{ self: [
				"auto",
				...re(),
				{ baseline: ["", "last"] }
			] }],
			"place-content": [{ "place-content": ne() }],
			"place-items": [{ "place-items": [...re(), "baseline"] }],
			"place-self": [{ "place-self": ["auto", ...re()] }],
			p: [{ p: w() }],
			px: [{ px: w() }],
			py: [{ py: w() }],
			ps: [{ ps: w() }],
			pe: [{ pe: w() }],
			pbs: [{ pbs: w() }],
			pbe: [{ pbe: w() }],
			pt: [{ pt: w() }],
			pr: [{ pr: w() }],
			pb: [{ pb: w() }],
			pl: [{ pl: w() }],
			m: [{ m: ie() }],
			mx: [{ mx: ie() }],
			my: [{ my: ie() }],
			ms: [{ ms: ie() }],
			me: [{ me: ie() }],
			mbs: [{ mbs: ie() }],
			mbe: [{ mbe: ie() }],
			mt: [{ mt: ie() }],
			mr: [{ mr: ie() }],
			mb: [{ mb: ie() }],
			ml: [{ ml: ie() }],
			"space-x": [{ "space-x": w() }],
			"space-x-reverse": ["space-x-reverse"],
			"space-y": [{ "space-y": w() }],
			"space-y-reverse": ["space-y-reverse"],
			size: [{ size: ae() }],
			"inline-size": [{ inline: ["auto", ...O()] }],
			"min-inline-size": [{ "min-inline": ["auto", ...O()] }],
			"max-inline-size": [{ "max-inline": ["none", ...O()] }],
			"block-size": [{ block: ["auto", ...k()] }],
			"min-block-size": [{ "min-block": ["auto", ...k()] }],
			"max-block-size": [{ "max-block": ["none", ...k()] }],
			w: [{ w: [
				s,
				"screen",
				...ae()
			] }],
			"min-w": [{ "min-w": [
				s,
				"screen",
				"none",
				...ae()
			] }],
			"max-w": [{ "max-w": [
				s,
				"screen",
				"none",
				"prose",
				{ screen: [o] },
				...ae()
			] }],
			h: [{ h: [
				"screen",
				"lh",
				...ae()
			] }],
			"min-h": [{ "min-h": [
				"screen",
				"lh",
				"none",
				...ae()
			] }],
			"max-h": [{ "max-h": [
				"screen",
				"lh",
				...ae()
			] }],
			"font-size": [{ text: [
				"base",
				n,
				ki,
				Si
			] }],
			"font-smoothing": ["antialiased", "subpixel-antialiased"],
			"font-style": ["italic", "not-italic"],
			"font-weight": [{ font: [
				r,
				Pi,
				wi
			] }],
			"font-stretch": [{ "font-stretch": [
				"ultra-condensed",
				"extra-condensed",
				"condensed",
				"semi-condensed",
				"normal",
				"semi-expanded",
				"expanded",
				"extra-expanded",
				"ultra-expanded",
				fi,
				H
			] }],
			"font-family": [{ font: [
				W,
				Ti,
				t
			] }],
			"font-features": [{ "font-features": [H] }],
			"fvn-normal": ["normal-nums"],
			"fvn-ordinal": ["ordinal"],
			"fvn-slashed-zero": ["slashed-zero"],
			"fvn-figure": ["lining-nums", "oldstyle-nums"],
			"fvn-spacing": ["proportional-nums", "tabular-nums"],
			"fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
			tracking: [{ tracking: [
				i,
				U,
				H
			] }],
			"line-clamp": [{ "line-clamp": [
				V,
				"none",
				U,
				Ci
			] }],
			leading: [{ leading: [a, ...w()] }],
			"list-image": [{ "list-image": [
				"none",
				U,
				H
			] }],
			"list-style-position": [{ list: ["inside", "outside"] }],
			"list-style-type": [{ list: [
				"disc",
				"decimal",
				"none",
				U,
				H
			] }],
			"text-alignment": [{ text: [
				"left",
				"center",
				"right",
				"justify",
				"start",
				"end"
			] }],
			"placeholder-color": [{ placeholder: A() }],
			"text-color": [{ text: A() }],
			"text-decoration": [
				"underline",
				"overline",
				"line-through",
				"no-underline"
			],
			"text-decoration-style": [{ decoration: [...de(), "wavy"] }],
			"text-decoration-thickness": [{ decoration: [
				V,
				"from-font",
				"auto",
				U,
				Si
			] }],
			"text-decoration-color": [{ decoration: A() }],
			"underline-offset": [{ "underline-offset": [
				V,
				"auto",
				U,
				H
			] }],
			"text-transform": [
				"uppercase",
				"lowercase",
				"capitalize",
				"normal-case"
			],
			"text-overflow": [
				"truncate",
				"text-ellipsis",
				"text-clip"
			],
			"text-wrap": [{ text: [
				"wrap",
				"nowrap",
				"balance",
				"pretty"
			] }],
			indent: [{ indent: w() }],
			"tab-size": [{ tab: [
				di,
				U,
				H
			] }],
			"vertical-align": [{ align: [
				"baseline",
				"top",
				"middle",
				"bottom",
				"text-top",
				"text-bottom",
				"sub",
				"super",
				U,
				H
			] }],
			whitespace: [{ whitespace: [
				"normal",
				"nowrap",
				"pre",
				"pre-line",
				"pre-wrap",
				"break-spaces"
			] }],
			break: [{ break: [
				"normal",
				"words",
				"all",
				"keep"
			] }],
			wrap: [{ wrap: [
				"break-word",
				"anywhere",
				"normal"
			] }],
			hyphens: [{ hyphens: [
				"none",
				"manual",
				"auto"
			] }],
			content: [{ content: [
				"none",
				U,
				H
			] }],
			"bg-attachment": [{ bg: [
				"fixed",
				"local",
				"scroll"
			] }],
			"bg-clip": [{ "bg-clip": [
				"border",
				"padding",
				"content",
				"text"
			] }],
			"bg-origin": [{ "bg-origin": [
				"border",
				"padding",
				"content"
			] }],
			"bg-position": [{ bg: oe() }],
			"bg-repeat": [{ bg: se() }],
			"bg-size": [{ bg: ce() }],
			"bg-image": [{ bg: [
				"none",
				{
					linear: [
						{ to: [
							"t",
							"tr",
							"r",
							"br",
							"b",
							"bl",
							"l",
							"tl"
						] },
						di,
						U,
						H
					],
					radial: [
						"",
						U,
						H
					],
					conic: [
						di,
						U,
						H
					]
				},
				Mi,
				Di
			] }],
			"bg-color": [{ bg: A() }],
			"gradient-from-pos": [{ from: le() }],
			"gradient-via-pos": [{ via: le() }],
			"gradient-to-pos": [{ to: le() }],
			"gradient-from": [{ from: A() }],
			"gradient-via": [{ via: A() }],
			"gradient-to": [{ to: A() }],
			rounded: [{ rounded: j() }],
			"rounded-s": [{ "rounded-s": j() }],
			"rounded-e": [{ "rounded-e": j() }],
			"rounded-t": [{ "rounded-t": j() }],
			"rounded-r": [{ "rounded-r": j() }],
			"rounded-b": [{ "rounded-b": j() }],
			"rounded-l": [{ "rounded-l": j() }],
			"rounded-ss": [{ "rounded-ss": j() }],
			"rounded-se": [{ "rounded-se": j() }],
			"rounded-ee": [{ "rounded-ee": j() }],
			"rounded-es": [{ "rounded-es": j() }],
			"rounded-tl": [{ "rounded-tl": j() }],
			"rounded-tr": [{ "rounded-tr": j() }],
			"rounded-br": [{ "rounded-br": j() }],
			"rounded-bl": [{ "rounded-bl": j() }],
			"border-w": [{ border: ue() }],
			"border-w-x": [{ "border-x": ue() }],
			"border-w-y": [{ "border-y": ue() }],
			"border-w-s": [{ "border-s": ue() }],
			"border-w-e": [{ "border-e": ue() }],
			"border-w-bs": [{ "border-bs": ue() }],
			"border-w-be": [{ "border-be": ue() }],
			"border-w-t": [{ "border-t": ue() }],
			"border-w-r": [{ "border-r": ue() }],
			"border-w-b": [{ "border-b": ue() }],
			"border-w-l": [{ "border-l": ue() }],
			"divide-x": [{ "divide-x": ue() }],
			"divide-x-reverse": ["divide-x-reverse"],
			"divide-y": [{ "divide-y": ue() }],
			"divide-y-reverse": ["divide-y-reverse"],
			"border-style": [{ border: [
				...de(),
				"hidden",
				"none"
			] }],
			"divide-style": [{ divide: [
				...de(),
				"hidden",
				"none"
			] }],
			"border-color": [{ border: A() }],
			"border-color-x": [{ "border-x": A() }],
			"border-color-y": [{ "border-y": A() }],
			"border-color-s": [{ "border-s": A() }],
			"border-color-e": [{ "border-e": A() }],
			"border-color-bs": [{ "border-bs": A() }],
			"border-color-be": [{ "border-be": A() }],
			"border-color-t": [{ "border-t": A() }],
			"border-color-r": [{ "border-r": A() }],
			"border-color-b": [{ "border-b": A() }],
			"border-color-l": [{ "border-l": A() }],
			"divide-color": [{ divide: A() }],
			"outline-style": [{ outline: [
				...de(),
				"none",
				"hidden"
			] }],
			"outline-offset": [{ "outline-offset": [
				V,
				U,
				H
			] }],
			"outline-w": [{ outline: [
				"",
				V,
				ki,
				Si
			] }],
			"outline-color": [{ outline: A() }],
			shadow: [{ shadow: [
				"",
				"none",
				u,
				Ni,
				Oi
			] }],
			"shadow-color": [{ shadow: A() }],
			"inset-shadow": [{ "inset-shadow": [
				"none",
				d,
				Ni,
				Oi
			] }],
			"inset-shadow-color": [{ "inset-shadow": A() }],
			"ring-w": [{ ring: ue() }],
			"ring-w-inset": ["ring-inset"],
			"ring-color": [{ ring: A() }],
			"ring-offset-w": [{ "ring-offset": [V, Si] }],
			"ring-offset-color": [{ "ring-offset": A() }],
			"inset-ring-w": [{ "inset-ring": ue() }],
			"inset-ring-color": [{ "inset-ring": A() }],
			"text-shadow": [{ "text-shadow": [
				"none",
				f,
				Ni,
				Oi
			] }],
			"text-shadow-color": [{ "text-shadow": A() }],
			opacity: [{ opacity: [
				V,
				U,
				H
			] }],
			"mix-blend": [{ "mix-blend": [
				...M(),
				"plus-darker",
				"plus-lighter"
			] }],
			"bg-blend": [{ "bg-blend": M() }],
			"mask-clip": [{ "mask-clip": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }, "mask-no-clip"],
			"mask-composite": [{ mask: [
				"add",
				"subtract",
				"intersect",
				"exclude"
			] }],
			"mask-image-linear-pos": [{ "mask-linear": [V] }],
			"mask-image-linear-from-pos": [{ "mask-linear-from": N() }],
			"mask-image-linear-to-pos": [{ "mask-linear-to": N() }],
			"mask-image-linear-from-color": [{ "mask-linear-from": A() }],
			"mask-image-linear-to-color": [{ "mask-linear-to": A() }],
			"mask-image-t-from-pos": [{ "mask-t-from": N() }],
			"mask-image-t-to-pos": [{ "mask-t-to": N() }],
			"mask-image-t-from-color": [{ "mask-t-from": A() }],
			"mask-image-t-to-color": [{ "mask-t-to": A() }],
			"mask-image-r-from-pos": [{ "mask-r-from": N() }],
			"mask-image-r-to-pos": [{ "mask-r-to": N() }],
			"mask-image-r-from-color": [{ "mask-r-from": A() }],
			"mask-image-r-to-color": [{ "mask-r-to": A() }],
			"mask-image-b-from-pos": [{ "mask-b-from": N() }],
			"mask-image-b-to-pos": [{ "mask-b-to": N() }],
			"mask-image-b-from-color": [{ "mask-b-from": A() }],
			"mask-image-b-to-color": [{ "mask-b-to": A() }],
			"mask-image-l-from-pos": [{ "mask-l-from": N() }],
			"mask-image-l-to-pos": [{ "mask-l-to": N() }],
			"mask-image-l-from-color": [{ "mask-l-from": A() }],
			"mask-image-l-to-color": [{ "mask-l-to": A() }],
			"mask-image-x-from-pos": [{ "mask-x-from": N() }],
			"mask-image-x-to-pos": [{ "mask-x-to": N() }],
			"mask-image-x-from-color": [{ "mask-x-from": A() }],
			"mask-image-x-to-color": [{ "mask-x-to": A() }],
			"mask-image-y-from-pos": [{ "mask-y-from": N() }],
			"mask-image-y-to-pos": [{ "mask-y-to": N() }],
			"mask-image-y-from-color": [{ "mask-y-from": A() }],
			"mask-image-y-to-color": [{ "mask-y-to": A() }],
			"mask-image-radial": [{ "mask-radial": [U, H] }],
			"mask-image-radial-from-pos": [{ "mask-radial-from": N() }],
			"mask-image-radial-to-pos": [{ "mask-radial-to": N() }],
			"mask-image-radial-from-color": [{ "mask-radial-from": A() }],
			"mask-image-radial-to-color": [{ "mask-radial-to": A() }],
			"mask-image-radial-shape": [{ "mask-radial": ["circle", "ellipse"] }],
			"mask-image-radial-size": [{ "mask-radial": [{
				closest: ["side", "corner"],
				farthest: ["side", "corner"]
			}] }],
			"mask-image-radial-pos": [{ "mask-radial-at": b() }],
			"mask-image-conic-pos": [{ "mask-conic": [V] }],
			"mask-image-conic-from-pos": [{ "mask-conic-from": N() }],
			"mask-image-conic-to-pos": [{ "mask-conic-to": N() }],
			"mask-image-conic-from-color": [{ "mask-conic-from": A() }],
			"mask-image-conic-to-color": [{ "mask-conic-to": A() }],
			"mask-mode": [{ mask: [
				"alpha",
				"luminance",
				"match"
			] }],
			"mask-origin": [{ "mask-origin": [
				"border",
				"padding",
				"content",
				"fill",
				"stroke",
				"view"
			] }],
			"mask-position": [{ mask: oe() }],
			"mask-repeat": [{ mask: se() }],
			"mask-size": [{ mask: ce() }],
			"mask-type": [{ "mask-type": ["alpha", "luminance"] }],
			"mask-image": [{ mask: [
				"none",
				U,
				H
			] }],
			filter: [{ filter: [
				"",
				"none",
				U,
				H
			] }],
			blur: [{ blur: P() }],
			brightness: [{ brightness: [
				V,
				U,
				H
			] }],
			contrast: [{ contrast: [
				V,
				U,
				H
			] }],
			"drop-shadow": [{ "drop-shadow": [
				"",
				"none",
				p,
				Ni,
				Oi
			] }],
			"drop-shadow-color": [{ "drop-shadow": A() }],
			grayscale: [{ grayscale: [
				"",
				V,
				U,
				H
			] }],
			"hue-rotate": [{ "hue-rotate": [
				V,
				U,
				H
			] }],
			invert: [{ invert: [
				"",
				V,
				U,
				H
			] }],
			saturate: [{ saturate: [
				V,
				U,
				H
			] }],
			sepia: [{ sepia: [
				"",
				V,
				U,
				H
			] }],
			"backdrop-filter": [{ "backdrop-filter": [
				"",
				"none",
				U,
				H
			] }],
			"backdrop-blur": [{ "backdrop-blur": P() }],
			"backdrop-brightness": [{ "backdrop-brightness": [
				V,
				U,
				H
			] }],
			"backdrop-contrast": [{ "backdrop-contrast": [
				V,
				U,
				H
			] }],
			"backdrop-grayscale": [{ "backdrop-grayscale": [
				"",
				V,
				U,
				H
			] }],
			"backdrop-hue-rotate": [{ "backdrop-hue-rotate": [
				V,
				U,
				H
			] }],
			"backdrop-invert": [{ "backdrop-invert": [
				"",
				V,
				U,
				H
			] }],
			"backdrop-opacity": [{ "backdrop-opacity": [
				V,
				U,
				H
			] }],
			"backdrop-saturate": [{ "backdrop-saturate": [
				V,
				U,
				H
			] }],
			"backdrop-sepia": [{ "backdrop-sepia": [
				"",
				V,
				U,
				H
			] }],
			"border-collapse": [{ border: ["collapse", "separate"] }],
			"border-spacing": [{ "border-spacing": w() }],
			"border-spacing-x": [{ "border-spacing-x": w() }],
			"border-spacing-y": [{ "border-spacing-y": w() }],
			"table-layout": [{ table: ["auto", "fixed"] }],
			caption: [{ caption: ["top", "bottom"] }],
			transition: [{ transition: [
				"",
				"all",
				"colors",
				"opacity",
				"shadow",
				"transform",
				"none",
				U,
				H
			] }],
			"transition-behavior": [{ transition: ["normal", "discrete"] }],
			duration: [{ duration: [
				V,
				"initial",
				U,
				H
			] }],
			ease: [{ ease: [
				"linear",
				"initial",
				_,
				U,
				H
			] }],
			delay: [{ delay: [
				V,
				U,
				H
			] }],
			animate: [{ animate: [
				"none",
				v,
				U,
				H
			] }],
			backface: [{ backface: ["hidden", "visible"] }],
			perspective: [{ perspective: [
				h,
				U,
				H
			] }],
			"perspective-origin": [{ "perspective-origin": x() }],
			rotate: [{ rotate: fe() }],
			"rotate-x": [{ "rotate-x": fe() }],
			"rotate-y": [{ "rotate-y": fe() }],
			"rotate-z": [{ "rotate-z": fe() }],
			scale: [{ scale: F() }],
			"scale-x": [{ "scale-x": F() }],
			"scale-y": [{ "scale-y": F() }],
			"scale-z": [{ "scale-z": F() }],
			"scale-3d": ["scale-3d"],
			skew: [{ skew: I() }],
			"skew-x": [{ "skew-x": I() }],
			"skew-y": [{ "skew-y": I() }],
			transform: [{ transform: [
				U,
				H,
				"",
				"none",
				"gpu",
				"cpu"
			] }],
			"transform-origin": [{ origin: x() }],
			"transform-style": [{ transform: ["3d", "flat"] }],
			translate: [{ translate: pe() }],
			"translate-x": [{ "translate-x": pe() }],
			"translate-y": [{ "translate-y": pe() }],
			"translate-z": [{ "translate-z": pe() }],
			"translate-none": ["translate-none"],
			zoom: [{ zoom: [
				di,
				U,
				H
			] }],
			accent: [{ accent: A() }],
			appearance: [{ appearance: ["none", "auto"] }],
			"caret-color": [{ caret: A() }],
			"color-scheme": [{ scheme: [
				"normal",
				"dark",
				"light",
				"light-dark",
				"only-dark",
				"only-light"
			] }],
			cursor: [{ cursor: [
				"auto",
				"default",
				"pointer",
				"wait",
				"text",
				"move",
				"help",
				"not-allowed",
				"none",
				"context-menu",
				"progress",
				"cell",
				"crosshair",
				"vertical-text",
				"alias",
				"copy",
				"no-drop",
				"grab",
				"grabbing",
				"all-scroll",
				"col-resize",
				"row-resize",
				"n-resize",
				"e-resize",
				"s-resize",
				"w-resize",
				"ne-resize",
				"nw-resize",
				"se-resize",
				"sw-resize",
				"ew-resize",
				"ns-resize",
				"nesw-resize",
				"nwse-resize",
				"zoom-in",
				"zoom-out",
				U,
				H
			] }],
			"field-sizing": [{ "field-sizing": ["fixed", "content"] }],
			"pointer-events": [{ "pointer-events": ["auto", "none"] }],
			resize: [{ resize: [
				"none",
				"",
				"y",
				"x"
			] }],
			"scroll-behavior": [{ scroll: ["auto", "smooth"] }],
			"scrollbar-thumb-color": [{ "scrollbar-thumb": A() }],
			"scrollbar-track-color": [{ "scrollbar-track": A() }],
			"scrollbar-gutter": [{ "scrollbar-gutter": [
				"auto",
				"stable",
				"both"
			] }],
			"scrollbar-w": [{ scrollbar: [
				"auto",
				"thin",
				"none"
			] }],
			"scroll-m": [{ "scroll-m": w() }],
			"scroll-mx": [{ "scroll-mx": w() }],
			"scroll-my": [{ "scroll-my": w() }],
			"scroll-ms": [{ "scroll-ms": w() }],
			"scroll-me": [{ "scroll-me": w() }],
			"scroll-mbs": [{ "scroll-mbs": w() }],
			"scroll-mbe": [{ "scroll-mbe": w() }],
			"scroll-mt": [{ "scroll-mt": w() }],
			"scroll-mr": [{ "scroll-mr": w() }],
			"scroll-mb": [{ "scroll-mb": w() }],
			"scroll-ml": [{ "scroll-ml": w() }],
			"scroll-p": [{ "scroll-p": w() }],
			"scroll-px": [{ "scroll-px": w() }],
			"scroll-py": [{ "scroll-py": w() }],
			"scroll-ps": [{ "scroll-ps": w() }],
			"scroll-pe": [{ "scroll-pe": w() }],
			"scroll-pbs": [{ "scroll-pbs": w() }],
			"scroll-pbe": [{ "scroll-pbe": w() }],
			"scroll-pt": [{ "scroll-pt": w() }],
			"scroll-pr": [{ "scroll-pr": w() }],
			"scroll-pb": [{ "scroll-pb": w() }],
			"scroll-pl": [{ "scroll-pl": w() }],
			"snap-align": [{ snap: [
				"start",
				"end",
				"center",
				"align-none"
			] }],
			"snap-stop": [{ snap: ["normal", "always"] }],
			"snap-type": [{ snap: [
				"none",
				"x",
				"y",
				"both"
			] }],
			"snap-strictness": [{ snap: ["mandatory", "proximity"] }],
			touch: [{ touch: [
				"auto",
				"none",
				"manipulation"
			] }],
			"touch-x": [{ "touch-pan": [
				"x",
				"left",
				"right"
			] }],
			"touch-y": [{ "touch-pan": [
				"y",
				"up",
				"down"
			] }],
			"touch-pz": ["touch-pinch-zoom"],
			select: [{ select: [
				"none",
				"text",
				"all",
				"auto"
			] }],
			"will-change": [{ "will-change": [
				"auto",
				"scroll",
				"contents",
				"transform",
				U,
				H
			] }],
			fill: [{ fill: ["none", ...A()] }],
			"stroke-w": [{ stroke: [
				V,
				ki,
				Si,
				Ci
			] }],
			stroke: [{ stroke: ["none", ...A()] }],
			"forced-color-adjust": [{ "forced-color-adjust": ["auto", "none"] }]
		},
		conflictingClassGroups: {
			"container-named": ["container-type"],
			overflow: ["overflow-x", "overflow-y"],
			overscroll: ["overscroll-x", "overscroll-y"],
			inset: [
				"inset-x",
				"inset-y",
				"inset-bs",
				"inset-be",
				"start",
				"end",
				"top",
				"right",
				"bottom",
				"left"
			],
			"inset-x": ["right", "left"],
			"inset-y": ["top", "bottom"],
			flex: [
				"basis",
				"grow",
				"shrink"
			],
			gap: ["gap-x", "gap-y"],
			p: [
				"px",
				"py",
				"ps",
				"pe",
				"pbs",
				"pbe",
				"pt",
				"pr",
				"pb",
				"pl"
			],
			px: ["pr", "pl"],
			py: ["pt", "pb"],
			m: [
				"mx",
				"my",
				"ms",
				"me",
				"mbs",
				"mbe",
				"mt",
				"mr",
				"mb",
				"ml"
			],
			mx: ["mr", "ml"],
			my: ["mt", "mb"],
			size: ["w", "h"],
			"font-size": ["leading"],
			"fvn-normal": [
				"fvn-ordinal",
				"fvn-slashed-zero",
				"fvn-figure",
				"fvn-spacing",
				"fvn-fraction"
			],
			"fvn-ordinal": ["fvn-normal"],
			"fvn-slashed-zero": ["fvn-normal"],
			"fvn-figure": ["fvn-normal"],
			"fvn-spacing": ["fvn-normal"],
			"fvn-fraction": ["fvn-normal"],
			"line-clamp": ["display", "overflow"],
			rounded: [
				"rounded-s",
				"rounded-e",
				"rounded-t",
				"rounded-r",
				"rounded-b",
				"rounded-l",
				"rounded-ss",
				"rounded-se",
				"rounded-ee",
				"rounded-es",
				"rounded-tl",
				"rounded-tr",
				"rounded-br",
				"rounded-bl"
			],
			"rounded-s": ["rounded-ss", "rounded-es"],
			"rounded-e": ["rounded-se", "rounded-ee"],
			"rounded-t": ["rounded-tl", "rounded-tr"],
			"rounded-r": ["rounded-tr", "rounded-br"],
			"rounded-b": ["rounded-br", "rounded-bl"],
			"rounded-l": ["rounded-tl", "rounded-bl"],
			"border-spacing": ["border-spacing-x", "border-spacing-y"],
			"border-w": [
				"border-w-x",
				"border-w-y",
				"border-w-s",
				"border-w-e",
				"border-w-bs",
				"border-w-be",
				"border-w-t",
				"border-w-r",
				"border-w-b",
				"border-w-l"
			],
			"border-w-x": ["border-w-r", "border-w-l"],
			"border-w-y": ["border-w-t", "border-w-b"],
			"border-color": [
				"border-color-x",
				"border-color-y",
				"border-color-s",
				"border-color-e",
				"border-color-bs",
				"border-color-be",
				"border-color-t",
				"border-color-r",
				"border-color-b",
				"border-color-l"
			],
			"border-color-x": ["border-color-r", "border-color-l"],
			"border-color-y": ["border-color-t", "border-color-b"],
			translate: [
				"translate-x",
				"translate-y",
				"translate-none"
			],
			"translate-none": [
				"translate",
				"translate-x",
				"translate-y",
				"translate-z"
			],
			"scroll-m": [
				"scroll-mx",
				"scroll-my",
				"scroll-ms",
				"scroll-me",
				"scroll-mbs",
				"scroll-mbe",
				"scroll-mt",
				"scroll-mr",
				"scroll-mb",
				"scroll-ml"
			],
			"scroll-mx": ["scroll-mr", "scroll-ml"],
			"scroll-my": ["scroll-mt", "scroll-mb"],
			"scroll-p": [
				"scroll-px",
				"scroll-py",
				"scroll-ps",
				"scroll-pe",
				"scroll-pbs",
				"scroll-pbe",
				"scroll-pt",
				"scroll-pr",
				"scroll-pb",
				"scroll-pl"
			],
			"scroll-px": ["scroll-pr", "scroll-pl"],
			"scroll-py": ["scroll-pt", "scroll-pb"],
			touch: [
				"touch-x",
				"touch-y",
				"touch-pz"
			],
			"touch-x": ["touch"],
			"touch-y": ["touch"],
			"touch-pz": ["touch"]
		},
		conflictingClassGroupModifiers: { "font-size": ["leading"] },
		postfixLookupClassGroups: ["container-type"],
		orderSensitiveModifiers: [
			"*",
			"**",
			"after",
			"backdrop",
			"before",
			"details-content",
			"file",
			"first-letter",
			"first-line",
			"marker",
			"placeholder",
			"selection"
		]
	};
});
//#endregion
//#region src/lib/utils.ts
function Ki(...e) {
	return Gi(xr(e));
}
//#endregion
//#region src/components/ui/input.tsx
var qi = F.forwardRef(({ className: e, type: t, ...n }, r) => /* @__PURE__ */ (0, I.jsx)("input", {
	type: t,
	className: Ki("flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm", e),
	ref: r,
	...n
}));
qi.displayName = "Input";
//#endregion
//#region src/lib/geocode.ts
var Ji = {
	BASE_URL: "./",
	DEV: !1,
	MODE: "production",
	PROD: !0,
	SSR: !1,
	VITE_LOVABLE_CONNECTOR_MAPBOX_PUBLIC_TOKEN: "pk.eyJ1IjoiYWxleGt1cnRzc29uIiwiYSI6ImNtc2xqaXllYzBzeXkyeHM2djJ0cWxuZGcifQ.0rJBn3aWFifsywR-PYzqaw",
	VITE_PREVIEW_EMAIL_GATE: "true",
	VITE_PREVIEW_FUNCTION_URL: "https://previewapi-thgnkdml6q-ew.a.run.app"
}.VITE_LOVABLE_CONNECTOR_MAPBOX_PUBLIC_TOKEN, Yi = "15,60", Xi = "place,locality,region,district,neighborhood,address,postcode";
async function Zi(e, t) {
	let n = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(e)}.json?limit=8&autocomplete=true&language=sv,en&proximity=${Yi}&types=${Xi}&access_token=${Ji}`, r = await fetch(n, { signal: t ?? null });
	return r.ok ? ((await r.json()).features ?? []).map((e) => ({
		...e,
		country: e.context?.find((e) => e.id?.startsWith("country."))?.short_code
	})) : (console.error(`Map search failed [${r.status}]`), null);
}
var Qi = (e) => e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().replace(/[^a-z0-9]+/g, " ").trim();
function $i(e) {
	return /^(eiffeltornet|eiffel tower)( paris)?$/.test(Qi(e)) ? "Tour Eiffel" : e;
}
function ea(e, t) {
	let n = Qi(e), r = n.split(" "), i = (e) => {
		let t = Qi(e.text), i = Qi(e.place_name);
		return t === n ? 4 : r.every((e) => t.split(" ").includes(e)) ? 3 : t.startsWith(n) ? 2 : +!!r.every((e) => i.includes(e));
	}, a = (t) => {
		let n = t.id.split(".")[0];
		return /\d/.test(e) ? n === "address" ? 3 : 0 : n === "place" || n === "locality" ? 3 : n === "poi" ? 2 : 0;
	}, o = /* @__PURE__ */ new Set();
	return t.map((e, t) => ({
		f: e,
		index: t
	})).sort((e, t) => i(t.f) - i(e.f) || Number(t.f.country === "se") - Number(e.f.country === "se") || a(t.f) - a(e.f) || e.index - t.index).filter(({ f: e }) => {
		let t = Qi(e.id.startsWith("address.") ? e.place_name : e.text) + ":" + e.center.map((e) => e.toFixed(3)).join(",");
		return !o.has(t) && (o.add(t), !0);
	}).slice(0, 8).map(({ f: e }) => e);
}
async function ta(e, t) {
	let n = new URLSearchParams({
		q: $i(e),
		access_token: Ji,
		language: "sv",
		limit: "8",
		proximity: Yi
	}), r = await fetch(`https://api.mapbox.com/search/searchbox/v1/forward?${n}`, { signal: t });
	return r.ok ? ((await r.json()).features ?? []).filter((e) => e.geometry?.coordinates?.length === 2 && e.geometry.coordinates.every(Number.isFinite)).map((e) => ({
		id: `${e.properties.feature_type}.${e.properties.mapbox_id}`,
		text: e.properties.name_preferred || e.properties.name,
		place_name: e.properties.full_address || e.properties.place_formatted || e.properties.name,
		center: e.geometry.coordinates,
		country: e.properties.context?.country?.country_code?.toLowerCase()
	})) : null;
}
async function na(e, t) {
	let n = await Promise.allSettled([Zi(e, t), ta(e, t)]);
	if (t?.aborted) throw new DOMException("Aborted", "AbortError");
	let r = n.filter((e) => e.status === "fulfilled" && e.value !== null);
	if (!r.length) return null;
	let i = r.flatMap((e) => e.value ?? []);
	if ($i(e) !== e) {
		let t = n[1];
		if (t.status === "fulfilled" && t.value?.length) {
			let n = t.value.filter((e) => e.country === "fr" && /^(eiffeltornet|tour eiffel|eiffel tower)$/.test(Qi(e.text)));
			if (n.length) return [...n, ...ea(e, i.filter((e) => !n.includes(e)))].slice(0, 8);
		}
	}
	return ea(e, i);
}
async function ra(e, t) {
	let n = e.trim();
	if (!n) return { places: [] };
	if (!Ji) return {
		places: [],
		error: "Map search is not configured yet."
	};
	try {
		let e = await na(n, t);
		return e === null ? {
			places: [],
			error: "Search is temporarily unavailable."
		} : { places: e.map((e) => ({
			id: e.id,
			name: e.text,
			context: e.place_name,
			center: e.center,
			kind: e.id.split(".")[0] ?? "place"
		})) };
	} catch (e) {
		return e?.name === "AbortError" ? { places: [] } : (console.error("Mapbox geocoding error:", e), {
			places: [],
			error: "Search is temporarily unavailable."
		});
	}
}
//#endregion
//#region src/lib/geo-ip.functions.ts
var ia = async () => null, aa = "https://terrain-weaver-c6tn2-f5gfbp0c.myshopify.com/api/2025-07/graphql.json", oa = "6b7472072c2486e93a1c08a6d53d8c5d", sa = "\n  query GetProducts($first: Int!, $query: String) {\n    products(first: $first, query: $query) {\n      edges {\n        node {\n          id\n          title\n          description\n          handle\n          priceRange { minVariantPrice { amount currencyCode } }\n          images(first: 100) { edges { node { url altText } } }\n          variants(first: 250) {\n            edges {\n              node {\n                id\n                title\n                sku\n                image { url altText }\n                price { amount currencyCode }\n                availableForSale\n                selectedOptions { name value }\n              }\n            }\n          }\n          options { name values }\n        }\n      }\n    }\n  }\n";
async function ca(e, t = {}) {
	let n = await fetch(aa, {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			"X-Shopify-Storefront-Access-Token": oa
		},
		body: JSON.stringify({
			query: e,
			variables: t
		}),
		signal: AbortSignal.timeout(15e3)
	});
	if (n.status === 402) {
		Yt.error("Shopify: Payment required", { description: "Shopify API access requires an active Shopify billing plan. Visit https://admin.shopify.com to upgrade." });
		return;
	}
	if (!n.ok) throw Error(`HTTP error! status: ${n.status}`);
	let r = await n.json();
	if (r.errors) throw Error(`Error calling Shopify: ${r.errors.map((e) => e.message).join(", ")}`);
	return r;
}
async function la(e) {
	if (e === "handle:custom-3d-terrain-map" && typeof document < "u") {
		let e = document.getElementById("dearplace-product-data");
		if (e?.textContent) try {
			let t = JSON.parse(e.textContent);
			if (t.node?.handle === "custom-3d-terrain-map" && t.node.variants.edges.length) return [t];
		} catch {}
	}
	return (await ca(sa, {
		first: 20,
		query: e ?? null
	}))?.data?.products?.edges ?? [];
}
function ua(e, t) {
	let n = typeof e == "string" ? parseFloat(e) : e;
	try {
		return new Intl.NumberFormat(t === "SEK" ? "sv-SE" : void 0, {
			style: "currency",
			currency: t,
			maximumFractionDigits: 0
		}).format(n);
	} catch {
		return `${t} ${n.toFixed(0)}`;
	}
}
//#endregion
//#region src/lib/addons.ts
var da = {
	marker1: "DP-ADDON-MARK-1",
	marker2: "DP-ADDON-MARK-2",
	marker3: "DP-ADDON-MARK-3",
	plaque: "DP-ADDON-PLAQUE",
	giftWrap: "DP-ADDON-GIFTWRAP",
	priority1420: "DP-ADDON-PRIORITY-1420",
	priority26: "DP-ADDON-PRIORITY-26"
};
async function fa() {
	let e = await la("tag:addon"), t = {};
	for (let n of e) {
		let e = n.node.images.edges[0]?.node.url ?? null;
		for (let r of n.node.variants.edges) {
			let i = r.node, a = i.sku ?? i.id;
			t[a] = {
				productId: n.node.id,
				variantId: i.id,
				title: i.title,
				handle: n.node.handle,
				productTitle: n.node.title,
				sku: a,
				price: i.price,
				imageUrl: e,
				availableForSale: i.availableForSale
			};
		}
	}
	return t;
}
function pa(e) {
	return e === 1 ? da.marker1 : e === 2 ? da.marker2 : e >= 3 ? da.marker3 : null;
}
function ma(e) {
	return parseInt(e, 10) >= 25 ? da.priority26 : da.priority1420;
}
//#endregion
//#region src/lib/native-cart.ts
var ha = () => window.Shopify?.routes?.root ?? "/", ga = (e) => `${ha()}${e}`;
async function _a() {
	let e = await fetch(ga("cart.js"), {
		credentials: "same-origin",
		cache: "no-store"
	});
	if (!e.ok) throw Error("cart_unavailable");
	return e.json();
}
function va(e, t) {
	let n = (e) => Object.entries(e ?? {}).filter(([e]) => e !== "_dp_session_id").sort(([e], [t]) => e.localeCompare(t));
	return JSON.stringify(n(e)) === JSON.stringify(n(t));
}
function ya(e, t) {
	let n = e.items.filter((e) => e.properties?._configuration_id === t.configurationId);
	if (!n.length) return !1;
	if (n.length !== t.items.length || !t.items.every((e) => n.some((t) => String(t.variant_id) === e.id && t.quantity === e.quantity && va(e.properties, t.properties)))) throw Error("cart_configuration_conflict");
	return !0;
}
async function ba(e) {
	let t = await _a();
	if (ya(t, e)) return t;
	let n;
	try {
		n = await fetch(ga("cart/add.js"), {
			method: "POST",
			credentials: "same-origin",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ items: e.items })
		});
	} catch {
		if (t = await _a(), ya(t, e)) return t;
		throw Error("cart_add_unconfirmed");
	}
	if (!n.ok) {
		if (t = await _a(), ya(t, e)) return t;
		throw Error("cart_add_failed");
	}
	if (t = await _a(), !ya(t, e)) throw Error("cart_add_unconfirmed");
	return t;
}
var xa = Promise.resolve();
function Sa(e) {
	let t = () => typeof navigator < "u" && navigator.locks ? navigator.locks.request("dearplace-native-cart", () => ba(e)) : ba(e), n = xa.then(t, t);
	return xa = n.catch(() => {}), n;
}
//#endregion
//#region src/stores/cartStore.ts
var Ca = /* @__PURE__ */ new Set(), wa = (e) => {
	Ea = {
		...Ea,
		...e
	}, Ca.forEach((e) => e());
}, Ta = (e) => wa({
	items: e.items.map((t) => ({
		variantId: String(t.variant_id),
		title: t.product_title,
		quantity: t.quantity,
		price: {
			amount: String(t.final_price / 100),
			currencyCode: e.currency
		}
	})),
	cartId: e.token
}), Ea = {
	items: [],
	isLoading: !1,
	cartId: null,
	refresh: async () => Ta(await _a()),
	addPrepared: async (e) => {
		wa({ isLoading: !0 });
		try {
			Ta(await Sa(e));
		} finally {
			wa({ isLoading: !1 });
		}
	},
	resolveCheckoutUrl: async () => {
		let e = await _a();
		return Ta(e), e.item_count ? `${ha()}checkout` : null;
	}
}, Da = Object.assign((e) => e((0, F.useSyncExternalStore)((e) => (Ca.add(e), () => Ca.delete(e)), () => Ea, () => Ea)), { getState: () => Ea }), G = {
	tradingName: "dearplace.studio",
	legalName: "Curt & Co AB",
	orgNumber: "5590408075",
	address: "Bäckegatan 30b, 41316 Göteborg, Sweden",
	vatNumber: "SE559040807501",
	email: "hello@dearplace.studio",
	dataController: "Curt & Co AB"
};
//#endregion
//#region src/hooks/useHydrated.ts
function Oa() {
	let [e, t] = (0, F.useState)(!1);
	return (0, F.useEffect)(() => t(!0), []), e;
}
//#endregion
//#region src/components/ProductPreview.tsx
var ka = (0, F.lazy)(() => import("./dp-TerrainPreview-CVwN1YhK.js")), Aa = (0, F.lazy)(() => import("./dp-ReliefCanvas-CX06RleF.js")), ja = {
	White: {
		surface: "linear-gradient(145deg,#ffffff 0%,#f4f4f3 55%,#e4e4e2 100%)",
		edge: "rgba(150,138,118,0.55)",
		inner: "rgba(120,108,90,0.35)",
		plaque: "rgba(80,72,60,0.85)",
		mat: "#fbf8f2"
	},
	Black: {
		surface: "linear-gradient(145deg,#3a3d41 0%,#1d1f22 55%,#0d0e10 100%)",
		edge: "rgba(0,0,0,0.75)",
		inner: "rgba(0,0,0,0.6)",
		plaque: "rgba(228,233,238,0.9)",
		mat: "#15171a"
	}
}, Ma = {
	"20 x 20 cm": .48,
	"25 x 25 cm": .58,
	"52 x 52 cm": .74,
	"55 x 55 cm": .78
};
function Na({ center: e, radiusKm: t, style: n, model: r, size: i, base: a, engraving: o, locationName: s, mapView: c = !1, closeUp: l = !1, resolution: u, ready: d = !0, onCenterChange: f }) {
	let p = ja[a] ?? ja.White, m = Ma[i] ?? .48, h = /* @__PURE__ */ (0, I.jsx)("div", {
		className: "flex h-full w-full items-center justify-center bg-muted/50",
		children: /* @__PURE__ */ (0, I.jsx)(w, { className: "h-5 w-5 animate-spin text-muted-foreground" })
	});
	if (!d) return /* @__PURE__ */ (0, I.jsx)("div", { className: "h-full w-full bg-muted/40" });
	if (c) return /* @__PURE__ */ (0, I.jsx)(F.Suspense, {
		fallback: h,
		children: /* @__PURE__ */ (0, I.jsx)(ka, {
			center: e,
			radiusKm: t,
			style: n,
			model: r,
			flat: !0,
			mask: !1,
			controls: !1,
			labels: !0,
			...f ? { onCenterChange: f } : {}
		})
	});
	let g = /* @__PURE__ */ (0, I.jsx)(F.Suspense, {
		fallback: h,
		children: /* @__PURE__ */ (0, I.jsx)(Aa, {
			center: e,
			radiusKm: t,
			model: r,
			style: n,
			tilt: l ? 14 : 16,
			interactive: l,
			...u ? { resolution: u } : {}
		})
	});
	return /* @__PURE__ */ (0, I.jsx)("div", {
		className: "relative flex h-full w-full items-center justify-center overflow-hidden bg-[radial-gradient(115%_95%_at_30%_5%,#efe9e0_0%,#ded7cb_55%,#c2bab0_100%)] p-[7%]",
		children: /* @__PURE__ */ (0, I.jsxs)("div", {
			className: "relative",
			style: {
				width: `${m * 128}%`,
				maxWidth: "88%"
			},
			children: [/* @__PURE__ */ (0, I.jsx)("div", {
				className: "pointer-events-none absolute -inset-x-6 -bottom-6 h-10 rounded-[50%] blur-2xl",
				style: { background: "rgba(60,48,34,0.35)" }
			}), /* @__PURE__ */ (0, I.jsxs)("div", {
				className: "relative",
				style: {
					aspectRatio: "1 / 1.04",
					background: p.surface,
					borderRadius: 3,
					padding: "2.2%",
					boxShadow: `0 34px 60px -28px rgba(50,38,26,0.55), inset 0 0 0 1px ${p.edge}`
				},
				children: [/* @__PURE__ */ (0, I.jsxs)("div", {
					className: "relative h-full w-full overflow-hidden",
					style: {
						background: `color-mix(in oklab, ${p.mat} 88%, ${n.colors.land})`,
						padding: "3%",
						boxShadow: `inset 0 0 0 1px ${p.inner}`
					},
					children: [/* @__PURE__ */ (0, I.jsx)("div", {
						className: "relative h-full w-full overflow-hidden",
						style: { boxShadow: `inset 0 1px 8px rgba(0,0,0,0.3), inset 0 0 0 1px ${p.inner}` },
						children: g
					}), /* @__PURE__ */ (0, I.jsx)("div", {
						className: "absolute inset-x-0 bottom-0 flex h-[3.2%] items-center justify-center text-center",
						style: { color: p.plaque },
						children: /* @__PURE__ */ (0, I.jsx)("span", {
							className: "truncate px-2 text-[clamp(6px,1.1vw,11px)] font-medium tracking-[0.22em] uppercase",
							children: o.trim() || s
						})
					})]
				}), /* @__PURE__ */ (0, I.jsx)("div", {
					className: "pointer-events-none absolute inset-0",
					style: {
						background: "linear-gradient(118deg, rgba(255,255,255,0.18) 0%, rgba(255,255,255,0.04) 24%, rgba(255,255,255,0) 44%)",
						borderRadius: 3
					}
				})]
			})]
		})
	});
}
//#endregion
//#region src/components/CompareDisclosure.tsx
var Pa = {
	size: document.getElementById("dearplace-app")?.dataset.sizeComparison ?? "/dear-compare-sizes-20-25.png",
	frame: {
		version: 1,
		asset_id: "160eb7e1-410c-4396-932a-aa3af115e904",
		project_id: "9ee69a02-3870-4aa9-b8ae-aa6172fe39fa",
		url: "https://dearplace.studio/__l5e/assets-v1/160eb7e1-410c-4396-932a-aa3af115e904/frame-colors-new.png",
		r2_key: "a/v1/9ee69a02-3870-4aa9-b8ae-aa6172fe39fa/160eb7e1-410c-4396-932a-aa3af115e904/frame-colors-new.png",
		original_filename: "frame-colors-new.png",
		size: 2884684,
		content_type: "image/png",
		created_at: "2026-09-07T13:46:25Z"
	}.url,
	look: {
		version: 1,
		asset_id: "20140256-fd6a-43fc-a040-67e958145c5b",
		project_id: "9ee69a02-3870-4aa9-b8ae-aa6172fe39fa",
		url: "https://dearplace.studio/__l5e/assets-v1/20140256-fd6a-43fc-a040-67e958145c5b/compare-look.jpg",
		r2_key: "a/v1/9ee69a02-3870-4aa9-b8ae-aa6172fe39fa/20140256-fd6a-43fc-a040-67e958145c5b/compare-look.jpg",
		original_filename: "compare-look.jpg",
		size: 2096885,
		content_type: "image/png",
		created_at: "2026-08-26T08:02:52Z"
	}.url
};
function Fa({ title: e, section: t }) {
	let { t: n } = x(), [r, i] = (0, F.useState)(!1), a = Pa[t];
	return /* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsxs)("div", {
		className: "flex items-center justify-between gap-3",
		children: [/* @__PURE__ */ (0, I.jsx)("h2", {
			className: "font-display text-lg font-medium",
			children: e
		}), a && /* @__PURE__ */ (0, I.jsxs)("button", {
			type: "button",
			"aria-expanded": r,
			onClick: () => {
				i((e) => (se("compare_toggle", t, { open: !e }), !e));
			},
			className: "inline-flex shrink-0 items-center gap-1 rounded-full px-2 py-1 text-[11px] text-ink/60 transition-colors hover:bg-ink/5 hover:text-ink active:scale-95",
			children: [
				/* @__PURE__ */ (0, I.jsx)(cr, { className: "h-3 w-3 opacity-60" }),
				n(r ? `conf.compare.${t}.hide` : `conf.compare.${t}.show`),
				/* @__PURE__ */ (0, I.jsx)(ar, { className: `h-3 w-3 opacity-60 transition-transform duration-200 ${r ? "rotate-180" : ""}` })
			]
		})]
	}), r && a && /* @__PURE__ */ (0, I.jsx)("img", {
		src: a,
		alt: n(`conf.compare.${t}.alt`),
		loading: "lazy",
		className: "mt-3 w-full rounded-xl border border-border object-cover"
	})] });
}
//#endregion
//#region src/components/PreviewEmailGate.tsx
function Ia({ language: e, onRequest: t, onUnlock: n, onDismiss: r }) {
	let i = e === "sv", [a, o] = (0, F.useState)(jn), [s, c] = (0, F.useState)(!1), [l, u] = (0, F.useState)(!1), d = (0, F.useRef)(!1), f = (0, F.useRef)(null);
	return (0, F.useEffect)(() => {
		let e = f.current, t = document.body.style.overflow;
		return e?.showModal(), document.body.style.overflow = "hidden", () => {
			e?.close(), document.body.style.overflow = t;
		};
	}, []), /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("div", {
		className: "flex h-full min-h-64 items-center justify-center bg-[#efe9e0] p-6 text-center text-sm",
		"aria-hidden": "true",
		children: i ? "Din förhandsvisning är klar" : "Your preview is ready"
	}), /* @__PURE__ */ (0, I.jsxs)("dialog", {
		ref: f,
		className: "dp-preview-email-dialog",
		"aria-labelledby": "preview-email-title",
		"aria-describedby": "preview-email-description",
		onCancel: (e) => {
			e.preventDefault(), s || r();
		},
		children: [/* @__PURE__ */ (0, I.jsx)("button", {
			type: "button",
			className: "dp-preview-email-close",
			"aria-label": i ? "Tillbaka till kartan" : "Back to map",
			disabled: s,
			onClick: r,
			children: "×"
		}), /* @__PURE__ */ (0, I.jsxs)("form", {
			className: "dp-preview-email-form flex flex-col gap-4",
			onSubmit: async (e) => {
				if (e.preventDefault(), !d.current) {
					d.current = !0, c(!0), u(!1);
					try {
						await t(a.trim().toLowerCase()), n();
					} catch {
						u(!0);
					} finally {
						d.current = !1, c(!1);
					}
				}
			},
			children: [
				/* @__PURE__ */ (0, I.jsx)("h3", {
					id: "preview-email-title",
					className: "text-2xl font-semibold",
					children: i ? "Din förhandsvisning är klar" : "Your preview is ready"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					id: "preview-email-description",
					className: "text-sm",
					children: i ? "Ange din e-postadress för att se din modell och få en länk tillbaka till din sparade karta." : "Enter your email to see your model and receive a link back to your saved map."
				}),
				/* @__PURE__ */ (0, I.jsxs)("label", {
					className: "text-sm font-medium",
					children: [i ? "E-postadress" : "Email address", /* @__PURE__ */ (0, I.jsx)("input", {
						className: "mt-2 block w-full rounded-md border bg-white p-3 text-base",
						type: "email",
						autoComplete: "email",
						inputMode: "email",
						required: !0,
						maxLength: 255,
						value: a,
						onChange: (e) => o(e.target.value),
						disabled: s,
						"data-ph-mask": !0
					})]
				}),
				l && /* @__PURE__ */ (0, I.jsx)("p", {
					role: "alert",
					className: "text-sm text-red-700",
					children: i ? "Det gick inte att skicka din begäran. Försök igen. Din modell finns kvar." : "We couldn’t send your request. Please try again. Your model is still saved."
				}),
				/* @__PURE__ */ (0, I.jsx)("button", {
					className: "min-h-12 rounded-md bg-primary px-4 py-3 font-semibold text-primary-foreground disabled:opacity-60",
					disabled: s,
					type: "submit",
					children: s ? i ? "Skickar…" : "Sending…" : i ? "Visa och mejla min förhandsvisning" : "Show and email my preview"
				}),
				/* @__PURE__ */ (0, I.jsxs)("p", {
					className: "text-xs text-muted-foreground",
					children: [
						i ? "Vi mejlar din sparade modell och påminnelser om den. Du kan avregistrera dig i mejlen." : "We’ll email your saved model and reminders about it. You can unsubscribe in the emails.",
						" ",
						/* @__PURE__ */ (0, I.jsx)("a", {
							className: "underline",
							href: i ? "/sv/pages/privacy" : "/pages/privacy",
							target: "_blank",
							rel: "noreferrer",
							children: i ? "Integritetspolicy" : "Privacy policy"
						})
					]
				})
			]
		})]
	})] });
}
//#endregion
//#region node_modules/@radix-ui/react-compose-refs/dist/index.mjs
var La = Object.defineProperty, Ra = (e, t) => La(e, "name", {
	value: t,
	configurable: !0
});
function za(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Ra(za, "setRef");
function Ba(...e) {
	return (t) => {
		let n = !1, r = e.map((e) => {
			let r = za(e, t);
			return !n && typeof r == "function" && (n = !0), r;
		});
		if (n) return () => {
			for (let t = 0; t < r.length; t++) {
				let n = r[t];
				typeof n == "function" ? n() : za(e[t], null);
			}
		};
	};
}
Ra(Ba, "composeRefs");
function Va(...e) {
	return F.useCallback(Ba(...e), e);
}
Ra(Va, "useComposedRefs");
//#endregion
//#region node_modules/@radix-ui/react-slot/dist/index.mjs
var Ha = Object.defineProperty, Ua = (e, t) => Ha(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function Wa(e) {
	let t = F.forwardRef((t, n) => {
		let { children: r, ...i } = t, a = null, o = !1, s = [];
		$a(r) && typeof ro == "function" && (r = ro(r._payload)), F.Children.forEach(r, (e) => {
			if (Za(e)) {
				o = !0;
				let t = e, n = "child" in t.props ? t.props.child : t.props.children;
				$a(n) && typeof ro == "function" && (n = ro(n._payload)), a = Ja(t, n), s.push(a?.props?.children);
			} else s.push(e);
		}), a ? a = F.cloneElement(a, void 0, s) : !o && F.Children.count(r) === 1 && F.isValidElement(r) && (a = r);
		let c = a ? Xa(a) : void 0, l = Va(n, c);
		if (!a) {
			if (r || r === 0) throw Error(o ? no(e) : to(e));
			return r;
		}
		let u = Ya(i, a.props ?? {});
		return a.type !== F.Fragment && (u.ref = n ? l : c), F.cloneElement(a, u);
	});
	return t.displayName = `${e}.Slot`, t;
}
Ua(Wa, "createSlot");
var Ga = /* @__PURE__ */ Wa("Slot"), Ka = Symbol.for("radix.slottable");
// @__NO_SIDE_EFFECTS__
function qa(e) {
	let t = /* @__PURE__ */ Ua((e) => "child" in e ? e.children(e.child) : e.children, "Slottable");
	return t.displayName = `${e}.Slottable`, t.__radixId = Ka, t;
}
Ua(qa, "createSlottable");
var Ja = /* @__PURE__ */ Ua((e, t) => {
	if ("child" in e.props) {
		let t = e.props.child;
		return F.isValidElement(t) ? F.cloneElement(t, void 0, e.props.children(t.props.children)) : null;
	}
	return F.isValidElement(t) ? t : null;
}, "getSlottableElementFromSlottable");
function Ya(e, t) {
	let n = { ...t };
	for (let r in t) {
		let i = e[r], a = t[r];
		/^on[A-Z]/.test(r) ? i && a ? n[r] = (...e) => {
			let t = a(...e);
			return i(...e), t;
		} : i && (n[r] = i) : r === "style" ? n[r] = {
			...i,
			...a
		} : r === "className" && (n[r] = [i, a].filter(Boolean).join(" "));
	}
	return {
		...e,
		...n
	};
}
Ua(Ya, "mergeProps");
function Xa(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Ua(Xa, "getElementRef");
function Za(e) {
	return F.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Ka;
}
Ua(Za, "isSlottable");
var Qa = Symbol.for("react.lazy");
function $a(e) {
	return typeof e == "object" && !!e && "$$typeof" in e && e.$$typeof === Qa && "_payload" in e && eo(e._payload);
}
Ua($a, "isLazyComponent");
function eo(e) {
	return typeof e == "object" && !!e && "then" in e;
}
Ua(eo, "isPromiseLike");
var to = /* @__PURE__ */ Ua((e) => `${e} failed to slot onto its children. Expected a single React element child or \`Slottable\`.`, "createSlotError"), no = /* @__PURE__ */ Ua((e) => `${e} failed to slot onto its \`Slottable\`. Expected \`Slottable\` to receive a single React element child.`, "createSlottableError"), ro = F.use, io = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, ao = xr, oo = ((e, t) => (n) => {
	if (t?.variants == null) return ao(e, n?.class, n?.className);
	let { variants: r, defaultVariants: i } = t, a = Object.keys(r).map((e) => {
		let t = n?.[e], a = i?.[e];
		if (t === null) return null;
		let o = io(t) || io(a);
		return r[e][o];
	}), o = n && Object.entries(n).reduce((e, t) => {
		let [n, r] = t;
		return r === void 0 || (e[n] = r), e;
	}, {});
	return ao(e, a, t?.compoundVariants?.reduce((e, t) => {
		let { class: n, className: r, ...a } = t;
		return Object.entries(a).every((e) => {
			let [t, n] = e;
			return Array.isArray(n) ? n.includes({
				...i,
				...o
			}[t]) : {
				...i,
				...o
			}[t] === n;
		}) ? [
			...e,
			n,
			r
		] : e;
	}, []), n?.class, n?.className);
})("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium cursor-pointer transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 disabled:cursor-not-allowed [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", {
	variants: {
		variant: {
			default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
			destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
			outline: "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
			secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
			ghost: "hover:bg-accent hover:text-accent-foreground",
			link: "text-primary underline-offset-4 hover:underline"
		},
		size: {
			default: "h-9 px-4 py-2",
			sm: "h-8 rounded-md px-3 text-xs",
			lg: "h-10 rounded-md px-8",
			icon: "h-9 w-9"
		}
	},
	defaultVariants: {
		variant: "default",
		size: "default"
	}
}), K = F.forwardRef(({ className: e, variant: t, size: n, asChild: r = !1, ...i }, a) => /* @__PURE__ */ (0, I.jsx)(r ? Ga : "button", {
	className: Ki(oo({
		variant: t,
		size: n,
		className: e
	})),
	ref: a,
	...i
}));
K.displayName = "Button";
//#endregion
//#region src/lib/model-api.functions.ts
var so = async (...e) => await (await bn("render", "POST")).json(), co = async (...e) => xn(), lo = Sn, uo = "dp.dev.renders.v1", fo = 300, po = 0;
function mo(e) {
	return [
		e.lat.toFixed(5),
		e.lon.toFixed(5),
		e.scale,
		e.sizeCm,
		e.color,
		e.frame
	].join("|");
}
function ho() {
	if (typeof window > "u") return {};
	try {
		return JSON.parse(window.localStorage.getItem(uo) ?? "{}");
	} catch {
		return {};
	}
}
function go(e, t) {
	if (!(typeof window > "u")) try {
		let n = ho();
		n[e] = t;
		let r = Object.entries(n).slice(-20);
		window.localStorage.setItem(uo, JSON.stringify(Object.fromEntries(r)));
	} catch {}
}
function _o(e) {
	if (!(typeof window > "u")) try {
		let t = ho();
		delete t[e], window.localStorage.setItem(uo, JSON.stringify(t));
	} catch {}
}
function vo(e, t) {
	let n = e ? `${Cn()}|${mo(e)}` : "", r = me(), [i, a] = (0, F.useState)(0), o = (0, F.useRef)(0);
	(0, F.useEffect)(() => {
		a(0), o.current = 0;
	}, [n]);
	let s = At({
		queryKey: [
			"model-render",
			n,
			i
		],
		enabled: !!e,
		staleTime: Infinity,
		gcTime: 36e5,
		retry: !1,
		retryDelay: (e) => 800 * 2 ** e,
		queryFn: async () => {
			let r = i === 0 ? t : null;
			if (r) return {
				id: r,
				cached: !0
			};
			let a = await so({ data: e });
			if (!a.id) throw Error(a.error ?? "render_failed");
			return go(n, a.id), {
				id: a.id,
				cached: !1
			};
		}
	}), c = s.data?.id ?? null, [l, u] = (0, F.useState)(!1);
	(0, F.useEffect)(() => {
		u(!1);
	}, [n, i]);
	let [d, f] = (0, F.useState)(0);
	(0, F.useEffect)(() => {
		if (!e || l) return;
		let t = Date.now() - d * 1e3, n = setInterval(() => f(Math.round((Date.now() - t) / 1e3)), 1e3);
		return () => clearInterval(n);
	}, [
		n,
		i,
		e,
		l
	]), (0, F.useEffect)(() => {
		l || f(0);
	}, [
		n,
		i,
		l
	]);
	let p = !l && d >= fo, m = At({
		queryKey: [
			"model-render-status",
			c,
			i
		],
		enabled: !!c,
		retry: 3,
		retryDelay: (e) => 1e3 * 2 ** e,
		refetchInterval: (e) => {
			let t = e.state.data?.status;
			return t === "ready" || t === "failed" ? !1 : e.state.data?.transient ? 6e3 : 3e3;
		},
		queryFn: () => co({ data: { id: c } })
	});
	(0, F.useEffect)(() => {
		m.data?.status === "ready" && u(!0);
	}, [m.data?.status]);
	let h = s.isError, g = m.data?.status === "failed", _;
	_ = h || g ? "failed" : !c || !m.data ? "queued" : m.data.status;
	let v = _ === "failed" ? h && String(s.error?.message ?? "").includes("renderer_unsupported_size") ? "unsupported_size" : h && String(s.error?.message ?? "").includes("renderer_unsupported_option") ? "unsupported_option" : h && String(s.error?.message ?? "").includes("unreachable") ? "unreachable" : "failed" : null, y = (0, F.useCallback)(() => {
		_o(n), r.removeQueries({ queryKey: [
			"model-render-status",
			c,
			i
		] }), r.removeQueries({ queryKey: [
			"model-render",
			n,
			i
		] }), a((e) => e + 1);
	}, [
		i,
		c,
		n,
		r
	]);
	return (0, F.useEffect)(() => {
		if (_ !== "failed" || o.current >= po) return;
		o.current += 1;
		let e = setTimeout(y, 1500);
		return () => clearTimeout(e);
	}, [_, y]), {
		id: c,
		retry: (0, F.useCallback)(() => {
			o.current = po, y();
		}, [y]),
		state: _,
		errorKind: v,
		recovering: _ === "failed" && o.current < po,
		degraded: (m.isError || !!m.data?.transient) && _ !== "ready",
		takingLonger: p,
		progress: m.data?.progress ?? null,
		elapsed: d,
		fromCache: s.data?.cached ?? !1,
		imageUrl: (e) => c ? lo(c, e) : null
	};
}
//#endregion
//#region src/components/RenderPreview.tsx
function yo(e, t) {
	let n = e.toLowerCase();
	return n.includes("start") ? t("render.stage.starting") : n.includes("fetch") ? t("render.stage.fetching") : n.includes("build") ? t("render.stage.building") : n.includes("render") ? t("render.stage.rendering") : n.includes("finish") || n.includes("final") ? t("render.stage.finishing") : e;
}
function bo({ params: e, locationName: t, onReady: n, resumeId: r, purchase: i, onDismissEmail: a }) {
	let { t: o, lang: s } = x(), c = vo(e, r);
	(0, F.useEffect)(() => {
		c.state === "failed" && A({
			error_kind: c.errorKind || "unknown",
			design_id: Cn(),
			...c.id ? { model_id: c.id } : {}
		});
	}, [
		c.state,
		c.errorKind,
		c.id
	]);
	let [l, u] = (0, F.useState)(null), [d, f] = (0, F.useState)(!1), [p, m] = (0, F.useState)(!1), [h, g] = (0, F.useState)(!1), _ = (0, F.useRef)(null), [v, y] = (0, F.useState)(!1), [b, S] = (0, F.useState)("flat");
	(0, F.useEffect)(() => {
		if (!h) return;
		let e = document.getElementById("dearplace-app")?.shadowRoot, t = e?.activeElement ?? document.activeElement;
		_.current?.querySelector("button")?.focus();
		let n = (t) => {
			if (t.key === "Escape" && g(!1), t.key === "Tab") {
				let n = Array.from(_.current?.querySelectorAll("button:not(:disabled)") ?? []), r = e?.activeElement ?? document.activeElement, i = n.indexOf(r);
				n.length && (i === -1 || t.shiftKey && i === 0 || !t.shiftKey && i === n.length - 1) && (t.preventDefault(), n[t.shiftKey ? n.length - 1 : 0].focus());
			}
		};
		window.addEventListener("keydown", n);
		let r = document.body.style.overflow;
		return document.body.dataset.dpPreviewOverflow = r, document.body.style.overflow = "hidden", () => {
			window.removeEventListener("keydown", n);
			let e = document.getElementById("dear-cart-drawer")?.hasAttribute("open");
			e || (document.body.style.overflow = r), delete document.body.dataset.dpPreviewOverflow, !e && t?.isConnected && t.focus();
		};
	}, [h]);
	let C = c.state === "ready" ? c.id : null, T = jn();
	(0, F.useEffect)(() => {
		C && T && D("preview_email_saved", {
			source: "remembered_preview",
			model_id: C,
			design_id: Cn()
		});
	}, [C, T]), (0, F.useEffect)(() => {
		Wn && C && T && !Kn(C) && l !== C && In(C, s === "sv" ? "sv" : "en", {
			place_name: t,
			size: `${e?.sizeCm ?? 20}x${e?.sizeCm ?? 20}`,
			color: e?.color,
			frame: e?.frame,
			lat: e?.lat,
			lon: e?.lon
		}).then(() => qn(C)).catch(() => {});
	}, [
		C,
		T,
		l
	]), (0, F.useEffect)(() => {
		C && (r || k(C, {
			design_id: Cn(),
			size: e?.sizeCm,
			color: e?.color,
			frame: e?.frame
		}), n && n(C));
	}, [C, n]);
	let [E, ee] = (0, F.useState)(!1), [te, ne] = (0, F.useState)(0), re = c.state === "ready" ? c.imageUrl("flat") : null, ae = c.state === "ready" ? c.imageUrl("wall") : null, O = re && !E ? re : null, oe = ae && !E ? ae : null, se = () => {
		te < 2 ? (ne((e) => e + 1), f(!1), m(!1)) : ee(!0);
	};
	(0, F.useEffect)(() => {
		ee(!1), ne(0), f(!1), m(!1);
	}, [re, ae]);
	let ce = (e) => {
		S(e), g(!0), ie(e === "wall" ? "render_wall_zoom" : "render_zoom", { place: t });
	}, le = () => {
		g(!1), ie("render_zoom_close", { place: t });
	};
	if (c.state === "failed" && !c.recovering) {
		let e = c.errorKind === "unreachable" ? o("render.unreachable") : c.errorKind === "unsupported_size" ? o("render.unsupportedSize") : c.errorKind === "unsupported_option" ? o("render.unsupportedOption") : o("render.failed");
		return /* @__PURE__ */ (0, I.jsxs)("div", {
			className: "flex h-full w-full flex-col items-center justify-center gap-3 bg-muted/40 px-6 text-center",
			children: [/* @__PURE__ */ (0, I.jsx)("p", {
				className: "text-sm text-muted-foreground",
				children: e
			}), !c.errorKind?.startsWith("unsupported_") && /* @__PURE__ */ (0, I.jsxs)(K, {
				variant: "outline",
				size: "sm",
				className: "rounded-full",
				onClick: () => {
					ie("render_retry", { reason: c.errorKind ?? "failed" }), c.retry();
				},
				children: [
					/* @__PURE__ */ (0, I.jsx)(fr, { className: "mr-2 h-3.5 w-3.5" }),
					" ",
					o("render.retry")
				]
			})]
		});
	}
	if (c.state === "ready" && E) return /* @__PURE__ */ (0, I.jsxs)("div", {
		className: "flex h-full w-full flex-col items-center justify-center gap-3 bg-muted/40 px-6 text-center",
		children: [/* @__PURE__ */ (0, I.jsx)("p", {
			className: "text-sm text-muted-foreground",
			children: o("render.imageFailed")
		}), /* @__PURE__ */ (0, I.jsxs)(K, {
			variant: "outline",
			size: "sm",
			className: "rounded-full",
			onClick: () => {
				ie("render_retry", { reason: "image_load" }), ee(!1), ne((e) => e + 1);
			},
			children: [
				/* @__PURE__ */ (0, I.jsx)(fr, { className: "mr-2 h-3.5 w-3.5" }),
				" ",
				o("render.retry")
			]
		})]
	});
	if (!O || !oe) return /* @__PURE__ */ (0, I.jsxs)("div", {
		className: "flex h-full w-full flex-col items-center justify-center gap-4 bg-[radial-gradient(115%_95%_at_30%_5%,#efe9e0_0%,#ded7cb_55%,#c2bab0_100%)] px-8 text-center",
		children: [/* @__PURE__ */ (0, I.jsx)(w, { className: "h-6 w-6 animate-spin text-foreground/50" }), /* @__PURE__ */ (0, I.jsxs)("div", { children: [
			/* @__PURE__ */ (0, I.jsx)("p", {
				className: "text-sm font-medium",
				children: o("render.building", { place: t })
			}),
			/* @__PURE__ */ (0, I.jsx)("p", {
				className: "mt-1 text-xs text-muted-foreground",
				children: c.recovering ? o("render.recovering") : c.degraded ? o("render.degraded") : c.progress ? yo(c.progress, o) : o("render.queued")
			}),
			/* @__PURE__ */ (0, I.jsx)("p", {
				className: "mt-2 text-xs text-muted-foreground",
				role: "status",
				children: s === "sv" ? `Tid hittills: ${Math.floor(c.elapsed / 60)} min ${Math.floor(c.elapsed % 60)} sek. Dina val finns kvar.` : `Elapsed: ${Math.floor(c.elapsed / 60)}m ${Math.floor(c.elapsed % 60)}s. Your choices are saved.`
			}),
			c.takingLonger && /* @__PURE__ */ (0, I.jsx)("p", {
				className: "mt-1 text-xs text-muted-foreground",
				children: o("render.longWait")
			})
		] })]
	});
	if (Wn && !T && C && l !== C && !Kn(C)) return /* @__PURE__ */ (0, I.jsx)(Ia, {
		language: s === "sv" ? "sv" : "en",
		onDismiss: a,
		onRequest: (n) => Pn(n, s === "sv" ? "sv" : "en", {
			place_name: t,
			size: `${e?.sizeCm ?? 20}x${e?.sizeCm ?? 20}`,
			color: e?.color,
			frame: e?.frame,
			lat: e?.lat,
			lon: e?.lon
		}),
		onUnlock: () => {
			qn(C), u(C);
		}
	}, C);
	let j = b === "wall" ? oe : O, ue = b === "wall" ? o("render.view.wall") : o("render.alt", { place: t });
	return /* @__PURE__ */ (0, I.jsxs)("div", {
		className: "relative h-full w-full bg-[#efe9e0]",
		children: [
			/* @__PURE__ */ (0, I.jsx)("button", {
				type: "button",
				onClick: () => ce("flat"),
				"aria-label": o("render.zoom"),
				title: o("render.zoom"),
				className: "group absolute inset-0 z-10 block h-full w-full appearance-none overflow-hidden p-0 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-foreground/20",
				children: /* @__PURE__ */ (0, I.jsx)("img", {
					src: O,
					alt: o("render.alt", { place: t }),
					className: `pointer-events-none h-full w-full object-contain transition-opacity duration-300 ${d ? "opacity-100" : "opacity-0"}`,
					onLoad: () => f(!0),
					onError: se,
					loading: "lazy"
				}, `${O}:${te}`)
			}),
			/* @__PURE__ */ (0, I.jsxs)("button", {
				type: "button",
				onClick: () => ce("wall"),
				"aria-label": o("render.view.wall"),
				title: o("render.view.wall"),
				className: "group absolute bottom-3 right-3 z-20 w-[38%] max-w-[210px] overflow-hidden rounded-lg border border-black/10 bg-white/90 text-left shadow-[0_12px_28px_-16px_rgba(0,0,0,0.35)] backdrop-blur transition-transform duration-200 hover:scale-[1.02] focus:outline-none focus-visible:ring-2 focus-visible:ring-foreground/20",
				children: [
					/* @__PURE__ */ (0, I.jsx)("img", {
						src: oe,
						alt: o("render.view.wall"),
						className: `pointer-events-none aspect-[4/5] w-full object-cover transition-opacity duration-300 ${p ? "opacity-100" : "opacity-0"}`,
						onLoad: () => m(!0),
						onError: se,
						loading: "lazy"
					}, `${oe}:${te}`),
					/* @__PURE__ */ (0, I.jsx)("span", {
						className: "absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/50 to-transparent px-2.5 py-2 text-[10px] font-medium text-white",
						children: o("render.view.wall")
					}),
					/* @__PURE__ */ (0, I.jsx)("span", {
						className: "absolute right-2 top-2 inline-flex h-7 w-7 items-center justify-center rounded-full bg-white/85 text-foreground/70 opacity-0 shadow-sm backdrop-blur transition-opacity duration-200 group-hover:opacity-100",
						children: /* @__PURE__ */ (0, I.jsx)(yr, { className: "h-3.5 w-3.5" })
					})
				]
			}),
			!d && /* @__PURE__ */ (0, I.jsx)("div", {
				className: "absolute inset-0 z-30 flex items-center justify-center bg-[#efe9e0]/80",
				children: /* @__PURE__ */ (0, I.jsx)(w, { className: "h-5 w-5 animate-spin text-foreground/40" })
			}),
			/* @__PURE__ */ (0, I.jsx)("button", {
				type: "button",
				onClick: () => ce("flat"),
				"aria-label": o("render.zoom"),
				title: o("render.zoom"),
				className: "pointer-events-none absolute right-3 top-3 z-20 inline-flex h-9 w-9 items-center justify-center rounded-full border border-black/10 bg-white/85 text-foreground/70 shadow-sm backdrop-blur transition-colors hover:text-foreground",
				children: /* @__PURE__ */ (0, I.jsx)(yr, { className: "h-4 w-4" })
			}),
			h && typeof document < "u" && (0, Mt.createPortal)(/* @__PURE__ */ (0, I.jsxs)("div", {
				ref: _,
				className: "dp-preview-dialog fixed inset-0 z-[200] flex flex-col items-center justify-center bg-black/95 p-3 sm:p-8",
				role: "dialog",
				"aria-label": s === "sv" ? `Din karta av ${t}` : `Your map of ${t}`,
				"aria-modal": "true",
				onClick: le,
				children: [
					/* @__PURE__ */ (0, I.jsx)("img", {
						src: j,
						alt: ue,
						className: "min-h-0 max-h-[60dvh] max-w-full flex-1 object-contain",
						onClick: (e) => e.stopPropagation()
					}),
					/* @__PURE__ */ (0, I.jsxs)("div", {
						className: "mt-4 flex items-center gap-2 rounded-full bg-white/10 p-1 backdrop-blur",
						onClick: (e) => e.stopPropagation(),
						children: [/* @__PURE__ */ (0, I.jsx)("button", {
							type: "button",
							onClick: () => {
								S("flat"), ie("render_zoom_swap", {
									kind: "flat",
									place: t
								});
							},
							className: `rounded-full px-4 py-2 text-xs font-medium transition-colors ${b === "flat" ? "bg-white text-foreground" : "text-white/80 hover:text-white"}`,
							children: o("render.view.flat")
						}), /* @__PURE__ */ (0, I.jsx)("button", {
							type: "button",
							onClick: () => {
								S("wall"), ie("render_zoom_swap", {
									kind: "wall",
									place: t
								});
							},
							className: `rounded-full px-4 py-2 text-xs font-medium transition-colors ${b === "wall" ? "bg-white text-foreground" : "text-white/80 hover:text-white"}`,
							children: o("render.view.wall")
						})]
					}),
					i && /* @__PURE__ */ (0, I.jsxs)("div", {
						className: "dp-preview-buy",
						onClick: (e) => e.stopPropagation(),
						children: [
							/* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("strong", { children: t }), /* @__PURE__ */ (0, I.jsx)("span", { children: i.price })] }),
							/* @__PURE__ */ (0, I.jsx)("button", {
								type: "button",
								className: "dp-map-primary",
								disabled: i.disabled,
								onClick: async () => {
									y(!1);
									try {
										await i.onAdd() ? le() : y(!0);
									} catch {
										y(!0);
									}
								},
								children: i.busy ? s === "sv" ? "Lägger till…" : "Adding…" : i.label
							}),
							/* @__PURE__ */ (0, I.jsx)("p", { children: i.detail }),
							v && /* @__PURE__ */ (0, I.jsx)("p", {
								role: "alert",
								children: s === "sv" ? "Kunde inte lägga till. Din karta finns kvar – försök igen." : "Could not add your map. It is saved — please try again."
							})
						]
					}),
					/* @__PURE__ */ (0, I.jsx)("button", {
						type: "button",
						onClick: le,
						"aria-label": o("render.close"),
						className: "absolute right-4 top-4 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white/90 text-foreground shadow-sm",
						children: /* @__PURE__ */ (0, I.jsx)(vr, { className: "h-5 w-5" })
					})
				]
			}), document.getElementById("dearplace-app")?.shadowRoot?.getElementById("dp-portals") ?? document.body)
		]
	});
}
//#endregion
//#region node_modules/@radix-ui/primitive/dist/index.mjs
var xo = Object.defineProperty, So = (e, t) => xo(e, "name", {
	value: t,
	configurable: !0
}), Co = !!(typeof window < "u" && window.document && window.document.createElement);
function wo(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
	return /* @__PURE__ */ So(function(r) {
		if (e?.(r), n === !1 || !r || !r.defaultPrevented) return t?.(r);
	}, "handleEvent");
}
So(wo, "composeEventHandlers");
function To(e) {
	if (!Co) throw Error("Cannot access window outside of the DOM");
	return e?.ownerDocument?.defaultView ?? window;
}
So(To, "getOwnerWindow");
function Eo(e) {
	if (!Co) throw Error("Cannot access document outside of the DOM");
	return e?.ownerDocument ?? document;
}
So(Eo, "getOwnerDocument");
function Do(e, t = !1) {
	let { activeElement: n } = Eo(e);
	if (!n?.nodeName) return null;
	if (Oo(n) && n.contentDocument) return Do(n.contentDocument.body, t);
	if (t) {
		let e = n.getAttribute("aria-activedescendant");
		if (e) {
			let t = Eo(n).getElementById(e);
			if (t) return t;
		}
	}
	return n;
}
So(Do, "getActiveElement");
function Oo(e) {
	return e.tagName === "IFRAME";
}
So(Oo, "isFrame");
//#endregion
//#region node_modules/@radix-ui/react-context/dist/index.mjs
var ko = Object.defineProperty, Ao = (e, t) => ko(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function jo(e, t) {
	let n = F.createContext(t);
	n.displayName = e + "Context";
	let r = /* @__PURE__ */ Ao((e) => {
		let { children: t, ...r } = e, i = F.useMemo(() => r, Object.values(r));
		return /* @__PURE__ */ (0, I.jsx)(n.Provider, {
			value: i,
			children: t
		});
	}, "Provider");
	r.displayName = e + "Provider";
	function i(r, i = {}) {
		let { optional: a = !1 } = i, o = F.useContext(n);
		if (o) return o;
		if (t !== void 0) return t;
		if (!a) throw Error(`\`${r}\` must be used within \`${e}\``);
	}
	return Ao(i, "useContext"), [r, i];
}
Ao(jo, "createContext");
// @__NO_SIDE_EFFECTS__
function Mo(e, t = []) {
	let n = [];
	function r(t, r) {
		let i = F.createContext(r);
		i.displayName = t + "Context";
		let a = n.length;
		n = [...n, r];
		let o = /* @__PURE__ */ Ao((t) => {
			let { scope: n, children: r, ...o } = t, s = n?.[e]?.[a] || i, c = F.useMemo(() => o, Object.values(o));
			return /* @__PURE__ */ (0, I.jsx)(s.Provider, {
				value: c,
				children: r
			});
		}, "Provider");
		o.displayName = t + "Provider";
		function s(n, o, s = {}) {
			let { optional: c = !1 } = s, l = o?.[e]?.[a] || i, u = F.useContext(l);
			if (u) return u;
			if (r !== void 0) return r;
			if (!c) throw Error(`\`${n}\` must be used within \`${t}\``);
		}
		return Ao(s, "useContext"), [o, s];
	}
	Ao(r, "createContext");
	let i = /* @__PURE__ */ Ao(() => {
		let t = n.map((e) => F.createContext(e));
		return /* @__PURE__ */ Ao(function(n) {
			let r = n?.[e] || t;
			return F.useMemo(() => ({ [`__scope${e}`]: {
				...n,
				[e]: r
			} }), [n, r]);
		}, "useScope");
	}, "createScope");
	return i.scopeName = e, [r, No(i, ...t)];
}
Ao(Mo, "createContextScope");
function No(...e) {
	let t = e[0];
	if (e.length === 1) return t;
	let n = /* @__PURE__ */ Ao(() => {
		let n = e.map((e) => ({
			useScope: e(),
			scopeName: e.scopeName
		}));
		return /* @__PURE__ */ Ao(function(e) {
			let r = n.reduce((t, { useScope: n, scopeName: r }) => {
				let i = n(e)[`__scope${r}`];
				return {
					...t,
					...i
				};
			}, {});
			return F.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
		}, "useComposedScopes");
	}, "createScope");
	return n.scopeName = t.scopeName, n;
}
Ao(No, "composeContextScopes");
//#endregion
//#region node_modules/@radix-ui/react-use-layout-effect/dist/index.mjs
var Po = globalThis?.document ? F.useLayoutEffect : () => {}, Fo = Object.defineProperty, Io = (e, t) => Fo(e, "name", {
	value: t,
	configurable: !0
}), Lo = F.useId || (() => void 0), Ro = 0;
function zo(e) {
	let [t, n] = F.useState(Lo());
	return Po(() => {
		e || n((e) => e ?? String(Ro++));
	}, [e]), e || (t ? `radix-${t}` : "");
}
Io(zo, "useId");
//#endregion
//#region node_modules/@radix-ui/react-use-effect-event/dist/index.mjs
var Bo = Object.defineProperty, Vo = (e, t) => Bo(e, "name", {
	value: t,
	configurable: !0
}), Ho = F.useEffectEvent, Uo = F.useInsertionEffect;
function Wo(e) {
	if (typeof Ho == "function") return Ho(e);
	let t = F.useRef(() => {
		throw Error("Cannot call an event handler while rendering.");
	});
	return typeof Uo == "function" ? Uo(() => {
		t.current = e;
	}) : Po(() => {
		t.current = e;
	}), F.useMemo(() => ((...e) => t.current?.(...e)), []);
}
Vo(Wo, "useEffectEvent");
//#endregion
//#region node_modules/@radix-ui/react-use-controllable-state/dist/index.mjs
var Go = Object.defineProperty, Ko = (e, t) => Go(e, "name", {
	value: t,
	configurable: !0
}), qo = F.useInsertionEffect || Po;
function Jo({ prop: e, defaultProp: t, onChange: n = /* @__PURE__ */ Ko(() => {}, "onChange"), caller: r }) {
	let [i, a, o] = Yo({
		defaultProp: t,
		onChange: n
	}), s = e !== void 0;
	return [s ? e : i, F.useCallback((t) => {
		if (s) {
			let n = Xo(t) ? t(e) : t;
			n !== e && o.current?.(n);
		} else a(t);
	}, [
		s,
		e,
		a,
		o
	])];
}
Ko(Jo, "useControllableState");
function Yo({ defaultProp: e, onChange: t }) {
	let [n, r] = F.useState(e), i = F.useRef(n), a = F.useRef(t);
	return qo(() => {
		a.current = t;
	}, [t]), F.useEffect(() => {
		i.current !== n && (a.current?.(n), i.current = n);
	}, [n, i]), [
		n,
		r,
		a
	];
}
Ko(Yo, "useUncontrolledState");
function Xo(e) {
	return typeof e == "function";
}
Ko(Xo, "isFunction");
var Zo = Symbol("RADIX:SYNC_STATE");
function Qo(e, t, n, r) {
	let { prop: i, defaultProp: a, onChange: o, caller: s } = t, c = i !== void 0, l = Wo(o), u = [{
		...n,
		state: a
	}];
	r && u.push(r);
	let [d, f] = F.useReducer((t, n) => {
		if (n.type === Zo) return {
			...t,
			state: n.state
		};
		let r = e(t, n);
		return c && !Object.is(r.state, t.state) && l(r.state), r;
	}, ...u), p = d.state, m = F.useRef(p);
	F.useEffect(() => {
		m.current !== p && (m.current = p, c || l(p));
	}, [
		p,
		m,
		c
	]);
	let h = F.useMemo(() => i === void 0 ? d : {
		...d,
		state: i
	}, [d, i]);
	return F.useEffect(() => {
		c && !Object.is(i, d.state) && f({
			type: Zo,
			state: i
		});
	}, [
		i,
		d.state,
		c
	]), [h, f];
}
Ko(Qo, "useControllableStateReducer");
//#endregion
//#region node_modules/@radix-ui/react-primitive/dist/index.mjs
var $o = Object.defineProperty, es = (e, t) => $o(e, "name", {
	value: t,
	configurable: !0
}), ts = [
	"a",
	"button",
	"div",
	"form",
	"h2",
	"h3",
	"img",
	"input",
	"label",
	"li",
	"nav",
	"ol",
	"p",
	"select",
	"span",
	"svg",
	"ul"
].reduce((e, t) => {
	let n = /* @__PURE__ */ Wa(`Primitive.${t}`), r = F.forwardRef((e, r) => {
		let { asChild: i, ...a } = e, o = i ? n : t;
		return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ (0, I.jsx)(o, {
			...a,
			ref: r
		});
	});
	return r.displayName = `Primitive.${t}`, {
		...e,
		[t]: r
	};
}, {});
function ns(e, t) {
	e && Mt.flushSync(() => e.dispatchEvent(t));
}
es(ns, "dispatchDiscreteCustomEvent");
//#endregion
//#region node_modules/@radix-ui/react-use-callback-ref/dist/index.mjs
var rs = Object.defineProperty, is = (e, t) => rs(e, "name", {
	value: t,
	configurable: !0
});
function as(e) {
	let t = F.useRef(e);
	return F.useEffect(() => {
		t.current = e;
	}), F.useMemo(() => ((...e) => t.current?.(...e)), []);
}
is(as, "useCallbackRef");
//#endregion
//#region node_modules/@radix-ui/react-dismissable-layer/dist/index.mjs
var os = Object.defineProperty, ss = (e, t) => os(e, "name", {
	value: t,
	configurable: !0
}), cs = "dismissableLayer.update", ls = "dismissableLayer.pointerDownOutside", us = "dismissableLayer.focusOutside", ds, fs = F.createContext({
	layers: /* @__PURE__ */ new Set(),
	layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
	branches: /* @__PURE__ */ new Set(),
	dismissableSurfaces: /* @__PURE__ */ new Set()
}), ps = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ ss(function(e, t) {
	let { disableOutsidePointerEvents: n = !1, deferPointerDownOutside: r = !1, onEscapeKeyDown: i, onPointerDownOutside: a, onFocusOutside: o, onInteractOutside: s, onDismiss: c, ...l } = e, u = F.useContext(fs), [d, f] = F.useState(null), p = d?.ownerDocument ?? globalThis?.document, [, m] = F.useState({}), h = Va(t, f), g = Array.from(u.layers), [_] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), v = _ ? g.indexOf(_) : -1, y = d ? g.indexOf(d) : -1, b = u.layersWithOutsidePointerEventsDisabled.size > 0, x = y >= v, S = F.useRef(!1), C = gs((e) => {
		a?.(e), s?.(e), e.defaultPrevented || c?.();
	}, {
		ownerDocument: p,
		deferPointerDownOutside: r,
		isDeferredPointerDownOutsideRef: S,
		dismissableSurfaces: u.dismissableSurfaces,
		shouldHandlePointerDownOutside: F.useCallback((e) => {
			if (!(e instanceof Node)) return !1;
			let t = [...u.branches].some((t) => t.contains(e));
			return x && !t;
		}, [u.branches, x])
	}), w = _s((e) => {
		if (r && S.current) return;
		let t = e.target;
		[...u.branches].some((e) => e.contains(t)) || (o?.(e), s?.(e), e.defaultPrevented || c?.());
	}, p), T = d ? y === g.length - 1 : !1, E = as((e) => {
		e.key === "Escape" && (i?.(e), !e.defaultPrevented && c && (e.preventDefault(), c()));
	});
	return F.useEffect(() => {
		if (T) return p.addEventListener("keydown", E, { capture: !0 }), () => p.removeEventListener("keydown", E, { capture: !0 });
	}, [
		p,
		T,
		E
	]), F.useEffect(() => {
		if (d) return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && (ds = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), vs(), () => {
			n && (u.layersWithOutsidePointerEventsDisabled.delete(d), u.layersWithOutsidePointerEventsDisabled.size === 0 && (p.body.style.pointerEvents = ds));
		};
	}, [
		d,
		p,
		n,
		u
	]), F.useEffect(() => () => {
		d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), vs());
	}, [d, u]), F.useEffect(() => {
		let e = /* @__PURE__ */ ss(() => m({}), "handleUpdate");
		return document.addEventListener(cs, e), () => document.removeEventListener(cs, e);
	}, []), /* @__PURE__ */ (0, I.jsx)(ts.div, {
		...l,
		ref: h,
		style: {
			pointerEvents: b ? x ? "auto" : "none" : void 0,
			...e.style
		},
		onFocusCapture: wo(e.onFocusCapture, w.onFocusCapture),
		onBlurCapture: wo(e.onBlurCapture, w.onBlurCapture),
		onPointerDownCapture: wo(e.onPointerDownCapture, C.onPointerDownCapture)
	});
}, "DismissableLayer"));
function ms() {
	let e = F.useContext(fs), [t, n] = F.useState(null);
	return F.useEffect(() => {
		if (t) return e.dismissableSurfaces.add(t), () => {
			e.dismissableSurfaces.delete(t);
		};
	}, [t, e.dismissableSurfaces]), n;
}
ss(ms, "useDismissableLayerSurface");
var hs = /* @__PURE__ */ ss(() => !0, "IS_TRUE");
function gs(e, t) {
	let { ownerDocument: n = globalThis?.document, deferPointerDownOutside: r = !1, isDeferredPointerDownOutsideRef: i, dismissableSurfaces: a, shouldHandlePointerDownOutside: o = hs } = t, s = as(e), c = F.useRef(!1), l = F.useRef(!1), u = F.useRef(/* @__PURE__ */ new Map()), d = F.useRef(() => {});
	return F.useEffect(() => {
		function e() {
			l.current = !1, i.current = !1, u.current.clear();
		}
		ss(e, "resetOutsideInteraction");
		function t() {
			return Array.from(u.current.values()).some(Boolean);
		}
		ss(t, "isOutsideInteractionIntercepted");
		function f(e) {
			if (!l.current) return;
			let t = e.target;
			t instanceof Node && [...a].some((e) => e.contains(t)) || u.current.set(e.type, !0), e.type === "click" && window.setTimeout(() => {
				l.current && d.current();
			}, 0);
		}
		ss(f, "handleInteractionCapture");
		function p(e) {
			l.current && u.current.set(e.type, !1);
		}
		ss(p, "handleInteractionBubble");
		let m = /* @__PURE__ */ ss((a) => {
			if (a.target && !c.current) {
				let f = function() {
					n.removeEventListener("click", d.current);
					let r = t();
					e(), r || ys(ls, s, p, { discrete: !0 });
				};
				if (ss(f, "handleAndDispatchPointerDownOutsideEvent"), !o(a.target)) {
					n.removeEventListener("click", d.current), e(), c.current = !1;
					return;
				}
				let p = { originalEvent: a };
				l.current = !0, i.current = r && a.button === 0, u.current.clear(), !r || a.button !== 0 ? f() : (n.removeEventListener("click", d.current), d.current = f, n.addEventListener("click", d.current, { once: !0 }));
			} else n.removeEventListener("click", d.current), e();
			c.current = !1;
		}, "handlePointerDown"), h = [
			"pointerup",
			"mousedown",
			"mouseup",
			"touchstart",
			"touchend",
			"click"
		];
		for (let e of h) n.addEventListener(e, f, !0), n.addEventListener(e, p);
		let g = window.setTimeout(() => {
			n.addEventListener("pointerdown", m);
		}, 0);
		return () => {
			window.clearTimeout(g), n.removeEventListener("pointerdown", m), n.removeEventListener("click", d.current);
			for (let e of h) n.removeEventListener(e, f, !0), n.removeEventListener(e, p);
		};
	}, [
		n,
		s,
		r,
		i,
		a,
		o
	]), { onPointerDownCapture: /* @__PURE__ */ ss(() => c.current = !0, "onPointerDownCapture") };
}
ss(gs, "usePointerDownOutside");
function _s(e, t = globalThis?.document) {
	let n = as(e), r = F.useRef(!1);
	return F.useEffect(() => {
		let e = /* @__PURE__ */ ss((e) => {
			e.target && !r.current && ys(us, n, { originalEvent: e }, { discrete: !1 });
		}, "handleFocus");
		return t.addEventListener("focusin", e), () => t.removeEventListener("focusin", e);
	}, [t, n]), {
		onFocusCapture: /* @__PURE__ */ ss(() => r.current = !0, "onFocusCapture"),
		onBlurCapture: /* @__PURE__ */ ss(() => r.current = !1, "onBlurCapture")
	};
}
ss(_s, "useFocusOutside");
function vs() {
	let e = new CustomEvent(cs);
	document.dispatchEvent(e);
}
ss(vs, "dispatchUpdate");
function ys(e, t, n, { discrete: r }) {
	let i = n.originalEvent.target, a = new CustomEvent(e, {
		bubbles: !1,
		cancelable: !0,
		detail: n
	});
	t && i.addEventListener(e, t, { once: !0 }), r ? ns(i, a) : i.dispatchEvent(a);
}
ss(ys, "handleAndDispatchCustomEvent");
//#endregion
//#region node_modules/@radix-ui/react-focus-scope/dist/index.mjs
var bs = Object.defineProperty, xs = (e, t) => bs(e, "name", {
	value: t,
	configurable: !0
}), Ss = "focusScope.autoFocusOnMount", Cs = "focusScope.autoFocusOnUnmount", ws = {
	bubbles: !1,
	cancelable: !0
}, Ts = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ xs(function(e, t) {
	let { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: a, ...o } = e, [s, c] = F.useState(null), l = as(i), u = as(a), d = F.useRef(null), f = Va(t, c), p = F.useRef({
		paused: !1,
		pause() {
			this.paused = !0;
		},
		resume() {
			this.paused = !1;
		}
	}).current;
	F.useEffect(() => {
		if (r) {
			let e = function(e) {
				if (p.paused || !s) return;
				let t = e.target;
				s.contains(t) ? d.current = t : Ms(d.current, { select: !0 });
			}, t = function(e) {
				if (p.paused || !s) return;
				let t = e.relatedTarget;
				t !== null && (s.contains(t) || Ms(d.current, { select: !0 }));
			}, n = function(e) {
				if (document.activeElement === document.body) for (let t of e) t.removedNodes.length > 0 && Ms(s);
			};
			xs(e, "handleFocusIn"), xs(t, "handleFocusOut"), xs(n, "handleMutations"), document.addEventListener("focusin", e), document.addEventListener("focusout", t);
			let r = new MutationObserver(n);
			return s && r.observe(s, {
				childList: !0,
				subtree: !0
			}), () => {
				document.removeEventListener("focusin", e), document.removeEventListener("focusout", t), r.disconnect();
			};
		}
	}, [
		r,
		s,
		p.paused
	]), F.useEffect(() => {
		if (s) {
			Ns.add(p);
			let e = document.activeElement;
			if (!s.contains(e)) {
				let t = new CustomEvent(Ss, ws);
				s.addEventListener(Ss, l), s.dispatchEvent(t), t.defaultPrevented || (Es(Is(Os(s)), { select: !0 }), document.activeElement === e && Ms(s));
			}
			return () => {
				s.removeEventListener(Ss, l), setTimeout(() => {
					let t = new CustomEvent(Cs, ws);
					s.addEventListener(Cs, u), s.dispatchEvent(t), t.defaultPrevented || Ms(e ?? document.body, { select: !0 }), s.removeEventListener(Cs, u), Ns.remove(p);
				}, 0);
			};
		}
	}, [
		s,
		l,
		u,
		p
	]);
	let m = F.useCallback((e) => {
		if (!n && !r || p.paused) return;
		let t = e.key === "Tab" && !e.altKey && !e.ctrlKey && !e.metaKey, i = document.activeElement;
		if (t && i) {
			let t = e.currentTarget, [r, a] = Ds(t);
			r && a ? !e.shiftKey && i === a ? (e.preventDefault(), n && Ms(r, { select: !0 })) : e.shiftKey && i === r && (e.preventDefault(), n && Ms(a, { select: !0 })) : i === t && e.preventDefault();
		}
	}, [
		n,
		r,
		p.paused
	]);
	return /* @__PURE__ */ (0, I.jsx)(ts.div, {
		tabIndex: -1,
		...o,
		ref: f,
		onKeyDown: m
	});
}, "FocusScope"));
function Es(e, { select: t = !1 } = {}) {
	let n = document.activeElement;
	for (let r of e) if (Ms(r, { select: t }), document.activeElement !== n) return;
}
xs(Es, "focusFirst");
function Ds(e) {
	let t = Os(e);
	return [ks(t, e), ks(t.reverse(), e)];
}
xs(Ds, "getTabbableEdges");
function Os(e) {
	let t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, { acceptNode: /* @__PURE__ */ xs((e) => {
		let t = e.tagName === "INPUT" && e.type === "hidden";
		return e.disabled || e.hidden || t ? NodeFilter.FILTER_SKIP : e.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
	}, "acceptNode") });
	for (; n.nextNode();) t.push(n.currentNode);
	return t;
}
xs(Os, "getTabbableCandidates");
function ks(e, t) {
	let n = typeof t.checkVisibility == "function" && t.checkVisibility({ checkVisibilityCSS: !0 });
	for (let r of e) if (!(n ? !r.checkVisibility({ checkVisibilityCSS: !0 }) : As(r, { upTo: t }))) return r;
}
xs(ks, "findVisible");
function As(e, { upTo: t }) {
	if (getComputedStyle(e).visibility === "hidden") return !0;
	for (; e;) {
		if (t !== void 0 && e === t) return !1;
		if (getComputedStyle(e).display === "none") return !0;
		e = e.parentElement;
	}
	return !1;
}
xs(As, "isHidden");
function js(e) {
	return e instanceof HTMLInputElement && "select" in e;
}
xs(js, "isSelectableInput");
function Ms(e, { select: t = !1 } = {}) {
	if (e && e.focus) {
		let n = document.activeElement;
		e.focus({ preventScroll: !0 }), e !== n && js(e) && t && e.select();
	}
}
xs(Ms, "focus");
var Ns = Ps();
function Ps() {
	let e = [];
	return {
		add(t) {
			let n = e[0];
			t !== n && n?.pause(), e = Fs(e, t), e.unshift(t);
		},
		remove(t) {
			e = Fs(e, t), e[0]?.resume();
		}
	};
}
xs(Ps, "createFocusScopesStack");
function Fs(e, t) {
	let n = [...e], r = n.indexOf(t);
	return r !== -1 && n.splice(r, 1), n;
}
xs(Fs, "arrayRemove");
function Is(e) {
	return e.filter((e) => e.tagName !== "A");
}
xs(Is, "removeLinks");
//#endregion
//#region node_modules/@radix-ui/react-portal/dist/index.mjs
var Ls = Object.defineProperty, Rs = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ ((e, t) => Ls(e, "name", {
	value: t,
	configurable: !0
}))(function(e, t) {
	let { container: n, ...r } = e, [i, a] = F.useState(!1);
	Po(() => a(!0), []);
	let o = n || i && globalThis?.document?.body;
	return o ? Mt.createPortal(/* @__PURE__ */ (0, I.jsx)(ts.div, {
		...r,
		ref: t
	}), o) : null;
}, "Portal")), zs = Object.defineProperty, Bs = (e, t) => zs(e, "name", {
	value: t,
	configurable: !0
});
function Vs(e, t) {
	return F.useReducer((e, n) => t[e][n] ?? e, e);
}
Bs(Vs, "useStateMachine");
var Hs = /* @__PURE__ */ Bs((e) => {
	let { present: t, children: n } = e, r = Us(t), i = typeof n == "function" ? n({ present: r.isPresent }) : F.Children.only(n), a = Gs(r.ref, qs(i));
	return typeof n == "function" || r.isPresent ? F.cloneElement(i, { ref: a }) : null;
}, "Presence");
function Us(e) {
	let [t, n] = F.useState(), r = F.useRef(null), i = F.useRef(e), a = F.useRef("none"), o = F.useRef(void 0), [s, c] = Vs(e ? "mounted" : "unmounted", {
		mounted: {
			UNMOUNT: "unmounted",
			ANIMATION_OUT: "unmountSuspended"
		},
		unmountSuspended: {
			MOUNT: "mounted",
			ANIMATION_END: "unmounted"
		},
		unmounted: { MOUNT: "mounted" }
	});
	return F.useEffect(() => {
		s === "mounted" ? (a.current = o.current ?? Ks(r.current), o.current = void 0) : a.current = "none";
	}, [s]), Po(() => {
		let t = r.current, n = i.current;
		if (n !== e) {
			let r = a.current, s = Ks(t);
			e ? (o.current = s, c("MOUNT")) : s === "none" || t?.display === "none" ? c("UNMOUNT") : c(n && r !== s ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
		}
	}, [e, c]), Po(() => {
		if (t) {
			let e, n = t.ownerDocument.defaultView ?? window, o = /* @__PURE__ */ Bs((a) => {
				let o = Ks(r.current).includes(CSS.escape(a.animationName));
				if (a.target === t && o && (c("ANIMATION_END"), !i.current)) {
					let r = t.style.animationFillMode;
					t.style.animationFillMode = "forwards", e = n.setTimeout(() => {
						t.style.animationFillMode === "forwards" && (t.style.animationFillMode = r);
					});
				}
			}, "handleAnimationEnd"), s = /* @__PURE__ */ Bs((e) => {
				e.target === t && (a.current = Ks(r.current));
			}, "handleAnimationStart");
			return t.addEventListener("animationstart", s), t.addEventListener("animationcancel", o), t.addEventListener("animationend", o), () => {
				n.clearTimeout(e), t.removeEventListener("animationstart", s), t.removeEventListener("animationcancel", o), t.removeEventListener("animationend", o);
			};
		}
		c("ANIMATION_END");
	}, [t, c]), {
		isPresent: ["mounted", "unmountSuspended"].includes(s),
		ref: F.useCallback((e) => {
			if (e) {
				let t = getComputedStyle(e);
				r.current = t, o.current = Ks(t);
			} else r.current = null;
			n(e);
		}, [])
	};
}
Bs(Us, "usePresence");
function Ws(e, t) {
	if (typeof e == "function") return e(t);
	e != null && (e.current = t);
}
Bs(Ws, "setRef");
function Gs(...e) {
	let t = F.useRef(e);
	return t.current = e, F.useCallback((e) => {
		let n = t.current, r = !1, i = n.map((t) => {
			let n = Ws(t, e);
			return !r && typeof n == "function" && (r = !0), n;
		});
		if (r) return () => {
			for (let e = 0; e < i.length; e++) {
				let t = i[e];
				typeof t == "function" ? t() : Ws(n[e], null);
			}
		};
	}, []);
}
Bs(Gs, "useStableComposedRefs");
function Ks(e) {
	return e?.animationName || "none";
}
Bs(Ks, "getAnimationName");
function qs(e) {
	let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning;
	return n ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
Bs(qs, "getElementRef");
//#endregion
//#region node_modules/@radix-ui/react-focus-guards/dist/index.mjs
var Js = Object.defineProperty, Ys = (e, t) => Js(e, "name", {
	value: t,
	configurable: !0
}), Xs = 0, Zs = null;
function Qs(e) {
	return $s(), e.children;
}
Ys(Qs, "FocusGuards");
function $s() {
	F.useEffect(() => {
		Zs ||= {
			start: ec(),
			end: ec()
		};
		let { start: e, end: t } = Zs;
		return document.body.firstElementChild !== e && document.body.insertAdjacentElement("afterbegin", e), document.body.lastElementChild !== t && document.body.insertAdjacentElement("beforeend", t), Xs++, () => {
			Xs === 1 && (Zs?.start.remove(), Zs?.end.remove(), Zs = null), Xs = Math.max(0, Xs - 1);
		};
	}, []);
}
Ys($s, "useFocusGuards");
function ec() {
	let e = document.createElement("span");
	return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
Ys(ec, "createFocusGuard");
//#endregion
//#region node_modules/tslib/tslib.es6.mjs
var tc = function() {
	return tc = Object.assign || function(e) {
		for (var t, n = 1, r = arguments.length; n < r; n++) for (var i in t = arguments[n], t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
		return e;
	}, tc.apply(this, arguments);
};
function nc(e, t) {
	var n = {};
	for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
	if (e != null && typeof Object.getOwnPropertySymbols == "function") for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++) t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
	return n;
}
function rc(e, t, n) {
	if (n || arguments.length === 2) for (var r = 0, i = t.length, a; r < i; r++) (a || !(r in t)) && (a ||= Array.prototype.slice.call(t, 0, r), a[r] = t[r]);
	return e.concat(a || Array.prototype.slice.call(t));
}
//#endregion
//#region node_modules/react-remove-scroll-bar/dist/es2015/constants.js
var ic = "right-scroll-bar-position", ac = "width-before-scroll-bar", oc = "with-scroll-bars-hidden", sc = "--removed-body-scroll-bar-size";
//#endregion
//#region node_modules/use-callback-ref/dist/es2015/assignRef.js
function cc(e, t) {
	return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
//#endregion
//#region node_modules/use-callback-ref/dist/es2015/useRef.js
function lc(e, t) {
	var n = (0, F.useState)(function() {
		return {
			value: e,
			callback: t,
			facade: {
				get current() {
					return n.value;
				},
				set current(e) {
					var t = n.value;
					t !== e && (n.value = e, n.callback(e, t));
				}
			}
		};
	})[0];
	return n.callback = t, n.facade;
}
//#endregion
//#region node_modules/use-callback-ref/dist/es2015/useMergeRef.js
var uc = typeof window < "u" ? F.useLayoutEffect : F.useEffect, dc = /* @__PURE__ */ new WeakMap();
function fc(e, t) {
	var n = lc(t || null, function(t) {
		return e.forEach(function(e) {
			return cc(e, t);
		});
	});
	return uc(function() {
		var t = dc.get(n);
		if (t) {
			var r = new Set(t), i = new Set(e), a = n.current;
			r.forEach(function(e) {
				i.has(e) || cc(e, null);
			}), i.forEach(function(e) {
				r.has(e) || cc(e, a);
			});
		}
		dc.set(n, e);
	}, [e]), n;
}
//#endregion
//#region node_modules/use-sidecar/dist/es2015/medium.js
function pc(e) {
	return e;
}
function mc(e, t) {
	t === void 0 && (t = pc);
	var n = [], r = !1;
	return {
		read: function() {
			if (r) throw Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
			return n.length ? n[n.length - 1] : e;
		},
		useMedium: function(e) {
			var i = t(e, r);
			return n.push(i), function() {
				n = n.filter(function(e) {
					return e !== i;
				});
			};
		},
		assignSyncMedium: function(e) {
			for (r = !0; n.length;) {
				var t = n;
				n = [], t.forEach(e);
			}
			n = {
				push: function(t) {
					return e(t);
				},
				filter: function() {
					return n;
				}
			};
		},
		assignMedium: function(e) {
			r = !0;
			var t = [];
			if (n.length) {
				var i = n;
				n = [], i.forEach(e), t = n;
			}
			var a = function() {
				var n = t;
				t = [], n.forEach(e);
			}, o = function() {
				return Promise.resolve().then(a);
			};
			o(), n = {
				push: function(e) {
					t.push(e), o();
				},
				filter: function(e) {
					return t = t.filter(e), n;
				}
			};
		}
	};
}
function hc(e) {
	e === void 0 && (e = {});
	var t = mc(null);
	return t.options = tc({
		async: !0,
		ssr: !1
	}, e), t;
}
//#endregion
//#region node_modules/use-sidecar/dist/es2015/exports.js
var gc = function(e) {
	var t = e.sideCar, n = nc(e, ["sideCar"]);
	if (!t) throw Error("Sidecar: please provide `sideCar` property to import the right car");
	var r = t.read();
	if (!r) throw Error("Sidecar medium not found");
	return F.createElement(r, tc({}, n));
};
gc.isSideCarExport = !0;
function _c(e, t) {
	return e.useMedium(t), gc;
}
//#endregion
//#region node_modules/react-remove-scroll/dist/es2015/medium.js
var vc = hc(), yc = function() {}, bc = F.forwardRef(function(e, t) {
	var n = F.useRef(null), r = F.useState({
		onScrollCapture: yc,
		onWheelCapture: yc,
		onTouchMoveCapture: yc
	}), i = r[0], a = r[1], o = e.forwardProps, s = e.children, c = e.className, l = e.removeScrollBar, u = e.enabled, d = e.shards, f = e.sideCar, p = e.noRelative, m = e.noIsolation, h = e.inert, g = e.allowPinchZoom, _ = e.as, v = _ === void 0 ? "div" : _, y = e.gapMode, b = nc(e, [
		"forwardProps",
		"children",
		"className",
		"removeScrollBar",
		"enabled",
		"shards",
		"sideCar",
		"noRelative",
		"noIsolation",
		"inert",
		"allowPinchZoom",
		"as",
		"gapMode"
	]), x = f, S = fc([n, t]), C = tc(tc({}, b), i);
	return F.createElement(F.Fragment, null, u && F.createElement(x, {
		sideCar: vc,
		removeScrollBar: l,
		shards: d,
		noRelative: p,
		noIsolation: m,
		inert: h,
		setCallbacks: a,
		allowPinchZoom: !!g,
		lockRef: n,
		gapMode: y
	}), o ? F.cloneElement(F.Children.only(s), tc(tc({}, C), { ref: S })) : F.createElement(v, tc({}, C, {
		className: c,
		ref: S
	}), s));
});
bc.defaultProps = {
	enabled: !0,
	removeScrollBar: !0,
	inert: !1
}, bc.classNames = {
	fullWidth: ac,
	zeroRight: ic
};
//#endregion
//#region node_modules/get-nonce/dist/es2015/index.js
var xc = function() {
	if (typeof __webpack_nonce__ < "u") return __webpack_nonce__;
};
//#endregion
//#region node_modules/react-style-singleton/dist/es2015/singleton.js
function Sc() {
	if (!document) return null;
	var e = document.createElement("style");
	e.type = "text/css";
	var t = xc();
	return t && e.setAttribute("nonce", t), e;
}
function Cc(e, t) {
	e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function wc(e) {
	(document.head || document.getElementsByTagName("head")[0]).appendChild(e);
}
var Tc = function() {
	var e = 0, t = null;
	return {
		add: function(n) {
			e == 0 && (t = Sc()) && (Cc(t, n), wc(t)), e++;
		},
		remove: function() {
			e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
		}
	};
}, Ec = function() {
	var e = Tc();
	return function(t, n) {
		F.useEffect(function() {
			return e.add(t), function() {
				e.remove();
			};
		}, [t && n]);
	};
}, Dc = function() {
	var e = Ec();
	return function(t) {
		var n = t.styles, r = t.dynamic;
		return e(n, r), null;
	};
}, Oc = {
	left: 0,
	top: 0,
	right: 0,
	gap: 0
}, kc = function(e) {
	return parseInt(e || "", 10) || 0;
}, Ac = function(e) {
	var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
	return [
		kc(n),
		kc(r),
		kc(i)
	];
}, jc = function(e) {
	if (e === void 0 && (e = "margin"), typeof window > "u") return Oc;
	var t = Ac(e), n = document.documentElement.clientWidth, r = window.innerWidth;
	return {
		left: t[0],
		top: t[1],
		right: t[2],
		gap: Math.max(0, r - n + t[2] - t[0])
	};
}, Mc = Dc(), Nc = "data-scroll-locked", Pc = function(e, t, n, r) {
	var i = e.left, a = e.top, o = e.right, s = e.gap;
	return n === void 0 && (n = "margin"), `
  .${oc} {
   overflow: hidden ${r};
   padding-right: ${s}px ${r};
  }
  body[${Nc}] {
    overflow: hidden ${r};
    overscroll-behavior: contain;
    ${[
		t && `position: relative ${r};`,
		n === "margin" && `
    padding-left: ${i}px;
    padding-top: ${a}px;
    padding-right: ${o}px;
    margin-left:0;
    margin-top:0;
    margin-right: ${s}px ${r};
    `,
		n === "padding" && `padding-right: ${s}px ${r};`
	].filter(Boolean).join("")}
  }
  
  .${ic} {
    right: ${s}px ${r};
  }
  
  .${ac} {
    margin-right: ${s}px ${r};
  }
  
  .${ic} .${ic} {
    right: 0 ${r};
  }
  
  .${ac} .${ac} {
    margin-right: 0 ${r};
  }
  
  body[${Nc}] {
    ${sc}: ${s}px;
  }
`;
}, Fc = function() {
	var e = parseInt(document.body.getAttribute("data-scroll-locked") || "0", 10);
	return isFinite(e) ? e : 0;
}, Ic = function() {
	F.useEffect(function() {
		return document.body.setAttribute(Nc, (Fc() + 1).toString()), function() {
			var e = Fc() - 1;
			e <= 0 ? document.body.removeAttribute(Nc) : document.body.setAttribute(Nc, e.toString());
		};
	}, []);
}, Lc = function(e) {
	var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
	Ic();
	var a = F.useMemo(function() {
		return jc(i);
	}, [i]);
	return F.createElement(Mc, { styles: Pc(a, !t, i, n ? "" : "!important") });
}, Rc = !1;
if (typeof window < "u") try {
	var zc = Object.defineProperty({}, "passive", { get: function() {
		return Rc = !0, !0;
	} });
	window.addEventListener("test", zc, zc), window.removeEventListener("test", zc, zc);
} catch {
	Rc = !1;
}
var Bc = Rc ? { passive: !1 } : !1, Vc = function(e) {
	return e.tagName === "TEXTAREA";
}, Hc = function(e, t) {
	if (!(e instanceof Element)) return !1;
	var n = window.getComputedStyle(e);
	return n[t] !== "hidden" && !(n.overflowY === n.overflowX && !Vc(e) && n[t] === "visible");
}, Uc = function(e) {
	return Hc(e, "overflowY");
}, Wc = function(e) {
	return Hc(e, "overflowX");
}, Gc = function(e, t) {
	var n = t.ownerDocument, r = t;
	do {
		if (typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host), Jc(e, r)) {
			var i = Yc(e, r);
			if (i[1] > i[2]) return !0;
		}
		r = r.parentNode;
	} while (r && r !== n.body);
	return !1;
}, Kc = function(e) {
	return [
		e.scrollTop,
		e.scrollHeight,
		e.clientHeight
	];
}, qc = function(e) {
	return [
		e.scrollLeft,
		e.scrollWidth,
		e.clientWidth
	];
}, Jc = function(e, t) {
	return e === "v" ? Uc(t) : Wc(t);
}, Yc = function(e, t) {
	return e === "v" ? Kc(t) : qc(t);
}, Xc = function(e, t) {
	return e === "h" && t === "rtl" ? -1 : 1;
}, Zc = function(e, t, n, r, i) {
	var a = Xc(e, window.getComputedStyle(t).direction), o = a * r, s = n.target, c = t.contains(s), l = !1, u = o > 0, d = 0, f = 0;
	do {
		if (!s) break;
		var p = Yc(e, s), m = p[0], h = p[1] - p[2] - a * m;
		(m || h) && Jc(e, s) && (d += h, f += m);
		var g = s.parentNode;
		s = g && g.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? g.host : g;
	} while (!c && s !== document.body || c && (t.contains(s) || t === s));
	return (u && (i && Math.abs(d) < 1 || !i && o > d) || !u && (i && Math.abs(f) < 1 || !i && -o > f)) && (l = !0), l;
}, Qc = function(e) {
	return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, $c = function(e) {
	return [e.deltaX, e.deltaY];
}, el = function(e) {
	return e && "current" in e ? e.current : e;
}, tl = function(e, t) {
	return e[0] === t[0] && e[1] === t[1];
}, nl = function(e) {
	return `
  .block-interactivity-${e} {pointer-events: none;}
  .allow-interactivity-${e} {pointer-events: all;}
`;
}, rl = 0, il = [];
function al(e) {
	var t = F.useRef([]), n = F.useRef([0, 0]), r = F.useRef(), i = F.useState(rl++)[0], a = F.useState(Dc)[0], o = F.useRef(e);
	F.useEffect(function() {
		o.current = e;
	}, [e]), F.useEffect(function() {
		if (e.inert) {
			document.body.classList.add(`block-interactivity-${i}`);
			var t = rc([e.lockRef.current], (e.shards || []).map(el), !0).filter(Boolean);
			return t.forEach(function(e) {
				return e.classList.add(`allow-interactivity-${i}`);
			}), function() {
				document.body.classList.remove(`block-interactivity-${i}`), t.forEach(function(e) {
					return e.classList.remove(`allow-interactivity-${i}`);
				});
			};
		}
	}, [
		e.inert,
		e.lockRef.current,
		e.shards
	]);
	var s = F.useCallback(function(e, t) {
		if ("touches" in e && e.touches.length === 2 || e.type === "wheel" && e.ctrlKey) return !o.current.allowPinchZoom;
		var i = Qc(e), a = n.current, s = "deltaX" in e ? e.deltaX : a[0] - i[0], c = "deltaY" in e ? e.deltaY : a[1] - i[1], l, u = e.target, d = Math.abs(s) > Math.abs(c) ? "h" : "v";
		if ("touches" in e && d === "h" && u.type === "range") return !1;
		var f = window.getSelection(), p = f && f.anchorNode;
		if (p && (p === u || p.contains(u))) return !1;
		var m = Gc(d, u);
		if (!m) return !0;
		if (m ? l = d : (l = d === "v" ? "h" : "v", m = Gc(d, u)), !m) return !1;
		if (!r.current && "changedTouches" in e && (s || c) && (r.current = l), !l) return !0;
		var h = r.current || l;
		return Zc(h, t, e, h === "h" ? s : c, !0);
	}, []), c = F.useCallback(function(e) {
		var n = e;
		if (il.length && il[il.length - 1] === a) {
			var r = "deltaY" in n ? $c(n) : Qc(n), i = t.current.filter(function(e) {
				return e.name === n.type && (e.target === n.target || n.target === e.shadowParent) && tl(e.delta, r);
			})[0];
			if (i && i.should) {
				n.cancelable && n.preventDefault();
				return;
			}
			if (!i) {
				var c = (o.current.shards || []).map(el).filter(Boolean).filter(function(e) {
					return e.contains(n.target);
				});
				(c.length > 0 ? s(n, c[0]) : !o.current.noIsolation) && n.cancelable && n.preventDefault();
			}
		}
	}, []), l = F.useCallback(function(e, n, r, i) {
		var a = {
			name: e,
			delta: n,
			target: r,
			should: i,
			shadowParent: ol(r)
		};
		t.current.push(a), setTimeout(function() {
			t.current = t.current.filter(function(e) {
				return e !== a;
			});
		}, 1);
	}, []), u = F.useCallback(function(e) {
		n.current = Qc(e), r.current = void 0;
	}, []), d = F.useCallback(function(t) {
		l(t.type, $c(t), t.target, s(t, e.lockRef.current));
	}, []), f = F.useCallback(function(t) {
		l(t.type, Qc(t), t.target, s(t, e.lockRef.current));
	}, []);
	F.useEffect(function() {
		return il.push(a), e.setCallbacks({
			onScrollCapture: d,
			onWheelCapture: d,
			onTouchMoveCapture: f
		}), document.addEventListener("wheel", c, Bc), document.addEventListener("touchmove", c, Bc), document.addEventListener("touchstart", u, Bc), function() {
			il = il.filter(function(e) {
				return e !== a;
			}), document.removeEventListener("wheel", c, Bc), document.removeEventListener("touchmove", c, Bc), document.removeEventListener("touchstart", u, Bc);
		};
	}, []);
	var p = e.removeScrollBar, m = e.inert;
	return F.createElement(F.Fragment, null, m ? F.createElement(a, { styles: nl(i) }) : null, p ? F.createElement(Lc, {
		noRelative: e.noRelative,
		gapMode: e.gapMode
	}) : null);
}
function ol(e) {
	for (var t = null; e !== null;) e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
	return t;
}
//#endregion
//#region node_modules/react-remove-scroll/dist/es2015/sidecar.js
var sl = _c(vc, al), cl = F.forwardRef(function(e, t) {
	return F.createElement(bc, tc({}, e, {
		ref: t,
		sideCar: sl
	}));
});
cl.classNames = bc.classNames;
//#endregion
//#region node_modules/aria-hidden/dist/es2015/index.js
var ll = function(e) {
	return typeof document > "u" ? null : (Array.isArray(e) ? e[0] : e).ownerDocument.body;
}, ul = /* @__PURE__ */ new WeakMap(), dl = /* @__PURE__ */ new WeakMap(), fl = {}, pl = 0, ml = function(e) {
	return e && (e.host || ml(e.parentNode));
}, hl = function(e, t) {
	return t.map(function(t) {
		if (e.contains(t)) return t;
		var n = ml(t);
		return n && e.contains(n) ? n : (console.error("aria-hidden", t, "in not contained inside", e, ". Doing nothing"), null);
	}).filter(function(e) {
		return !!e;
	});
}, gl = function(e, t, n, r) {
	var i = hl(t, Array.isArray(e) ? e : [e]);
	fl[n] || (fl[n] = /* @__PURE__ */ new WeakMap());
	var a = fl[n], o = [], s = /* @__PURE__ */ new Set(), c = new Set(i), l = function(e) {
		e && !s.has(e) && (s.add(e), l(e.parentNode));
	};
	i.forEach(l);
	var u = function(e) {
		e && !c.has(e) && Array.prototype.forEach.call(e.children, function(e) {
			if (s.has(e)) u(e);
			else try {
				var t = e.getAttribute(r), i = t !== null && t !== "false", c = (ul.get(e) || 0) + 1, l = (a.get(e) || 0) + 1;
				ul.set(e, c), a.set(e, l), o.push(e), c === 1 && i && dl.set(e, !0), l === 1 && e.setAttribute(n, "true"), i || e.setAttribute(r, "true");
			} catch (t) {
				console.error("aria-hidden: cannot operate on ", e, t);
			}
		});
	};
	return u(t), s.clear(), pl++, function() {
		o.forEach(function(e) {
			var t = ul.get(e) - 1, i = a.get(e) - 1;
			ul.set(e, t), a.set(e, i), t || (dl.has(e) || e.removeAttribute(r), dl.delete(e)), i || e.removeAttribute(n);
		}), pl--, pl || (ul = /* @__PURE__ */ new WeakMap(), ul = /* @__PURE__ */ new WeakMap(), dl = /* @__PURE__ */ new WeakMap(), fl = {});
	};
}, _l = function(e, t, n) {
	n === void 0 && (n = "data-aria-hidden");
	var r = Array.from(Array.isArray(e) ? e : [e]), i = t || ll(e);
	return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live], script"))), gl(r, i, n, "aria-hidden")) : function() {
		return null;
	};
}, vl = Object.defineProperty, yl = (e, t) => vl(e, "name", {
	value: t,
	configurable: !0
}), bl = "Dialog", [xl, Sl] = /* @__PURE__ */ Mo(bl), [Cl, wl] = xl(bl), Tl = /* @__PURE__ */ yl((e) => {
	let { __scopeDialog: t, children: n, open: r, defaultOpen: i, onOpenChange: a, modal: o = !0 } = e, s = F.useRef(null), c = F.useRef(null), [l, u] = Jo({
		prop: r,
		defaultProp: i ?? !1,
		onChange: a,
		caller: bl
	}), [d, f] = F.useState(0), [p, m] = F.useState(0);
	return /* @__PURE__ */ (0, I.jsx)(Cl, {
		scope: t,
		triggerRef: s,
		contentRef: c,
		contentId: zo(),
		titleId: zo(),
		descriptionId: zo(),
		titlePresent: d > 0,
		descriptionPresent: p > 0,
		setTitleCount: f,
		setDescriptionCount: m,
		open: l,
		onOpenChange: u,
		onOpenToggle: F.useCallback(() => u((e) => !e), [u]),
		modal: o,
		children: n
	});
}, "Dialog"), El = "DialogPortal", [Dl, Ol] = xl(El, { forceMount: void 0 }), kl = /* @__PURE__ */ yl((e) => {
	let { __scopeDialog: t, forceMount: n, children: r, container: i } = e, a = wl(El, t);
	return /* @__PURE__ */ (0, I.jsx)(Dl, {
		scope: t,
		forceMount: n,
		children: F.Children.map(r, (e) => /* @__PURE__ */ (0, I.jsx)(Hs, {
			present: n || a.open,
			children: /* @__PURE__ */ (0, I.jsx)(Rs, {
				asChild: !0,
				container: i,
				children: e
			})
		}))
	});
}, "DialogPortal"), Al = "DialogOverlay", jl = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ yl(function(e, t) {
	let n = Ol(Al, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = wl(Al, e.__scopeDialog);
	return a.modal ? /* @__PURE__ */ (0, I.jsx)(Hs, {
		present: r || a.open,
		children: /* @__PURE__ */ (0, I.jsx)(Nl, {
			...i,
			ref: t
		})
	}) : null;
}, "DialogOverlay")), Ml = /* @__PURE__ */ Wa("DialogOverlay.RemoveScroll"), Nl = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ yl(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = wl(Al, n), a = Va(t, ms());
	return /* @__PURE__ */ (0, I.jsx)(cl, {
		as: Ml,
		allowPinchZoom: !0,
		shards: [i.contentRef],
		children: /* @__PURE__ */ (0, I.jsx)(ts.div, {
			"data-state": Vl(i.open),
			...r,
			ref: a,
			style: {
				pointerEvents: "auto",
				...r.style
			}
		})
	});
}, "DialogOverlayImpl")), Pl = "DialogContent", Fl = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ yl(function(e, t) {
	let n = Ol(Pl, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, a = wl(Pl, e.__scopeDialog);
	return /* @__PURE__ */ (0, I.jsx)(Hs, {
		present: r || a.open,
		children: a.modal ? /* @__PURE__ */ (0, I.jsx)(Il, {
			...i,
			ref: t
		}) : /* @__PURE__ */ (0, I.jsx)(Ll, {
			...i,
			ref: t
		})
	});
}, "DialogContent")), Il = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ yl(function(e, t) {
	let n = wl(Pl, e.__scopeDialog), r = F.useRef(null), i = Va(t, n.contentRef, r);
	return F.useEffect(() => {
		let e = r.current;
		if (e) return _l(e);
	}, []), /* @__PURE__ */ (0, I.jsx)(q, {
		...e,
		ref: i,
		trapFocus: n.open,
		disableOutsidePointerEvents: n.open,
		onCloseAutoFocus: wo(e.onCloseAutoFocus, (e) => {
			e.preventDefault(), n.triggerRef.current?.focus();
		}),
		onPointerDownOutside: wo(e.onPointerDownOutside, (e) => {
			let t = e.detail.originalEvent, n = t.button === 0 && t.ctrlKey === !0;
			(t.button === 2 || n) && e.preventDefault();
		}),
		onFocusOutside: wo(e.onFocusOutside, (e) => e.preventDefault())
	});
}, "DialogContentModal")), Ll = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ yl(function(e, t) {
	let n = wl(Pl, e.__scopeDialog), r = F.useRef(!1), i = F.useRef(!1);
	return /* @__PURE__ */ (0, I.jsx)(q, {
		...e,
		ref: t,
		trapFocus: !1,
		disableOutsidePointerEvents: !1,
		onCloseAutoFocus: (t) => {
			e.onCloseAutoFocus?.(t), t.defaultPrevented || (r.current || n.triggerRef.current?.focus(), t.preventDefault()), r.current = !1, i.current = !1;
		},
		onInteractOutside: (t) => {
			e.onInteractOutside?.(t), t.defaultPrevented || (r.current = !0, t.detail.originalEvent.type === "pointerdown" && (i.current = !0));
			let a = t.target;
			n.triggerRef.current?.contains(a) && t.preventDefault(), t.detail.originalEvent.type === "focusin" && i.current && t.preventDefault();
		}
	});
}, "DialogContentNonModal")), q = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ yl(function(e, t) {
	let { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: a, ...o } = e, s = wl(Pl, n);
	return $s(), /* @__PURE__ */ (0, I.jsx)(I.Fragment, { children: /* @__PURE__ */ (0, I.jsx)(Ts, {
		asChild: !0,
		loop: !0,
		trapped: r,
		onMountAutoFocus: i,
		onUnmountAutoFocus: a,
		children: /* @__PURE__ */ (0, I.jsx)(ps, {
			role: "dialog",
			id: s.contentId,
			"aria-describedby": s.descriptionPresent ? s.descriptionId : void 0,
			"aria-labelledby": s.titlePresent ? s.titleId : void 0,
			"data-state": Vl(s.open),
			...o,
			ref: t,
			deferPointerDownOutside: !0,
			onDismiss: () => s.onOpenChange(!1)
		})
	}) });
}, "DialogContentImpl")), Rl = "DialogTitle", J = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ yl(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = wl(Rl, n), { setTitleCount: a } = i;
	return Po(() => (a((e) => e + 1), () => a((e) => e - 1)), [a]), /* @__PURE__ */ (0, I.jsx)(ts.h2, {
		id: i.titleId,
		...r,
		ref: t
	});
}, "DialogTitle")), Y = "DialogDescription", X = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ yl(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = wl(Y, n), { setDescriptionCount: a } = i;
	return Po(() => (a((e) => e + 1), () => a((e) => e - 1)), [a]), /* @__PURE__ */ (0, I.jsx)(ts.p, {
		id: i.descriptionId,
		...r,
		ref: t
	});
}, "DialogDescription")), zl = "DialogClose", Bl = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ yl(function(e, t) {
	let { __scopeDialog: n, ...r } = e, i = wl(zl, n);
	return /* @__PURE__ */ (0, I.jsx)(ts.button, {
		type: "button",
		...r,
		ref: t,
		onClick: wo(e.onClick, () => i.onOpenChange(!1))
	});
}, "DialogClose"));
function Vl(e) {
	return e ? "open" : "closed";
}
yl(Vl, "getState");
//#endregion
//#region src/components/ui/dialog.tsx
var Hl = Tl, Ul = kl, Wl = F.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ (0, I.jsx)(jl, {
	ref: n,
	className: Ki("fixed inset-0 z-50 bg-black/80  data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0", e),
	...t
}));
Wl.displayName = jl.displayName;
var Gl = F.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ (0, I.jsxs)(Ul, {
	container: document.getElementById("dearplace-app")?.shadowRoot?.getElementById("dp-portals") ?? void 0,
	children: [/* @__PURE__ */ (0, I.jsx)(Wl, {}), /* @__PURE__ */ (0, I.jsxs)(Fl, {
		ref: r,
		className: Ki("fixed left-[50%] top-[50%] z-50 grid w-full max-w-lg translate-x-[-50%] translate-y-[-50%] gap-4 border bg-background p-6 shadow-lg duration-200 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 sm:rounded-lg", e),
		...n,
		children: [t, /* @__PURE__ */ (0, I.jsxs)(Bl, {
			className: "absolute right-4 top-4 rounded-sm opacity-70 ring-offset-background cursor-pointer transition-opacity hover:opacity-100 focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:pointer-events-none data-[state=open]:bg-accent data-[state=open]:text-muted-foreground",
			children: [/* @__PURE__ */ (0, I.jsx)(vr, { className: "h-4 w-4" }), /* @__PURE__ */ (0, I.jsx)("span", {
				className: "sr-only",
				children: "Close"
			})]
		})]
	})]
}));
Gl.displayName = Fl.displayName;
var Kl = F.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ (0, I.jsx)(J, {
	ref: n,
	className: Ki("text-lg font-semibold leading-none tracking-tight", e),
	...t
}));
Kl.displayName = J.displayName;
var ql = F.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ (0, I.jsx)(X, {
	ref: n,
	className: Ki("text-sm text-muted-foreground", e),
	...t
}));
ql.displayName = X.displayName;
//#endregion
//#region src/lib/product-gallery.ts
var Jl = (e) => new URL(e.url).pathname.split("/").pop() || "";
function Yl(e, t) {
	if (!e) return [];
	let n = Jl(e).match(/^(vit|polar|pastell)-(white|black|oak)-product(?:[_.-]|$)/), r = n ? `${n[1]}-${n[2]}-` : null, i = r ? t.filter((e) => Jl(e).startsWith(r)) : [], a = t.filter((e) => Jl(e).startsWith("inspiration-") && !Jl(e).startsWith("inspiration-dining-room")), o = /* @__PURE__ */ new Set();
	return [
		e,
		...i,
		...a
	].filter((e) => {
		let t = new URL(e.url).pathname;
		return !o.has(t) && (o.add(t), !0);
	});
}
//#endregion
//#region src/components/ProductPhoto.tsx
function Xl(e, t) {
	let n = new URL(e, window.location.origin);
	return (n.hostname === "cdn.shopify.com" || n.hostname === "dearplace.studio") && /\/(?:cdn\/shop\/files|s\/files)\//.test(n.pathname) && n.searchParams.set("width", String(t)), n.toString();
}
function Zl(e) {
	return [
		480,
		960,
		1440
	].map((t) => `${Xl(e, t)} ${t}w`).join(",");
}
function Ql({ showProductOnFirstChange: e = !1, image: t, images: n, selection: r, loading: i, configuration: a }) {
	let { lang: o } = x(), [s, c] = (0, F.useState)(!1), [l, u] = (0, F.useState)(!1), d = (0, F.useMemo)(() => {
		let e = Yl(t, n), r = document.getElementById("dearplace-app")?.dataset.detailImage;
		r && e.length && e.splice(2, 0, {
			url: r,
			altText: o === "sv" ? "Närbild av en 3D-karta med upphöjda träd, byggnader och blått vatten" : "Close-up of a 3D map with raised trees, buildings and blue water"
		});
		let i = document.getElementById("dearplace-app")?.dataset.inspirationImages?.split(",").filter(Boolean) ?? [];
		if (e.length) for (let t of i) e.some((e) => e.url === t) || e.push({
			url: t,
			altText: o === "sv" ? "Dear Place-kartor på en färgglad tavelvägg" : "Dear Place maps styled on a colourful gallery wall"
		});
		let a = document.getElementById("dearplace-app")?.dataset;
		return e.length && e.unshift({
			url: a?.productVideoPoster ?? "/dear-product-detail-poster.jpg",
			videoUrl: a?.productVideo ?? "/dear-product-detail-video.mp4",
			altText: o === "sv" ? "Se kartans detaljer i verkligheten – produktvideo" : "See the map details in real life — product video"
		}), e;
	}, [
		t,
		n,
		o
	]), [f, p] = (0, F.useState)(0), m = (0, F.useRef)(0), h = (0, F.useRef)(null), g = d[f] ?? d[0], _ = (0, F.useRef)(null), v = (0, F.useRef)(null), y = (0, F.useRef)(null), b = (0, F.useRef)(0), S = (0, F.useRef)(0);
	(0, F.useEffect)(() => () => cancelAnimationFrame(b.current), []), (0, F.useEffect)(() => {
		(l || !d[f]?.videoUrl) && h.current?.pause();
	}, [
		f,
		l,
		d
	]), (0, F.useEffect)(() => {
		let e = v.current, t = e?.children[f];
		if (e && t) {
			let n = window.matchMedia("(min-width: 768px)").matches;
			e.scrollTo({
				left: n ? 0 : Math.min(t.offsetLeft, Math.max(0, e.scrollWidth - e.clientWidth)),
				top: n ? Math.min(t.offsetTop, Math.max(0, e.scrollHeight - e.clientHeight)) : 0,
				behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
			});
		}
	}, [f]);
	let C = (e = f) => ({
		gallery: "configurator_product",
		media_type: d[e]?.videoUrl ? "video" : "image",
		media_id: (d[e]?.videoUrl ?? d[e]?.url)?.split("?")[0].split("/").pop() ?? "unknown",
		position: e + 1,
		...a
	}), w = (e, t = !0) => {
		if (t) {
			let t = y.current, n = t?.children[e];
			t && n && t.scrollTo({
				left: n.offsetLeft + n.offsetWidth / 2 - t.clientWidth / 2,
				behavior: window.matchMedia("(min-width: 768px), (prefers-reduced-motion: reduce)").matches ? "instant" : "smooth"
			});
		}
		e !== m.current && oe(d[e]?.videoUrl ? "video_selected" : "image_selected", C(e)), m.current = e, p(e), c(!1);
	}, T = (0, F.useRef)(!1);
	(0, F.useEffect)(() => {
		!e || T.current || d.length < 2 || (T.current = !0, w(1));
	}, [e, d.length]);
	let E = (e) => {
		e !== l && oe(e ? "lightbox_open" : "lightbox_close", C()), u(e);
	};
	(0, F.useEffect)(() => {
		let e = _.current;
		if (!e || !g?.url || s) return;
		let t, n = !1, r = !1, i = () => {
			t && clearTimeout(t), t = void 0;
		}, a = () => {
			i(), !r && n && document.visibilityState === "visible" && e.complete && e.naturalWidth && (t = setTimeout(() => {
				let e = window.Shopify?.customerPrivacy;
				(e?.analyticsProcessingAllowed?.() || e?.marketingAllowed?.()) && (oe("impression", C()), r = !0);
			}, 1e3));
		}, o = new IntersectionObserver((e) => {
			n = e[0].isIntersecting && e[0].intersectionRatio >= .5, a();
		}, { threshold: [0, .5] });
		return o.observe(e), e.addEventListener("load", a), document.addEventListener("visibilitychange", a), document.addEventListener("visitorConsentCollected", a), () => {
			i(), o.disconnect(), e.removeEventListener("load", a), document.removeEventListener("visibilitychange", a), document.removeEventListener("visitorConsentCollected", a);
		};
	}, [
		g?.url,
		f,
		s
	]);
	let ee = () => {
		S.current = Date.now(), !b.current && (b.current = requestAnimationFrame(() => {
			b.current = 0;
			let e = y.current;
			if (!e) return;
			let t = Array.from(e.children);
			if (!t.length) return;
			let n = e.scrollLeft + e.clientWidth / 2, r = t.reduce((e, r, i) => Math.abs(r.offsetLeft + r.offsetWidth / 2 - n) < Math.abs(t[e].offsetLeft + t[e].offsetWidth / 2 - n) ? i : e, 0);
			r !== m.current && w(r, !1);
		}));
	}, te = !!g?.url && !s, D = o === "sv" ? "Produktbild" : "Product photo", ne = g?.altText || `${D} — ${r}`;
	return /* @__PURE__ */ (0, I.jsxs)("section", {
		"data-product-photo": !0,
		className: "flex h-full w-full flex-col bg-secondary/30",
		"aria-label": o === "sv" ? "Produktgalleri" : "Product gallery",
		children: [
			/* @__PURE__ */ (0, I.jsxs)("div", {
				ref: y,
				className: "dp-gallery-main-strip",
				onScroll: ee,
				tabIndex: 0,
				"aria-label": o === "sv" ? "Svep för fler bilder" : "Swipe for more images",
				onKeyDown: (e) => {
					(e.key === "ArrowRight" || e.key === "ArrowLeft") && (e.preventDefault(), w(Math.max(0, Math.min(d.length - 1, f + (e.key === "ArrowRight" ? 1 : -1)))));
				},
				children: [d.map((e, t) => /* @__PURE__ */ (0, I.jsx)("div", {
					className: "dp-gallery-slide",
					children: e.videoUrl ? /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("video", {
						ref: h,
						src: e.videoUrl,
						poster: e.url,
						controls: !0,
						autoPlay: !0,
						playsInline: !0,
						muted: !0,
						preload: "metadata",
						"aria-label": e.altText ?? D,
						onPlay: () => oe("video_play", C(t)),
						onEnded: () => oe("video_complete", C(t))
					}), /* @__PURE__ */ (0, I.jsx)("button", {
						type: "button",
						onClick: () => E(!0),
						"aria-label": o === "sv" ? "Förstora produktvideo" : "Enlarge product video",
						className: "absolute right-2 top-2 rounded-full bg-background/90 p-3 shadow-sm",
						children: /* @__PURE__ */ (0, I.jsx)(yr, { className: "h-5 w-5" })
					})] }) : /* @__PURE__ */ (0, I.jsxs)("button", {
						type: "button",
						className: "relative h-full w-full cursor-zoom-in",
						onClick: () => {
							Date.now() - S.current < 200 || (w(t), e.videoUrl || E(!0));
						},
						"aria-label": e.videoUrl ? o === "sv" ? "Spela produktvideo" : "Play product video" : o === "sv" ? "Förstora produktbild" : "Enlarge product photo",
						children: [/* @__PURE__ */ (0, I.jsx)("img", {
							ref: t === f ? _ : void 0,
							src: Xl(e.url, 960),
							srcSet: Zl(e.url),
							sizes: "(min-width: 768px) 50vw, 92vw",
							alt: e.altText || D,
							loading: t === 0 ? "eager" : "lazy",
							decoding: "async",
							fetchPriority: t === 0 ? "high" : "auto"
						}), /* @__PURE__ */ (0, I.jsx)("span", {
							className: "absolute top-2 right-2 rounded-full bg-background/90 p-3 shadow-sm",
							children: e.videoUrl ? /* @__PURE__ */ (0, I.jsx)(dr, { className: "h-5 w-5" }) : /* @__PURE__ */ (0, I.jsx)(yr, { className: "h-5 w-5" })
						})]
					})
				}, e.url)), !d.length && /* @__PURE__ */ (0, I.jsxs)("div", {
					className: "px-8 py-20 text-center text-muted-foreground",
					role: "status",
					children: [/* @__PURE__ */ (0, I.jsx)(lr, { className: "mx-auto mb-4 h-9 w-9" }), /* @__PURE__ */ (0, I.jsx)("p", { children: i ? o === "sv" ? "Hämtar produktbild…" : "Loading product photo…" : o === "sv" ? "Produktbild saknas." : "Product photo unavailable." })]
				})]
			}),
			d.length > 1 && /* @__PURE__ */ (0, I.jsx)("div", {
				className: "dp-gallery-thumbnail-rail border-t border-border/50 px-4 py-3",
				children: /* @__PURE__ */ (0, I.jsx)("div", {
					ref: v,
					className: "dp-gallery-thumbnails relative flex gap-2 overflow-x-auto",
					"aria-label": o === "sv" ? "Välj bild" : "Choose image",
					children: d.map((e, t) => /* @__PURE__ */ (0, I.jsxs)("button", {
						type: "button",
						onClick: () => w(t),
						"aria-pressed": t === f,
						"aria-label": e.videoUrl ? o === "sv" ? "Visa produktvideo" : "Show product video" : `${o === "sv" ? "Visa bild" : "Show image"} ${t + 1}`,
						className: `relative h-20 w-20 shrink-0 overflow-hidden rounded border-2 ${t === f ? "border-foreground" : "border-transparent"}`,
						children: [/* @__PURE__ */ (0, I.jsx)("img", {
							src: Xl(e.url, 192),
							alt: "",
							loading: "lazy",
							decoding: "async",
							className: "h-full w-full object-cover"
						}), e.videoUrl && /* @__PURE__ */ (0, I.jsx)("span", {
							className: "absolute inset-0 flex items-center justify-center bg-black/15",
							children: /* @__PURE__ */ (0, I.jsx)(dr, {
								className: "h-6 w-6 fill-white text-white",
								"aria-hidden": "true"
							})
						})]
					}, e.url))
				})
			}),
			/* @__PURE__ */ (0, I.jsx)("p", {
				className: "border-t border-border/50 px-5 py-4 text-center text-xs text-muted-foreground",
				"aria-live": "polite",
				children: r
			}),
			te && /* @__PURE__ */ (0, I.jsx)(Hl, {
				open: l,
				onOpenChange: E,
				children: /* @__PURE__ */ (0, I.jsxs)(Gl, {
					className: "dp-gallery-lightbox",
					"aria-describedby": void 0,
					children: [
						/* @__PURE__ */ (0, I.jsx)(Kl, {
							className: "sr-only",
							children: ne
						}),
						g?.videoUrl ? /* @__PURE__ */ (0, I.jsx)("video", {
							src: g.videoUrl,
							poster: g.url,
							controls: !0,
							playsInline: !0,
							muted: !0,
							preload: "metadata",
							"aria-label": ne,
							className: "dp-gallery-lightbox-video",
							onPlay: () => oe("video_play", C()),
							onEnded: () => oe("video_complete", C()),
							children: o === "sv" ? "Din webbläsare stöder inte videouppspelning." : "Your browser does not support video playback."
						}, g.videoUrl) : /* @__PURE__ */ (0, I.jsx)("img", {
							src: g.url,
							alt: ne,
							className: "dp-gallery-lightbox-image"
						}),
						/* @__PURE__ */ (0, I.jsx)("button", {
							type: "button",
							className: "dp-gallery-close",
							onClick: () => E(!1),
							children: o === "sv" ? "Stäng ×" : "Close ×"
						})
					]
				})
			})
		]
	});
}
//#endregion
//#region src/components/TrustBadges.tsx
function $l() {
	return /* @__PURE__ */ (0, I.jsx)("svg", {
		viewBox: "0 0 48 16",
		className: "h-3.5 w-auto",
		"aria-label": "Visa",
		role: "img",
		children: /* @__PURE__ */ (0, I.jsx)("text", {
			x: "0",
			y: "13",
			fontFamily: "Arial, Helvetica, sans-serif",
			fontSize: "15",
			fontWeight: "800",
			fontStyle: "italic",
			letterSpacing: "0.5",
			fill: "#1A1F71",
			children: "VISA"
		})
	});
}
function eu() {
	return /* @__PURE__ */ (0, I.jsxs)("svg", {
		viewBox: "0 0 44 26",
		className: "h-4 w-auto",
		"aria-label": "Mastercard",
		role: "img",
		children: [
			/* @__PURE__ */ (0, I.jsx)("circle", {
				cx: "16",
				cy: "13",
				r: "10",
				fill: "#EB001B"
			}),
			/* @__PURE__ */ (0, I.jsx)("circle", {
				cx: "28",
				cy: "13",
				r: "10",
				fill: "#F79E1B"
			}),
			/* @__PURE__ */ (0, I.jsx)("path", {
				d: "M22 4.6a10 10 0 0 1 0 16.8 10 10 0 0 1 0-16.8z",
				fill: "#FF5F00"
			}),
			/* @__PURE__ */ (0, I.jsx)("text", {
				x: "22",
				y: "25",
				textAnchor: "middle",
				fontFamily: "Arial, Helvetica, sans-serif",
				fontSize: "5.5",
				fontWeight: "600",
				fill: "#3A3A3A",
				children: "mastercard"
			})
		]
	});
}
function tu() {
	return /* @__PURE__ */ (0, I.jsxs)("svg", {
		viewBox: "0 0 52 20",
		className: "h-4 w-auto",
		"aria-label": "Klarna",
		role: "img",
		children: [/* @__PURE__ */ (0, I.jsx)("rect", {
			x: "0",
			y: "0",
			width: "52",
			height: "20",
			rx: "3",
			fill: "#FFA8CD"
		}), /* @__PURE__ */ (0, I.jsx)("text", {
			x: "26",
			y: "14",
			textAnchor: "middle",
			fontFamily: "Arial, Helvetica, sans-serif",
			fontSize: "9",
			fontWeight: "700",
			letterSpacing: "0.3",
			fill: "#17120F",
			children: "Klarna."
		})]
	});
}
var nu = [
	$l,
	eu,
	tu
];
function ru({ className: e }) {
	return /* @__PURE__ */ (0, I.jsx)("div", {
		className: Ki("flex flex-wrap items-center gap-2", e),
		children: nu.map((e, t) => /* @__PURE__ */ (0, I.jsx)("span", {
			className: "flex h-8 min-w-14 items-center justify-center rounded-lg border border-border bg-background px-2.5",
			children: /* @__PURE__ */ (0, I.jsx)(e, {})
		}, t))
	});
}
//#endregion
//#region node_modules/@radix-ui/react-collection/dist/index.mjs
var iu = Object.defineProperty, au = (e, t) => iu(e, "name", {
	value: t,
	configurable: !0
});
// @__NO_SIDE_EFFECTS__
function ou(e) {
	let t = e + "CollectionProvider", [n, r] = /* @__PURE__ */ Mo(t), [i, a] = n(t, {
		collectionRef: { current: null },
		itemMap: /* @__PURE__ */ new Map()
	}), o = /* @__PURE__ */ au((e) => {
		let { scope: t, children: n } = e, r = F.useRef(null), a = F.useRef(/* @__PURE__ */ new Map()).current;
		return /* @__PURE__ */ (0, I.jsx)(i, {
			scope: t,
			itemMap: a,
			collectionRef: r,
			children: n
		});
	}, "CollectionProvider");
	o.displayName = t;
	let s = e + "CollectionSlot", c = /* @__PURE__ */ Wa(s), l = F.forwardRef((e, t) => {
		let { scope: n, children: r } = e, i = Va(t, a(s, n).collectionRef);
		return /* @__PURE__ */ (0, I.jsx)(c, {
			ref: i,
			children: r
		});
	});
	l.displayName = s;
	let u = e + "CollectionItemSlot", d = "data-radix-collection-item", f = /* @__PURE__ */ Wa(u), p = F.forwardRef((e, t) => {
		let { scope: n, children: r, ...i } = e, o = F.useRef(null), s = Va(t, o), c = a(u, n);
		return F.useEffect(() => (c.itemMap.set(o, {
			ref: o,
			...i
		}), () => void c.itemMap.delete(o))), /* @__PURE__ */ (0, I.jsx)(f, {
			[d]: "",
			ref: s,
			children: r
		});
	});
	p.displayName = u;
	function m(t) {
		let n = a(e + "CollectionConsumer", t);
		return F.useCallback(() => {
			let e = n.collectionRef.current;
			if (!e) return [];
			let t = Array.from(e.querySelectorAll(`[${d}]`));
			return Array.from(n.itemMap.values()).sort((e, n) => t.indexOf(e.ref.current) - t.indexOf(n.ref.current));
		}, [n.collectionRef, n.itemMap]);
	}
	return au(m, "useCollection"), [
		{
			Provider: o,
			Slot: l,
			ItemSlot: p
		},
		m,
		r
	];
}
au(ou, "createCollection");
var su = /* @__PURE__ */ new WeakMap(), cu = class e extends Map {
	static {
		au(this, "OrderedDict");
	}
	#e;
	constructor(e) {
		super(e), this.#e = [...super.keys()], su.set(this, !0);
	}
	set(e, t) {
		return su.get(this) && (this.has(e) ? this.#e[this.#e.indexOf(e)] = e : this.#e.push(e)), super.set(e, t), this;
	}
	insert(e, t, n) {
		let r = this.has(t), i = this.#e.length, a = du(e), o = a >= 0 ? a : i + a, s = o < 0 || o >= i ? -1 : o;
		if (s === this.size || r && s === this.size - 1 || s === -1) return this.set(t, n), this;
		let c = this.size + +!r;
		a < 0 && o++;
		let l = [...this.#e], u, d = !1;
		for (let e = o; e < c; e++) if (o === e) {
			let i = l[e];
			l[e] === t && (i = l[e + 1]), r && this.delete(t), u = this.get(i), this.set(t, n);
		} else {
			!d && l[e - 1] === t && (d = !0);
			let n = l[d ? e : e - 1], r = u;
			u = this.get(n), this.delete(n), this.set(n, r);
		}
		return this;
	}
	with(t, n, r) {
		let i = new e(this);
		return i.insert(t, n, r), i;
	}
	before(e) {
		let t = this.#e.indexOf(e) - 1;
		if (!(t < 0)) return this.entryAt(t);
	}
	setBefore(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r, t, n);
	}
	after(e) {
		let t = this.#e.indexOf(e);
		if (t = t === -1 || t === this.size - 1 ? -1 : t + 1, t !== -1) return this.entryAt(t);
	}
	setAfter(e, t, n) {
		let r = this.#e.indexOf(e);
		return r === -1 ? this : this.insert(r + 1, t, n);
	}
	first() {
		return this.entryAt(0);
	}
	last() {
		return this.entryAt(-1);
	}
	clear() {
		return this.#e = [], super.clear();
	}
	delete(e) {
		let t = super.delete(e);
		return t && this.#e.splice(this.#e.indexOf(e), 1), t;
	}
	deleteAt(e) {
		let t = this.keyAt(e);
		return t !== void 0 && this.delete(t);
	}
	at(e) {
		let t = lu(this.#e, e);
		if (t !== void 0) return this.get(t);
	}
	entryAt(e) {
		let t = lu(this.#e, e);
		if (t !== void 0) return [t, this.get(t)];
	}
	indexOf(e) {
		return this.#e.indexOf(e);
	}
	keyAt(e) {
		return lu(this.#e, e);
	}
	from(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.at(r);
	}
	keyFrom(e, t) {
		let n = this.indexOf(e);
		if (n === -1) return;
		let r = n + t;
		return r < 0 && (r = 0), r >= this.size && (r = this.size - 1), this.keyAt(r);
	}
	find(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return r;
			n++;
		}
	}
	findIndex(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return n;
			n++;
		}
		return -1;
	}
	filter(t, n) {
		let r = [], i = 0;
		for (let e of this) Reflect.apply(t, n, [
			e,
			i,
			this
		]) && r.push(e), i++;
		return new e(r);
	}
	map(t, n) {
		let r = [], i = 0;
		for (let e of this) r.push([e[0], Reflect.apply(t, n, [
			e,
			i,
			this
		])]), i++;
		return new e(r);
	}
	reduce(...e) {
		let [t, n] = e, r = 0, i = n ?? this.at(0);
		for (let n of this) i = r === 0 && e.length === 1 ? n : Reflect.apply(t, this, [
			i,
			n,
			r,
			this
		]), r++;
		return i;
	}
	reduceRight(...e) {
		let [t, n] = e, r = n ?? this.at(-1);
		for (let n = this.size - 1; n >= 0; n--) {
			let i = this.at(n);
			r = n === this.size - 1 && e.length === 1 ? i : Reflect.apply(t, this, [
				r,
				i,
				n,
				this
			]);
		}
		return r;
	}
	toSorted(t) {
		let n = [...this.entries()].sort(t);
		return new e(n);
	}
	toReversed() {
		let t = new e();
		for (let e = this.size - 1; e >= 0; e--) {
			let n = this.keyAt(e), r = this.get(n);
			t.set(n, r);
		}
		return t;
	}
	toSpliced(...t) {
		let n = [...this.entries()];
		return n.splice(...t), new e(n);
	}
	slice(t, n) {
		let r = new e(), i = this.size - 1;
		if (t === void 0) return r;
		t < 0 && (t += this.size), n !== void 0 && n > 0 && (i = n - 1);
		for (let e = t; e <= i; e++) {
			let t = this.keyAt(e), n = this.get(t);
			r.set(t, n);
		}
		return r;
	}
	every(e, t) {
		let n = 0;
		for (let r of this) {
			if (!Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !1;
			n++;
		}
		return !0;
	}
	some(e, t) {
		let n = 0;
		for (let r of this) {
			if (Reflect.apply(e, t, [
				r,
				n,
				this
			])) return !0;
			n++;
		}
		return !1;
	}
};
function lu(e, t) {
	if ("at" in Array.prototype) return Array.prototype.at.call(e, t);
	let n = uu(e, t);
	return n === -1 ? void 0 : e[n];
}
au(lu, "at");
function uu(e, t) {
	let n = e.length, r = du(t), i = r >= 0 ? r : n + r;
	return i < 0 || i >= n ? -1 : i;
}
au(uu, "toSafeIndex");
function du(e) {
	return e !== e || e === 0 ? 0 : Math.trunc(e);
}
au(du, "toSafeInteger");
// @__NO_SIDE_EFFECTS__
function fu(e) {
	let t = e + "CollectionProvider", [n, r] = /* @__PURE__ */ Mo(t), [i, a] = n(t, {
		collectionElement: null,
		collectionRef: { current: null },
		collectionRefObject: { current: null },
		itemMap: new cu(),
		setItemMap: /* @__PURE__ */ au(() => void 0, "setItemMap")
	}), o = /* @__PURE__ */ au(({ state: e, ...t }) => e ? /* @__PURE__ */ (0, I.jsx)(c, {
		...t,
		state: e
	}) : /* @__PURE__ */ (0, I.jsx)(s, { ...t }), "CollectionProvider");
	o.displayName = t;
	let s = /* @__PURE__ */ au((e) => {
		let t = h();
		return /* @__PURE__ */ (0, I.jsx)(c, {
			...e,
			state: t
		});
	}, "CollectionInit");
	s.displayName = t + "Init";
	let c = /* @__PURE__ */ au((e) => {
		let { scope: t, children: n, state: r } = e, a = F.useRef(null), [o, s] = F.useState(null), c = Va(a, s), [l, u] = r;
		return F.useEffect(() => {
			if (!o) return;
			let e = gu(() => {});
			return e.observe(o, {
				childList: !0,
				subtree: !0
			}), () => {
				e.disconnect();
			};
		}, [o]), /* @__PURE__ */ (0, I.jsx)(i, {
			scope: t,
			itemMap: l,
			setItemMap: u,
			collectionRef: c,
			collectionRefObject: a,
			collectionElement: o,
			children: n
		});
	}, "CollectionProviderImpl");
	c.displayName = t + "Impl";
	let l = e + "CollectionSlot", u = /* @__PURE__ */ Wa(l), d = F.forwardRef((e, t) => {
		let { scope: n, children: r } = e, i = Va(t, a(l, n).collectionRef);
		return /* @__PURE__ */ (0, I.jsx)(u, {
			ref: i,
			children: r
		});
	});
	d.displayName = l;
	let f = e + "CollectionItemSlot", p = /* @__PURE__ */ Wa(f), m = F.forwardRef((e, t) => {
		let { scope: n, children: r, ...i } = e, o = F.useRef(null), [s, c] = F.useState(null), l = Va(t, o, c), { setItemMap: u } = a(f, n), d = F.useRef(i);
		pu(d.current, i) || (d.current = i);
		let m = d.current;
		return F.useEffect(() => {
			let e = m;
			return u((t) => s ? t.has(s) ? t.set(s, {
				...e,
				element: s
			}).toSorted(hu) : (t.set(s, {
				...e,
				element: s
			}), t.toSorted(hu)) : t), () => {
				u((e) => !s || !e.has(s) ? e : (e.delete(s), new cu(e)));
			};
		}, [
			s,
			m,
			u
		]), /* @__PURE__ */ (0, I.jsx)(p, {
			"data-radix-collection-item": "",
			ref: l,
			children: r
		});
	});
	m.displayName = f;
	function h() {
		return F.useState(new cu());
	}
	au(h, "useInitCollection");
	function g(t) {
		let { itemMap: n } = a(e + "CollectionConsumer", t);
		return n;
	}
	return au(g, "useCollection"), [{
		Provider: o,
		Slot: d,
		ItemSlot: m
	}, {
		createCollectionScope: r,
		useCollection: g,
		useInitCollection: h
	}];
}
au(fu, "createCollection");
function pu(e, t) {
	if (e === t) return !0;
	if (typeof e != "object" || typeof t != "object" || e == null || t == null) return !1;
	let n = Object.keys(e), r = Object.keys(t);
	if (n.length !== r.length) return !1;
	for (let r of n) if (!Object.prototype.hasOwnProperty.call(t, r) || e[r] !== t[r]) return !1;
	return !0;
}
au(pu, "shallowEqual");
function mu(e, t) {
	return !!(t.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_PRECEDING);
}
au(mu, "isElementPreceding");
function hu(e, t) {
	return !e[1].element || !t[1].element ? 0 : mu(e[1].element, t[1].element) ? -1 : 1;
}
au(hu, "sortByDocumentPosition");
function gu(e) {
	return new MutationObserver((t) => {
		for (let n of t) if (n.type === "childList") {
			e();
			return;
		}
	});
}
au(gu, "getChildListObserver");
//#endregion
//#region node_modules/@radix-ui/react-collapsible/dist/index.mjs
var _u = Object.defineProperty, vu = (e, t) => _u(e, "name", {
	value: t,
	configurable: !0
}), yu = "Collapsible", [bu, xu] = /* @__PURE__ */ Mo(yu), [Su, Cu] = bu(yu), wu = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ vu(function(e, t) {
	let { __scopeCollapsible: n, open: r, defaultOpen: i, disabled: a, onOpenChange: o, ...s } = e, [c, l] = Jo({
		prop: r,
		defaultProp: i ?? !1,
		onChange: o,
		caller: yu
	});
	return /* @__PURE__ */ (0, I.jsx)(Su, {
		scope: n,
		disabled: a,
		contentId: zo(),
		open: c,
		onOpenToggle: F.useCallback(() => l((e) => !e), [l]),
		children: /* @__PURE__ */ (0, I.jsx)(ts.div, {
			"data-state": Au(c),
			"data-disabled": a ? "" : void 0,
			...s,
			ref: t
		})
	});
}, "Collapsible")), Tu = "CollapsibleTrigger", Eu = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ vu(function(e, t) {
	let { __scopeCollapsible: n, ...r } = e, i = Cu(Tu, n);
	return /* @__PURE__ */ (0, I.jsx)(ts.button, {
		type: "button",
		"aria-controls": i.open ? i.contentId : void 0,
		"aria-expanded": i.open || !1,
		"data-state": Au(i.open),
		"data-disabled": i.disabled ? "" : void 0,
		disabled: i.disabled,
		...r,
		ref: t,
		onClick: wo(e.onClick, i.onOpenToggle)
	});
}, "CollapsibleTrigger")), Du = "CollapsibleContent", Ou = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ vu(function(e, t) {
	let { forceMount: n, ...r } = e, i = Cu(Du, e.__scopeCollapsible);
	return /* @__PURE__ */ (0, I.jsx)(Hs, {
		present: n || i.open,
		children: ({ present: e }) => /* @__PURE__ */ (0, I.jsx)(ku, {
			...r,
			ref: t,
			present: e
		})
	});
}, "CollapsibleContent")), ku = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ vu(function(e, t) {
	let { __scopeCollapsible: n, present: r, children: i, ...a } = e, o = Cu(Du, n), [s, c] = F.useState(r), l = F.useRef(null), u = Va(t, l), d = F.useRef(0), f = d.current, p = F.useRef(0), m = p.current, h = o.open || s, g = F.useRef(h), _ = F.useRef(void 0);
	return F.useEffect(() => {
		let e = requestAnimationFrame(() => g.current = !1);
		return () => cancelAnimationFrame(e);
	}, []), Po(() => {
		let e = l.current;
		if (e) {
			_.current = _.current || {
				transitionDuration: e.style.transitionDuration,
				animationName: e.style.animationName
			}, e.style.transitionDuration = "0s", e.style.animationName = "none";
			let t = e.getBoundingClientRect();
			d.current = t.height, p.current = t.width, g.current || (e.style.transitionDuration = _.current.transitionDuration, e.style.animationName = _.current.animationName), c(r);
		}
	}, [o.open, r]), /* @__PURE__ */ (0, I.jsx)(ts.div, {
		"data-state": Au(o.open),
		"data-disabled": o.disabled ? "" : void 0,
		id: o.contentId,
		hidden: !h,
		...a,
		ref: u,
		style: {
			"--radix-collapsible-content-height": f ? `${f}px` : void 0,
			"--radix-collapsible-content-width": m ? `${m}px` : void 0,
			...e.style
		},
		children: h && i
	});
}, "CollapsibleContentImpl"));
function Au(e) {
	return e ? "open" : "closed";
}
vu(Au, "getState");
var ju = wu, Mu = Eu, Nu = Ou, Pu = Object.defineProperty, Fu = (e, t) => Pu(e, "name", {
	value: t,
	configurable: !0
}), Iu = F.createContext(void 0);
function Lu(e) {
	let t = F.useContext(Iu);
	return e || t || "ltr";
}
Fu(Lu, "useDirection");
//#endregion
//#region node_modules/@radix-ui/react-accordion/dist/index.mjs
var Ru = Object.defineProperty, zu = (e, t) => Ru(e, "name", {
	value: t,
	configurable: !0
}), Bu = "Accordion", Vu = [
	"Home",
	"End",
	"ArrowDown",
	"ArrowUp",
	"ArrowLeft",
	"ArrowRight"
], [Hu, Uu, Wu] = /* @__PURE__ */ ou(Bu), [Z, Gu] = /* @__PURE__ */ Mo(Bu, [Wu, xu]), Ku = xu(), qu = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ zu(function(e, t) {
	let { type: n, ...r } = e, i = r, a = r;
	return /* @__PURE__ */ (0, I.jsx)(Hu.Provider, {
		scope: e.__scopeAccordion,
		children: n === "multiple" ? /* @__PURE__ */ (0, I.jsx)($u, {
			...a,
			ref: t
		}) : /* @__PURE__ */ (0, I.jsx)(Qu, {
			...i,
			ref: t
		})
	});
}, "Accordion")), [Ju, Yu] = Z(Bu), [Xu, Zu] = Z(Bu, { collapsible: !1 }), Qu = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ zu(function(e, t) {
	let { value: n, defaultValue: r, onValueChange: i = /* @__PURE__ */ zu(() => {}, "onValueChange"), collapsible: a = !1, ...o } = e, [s, c] = Jo({
		prop: n,
		defaultProp: r ?? "",
		onChange: i,
		caller: Bu
	});
	return /* @__PURE__ */ (0, I.jsx)(Ju, {
		scope: e.__scopeAccordion,
		value: F.useMemo(() => s ? [s] : [], [s]),
		onItemOpen: c,
		onItemClose: F.useCallback(() => a && c(""), [a, c]),
		children: /* @__PURE__ */ (0, I.jsx)(Xu, {
			scope: e.__scopeAccordion,
			collapsible: a,
			children: /* @__PURE__ */ (0, I.jsx)(nd, {
				...o,
				ref: t
			})
		})
	});
}, "AccordionImplSingle")), $u = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ zu(function(e, t) {
	let { value: n, defaultValue: r, onValueChange: i = /* @__PURE__ */ zu(() => {}, "onValueChange"), ...a } = e, [o, s] = Jo({
		prop: n,
		defaultProp: r ?? [],
		onChange: i,
		caller: Bu
	}), c = F.useCallback((e) => s((t = []) => [...t, e]), [s]), l = F.useCallback((e) => s((t = []) => t.filter((t) => t !== e)), [s]);
	return /* @__PURE__ */ (0, I.jsx)(Ju, {
		scope: e.__scopeAccordion,
		value: o,
		onItemOpen: c,
		onItemClose: l,
		children: /* @__PURE__ */ (0, I.jsx)(Xu, {
			scope: e.__scopeAccordion,
			collapsible: !0,
			children: /* @__PURE__ */ (0, I.jsx)(nd, {
				...a,
				ref: t
			})
		})
	});
}, "AccordionImplMultiple")), [ed, td] = Z(Bu), nd = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ zu(function(e, t) {
	let { __scopeAccordion: n, disabled: r, dir: i, orientation: a = "vertical", ...o } = e, s = Va(F.useRef(null), t), c = Uu(n), l = Lu(i) === "ltr", u = wo(e.onKeyDown, (e) => {
		if (!Vu.includes(e.key)) return;
		let t = e.target, n = c().filter((e) => !e.ref.current?.disabled), r = n.findIndex((e) => e.ref.current === t), i = n.length;
		if (r === -1) return;
		e.preventDefault();
		let o = r, s = i - 1, u = /* @__PURE__ */ zu(() => {
			o = r + 1, o > s && (o = 0);
		}, "moveNext"), d = /* @__PURE__ */ zu(() => {
			o = r - 1, o < 0 && (o = s);
		}, "movePrev");
		switch (e.key) {
			case "Home":
				o = 0;
				break;
			case "End":
				o = s;
				break;
			case "ArrowRight":
				a === "horizontal" && (l ? u() : d());
				break;
			case "ArrowDown":
				a === "vertical" && u();
				break;
			case "ArrowLeft":
				a === "horizontal" && (l ? d() : u());
				break;
			case "ArrowUp": a === "vertical" && d();
		}
		n[o % i].ref.current?.focus();
	});
	return /* @__PURE__ */ (0, I.jsx)(ed, {
		scope: n,
		disabled: r,
		direction: i,
		orientation: a,
		children: /* @__PURE__ */ (0, I.jsx)(Hu.Slot, {
			scope: n,
			children: /* @__PURE__ */ (0, I.jsx)(ts.div, {
				...o,
				"data-orientation": a,
				ref: s,
				onKeyDown: r ? void 0 : u
			})
		})
	});
}, "AccordionImpl")), rd = "AccordionItem", [id, ad] = Z(rd), od = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ zu(function(e, t) {
	let { __scopeAccordion: n, value: r, ...i } = e, a = td(rd, n), o = Yu(rd, n), s = Ku(n), c = zo(), l = r && o.value.includes(r) || !1, u = a.disabled || e.disabled;
	return /* @__PURE__ */ (0, I.jsx)(id, {
		scope: n,
		open: l,
		disabled: u,
		triggerId: c,
		children: /* @__PURE__ */ (0, I.jsx)(ju, {
			"data-orientation": a.orientation,
			"data-state": pd(l),
			...s,
			...i,
			ref: t,
			disabled: u,
			open: l,
			onOpenChange: (e) => {
				e ? o.onItemOpen(r) : o.onItemClose(r);
			}
		})
	});
}, "AccordionItem")), sd = "AccordionHeader", cd = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ zu(function(e, t) {
	let { __scopeAccordion: n, ...r } = e, i = td(Bu, n), a = ad(sd, n);
	return /* @__PURE__ */ (0, I.jsx)(ts.h3, {
		"data-orientation": i.orientation,
		"data-state": pd(a.open),
		"data-disabled": a.disabled ? "" : void 0,
		...r,
		ref: t
	});
}, "AccordionHeader")), ld = "AccordionTrigger", ud = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ zu(function(e, t) {
	let { __scopeAccordion: n, ...r } = e, i = td(Bu, n), a = ad(ld, n), o = Zu(ld, n), s = Ku(n);
	return /* @__PURE__ */ (0, I.jsx)(Hu.ItemSlot, {
		scope: n,
		children: /* @__PURE__ */ (0, I.jsx)(Mu, {
			"aria-disabled": a.open && !o.collapsible || void 0,
			"data-orientation": i.orientation,
			id: a.triggerId,
			...s,
			...r,
			ref: t
		})
	});
}, "AccordionTrigger")), dd = "AccordionContent", fd = /* @__PURE__ */ F.forwardRef(/* @__PURE__ */ zu(function(e, t) {
	let { __scopeAccordion: n, ...r } = e, i = td(Bu, n), a = ad(dd, n), o = Ku(n);
	return /* @__PURE__ */ (0, I.jsx)(Nu, {
		role: "region",
		"aria-labelledby": a.triggerId,
		"data-orientation": i.orientation,
		...o,
		...r,
		ref: t,
		style: {
			"--radix-accordion-content-height": "var(--radix-collapsible-content-height)",
			"--radix-accordion-content-width": "var(--radix-collapsible-content-width)",
			...e.style
		}
	});
}, "AccordionContent"));
function pd(e) {
	return e ? "open" : "closed";
}
zu(pd, "getState");
var md = qu, hd = od, gd = cd, _d = ud, vd = fd, yd = md, Q = F.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ (0, I.jsx)(hd, {
	ref: n,
	className: Ki("border-b", e),
	...t
}));
Q.displayName = "AccordionItem";
var bd = F.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ (0, I.jsx)(gd, {
	className: "flex",
	children: /* @__PURE__ */ (0, I.jsxs)(_d, {
		ref: r,
		className: Ki("flex flex-1 items-center justify-between py-4 text-sm font-medium cursor-pointer transition-all hover:underline text-left [&[data-state=open]>svg]:rotate-180", e),
		...n,
		children: [t, /* @__PURE__ */ (0, I.jsx)(ar, { className: "h-4 w-4 shrink-0 text-muted-foreground transition-transform duration-200" })]
	})
}));
bd.displayName = _d.displayName;
var xd = F.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ (0, I.jsx)(vd, {
	ref: r,
	className: "overflow-hidden text-sm data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down",
	...n,
	children: /* @__PURE__ */ (0, I.jsx)("div", {
		className: Ki("pb-4 pt-0", e),
		children: t
	})
}));
xd.displayName = vd.displayName;
//#endregion
//#region src/lib/lead.ts
var Sd = "dearplace.dev.lead.email", Cd = "dearplace.dev.lead.token";
function wd() {
	if (typeof window > "u") return null;
	try {
		let e = window.sessionStorage.getItem(Sd);
		return e && e.includes("@") ? e : null;
	} catch {
		return null;
	}
}
function Td(e) {
	if (!(typeof window > "u")) try {
		window.sessionStorage.setItem(Sd, e);
	} catch {}
}
function Ed(e) {
	if (!(typeof window > "u")) try {
		window.sessionStorage.setItem(Cd, e);
	} catch {}
}
//#endregion
//#region src/lib/leads.functions.ts
var Dd = ({ data: e }) => yn(e), Od = "City", kd = {
	pastel: "pastel",
	polar: "iceblue",
	white: "white"
}, Ad = {
	White: "white",
	Black: "black",
	Oak: "oak"
}, jd = (e) => h[e] ?? e, Md = [
	10,
	14,
	15,
	20,
	25,
	52,
	55
];
function $(e) {
	let t = parseInt(e, 10);
	return Md.find((e) => e === t) ?? 20;
}
function Nd({ initialPlaceQuery: e } = {}) {
	let t = Oa(), { t: n, lang: h } = x(), [y, S] = (0, F.useState)(""), [C, T] = (0, F.useState)(!1), [E, ee] = (0, F.useState)(!1), te = (0, F.useRef)(null), D = (0, F.useRef)(null), [ne, O] = (0, F.useState)(!1);
	(0, F.useEffect)(() => {
		let e = D.current;
		if (!e) return;
		let t = new IntersectionObserver(([e]) => O(e.isIntersecting), {
			rootMargin: "-80px 0px -100px 0px",
			threshold: 0
		});
		return t.observe(e), () => t.disconnect();
	}, []);
	let k = (0, F.useRef)(null), [oe, j] = (0, F.useState)([]), [ue, de] = (0, F.useState)(!1), [M, N] = (0, F.useState)({
		name: "Göteborg",
		center: [11.9746, 57.7089]
	}), [P, fe] = (0, F.useState)({
		size: !0,
		palette: !0,
		frame: !0
	}), pe = (0, F.useRef)(null), me = (0, F.useRef)(null), he = (0, F.useRef)(null), ge = (0, F.useRef)(null), _e = [
		{
			key: "size",
			label: h === "sv" ? "storlek" : "size",
			ref: me
		},
		{
			key: "palette",
			label: h === "sv" ? "färgpalett" : "colour palette",
			ref: he
		},
		{
			key: "frame",
			label: h === "sv" ? "ramfärg" : "frame colour",
			ref: ge
		}
	], ve = _e.filter(({ key: e }) => !P[e]), ye = ve.length === 0, [L, be] = (0, F.useState)(v.find((e) => e.id === "pastel")?.id ?? v[0].id), [xe, Se] = (0, F.useState)(1), [R, Ce] = (0, F.useState)(!1), [z, we] = (0, F.useState)(i), Te = a[0], [Ee, De] = (0, F.useState)("White"), Oe = m(Te, Ee), ke = n(`base.${Oe}`), Ae = (e) => {
		let [, t] = e.split("-");
		t && De(t);
	}, [je, Me] = (0, F.useState)("map"), [Ne, Pe] = (0, F.useState)(0), [Fe, Ie] = (0, F.useState)(!1), [Le, Re] = (0, F.useState)(""), [ze, Be] = (0, F.useState)(""), [Ve, He] = (0, F.useState)(!1), [Ue, We] = (0, F.useState)(!1), Ge = Fe ? [Le, ze].filter(Boolean).join(" / ") : "", Ke = c(z, Od, xe);
	l(z, Od, xe);
	let qe = r(z), Je = v.find((e) => e.id === L) ?? v[0], Ye = {
		lat: Number(M.center[1].toFixed(5)),
		lon: Number(M.center[0].toFixed(5)),
		scale: b(z, xe),
		sizeCm: $(z),
		color: kd[L] ?? "white",
		frame: Ad[Ee] ?? "white",
		placement: "proud"
	}, Xe = JSON.stringify(Ye), [Ze, Qe] = (0, F.useState)(null), [$e, et] = (0, F.useState)(null), [tt, nt] = (0, F.useState)(""), [rt, it] = (0, F.useState)(!1), [at, ot] = (0, F.useState)(!1), [st, ct] = (0, F.useState)("");
	(0, F.useEffect)(() => {
		ct("");
	}, [Xe, $e]);
	let lt = async () => {
		if ($e && Ze && Ze.key === Xe && !at) {
			ot(!0);
			try {
				let e = await (await bn("share-links", "POST", { language: h === "sv" ? "sv" : "en" })).json(), t = new URL(e.configurator_url);
				if (t.origin !== "https://dearplace.studio" || !t.hash.startsWith("#preview=")) throw Error("invalid_share_link");
				let n = new URLSearchParams(t.hash.slice(1));
				if (n.set("recreate", JSON.stringify({
					name: M.name,
					params: Ze.params
				})), t.hash = n.toString(), ct(t.href), navigator.share) try {
					await navigator.share({
						title: "Dear Place Studio",
						url: t.href
					});
					return;
				} catch (e) {
					if (e.name === "AbortError") return;
				}
				await navigator.clipboard.writeText(t.href), Yt.success(h === "sv" ? "Länken är kopierad." : "Link copied.");
			} catch {
				Yt.error(h === "sv" ? "Kopiera länken nedan eller försök igen." : "Copy the link below or try again.");
			} finally {
				ot(!1);
			}
		}
	}, ut = Ze !== null && Ze.key !== Xe;
	(0, F.useEffect)(() => {
		ut && Me("map");
	}, [ut, Xe]), (0, F.useEffect)(() => {
		if (Hn()) {
			Un().then((e) => {
				let t = e.params, n = d.find((e) => $(e) === t.sizeCm && !g.includes(e)), r = Object.keys(kd).find((e) => kd[e] === t.color), i = Object.keys(Ad).find((e) => Ad[e] === t.frame), a = Math.round(6e3 / t.scale * 10) / 10;
				if (!n || !r || !i || a < 1 || a > 1.5 || b(n, a) !== t.scale) throw Error("invalid_preview_options");
				hn(e), qn(e.modelId), ee(!0), N(e.place), S(e.place.name), we(n), be(r), De(i), Se(a), et(e.modelId), Qe({
					key: JSON.stringify(t),
					params: t,
					resumeId: e.modelId
				}), Me("art"), tr({
					...e,
					size: n,
					styleId: r,
					frameColor: i,
					zoomFactor: a
				}), requestAnimationFrame(() => te.current?.scrollIntoView({
					block: "start",
					behavior: "smooth"
				}));
			}).catch((e) => {
				nt(e.message === "preview_link_expired" ? "expired" : "unavailable");
				let t = Bn(), n = t?.params;
				if (!n) return;
				let r = d.find((e) => $(e) === n.sizeCm && !g.includes(e)), i = Object.keys(kd).find((e) => kd[e] === n.color), a = Object.keys(Ad).find((e) => Ad[e] === n.frame), o = Math.round(6e3 / n.scale * 10) / 10;
				!r || !i || !a || o < 1 || o > 1.5 || b(r, o) !== n.scale || n.placement !== "proud" || (ee(!0), N({
					name: t.name,
					center: [n.lon, n.lat]
				}), S(t.name), we(r), be(i), De(a), Se(o), Me("map"), it(!0));
			});
			return;
		}
		let t = new URLSearchParams(window.location.search);
		if (e || [
			"lat",
			"lon",
			"place",
			"size",
			"frame",
			"look",
			"zoom"
		].some((e) => t.has(e))) return;
		let n = nr();
		n && d.includes(n.size) && !g.includes(n.size) && v.some((e) => e.id === n.styleId) && Ad[n.frameColor] && n.params.sizeCm === $(n.size) && n.params.color === kd[n.styleId] && n.params.frame === Ad[n.frameColor] && n.params.scale === b(n.size, n.zoomFactor) && (hn(n), ee(!0), N(n.place), S(n.place.name), we(n.size), be(n.styleId), De(n.frameColor), Se(n.zoomFactor), Qe({
			key: JSON.stringify(n.params),
			params: n.params,
			resumeId: n.modelId
		}), Me("art"));
	}, []), (0, F.useEffect)(() => {
		let e = mn();
		$e && Ze && !ut && e && tr({
			...e,
			modelId: $e,
			place: M,
			size: z,
			styleId: L,
			frameColor: Ee,
			zoomFactor: xe,
			params: Ze.params
		});
	}, [
		$e,
		Ze,
		ut,
		M,
		z,
		L,
		Ee,
		xe
	]);
	let dt = (0, F.useRef)(null), ft = (e) => {
		Math.abs(e[0] - M.center[0]) < 1e-6 && Math.abs(e[1] - M.center[1]) < 1e-6 || (Ce(!0), ee(!0), N((t) => ({
			...t,
			center: e
		})), dt.current && clearTimeout(dt.current), dt.current = setTimeout(() => {
			ce({
				place_name: M.name,
				lat: Number(e[1].toFixed(5)),
				lon: Number(e[0].toFixed(5)),
				source: "map_drag"
			});
		}, 1200));
	}, [pt, mt] = (0, F.useState)(null), ht = (0, F.useRef)(!1), [gt, _t] = (0, F.useState)(!1);
	(0, F.useRef)(null), (0, F.useEffect)(() => {
		let e = wd();
		mt(e);
	}, []), (0, F.useEffect)(() => {
		M.name, Number(M.center[1].toFixed(5)), Number(M.center[0].toFixed(5));
	}, [M]), (0, F.useEffect)(() => {
		if (typeof window > "u") return;
		let e = new URLSearchParams(window.location.search), t = Number(e.get("lat")), r = Number(e.get("lon"));
		Number.isFinite(t) && Number.isFinite(r) && t !== 0 && r !== 0 && (ee(!0), N({
			name: (e.get("place") ?? "").slice(0, 120) || n("conf.myLocation"),
			center: [r, t]
		}));
		let i = e.get("size");
		i && d.includes(i) && !g.includes(i) && we(i);
		let a = e.get("frame");
		a && _.includes(a) && Ae(a);
		let o = e.get("look");
		o && v.some((e) => e.id === o) && be(o);
		let s = Number(e.get("zoom"));
		Number.isFinite(s) && s > 0 && Se(s);
	}, []);
	let vt = () => {
		let e = typeof window < "u" ? window.location.origin : "https://dearplace.studio", t = new URLSearchParams({
			place: M.name,
			lat: String(Ye.lat),
			lon: String(Ye.lon),
			size: z,
			frame: Oe,
			look: L,
			zoom: xe.toFixed(2)
		});
		return `${e}${h === "sv" ? "/sv" : ""}/pages/configurator?${t.toString()}`;
	}, yt = (e = {}) => ({
		place_name: M.name,
		lat: Ye.lat,
		lon: Ye.lon,
		size: z,
		frame: Oe,
		color: Je.name,
		radius_km: Number(Ke.toFixed(3)),
		configurator_url: vt(),
		...e
	}), bt = () => {
		et(null), Qe({
			key: Xe,
			params: Ye
		}), Me("art");
	}, xt = () => {
		St(null).catch((e) => Yt.error(n(e instanceof Error && e.message === "try_again_later" ? "gate.rateLimited" : "gate.saveError")));
	}, St = async (e) => {
		if (!ht.current) {
			ht.current = !0, _t(!0), ae({
				style: L,
				size: z,
				frame: Oe,
				color: Je.name,
				zoom: Number(xe.toFixed(2))
			});
			try {
				let t = yt(), n = await Dd({ data: {
					...e ? { email: e } : {},
					language: h === "en" ? "en" : "sv",
					design: {
						...t,
						render: Ye
					}
				} });
				if (!n.ok || !n.token) throw Error(h === "sv" ? "Det gick inte att spara. Försök igen." : "Could not save. Please try again.");
				Ed(n.token), e && (Td(e), mt(e)), e && (M.name, Je.name), bt();
			} catch (e) {
				throw A({
					error_kind: e instanceof Error && e.message === "try_again_later" ? "rate_limited" : "session_save_failed",
					size: z,
					frame: Oe,
					color: Je.name
				}), e;
			} finally {
				ht.current = !1, _t(!1);
			}
		}
	}, { data: Ct, isPending: wt, isError: Tt, isFetching: Et, refetch: Dt } = At({
		queryKey: ["product", "custom-3d-terrain-map"],
		queryFn: () => la("handle:custom-3d-terrain-map"),
		retry: 1
	}), Ot = Ct?.[0], B = (0, F.useMemo)(() => {
		if (Ot) return Ot.node.variants.edges.map((e) => e.node).find((e) => Zn(z, Xn(e, "Size")) && Zn(jd(Oe), Xn(e, "Base")) && Zn(Je.name, Xn(e, "Color")));
	}, [
		Ot,
		z,
		Oe,
		Je.name
	]), kt = Ot?.node.images.edges.find(({ node: e }) => {
		let t = e.url.split("/").pop()?.split("?")[0] ?? "", n = {
			white: "vit",
			polar: "polar",
			pastel: "pastell"
		}[L];
		return t.startsWith(`${n}-${Ee.toLowerCase()}-product`);
	})?.node ?? B?.image, jt = (0, F.useMemo)(() => {
		let e = {};
		if (!Ot) return e;
		let t = {};
		for (let e of Ot.node.variants.edges) {
			let n = e.node;
			if (!Zn(jd(Oe), Xn(n, "Base")) || !Zn(Je.name, Xn(n, "Color"))) continue;
			let r = Qn(Xn(n, "Size"), d);
			r && (t[r] = parseFloat(n.price.amount));
		}
		let n = t[z];
		if (n === void 0) return e;
		for (let [r, i] of Object.entries(t)) e[r] = Math.round(i - n);
		return e;
	}, [
		Ot,
		Oe,
		Je.name,
		z
	]), Mt = (0, F.useMemo)(() => {
		let e = {};
		if (!Ot) return e;
		let t = {};
		for (let e of Ot.node.variants.edges) {
			let n = e.node;
			if (!Zn(z, Xn(n, "Size")) || !Zn(Je.name, Xn(n, "Color"))) continue;
			let r = Qn(Xn(n, "Base"), _);
			r && (t[r] = parseFloat(n.price.amount));
		}
		let n = t[Oe];
		if (n === void 0) return e;
		for (let [r, i] of Object.entries(t)) e[r] = Math.round(i - n);
		return e;
	}, [
		Ot,
		z,
		Je.name,
		Oe
	]), Nt = (0, F.useMemo)(() => {
		let e = {};
		if (!Ot) return e;
		let t = {};
		for (let e of Ot.node.variants.edges) {
			let n = e.node;
			if (!Zn(z, Xn(n, "Size")) || !Zn(jd(Oe), Xn(n, "Base"))) continue;
			let r = v.find((e) => Zn(e.name, Xn(n, "Color")));
			r && (t[r.id] = parseFloat(n.price.amount));
		}
		let n = t.white;
		if (n === void 0) return e;
		for (let [r, i] of Object.entries(t)) e[r] = Math.round(i - n);
		return e;
	}, [
		Ot,
		z,
		Oe
	]), Pt = (e) => e > 0 ? `+${e} ${n("unit.currency")}` : e < 0 ? `−${Math.abs(e)} ${n("unit.currency")}` : "", { data: Ft } = At({
		queryKey: ["addons"],
		queryFn: fa
	}), It = (0, F.useMemo)(() => {
		if (!Ft) return [];
		let e = [], t = pa(Ne);
		return t && e.push({ sku: t }), Fe && Le.trim() && e.push({
			sku: da.plaque,
			note: [Le, ze].filter(Boolean).join(" / ")
		}), Ve && e.push({ sku: da.giftWrap }), Ue && e.push({ sku: ma(z) }), e.map((e) => {
			let t = Ft[e.sku];
			return t ? {
				...e,
				variant: t
			} : null;
		}).filter((e) => e !== null);
	}, [
		Ft,
		Ne,
		Fe,
		Le,
		ze,
		Ve,
		Ue,
		z
	]), Lt = It.reduce((e, t) => e + parseFloat(t.variant.price.amount), 0), Rt = (B ? parseFloat(B.price.amount) : 0) + Lt, zt = h === "sv" ? "Frakt beräknas i kassan. Fri frakt i Sverige över 550 kr." : "Shipping calculated at checkout. Free shipping in Sweden over 550 kr.", Bt = Da((e) => e.addPrepared);
	(0, F.useEffect)(() => {
		Da.getState().refresh().catch(() => {});
	}, []);
	let Vt = Da((e) => e.isLoading), [Ht, Ut] = (0, F.useState)(!1);
	(0, F.useEffect)(() => {
		let e = y.trim();
		if (!C || e.length < 3) {
			de(!1), j([]);
			return;
		}
		let t = !0, n = new AbortController();
		de(!0), j([]);
		let r = setTimeout(async () => {
			try {
				let r = await ra(e, n.signal);
				if (!t) return;
				r.error && Yt.error(r.error), j(r.places), r.places.length > 0 && le(e, { results: r.places.length });
			} finally {
				t && de(!1);
			}
		}, 400);
		return () => {
			t = !1, n.abort(), clearTimeout(r);
		};
	}, [y, C]);
	let Wt = (0, F.useRef)(!1);
	(0, F.useEffect)(() => {
		let t = e?.trim();
		if (!t || Wt.current) return;
		Wt.current = !0;
		let n = !0;
		return (async () => {
			let e = (await ra(t)).places[0];
			n && e && (ee(!0), N({
				name: e.name,
				center: e.center
			}), Me("map"), ce({
				place_name: e.name,
				lat: Number(e.center[1].toFixed(5)),
				lon: Number(e.center[0].toFixed(5)),
				source: "link"
			}));
		})(), () => {
			n = !1;
		};
	}, [e]);
	let Gt = (0, F.useRef)(!1);
	(0, F.useEffect)(() => {
		if (e || Gt.current) return;
		Gt.current = !0;
		let t = !0;
		return (async () => {
			try {
				let e = await ia();
				if (!t || !e) return;
				N((t) => t.name === "Göteborg" ? {
					name: e.name || t.name,
					center: e.center
				} : t);
			} catch {}
		})(), () => {
			t = !1;
		};
	}, [e]);
	let Kt = (0, F.useRef)(!1), qt = async (e = "inline") => {
		if (Kt.current) return !1;
		if (!E) return window.alert(h === "sv" ? "Ange en plats innan du lägger kartan i varukorgen." : "Please insert a location before adding to cart."), k.current?.focus(), !1;
		if (!B || !Ot || !B.availableForSale) return Yt.error(n("conf.unavailable")), !1;
		Kt.current = !0, Ut(!0), ie("add_to_cart_click", {
			placement: e,
			size: z,
			frame: Oe,
			look: L
		});
		try {
			if (!Ze || ut) {
				Me("map");
				let e = await Dd({ data: {
					language: h === "en" ? "en" : "sv",
					design: {
						...yt(),
						render: Ye
					}
				} });
				if (!e.ok || !e.token) throw Error("design_save_failed");
			}
			let e = await bn("checkout", "POST", {
				catalogVariantId: B.id,
				addons: It.map((e) => ({
					variantId: e.variant.variantId,
					...e.note ? { note: e.note } : {}
				}))
			});
			await Bt(Mn(await e.json())), bn("cart-observed", "POST").catch(() => {}), Ln().catch(() => {});
			let t = window.dearPlaceCart;
			return t ? t.open() : window.location.assign(`${ha()}cart`), !0;
		} catch (e) {
			let t = e instanceof Error ? e.message : "", n = t === "shopify_not_configured" ? h === "sv" ? "Kopplingen till Shopify-kassan är inte klar ännu. Din förhandsvisning är sparad." : "The Shopify checkout connection is not ready yet. Your preview is saved." : t === "cart_configuration_conflict" ? h === "sv" ? "Den här modellen finns redan i varukorgen med andra val. Ändra den i varukorgen först." : "This design is already in your cart with different options. Review your cart first." : h === "sv" ? "Det gick inte att lägga till modellen. Dina val finns kvar. Försök igen." : "The design could not be added. Your choices are kept. Please try again.";
			return Yt.error(n), !1;
		} finally {
			Kt.current = !1, Ut(!1);
		}
	};
	return (0, F.useEffect)(() => {
		if (B && !/\/products\//.test(window.location.pathname)) return re({
			product_id: Ot?.node.id.split("/").pop(),
			variant_id: B.id.split("/").pop(),
			value: parseFloat(B.price.amount),
			currency: B.price.currencyCode,
			size: z,
			color: Je.name,
			frame: Oe
		});
	}, [
		B?.id,
		B?.price.amount,
		B?.price.currencyCode,
		Ot?.node.id,
		z,
		Je.name,
		Oe
	]), /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsxs)("div", {
		className: "dp-mobile-configurator",
		children: [
			tt && /* @__PURE__ */ (0, I.jsxs)("section", {
				role: "alert",
				className: "m-3 rounded-md border border-border bg-background p-4",
				children: [
					/* @__PURE__ */ (0, I.jsx)("h2", {
						className: "font-display text-xl",
						children: tt === "expired" ? h === "sv" ? "Förhandsvisningslänken har gått ut eller är inte längre tillgänglig" : "This preview link has expired or is no longer available" : h === "sv" ? "Förhandsvisningen kunde inte öppnas" : "This preview could not be opened"
					}),
					/* @__PURE__ */ (0, I.jsx)("p", {
						className: "my-2 text-sm",
						children: rt ? h === "sv" ? "Platsen och valen är sparade i länken. Skapa en ny förhandsvisning av modellen." : "The link contains the location and options. You can generate a fresh preview of this model." : h === "sv" ? "Be avsändaren om en ny länk eller välj en plats för att skapa en ny modell." : "Ask the sender for a new link, or choose a location to create a new model."
					}),
					/* @__PURE__ */ (0, I.jsx)("button", {
						type: "button",
						disabled: gt,
						className: "min-h-11 rounded-md bg-foreground px-4 py-2 text-background",
						onClick: () => {
							nt(""), rt ? xt() : (Me("map"), te.current?.scrollIntoView({
								block: "center",
								behavior: "smooth"
							}));
						},
						children: rt ? h === "sv" ? "Återskapa modellen" : "Recreate this model" : h === "sv" ? "Välj en plats" : "Choose a location"
					})
				]
			}),
			/* @__PURE__ */ (0, I.jsxs)("div", {
				className: "flex w-full flex-col items-start md:flex-row",
				children: [/* @__PURE__ */ (0, I.jsx)("div", {
					className: "dp-config-gallery w-full md:sticky md:top-[72px] md:h-[calc(100vh-180px)] md:w-1/2 md:shrink-0 md:self-start lg:h-[calc(100vh-114px)]",
					children: /* @__PURE__ */ (0, I.jsx)(Ql, {
						showProductOnFirstChange: R,
						image: kt,
						images: Ot?.node.images.edges.map(({ node: e }) => e) ?? [],
						selection: `${z} · ${n(`theme.${Je.id}`)} · ${ke}`,
						loading: wt,
						configuration: {
							size: z,
							color: Je.name,
							frame: Oe
						}
					})
				}), /* @__PURE__ */ (0, I.jsx)("div", {
					className: "min-w-0 flex-1 px-5 py-8 pb-28 md:px-3 md:pb-8 md:py-8 lg:px-4",
					children: /* @__PURE__ */ (0, I.jsxs)("div", {
						className: "dp-config-stack flex flex-col gap-8",
						children: [
							/* @__PURE__ */ (0, I.jsx)("h1", {
								className: "dp-config-title",
								children: h === "sv" ? "Skapa din modell" : "Create your model"
							}),
							Tt && /* @__PURE__ */ (0, I.jsxs)("div", {
								role: "alert",
								className: "rounded-xl border border-border bg-secondary/40 p-4",
								children: [/* @__PURE__ */ (0, I.jsx)("p", { children: h === "sv" ? "Vi kunde inte hämta priserna. Dina val finns kvar. Försök igen." : "We could not load the prices. Your selections are saved. Please try again." }), /* @__PURE__ */ (0, I.jsx)("button", {
									type: "button",
									disabled: Et,
									onClick: () => void Dt(),
									className: "mt-3 rounded-lg bg-primary px-4 py-2 text-primary-foreground disabled:opacity-50",
									children: Et ? h === "sv" ? "Hämtar priser…" : "Loading prices…" : h === "sv" ? "Försök igen" : "Try again"
								})]
							}),
							/* @__PURE__ */ (0, I.jsx)("div", {
								className: "dp-config-stack order-2 flex flex-col gap-8",
								children: /* @__PURE__ */ (0, I.jsxs)("div", {
									className: "dp-config-stack flex flex-col gap-8",
									children: [/* @__PURE__ */ (0, I.jsxs)("section", { children: [
										!ye && /* @__PURE__ */ (0, I.jsxs)("div", {
											ref: pe,
											tabIndex: -1,
											id: "preview-required-choices",
											className: "dp-choice-reminder",
											"aria-live": "polite",
											children: [
												/* @__PURE__ */ (0, I.jsxs)("p", {
													className: "dp-choice-reminder-count",
													children: [
														h === "sv" ? "BÖRJA HÄR" : "START HERE",
														" · ",
														3 - ve.length,
														"/3 ",
														h === "sv" ? "VAL KLARA" : "CHOICES MADE"
													]
												}),
												/* @__PURE__ */ (0, I.jsx)("h2", { children: h === "sv" ? "Välj hur din karta ska se ut först" : "Choose how your map looks first" }),
												/* @__PURE__ */ (0, I.jsx)("p", { children: h === "sv" ? "Välj storlek, färgpalett och ramfärg ovan. Välj sedan din plats och skapa din förhandsvisning." : "Select your size, colour palette and frame colour above. Then choose your place and create your preview." }),
												/* @__PURE__ */ (0, I.jsx)("div", {
													className: "dp-choice-reminder-steps",
													children: _e.map(({ key: e, label: t, ref: n }, r) => /* @__PURE__ */ (0, I.jsxs)("button", {
														type: "button",
														className: P[e] ? "is-complete" : "",
														onClick: () => {
															n.current?.scrollIntoView({
																behavior: "smooth",
																block: "center"
															}), n.current?.querySelector("button[aria-pressed]:not(:disabled)")?.focus({ preventScroll: !0 });
														},
														children: [
															/* @__PURE__ */ (0, I.jsx)("span", {
																"aria-hidden": "true",
																children: P[e] ? "✓" : r + 1
															}),
															t,
															/* @__PURE__ */ (0, I.jsx)("span", {
																className: "sr-only",
																children: P[e] ? h === "sv" ? " vald" : " selected" : h === "sv" ? " krävs" : " required"
															})
														]
													}, e))
												})
											]
										}),
										/* @__PURE__ */ (0, I.jsx)("div", {
											className: "dp-design-options",
											children: /* @__PURE__ */ (0, I.jsxs)("div", {
												className: "flex flex-col gap-6 p-4",
												children: [
													/* @__PURE__ */ (0, I.jsxs)("section", {
														ref: he,
														className: "dp-palette-options scroll-mt-24",
														children: [
															/* @__PURE__ */ (0, I.jsx)("h2", {
																className: "font-display text-lg font-medium",
																children: n("conf.look")
															}),
															/* @__PURE__ */ (0, I.jsx)("p", {
																hidden: P.palette,
																className: "mt-1 text-xs text-muted-foreground",
																children: P.palette ? h === "sv" ? "Vald" : "Selected" : h === "sv" ? "Välj ett alternativ för att fortsätta" : "Choose an option to continue"
															}),
															/* @__PURE__ */ (0, I.jsx)("div", {
																className: "dp-size-options mt-3 grid grid-cols-2 gap-2",
																children: [...v].sort((e, t) => Number(t.id === "pastel") - Number(e.id === "pastel")).map((e) => /* @__PURE__ */ (0, I.jsxs)("button", {
																	"aria-pressed": P.palette && e.id === L,
																	type: "button",
																	onClick: () => {
																		e.id !== L && Ce(!0), be(e.id), fe((e) => ({
																			...e,
																			palette: !0
																		})), se("look", e.id);
																	},
																	className: `flex flex-col justify-between rounded-xl border p-4 text-left text-sm transition-all ${P.palette && e.id === L ? "border-primary bg-primary/10 ring-1 ring-primary" : "border-border hover:border-primary/60 hover:bg-secondary/40"}`,
																	children: [/* @__PURE__ */ (0, I.jsxs)("span", {
																		className: "flex items-start justify-between gap-2",
																		children: [/* @__PURE__ */ (0, I.jsx)("span", {
																			className: "font-medium",
																			children: n(`theme.${e.id}`)
																		}), Nt[e.id] !== void 0 && /* @__PURE__ */ (0, I.jsx)("span", {
																			className: "shrink-0 text-xs text-muted-foreground",
																			children: Nt[e.id] === 0 ? `+0 ${n("unit.currency")}` : Pt(Nt[e.id])
																		})]
																	}), /* @__PURE__ */ (0, I.jsx)("span", {
																		className: "mt-3 flex gap-1",
																		children: e.swatches.map((e, t) => /* @__PURE__ */ (0, I.jsx)("span", {
																			className: "h-5 w-5 rounded-full border border-border",
																			style: { backgroundColor: e }
																		}, t))
																	})]
																}, e.id))
															})
														]
													}),
													/* @__PURE__ */ (0, I.jsxs)("section", {
														ref: ge,
														className: "scroll-mt-24",
														children: [
															/* @__PURE__ */ (0, I.jsx)("h2", {
																className: "font-display text-lg font-medium",
																children: n("conf.frame")
															}),
															/* @__PURE__ */ (0, I.jsx)("p", {
																hidden: P.frame,
																className: "mt-1 text-xs text-muted-foreground",
																children: P.frame ? h === "sv" ? "Vald" : "Selected" : h === "sv" ? "Välj ett alternativ för att fortsätta" : "Choose an option to continue"
															}),
															/* @__PURE__ */ (0, I.jsx)("div", {
																className: "mt-3 grid grid-cols-3 gap-2",
																children: p.map((e) => {
																	let t = m(Te, e), r = Ot ? Mt[t] ?? 0 : f[t] ?? 0;
																	return /* @__PURE__ */ (0, I.jsx)("button", {
																		"aria-pressed": P.frame && e === Ee,
																		type: "button",
																		onClick: () => {
																			e !== Ee && Ce(!0), De(e), fe((e) => ({
																				...e,
																				frame: !0
																			})), se("frame", t, { surcharge_sek: r });
																		},
																		className: `flex flex-col justify-between rounded-xl border p-4 text-left text-sm transition-all ${P.frame && e === Ee ? "border-primary bg-primary/10 ring-1 ring-primary" : "border-border hover:border-primary/60 hover:bg-secondary/40"}`,
																		children: /* @__PURE__ */ (0, I.jsxs)("span", {
																			className: "flex items-start justify-between gap-2",
																			children: [/* @__PURE__ */ (0, I.jsx)("span", {
																				className: "font-medium",
																				children: n(`frameColor.${e}`)
																			}), r === 0 ? null : /* @__PURE__ */ (0, I.jsx)("span", {
																				className: "shrink-0 text-xs text-muted-foreground",
																				children: Pt(r)
																			})]
																		})
																	}, e);
																})
															})
														]
													}),
													/* @__PURE__ */ (0, I.jsxs)("section", {
														ref: me,
														className: "scroll-mt-24",
														children: [
															/* @__PURE__ */ (0, I.jsx)(Fa, {
																title: n("conf.size"),
																section: "size"
															}),
															/* @__PURE__ */ (0, I.jsx)("p", {
																hidden: P.size,
																className: "mt-1 text-xs text-muted-foreground",
																children: P.size ? h === "sv" ? "Vald" : "Selected" : h === "sv" ? "Välj ett alternativ för att fortsätta" : "Choose an option to continue"
															}),
															/* @__PURE__ */ (0, I.jsx)("div", {
																className: "dp-size-options mt-3 grid grid-cols-2 gap-2",
																children: d.filter((e) => !g.includes(e)).map((e) => {
																	let t = u.includes(e);
																	return /* @__PURE__ */ (0, I.jsxs)("button", {
																		"aria-pressed": P.size && e === z,
																		type: "button",
																		disabled: t,
																		onClick: () => {
																			e !== z && Ce(!0), we(e), fe((e) => ({
																				...e,
																				size: !0
																			})), se("size", e, { surcharge_sek: jt[e] ?? 0 });
																		},
																		className: `flex flex-col justify-between rounded-xl border p-4 text-left text-sm transition-all ${t ? "cursor-not-allowed border-dashed border-border text-muted-foreground" : P.size && e === z ? "border-primary bg-primary/10 ring-1 ring-primary" : "border-border hover:border-primary/60 hover:bg-secondary/40"}`,
																		children: [
																			/* @__PURE__ */ (0, I.jsxs)("span", {
																				className: "flex items-start justify-between gap-2",
																				children: [/* @__PURE__ */ (0, I.jsx)("span", {
																					className: "font-medium",
																					children: e
																				}), !t && (jt[e] ?? 0) !== 0 && /* @__PURE__ */ (0, I.jsx)("span", {
																					className: "shrink-0 text-xs text-muted-foreground",
																					children: Pt(jt[e] ?? 0)
																				})]
																			}),
																			!t && /* @__PURE__ */ (0, I.jsx)("span", {
																				className: "mt-2 block text-xs text-muted-foreground",
																				children: s(e, Od, xe, h)
																			}),
																			t && /* @__PURE__ */ (0, I.jsx)("span", {
																				className: "mt-2 block text-xs",
																				children: n("conf.soon")
																			})
																		]
																	}, e);
																})
															})
														]
													})
												]
											})
										}),
										/* @__PURE__ */ (0, I.jsxs)("div", {
											className: "mt-3",
											children: [/* @__PURE__ */ (0, I.jsx)("h2", {
												id: "where-heading",
												className: "font-display text-lg font-medium leading-tight mb-3",
												children: h === "sv" ? "Vilken plats vill du föreviga?" : "Which place would you like to remember?"
											}), /* @__PURE__ */ (0, I.jsxs)("div", {
												className: "dp-location-map-card",
												children: [
													/* @__PURE__ */ (0, I.jsx)("div", {
														className: "dp-location-controls",
														children: /* @__PURE__ */ (0, I.jsxs)("div", {
															className: "dp-place-search-anchor",
															onBlur: (e) => {
																e.currentTarget.contains(e.relatedTarget) || T(!1);
															},
															onKeyDown: (e) => {
																e.key === "Escape" && (T(!1), k.current?.focus({ preventScroll: !0 }));
															},
															children: [/* @__PURE__ */ (0, I.jsxs)("div", {
																className: "dp-place-search",
																children: [
																	/* @__PURE__ */ (0, I.jsx)(pr, { className: "dp-place-search-icon" }),
																	/* @__PURE__ */ (0, I.jsx)(qi, {
																		ref: k,
																		id: "place-search",
																		"aria-labelledby": "where-heading",
																		value: y,
																		onChange: (e) => {
																			T(!0), S(e.target.value);
																		},
																		placeholder: n("conf.search.placeholder"),
																		className: "dp-place-search-input",
																		"aria-controls": oe.length ? "place-search-results" : void 0,
																		autoComplete: "off"
																	}),
																	ue && /* @__PURE__ */ (0, I.jsx)(w, { className: "h-4 w-4 shrink-0 animate-spin text-muted-foreground" })
																]
															}), oe.length > 0 && /* @__PURE__ */ (0, I.jsx)("ul", {
																id: "place-search-results",
																className: "dp-place-results",
																children: oe.map((e) => /* @__PURE__ */ (0, I.jsx)("li", { children: /* @__PURE__ */ (0, I.jsxs)("button", {
																	type: "button",
																	className: "flex w-full items-start gap-2 px-3 py-2 text-left text-sm hover:bg-secondary",
																	onMouseDown: (e) => e.preventDefault(),
																	onClick: () => {
																		Ce(!0), ee(!0), N({
																			name: e.name,
																			center: e.center
																		}), ce({
																			place_name: e.name,
																			context: e.context,
																			lat: Number(e.center[1].toFixed(5)),
																			lon: Number(e.center[0].toFixed(5)),
																			source: "search",
																			query: y
																		}), Me("map"), S(e.name), T(!1), k.current?.focus({ preventScroll: !0 }), j([]);
																	},
																	children: [/* @__PURE__ */ (0, I.jsx)(ur, { className: "mt-0.5 h-4 w-4 flex-shrink-0 text-primary" }), /* @__PURE__ */ (0, I.jsxs)("span", { children: [/* @__PURE__ */ (0, I.jsx)("span", {
																		className: "font-medium",
																		children: e.name
																	}), /* @__PURE__ */ (0, I.jsx)("span", {
																		className: "block text-xs text-muted-foreground",
																		children: e.context
																	})] })]
																}) }, e.id))
															})]
														})
													}),
													/* @__PURE__ */ (0, I.jsx)("div", {
														ref: te,
														className: "relative aspect-square w-full overflow-hidden scroll-mt-24",
														children: je === "art" && Ze ? /* @__PURE__ */ (0, I.jsx)(bo, {
															params: Ze.params,
															resumeId: $e ?? Ze.resumeId,
															locationName: M.name,
															onReady: et,
															onDismissEmail: () => Me("map"),
															purchase: {
																label: n("conf.addToCart"),
																price: B ? ua(Rt, B.price.currencyCode) : "",
																detail: zt,
																disabled: !B?.availableForSale || gt || Vt || Ht || Fe && !Le.trim(),
																busy: Vt || Ht,
																onAdd: () => qt("preview_lightbox")
															}
														}) : je === "map" || je === "art" ? /* @__PURE__ */ (0, I.jsx)(Na, {
															center: M.center,
															radiusKm: Ke,
															style: Je,
															model: Od,
															size: z,
															base: Ee,
															engraving: Ge,
															locationName: M.name,
															mapView: !0,
															resolution: qe,
															ready: t,
															onCenterChange: ft
														}) : null
													}),
													je === "art" && Ze && /* @__PURE__ */ (0, I.jsxs)("div", {
														className: "px-3 py-2 flex flex-wrap gap-2",
														children: [
															/* @__PURE__ */ (0, I.jsxs)("button", {
																type: "button",
																className: "inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-md border border-border bg-background px-4 py-2 text-sm font-medium hover:bg-muted focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2",
																onClick: () => {
																	ie("back_to_map", {
																		placement: "preview",
																		size: z,
																		frame: Oe,
																		look: L
																	}), Me("map"), requestAnimationFrame(() => te.current?.scrollIntoView({
																		behavior: "smooth",
																		block: "start"
																	}));
																},
																children: [/* @__PURE__ */ (0, I.jsx)("span", {
																	"aria-hidden": "true",
																	children: "←"
																}), h === "sv" ? "Tillbaka till kartan" : "Back to map"]
															}),
															$e && !ut && /* @__PURE__ */ (0, I.jsxs)("button", {
																type: "button",
																disabled: at,
																onClick: lt,
																className: "inline-flex min-h-11 flex-1 items-center justify-center gap-2 rounded-md border border-border bg-background px-4 py-2 text-sm font-medium hover:bg-muted disabled:opacity-50",
																children: [/* @__PURE__ */ (0, I.jsx)(mr, {
																	className: "h-4 w-4 shrink-0",
																	"aria-hidden": "true"
																}), at ? h === "sv" ? "Förbereder länk…" : "Preparing link…" : h === "sv" ? "Dela din modell" : "Share your model"]
															}),
															st && /* @__PURE__ */ (0, I.jsxs)("label", {
																className: "w-full text-xs text-muted-foreground",
																children: [h === "sv" ? "Delningslänk · giltig i upp till 7 dagar" : "Share link · valid for up to 7 days", /* @__PURE__ */ (0, I.jsx)("input", {
																	readOnly: !0,
																	"aria-label": h === "sv" ? "Delningslänk" : "Share link",
																	value: st,
																	onFocus: (e) => e.target.select(),
																	className: "mt-1 w-full rounded border border-border p-2 text-sm"
																})]
															})
														]
													}),
													/* @__PURE__ */ (0, I.jsxs)("section", {
														className: "dp-map-adjust",
														"aria-label": n("conf.zoomLabel"),
														children: [/* @__PURE__ */ (0, I.jsxs)("div", {
															className: "flex items-baseline justify-between gap-2",
															children: [/* @__PURE__ */ (0, I.jsx)("h3", {
																className: "font-display text-sm font-medium",
																children: n("conf.zoomLabel")
															}), /* @__PURE__ */ (0, I.jsx)("span", {
																className: "text-xs text-muted-foreground",
																children: h === "sv" ? "Högre zoom · mer detalj" : "Higher zoom · more detail"
															})]
														}), /* @__PURE__ */ (0, I.jsx)("div", {
															className: "mt-2 grid grid-cols-6 gap-1.5",
															children: (() => {
																let { min: e, max: t, step: n } = o[Od], r = [];
																for (let i = e; i <= t + 1e-6; i += n) r.push(Number(i.toFixed(2)));
																return r.map((e) => /* @__PURE__ */ (0, I.jsx)("button", {
																	type: "button",
																	"aria-pressed": Math.abs(e - xe) < 1e-6,
																	onClick: () => {
																		e !== xe && Ce(!0), Se(e), Me("map"), se("zoom", `${e}x`);
																	},
																	className: `rounded-lg border px-1 py-2 text-center text-sm transition-all ${Math.abs(e - xe) < 1e-6 ? "border-primary bg-primary/10 ring-1 ring-primary" : "border-border bg-background hover:border-primary/60"}`,
																	children: /* @__PURE__ */ (0, I.jsx)("span", {
																		className: "block font-medium",
																		children: `${e.toFixed(2).replace(/\.?0+$/, "").replace(".", h === "sv" ? "," : ".")}×`
																	})
																}, e));
															})()
														})]
													})
												]
											})]
										})
									] }), /* @__PURE__ */ (0, I.jsxs)("div", {
										className: "dp-purchase-step py-5",
										children: [
											/* @__PURE__ */ (0, I.jsxs)("button", {
												type: "button",
												className: "dp-preview-action",
												disabled: gt,
												onClick: () => {
													if (!E) {
														window.alert(h === "sv" ? "Välj en plats för att förhandsvisa kartan." : "Select a location to preview your map."), k.current?.focus();
														return;
													}
													ie("generate_preview", {
														placement: "purchase_area",
														state: Ze && !ut ? "uptodate" : Ze ? "update" : "first",
														size: z,
														frame: Oe,
														look: L
													}), Ze && !ut ? Me("art") : xt(), te.current?.scrollIntoView({
														behavior: "smooth",
														block: "start"
													});
												},
												children: [/* @__PURE__ */ (0, I.jsxs)("span", {
													className: "dp-preview-action-title",
													children: [gt ? /* @__PURE__ */ (0, I.jsx)(w, { className: "h-4 w-4 animate-spin" }) : /* @__PURE__ */ (0, I.jsx)(or, { className: "h-4 w-4" }), gt ? h === "sv" ? "Förbereder förhandsvisning…" : "Preparing preview…" : ut ? h === "sv" ? "Uppdatera 3D-förhandsvisning" : "Update 3D preview" : h === "sv" ? "Öppna 3D-förhandsvisning" : "Open 3D preview"]
												}), /* @__PURE__ */ (0, I.jsx)("span", {
													className: "dp-preview-action-subtitle",
													children: h === "sv" ? "Se din modell innan du beställer." : "See your model before you order."
												})]
											}),
											/* @__PURE__ */ (0, I.jsxs)("button", {
												ref: D,
												type: "button",
												onClick: () => void qt("inline"),
												disabled: gt || !B || !B.availableForSale || Vt || Ht || Fe && !Le.trim(),
												className: "dp-map-primary dp-cart-action flex w-full items-center justify-between gap-4 px-5 py-4",
												children: [/* @__PURE__ */ (0, I.jsxs)("span", {
													className: "flex items-center gap-2",
													children: [Vt || Ht ? /* @__PURE__ */ (0, I.jsx)(w, { className: "h-4 w-4 animate-spin" }) : /* @__PURE__ */ (0, I.jsx)(gr, { className: "h-4 w-4" }), n("conf.addToCart")]
												}), /* @__PURE__ */ (0, I.jsx)("span", { children: B ? ua(Rt, B.price.currencyCode) : wt || Et ? h === "sv" ? "Hämtar pris…" : "Loading price…" : h === "sv" ? "Pris saknas" : "Price unavailable" })]
											}),
											/* @__PURE__ */ (0, I.jsx)("p", {
												className: "dp-purchase-reassurance",
												children: h === "sv" ? "Ram ingår · Frakt beräknas i kassan" : "Frame included · Shipping calculated at checkout"
											}),
											/* @__PURE__ */ (0, I.jsx)("p", {
												className: "dp-purchase-delivery",
												children: h === "sv" ? "Leverans inom Sverige: 4–5 arbetsdagar" : "Delivery within Sweden: 4–5 working days"
											}),
											/* @__PURE__ */ (0, I.jsx)(ru, { className: "mt-3 justify-center" })
										]
									})]
								})
							})
						]
					})
				})]
			}),
			/* @__PURE__ */ (0, I.jsx)("section", {
				className: "dp-config-faq w-full border-t border-border/60 py-10",
				children: /* @__PURE__ */ (0, I.jsxs)("div", {
					className: "mx-auto w-full max-w-6xl px-5",
					children: [/* @__PURE__ */ (0, I.jsx)("h2", {
						className: "font-display text-2xl font-light sm:text-3xl",
						children: n("home.faq.title")
					}), /* @__PURE__ */ (0, I.jsx)(yd, {
						type: "single",
						collapsible: !0,
						className: "mt-6 w-full",
						onValueChange: (e) => {
							e && ie("faq_open", { question: e });
						},
						children: [
							1,
							2,
							3,
							4,
							5,
							6
						].map((e) => /* @__PURE__ */ (0, I.jsxs)(Q, {
							value: `q${e}`,
							children: [/* @__PURE__ */ (0, I.jsx)(bd, {
								className: "text-left text-base w-full",
								children: n(`home.faq.${e}.q`)
							}), /* @__PURE__ */ (0, I.jsx)(xd, {
								className: "text-sm leading-relaxed text-muted-foreground w-full",
								children: n(`home.faq.${e}.a`)
							})]
						}, e))
					})]
				})
			}),
			/* @__PURE__ */ (0, I.jsx)("section", {
				className: "dp-config-information w-full border-t border-border/60 bg-secondary/30 py-10 pb-24 lg:pb-10",
				children: /* @__PURE__ */ (0, I.jsxs)("div", {
					className: "mx-auto w-full max-w-6xl px-5",
					children: [/* @__PURE__ */ (0, I.jsx)("h2", {
						className: "font-display text-2xl font-light sm:text-3xl",
						children: n("conf.productInfo.title")
					}), /* @__PURE__ */ (0, I.jsxs)("div", {
						className: "mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3",
						children: [
							/* @__PURE__ */ (0, I.jsx)("div", {
								className: "rounded-2xl border border-border bg-card p-5",
								children: /* @__PURE__ */ (0, I.jsxs)("div", {
									className: "flex items-start gap-3",
									children: [/* @__PURE__ */ (0, I.jsx)("div", {
										className: "grid h-9 w-9 shrink-0 place-items-center rounded-full bg-destructive/10 text-destructive",
										children: /* @__PURE__ */ (0, I.jsx)(hr, {
											className: "h-4.5 w-4.5",
											"aria-hidden": "true"
										})
									}), /* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("h3", {
										className: "font-display text-base font-medium",
										children: n("conf.productInfo.safety.title")
									}), /* @__PURE__ */ (0, I.jsx)("p", {
										className: "mt-2 text-sm leading-relaxed text-muted-foreground",
										children: n("conf.productInfo.safety.body")
									})] })]
								})
							}),
							/* @__PURE__ */ (0, I.jsx)("div", {
								className: "rounded-2xl border border-border bg-card p-5",
								children: /* @__PURE__ */ (0, I.jsxs)("div", {
									className: "flex items-start gap-3",
									children: [/* @__PURE__ */ (0, I.jsx)("div", {
										className: "grid h-9 w-9 shrink-0 place-items-center rounded-full bg-primary/10 text-primary",
										children: /* @__PURE__ */ (0, I.jsx)(_r, {
											className: "h-4.5 w-4.5",
											"aria-hidden": "true"
										})
									}), /* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("h3", {
										className: "font-display text-base font-medium",
										children: n("conf.productInfo.care.title")
									}), /* @__PURE__ */ (0, I.jsx)("p", {
										className: "mt-2 text-sm leading-relaxed text-muted-foreground",
										children: n("conf.productInfo.care.body")
									})] })]
								})
							}),
							/* @__PURE__ */ (0, I.jsx)("div", {
								className: "rounded-2xl border border-border bg-card p-5",
								children: /* @__PURE__ */ (0, I.jsxs)("div", {
									className: "flex items-start gap-3",
									children: [/* @__PURE__ */ (0, I.jsx)("div", {
										className: "grid h-9 w-9 shrink-0 place-items-center rounded-full bg-muted text-foreground",
										children: /* @__PURE__ */ (0, I.jsx)(sr, {
											className: "h-4.5 w-4.5",
											"aria-hidden": "true"
										})
									}), /* @__PURE__ */ (0, I.jsxs)("div", { children: [
										/* @__PURE__ */ (0, I.jsx)("h3", {
											className: "font-display text-base font-medium",
											children: n("conf.productInfo.maker.title")
										}),
										/* @__PURE__ */ (0, I.jsx)("p", {
											className: "mt-2 text-sm leading-relaxed text-muted-foreground",
											children: n("conf.productInfo.maker.body")
										}),
										/* @__PURE__ */ (0, I.jsxs)("p", {
											className: "mt-2 text-sm leading-relaxed text-muted-foreground",
											children: [n("conf.productInfo.maker.contact", { email: "" }).replace("{email}", ""), /* @__PURE__ */ (0, I.jsx)("a", {
												href: `mailto:${G.email}`,
												className: "underline underline-offset-2 hover:text-primary",
												children: G.email
											})]
										})
									] })]
								})
							})
						]
					})]
				})
			})
		]
	}), /* @__PURE__ */ (0, I.jsx)("div", {
		hidden: ne,
		className: "dp-mobile-purchase-bar md:hidden",
		"aria-label": h === "sv" ? "Din karta och nästa steg" : "Your map and next step",
		children: /* @__PURE__ */ (0, I.jsxs)("div", {
			className: "dp-mobile-purchase-row",
			children: [/* @__PURE__ */ (0, I.jsxs)("div", {
				role: "status",
				"aria-live": "polite",
				children: [/* @__PURE__ */ (0, I.jsx)("span", {
					className: "dp-mobile-price-label",
					children: h === "sv" ? "Din karta" : "Your map"
				}), /* @__PURE__ */ (0, I.jsx)("strong", { children: B ? ua(Rt, B.price.currencyCode) : wt || Et ? h === "sv" ? "Hämtar pris…" : "Loading price…" : h === "sv" ? "Pris saknas" : "Price unavailable" })]
			}), /* @__PURE__ */ (0, I.jsx)("button", {
				type: "button",
				className: "dp-map-primary",
				disabled: gt || Vt || Ht || !B?.availableForSale,
				onClick: () => void qt("mobile_sticky"),
				children: Vt || Ht ? h === "sv" ? "Lägger till…" : "Adding…" : h === "sv" ? "Lägg i varukorgen" : "Add to cart"
			})]
		})
	})] });
}
//#endregion
//#region src/components/LocalLink.tsx
function Pd({ to: e, search: t, children: n, ...r }) {
	let i = new URL(e, location.origin), a = i.pathname.split("/").filter(Boolean), o = a[0] === "sv" ? "sv" : "en";
	a[0] === "sv" && a.shift();
	let s = {
		frakt: "shipping",
		returer: "returns",
		integritet: "privacy"
	};
	a[0] === "pages" && a.shift();
	let c = s[a[0]] ?? a[0], l = new URLSearchParams({ lang: o });
	[
		"custom-3d-map",
		"personlig-3d-karta",
		"gifts",
		"present"
	].includes(c) ? (l.set("view", "landing"), l.set("kind", ["gifts", "present"].includes(c) ? "occasion" : "city"), l.set("slug", a[1] ?? "")) : c && l.set("view", c);
	for (let [e, t] of i.searchParams) l.set(e, t);
	for (let [e, n] of Object.entries(t ?? {})) n !== void 0 && l.set(e, n);
	let u = o === "sv" ? "/sv" : "", d = JSON.parse(document.getElementById("dearplace-app")?.dataset.routes ?? "{}")[l.get("view") === "landing" ? `${l.get("kind")}:${l.get("slug")}` : c];
	d && (l.delete("view"), l.delete("lang"), l.delete("kind"), l.delete("slug"));
	let f = d ? `${u}${d}` : `${u}/`;
	return /* @__PURE__ */ (0, I.jsx)("a", {
		...r,
		href: `${f}${l.size ? (f.includes("?") ? "&" : "?") + l : ""}`,
		children: n
	});
}
//#endregion
//#region src/content/landing.ts
var Fd = [
	{
		id: "stockholm",
		slug: {
			en: "stockholm",
			sv: "stockholm"
		},
		searchCity: "Stockholm",
		country: "SE",
		relatedCities: [
			"gothenburg",
			"malmo",
			"helsinki"
		],
		relatedOccasions: ["hometown", "moving-away"],
		copy: {
			en: {
				title: "Custom 3D Map of Stockholm | dearplace.studio",
				description: "Custom 3D map of Stockholm. Choose your area, colours and frame. Preview your design before ordering. Made in Gothenburg.",
				h1: "Custom 3D map of Stockholm",
				intro: "The flat you rented on Södermalm, the office by Slussen, the church where you got married. Stockholm is a city people remember street by street, and a relief map lets you keep exactly the part you mean.",
				geography: "Start with an address on Södermalm, around Gamla stan or beside the water. Move the square until it includes the streets you recognise and a little of the surrounding shoreline. A smaller area gives individual buildings more room in the finished map.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			},
			sv: {
				title: "Personlig 3D-karta över Stockholm | dearplace.studio",
				description: "Personlig 3D-karta över Stockholm. Välj ditt utsnitt, färger och ram. Se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "Personlig 3D-karta över Stockholm",
				intro: "Lägenheten på Söder, kontoret vid Slussen, kyrkan där ni gifte er. Stockholm är en stad man minns kvarter för kvarter — en 3D-karta låter dig behålla precis den delen du menar.",
				geography: "Börja med en adress på Södermalm, kring Gamla stan eller vid vattnet. Flytta rutan tills gatorna du känner igen och en del av strandlinjen ryms. Ett mindre område ger enskilda byggnader mer plats i den färdiga kartan.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			}
		}
	},
	{
		id: "gothenburg",
		slug: {
			en: "gothenburg",
			sv: "goteborg"
		},
		searchCity: "Göteborg",
		country: "SE",
		relatedCities: [
			"stockholm",
			"malmo",
			"oslo"
		],
		relatedOccasions: ["hometown", "housewarming"],
		copy: {
			en: {
				title: "Custom 3D Map of Gothenburg | dearplace.studio",
				description: "Custom 3D map of Gothenburg. Choose your area, colours and frame. Preview your design before ordering. Made in Gothenburg.",
				h1: "Custom 3D map of Gothenburg",
				intro: "Gothenburg is a city of edges: the river on one side, hills and rock on the other, and a grid of canals holding the centre together. A relief map keeps all three in one square.",
				geography: "Try the streets around your home, a stretch of the river or the neighbourhood where you first lived in Gothenburg. Compare a close view of the blocks with a wider view that includes water and green spaces, then preview your preferred composition.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			},
			sv: {
				title: "Personlig 3D-karta över Göteborg | dearplace.studio",
				description: "Personlig 3D-karta över Göteborg. Välj ditt utsnitt, färger och ram. Se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "Personlig 3D-karta över Göteborg",
				intro: "Göteborg är en stad av kanter: älven på ena sidan, berg och höjder på den andra, och ett kanalsystem som håller ihop mitten. En 3D-karta får med alla tre i samma ruta.",
				geography: "Välj kvarteren runt ditt hem, en bit av älven eller området där du först bodde i Göteborg. Jämför ett nära utsnitt av husen med ett större som tar med vatten och grönområden, och förhandsvisa den komposition du gillar bäst.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			}
		}
	},
	{
		id: "malmo",
		slug: {
			sv: "malmo",
			en: "malmo"
		},
		searchCity: "Malmö",
		country: "SE",
		relatedCities: [
			"copenhagen",
			"gothenburg",
			"stockholm"
		],
		relatedOccasions: ["housewarming", "moving-away"],
		copy: {
			sv: {
				title: "Personlig 3D-karta över Malmö | dearplace.studio",
				description: "Personlig 3D-karta över Malmö. Välj ditt utsnitt, färger och ram. Se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "Personlig 3D-karta över Malmö",
				intro: "Gamla Väster, Möllan, Västra hamnen — Malmö byter karaktär på några hundra meter. Därför blir just den ruta du väljer så personlig.",
				geography: "Välj kvarteren kring ditt hem, promenaden genom stan eller en plats vid vattnet i Malmö. Håll utsnittet samlat så att husen får utrymme i förhandsvisningen.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			},
			en: {
				title: "Custom 3D Map of Malmö | dearplace.studio",
				description: "Create a personal 3D map of Malmö. Choose your neighbourhood, colours and frame, then preview your design before ordering. Made in Gothenburg.",
				h1: "Custom 3D map of Malmö",
				intro: "Your first flat, the street you cycled down, a favourite spot by the water. Choose the part of Malmö that holds your memories and turn it into a framed 3D map.",
				geography: "Start with a familiar address and frame the streets around it. Compare a close view of your neighbourhood with a wider area that includes the waterfront or a favourite route. Use the preview to check the details that matter.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			}
		}
	},
	{
		id: "oslo",
		slug: {
			en: "oslo",
			sv: "oslo"
		},
		searchCity: "Oslo",
		country: "NO",
		relatedCities: [
			"bergen",
			"stockholm",
			"copenhagen"
		],
		relatedOccasions: ["hometown", "wedding"],
		copy: {
			en: {
				title: "Custom 3D Map of Oslo | dearplace.studio",
				description: "Custom 3D map of Oslo. Choose your area, colours and frame. Preview your design before ordering. Made in Gothenburg.",
				h1: "Custom 3D map of Oslo",
				intro: "The flat you lived in, the walk to the waterfront or the neighbourhood where you met. Turn your part of Oslo into a personal 3D map to bring home.",
				geography: "Choose a neighbourhood, a familiar street or an area beside the waterfront. Keep the place that matters near the centre and use the preview to judge how the buildings and surrounding terrain read together.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			},
			sv: {
				title: "Personlig 3D-karta över Oslo | dearplace.studio",
				description: "Skapa en personlig 3D-karta över Oslo. Välj område, färger och ram och se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "Personlig 3D-karta över Oslo",
				intro: "Lägenheten du bodde i, promenaden till vattnet eller kvarteret där ni träffades. Gör din del av Oslo till en personlig 3D-karta som får följa med hem.",
				geography: "Välj ett kvarter, en välbekant gata eller ett område vid vattnet. Håll platsen som betyder något nära mitten och använd förhandsvisningen för att se hur byggnader och terräng fungerar tillsammans.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			}
		}
	},
	{
		id: "copenhagen",
		slug: {
			en: "copenhagen",
			sv: "kopenhamn"
		},
		searchCity: "København",
		country: "DK",
		relatedCities: [
			"malmo",
			"stockholm",
			"helsinki"
		],
		relatedOccasions: ["wedding", "housewarming"],
		copy: {
			en: {
				title: "Custom 3D Map of Copenhagen | dearplace.studio",
				description: "Custom 3D map of Copenhagen. Choose your area, colours and frame. Preview your design before ordering. Made in Gothenburg.",
				h1: "Custom 3D map of Copenhagen",
				intro: "Nyhavn, Christianshavn, the lakes on a Sunday. Copenhagen is a city you know by its water edges, and those edges are exactly what a relief map is good at.",
				geography: "Start with a favourite address in Copenhagen and decide how much of the surrounding city belongs in the frame. A canal, a courtyard block or a familiar route can help make the composition personal. Check the preview before choosing the final area.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			},
			sv: {
				title: "Personlig 3D-karta över Köpenhamn | dearplace.studio",
				description: "Skapa en personlig 3D-karta över Köpenhamn. Välj område, färger och ram och se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "Personlig 3D-karta över Köpenhamn",
				intro: "Nyhavn, Christianshavn eller promenaden längs sjöarna. Välj den del av Köpenhamn som bär på dina minnen och gör den till en inramad 3D-karta.",
				geography: "Börja med en favoritadress i Köpenhamn och välj hur mycket av staden som ska få plats. En kanal, ett kvarter eller en välbekant promenadväg kan göra utsnittet personligt. Kontrollera förhandsvisningen innan du bestämmer dig.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			}
		}
	},
	{
		id: "helsinki",
		slug: {
			en: "helsinki",
			sv: "helsingfors"
		},
		searchCity: "Helsinki",
		country: "FI",
		relatedCities: [
			"stockholm",
			"copenhagen",
			"oslo"
		],
		relatedOccasions: ["moving-away", "hometown"],
		copy: {
			en: {
				title: "Custom 3D Map of Helsinki | dearplace.studio",
				description: "Custom 3D map of Helsinki. Choose your area, colours and frame. Preview your design before ordering. Made in Gothenburg.",
				h1: "Custom 3D map of Helsinki",
				intro: "Helsinki is a peninsula with the sea on three sides, which means most frames you choose will contain a coastline rather than just streets.",
				geography: "Choose a familiar neighbourhood or include part of the waterfront in your frame. Open water can give the surrounding buildings room to stand out. Adjust the area until the balance feels right, then check your generated preview.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			},
			sv: {
				title: "Personlig 3D-karta över Helsingfors | dearplace.studio",
				description: "Skapa en personlig 3D-karta över Helsingfors. Välj område, färger och ram och se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "Personlig 3D-karta över Helsingfors",
				intro: "Kvarteret du kom hem till, vägen genom staden eller en plats vid havet. Låt dina minnen av Helsingfors ta form i en personlig 3D-karta.",
				geography: "Välj ett välbekant kvarter eller ta med en del av strandlinjen. Öppet vatten kan ge byggnaderna utrymme att framträda. Justera utsnittet tills balansen känns rätt och kontrollera sedan förhandsvisningen.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			}
		}
	},
	{
		id: "bergen",
		slug: {
			en: "bergen",
			sv: "bergen"
		},
		searchCity: "Bergen",
		country: "NO",
		relatedCities: [
			"oslo",
			"stockholm",
			"copenhagen"
		],
		relatedOccasions: ["summer-house", "hometown"],
		copy: {
			en: {
				title: "Custom 3D Map of Bergen | dearplace.studio",
				description: "Custom 3D map of Bergen. Choose your area, colours and frame. Preview your design before ordering. Made in Gothenburg.",
				h1: "Custom 3D map of Bergen",
				intro: "Bergen is pressed between mountains and the sea, and that is precisely why it looks so unlike a flat printed map when you give it height.",
				geography: "Start with the streets you remember in Bergen, then compare a close view with one that includes more surrounding terrain or water. The best composition is the one that makes your own place recognisable in the preview.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			},
			sv: {
				title: "Personlig 3D-karta över Bergen | dearplace.studio",
				description: "Skapa en personlig 3D-karta över Bergen. Välj område, färger och ram och se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "Personlig 3D-karta över Bergen",
				intro: "Gatorna du minns, platsen vid vattnet eller kvarteret som blev ditt. Skapa en 3D-karta av den del av Bergen som betyder något för dig.",
				geography: "Börja med gatorna du minns i Bergen. Jämför ett nära utsnitt med ett som tar med mer av terrängen eller vattnet runt omkring. Välj det utsnitt där din plats känns igen i förhandsvisningen.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			}
		}
	}
], Id = [
	{
		id: "housewarming",
		slug: {
			en: "housewarming-gift",
			sv: "inflyttningspresent"
		},
		relatedCities: [
			"stockholm",
			"gothenburg",
			"malmo"
		],
		relatedOccasions: ["moving-away", "hometown"],
		copy: {
			en: {
				title: "Housewarming Gift: A 3D Map of Their New Home | dearplace.studio",
				description: "A housewarming gift, made from their new address. Choose your area, colours and frame. Preview your design before ordering. Made in Gothenburg.",
				h1: "A housewarming gift, made from their new address",
				intro: "The keys, the first boxes, the walk around a new neighbourhood. Turn that beginning into a framed 3D map of the place they now call home. Choose their address, frame the surrounding streets and preview the design before ordering.",
				geography: "Keep the new home near the centre and include enough of the neighbourhood to give it context. Try a closer zoom if the building feels too small.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			},
			sv: {
				title: "Inflyttningspresent: 3D-karta över det nya hemmet | dearplace.studio",
				description: "En inflyttningspresent av deras nya adress. Välj ditt utsnitt, färger och ram. Se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "En inflyttningspresent av deras nya adress",
				intro: "Nycklarna, de första flyttlådorna, promenaden i ett nytt kvarter. Gör början till en inramad 3D-karta över platsen de nu kallar hemma. Välj adressen, rama in gatorna runt omkring och förhandsvisa designen innan du beställer.",
				geography: "Placera det nya hemmet nära mitten och ta med tillräckligt av kvarteret för att ge det ett sammanhang. Prova att zooma in om huset känns för litet.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			}
		}
	},
	{
		id: "wedding",
		slug: {
			en: "wedding-anniversary-gift",
			sv: "brollopspresent"
		},
		relatedCities: [
			"stockholm",
			"copenhagen",
			"oslo"
		],
		relatedOccasions: ["hometown", "housewarming"],
		copy: {
			en: {
				title: "Wedding & Anniversary Gift: 3D Map of the Place | dearplace.studio",
				description: "A wedding gift with a place at its heart. Choose your area, colours and frame. Preview your design before ordering. Made in Gothenburg.",
				h1: "A wedding gift with a place at its heart",
				intro: "Where you met. The home you shared. The place you said yes. A custom 3D map turns one meaningful location into something you can see every day, with a palette and frame chosen for your home.",
				geography: "Choose one place that tells your story rather than trying to fit every memory into the frame. Preview the surrounding streets and make sure the location is easy to recognise.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			},
			sv: {
				title: "Bröllops- och årsdagspresent: 3D-karta över platsen | dearplace.studio",
				description: "En bröllopspresent med en plats i centrum. Välj ditt utsnitt, färger och ram. Se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "En bröllopspresent med en plats i centrum",
				intro: "Där ni möttes. Hemmet ni delade. Platsen där ni sa ja. En personlig 3D-karta gör en betydelsefull plats till något ni kan se varje dag, med färger och ram som passar ert hem.",
				geography: "Välj en plats som berättar er historia i stället för att försöka få med alla minnen. Förhandsvisa gatorna runt omkring och kontrollera att platsen går att känna igen.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			}
		}
	},
	{
		id: "hometown",
		slug: {
			en: "hometown-gift",
			sv: "present-fran-hemstaden"
		},
		relatedCities: [
			"gothenburg",
			"stockholm",
			"bergen"
		],
		relatedOccasions: ["moving-away", "wedding"],
		copy: {
			en: {
				title: "Hometown Gift: A 3D Map of Where They Grew Up | dearplace.studio",
				description: "A little of home, wherever life takes you. Choose your area, colours and frame. Preview your design before ordering. Made in Gothenburg.",
				h1: "A little of home, wherever life takes you",
				intro: "The street you grew up on, the route to school, the neighbourhood you still know by heart. Create a 3D map of your hometown that holds the everyday places behind the bigger memories.",
				geography: "Start at a familiar address and move the frame to include the nearby streets that matter. A focused neighbourhood usually tells a more personal story than a broad city view.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			},
			sv: {
				title: "Present från hemstaden: 3D-karta över uppväxten | dearplace.studio",
				description: "Lite av hemma, vart livet än tar dig. Välj ditt utsnitt, färger och ram. Se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "Lite av hemma, vart livet än tar dig",
				intro: "Gatan där du växte upp, vägen till skolan, kvarteret du fortfarande kan utantill. Skapa en 3D-karta över hemstaden som samlar vardagsplatserna bakom de stora minnena.",
				geography: "Börja vid en välbekant adress och flytta rutan så att gatorna som betyder något kommer med. Ett avgränsat kvarter berättar ofta mer än en stor vy över staden.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			}
		}
	},
	{
		id: "summer-house",
		slug: {
			en: "summer-house-memory",
			sv: "sommarstugan"
		},
		relatedCities: [
			"bergen",
			"helsinki",
			"stockholm"
		],
		relatedOccasions: ["hometown", "wedding"],
		copy: {
			en: {
				title: "Summer House Map: The Place You Return To | dearplace.studio",
				description: "Your summer house, made into a 3D map. Choose your area, colours and frame. Preview your design before ordering. Made in Gothenburg.",
				h1: "Your summer house, made into a 3D map",
				intro: "The road down to the water. The bend in the shoreline. The house you return to each summer. Turn your summer place into a framed 3D map, with room for the landscape that makes it yours.",
				geography: "Search for the summer house or a nearby place, then move the frame to balance the house with water, roads and surrounding land. Try different zoom levels: a closer view may make a small building easier to see, while a wider view tells more of the landscape.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			},
			sv: {
				title: "Sommarstugan som 3D-karta | dearplace.studio",
				description: "Din sommarstuga som personlig 3D-karta. Välj ditt utsnitt, färger och ram. Se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "Din sommarstuga som personlig 3D-karta",
				intro: "Vägen ner till vattnet. Strandens krök. Huset du återvänder till varje sommar. Gör ditt sommarställe till en inramad 3D-karta med plats för landskapet som gör det till ditt.",
				geography: "Sök efter sommarstugan eller en plats i närheten och flytta sedan rutan för att balansera huset med vatten, vägar och marken runt omkring. Prova olika zoomnivåer: ett närmare utsnitt kan göra ett litet hus tydligare, medan ett större visar mer av landskapet.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			}
		}
	},
	{
		id: "moving-away",
		slug: {
			en: "gift-for-someone-moving-away",
			sv: "flyttpresent"
		},
		relatedCities: [
			"stockholm",
			"malmo",
			"helsinki"
		],
		relatedOccasions: ["housewarming", "hometown"],
		copy: {
			en: {
				title: "Leaving Gift: A 3D Map of the City They're Leaving | dearplace.studio",
				description: "A leaving gift that brings their old neighbourhood along. Choose your area, colours and frame. Preview your design before ordering. Made in Gothenburg.",
				h1: "A leaving gift that brings their old neighbourhood along",
				intro: "A new chapter does not have to mean leaving every familiar street behind. Give a framed 3D map of the neighbourhood they are moving from—a reminder of the walks, homes and everyday places that made it theirs.",
				geography: "Choose the area they actually spent time in: their block, a favourite walk or the streets around work. Centre the frame on that place and check the preview before ordering.",
				detail: "Your map is built from available map and elevation data and made to order in Gothenburg. Choose 20 × 20 or 25 × 25 cm, White, Polar or Forest, and a white, black or oak frame. Detail varies by location and zoom: check the buildings, water and framing in your preview before adding the map to your cart.",
				faq: [
					{
						q: "Can I choose my own address and area?",
						a: "Yes. Search for the place and move the map until the area you want sits inside the frame. Adjust the zoom and generate a preview to check the composition."
					},
					{
						q: "Will every building and detail be included?",
						a: "That depends on the available map data and the scale of your chosen area. Small buildings and details may be simplified or missing. Check that the features that matter to you appear in the preview before ordering."
					},
					{
						q: "When is the map made and shipped?",
						a: "Your map is made to order in Gothenburg. Allow 2 working days for production, followed by shipping. We deliver within Sweden. See the shipping page for delivery details."
					}
				]
			},
			sv: {
				title: "Flyttpresent: 3D-karta över staden de lämnar | dearplace.studio",
				description: "En flyttpresent som tar med det gamla kvarteret. Välj ditt utsnitt, färger och ram. Se din förhandsvisning före beställning. Tillverkad i Göteborg.",
				h1: "En flyttpresent som tar med det gamla kvarteret",
				intro: "Ett nytt kapitel behöver inte betyda att alla välbekanta gator lämnas kvar. Ge en inramad 3D-karta över området de flyttar från, som ett minne av promenaderna, hemmen och vardagsplatserna som gjorde det till deras.",
				geography: "Välj området där de faktiskt tillbringade tid: kvarteret, favoritpromenaden eller gatorna runt jobbet. Centrera rutan där och kontrollera förhandsvisningen innan du beställer.",
				detail: "Din karta skapas från tillgängliga kart- och höjddata och tillverkas på beställning i Göteborg. Välj 20 × 20 eller 25 × 25 cm, White, Polar eller Forest och vit, svart eller ekfärgad ram. Detaljerna varierar med plats och zoom: kontrollera byggnader, vatten och utsnitt i förhandsvisningen innan du lägger kartan i varukorgen.",
				faq: [
					{
						q: "Kan jag välja en egen adress och ett eget utsnitt?",
						a: "Ja. Sök efter platsen och flytta kartan så att området du vill ha hamnar i rutan. Justera zoomen och skapa en förhandsvisning för att kontrollera utsnittet."
					},
					{
						q: "Kommer alla hus och detaljer med?",
						a: "Det beror på tillgängliga kartdata och utsnittets skala. Små byggnader och detaljer kan förenklas eller saknas. Kontrollera att det som är viktigt för dig syns i förhandsvisningen innan du beställer."
					},
					{
						q: "När tillverkas och skickas kartan?",
						a: "Kartan tillverkas på beställning i Göteborg. Räkna med 2 arbetsdagars produktion, därefter transport. Vi levererar inom Sverige. Läs fraktsidan för leveransinformation."
					}
				]
			}
		}
	}
], Ld = {
	home: {
		en: "/",
		sv: "/sv"
	},
	configurator: {
		en: "/pages/configurator",
		sv: "/sv/pages/configurator"
	},
	inspiration: {
		en: "/pages/inspiration",
		sv: "/sv/pages/inspiration"
	},
	shipping: {
		en: "/pages/shipping",
		sv: "/sv/pages/shipping"
	},
	returns: {
		en: "/pages/returns",
		sv: "/sv/pages/returns"
	},
	privacy: {
		en: "/pages/privacy",
		sv: "/sv/pages/privacy"
	},
	cookies: {
		en: "/pages/cookies",
		sv: "/sv/pages/cookies"
	},
	terms: {
		en: "/pages/terms",
		sv: "/sv/pages/terms"
	}
}, Rd = {
	en: "/custom-3d-map",
	sv: "/sv/personlig-3d-karta"
}, zd = {
	en: "/gifts",
	sv: "/sv/present"
};
function Bd(e, t) {
	return Ld[e][t];
}
function Vd(e, t) {
	return `${Rd[t]}/${e}`;
}
function Hd(e, t) {
	return `${zd[t]}/${e}`;
}
//#endregion
//#region src/components/pages/InspirationPage.tsx
function Ud() {
	let { t: e, lang: t } = x(), n = Fd.filter((e) => e.slug[t] && e.copy[t]), r = Id.filter((e) => e.slug[t] && e.copy[t]);
	return /* @__PURE__ */ (0, I.jsxs)("div", {
		className: "mx-auto w-full max-w-5xl px-5 py-10 sm:py-14",
		children: [
			/* @__PURE__ */ (0, I.jsx)("h1", {
				className: "font-display text-3xl font-light sm:text-4xl",
				children: e("insp.h1")
			}),
			/* @__PURE__ */ (0, I.jsx)("p", {
				className: "mt-3 max-w-2xl text-base leading-relaxed text-muted-foreground",
				children: e("insp.intro")
			}),
			/* @__PURE__ */ (0, I.jsxs)("section", {
				className: "mt-10",
				children: [/* @__PURE__ */ (0, I.jsx)("h2", {
					className: "font-display text-xl font-medium",
					children: e("insp.cities")
				}), /* @__PURE__ */ (0, I.jsx)("ul", {
					className: "mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3",
					children: n.map((e) => /* @__PURE__ */ (0, I.jsx)("li", { children: /* @__PURE__ */ (0, I.jsxs)(Pd, {
						to: Vd(e.slug[t], t),
						className: "block h-full rounded-xl border border-border/70 p-4 transition-colors hover:bg-secondary/50",
						children: [/* @__PURE__ */ (0, I.jsx)("span", {
							className: "font-display text-base",
							children: e.copy[t].h1
						}), /* @__PURE__ */ (0, I.jsx)("span", {
							className: "mt-1 block text-sm text-muted-foreground",
							children: e.copy[t].description
						})]
					}) }, e.id))
				})]
			}),
			/* @__PURE__ */ (0, I.jsxs)("section", {
				className: "mt-12",
				children: [/* @__PURE__ */ (0, I.jsx)("h2", {
					className: "font-display text-xl font-medium",
					children: e("insp.occasions")
				}), /* @__PURE__ */ (0, I.jsx)("ul", {
					className: "mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-3",
					children: r.map((e) => /* @__PURE__ */ (0, I.jsx)("li", { children: /* @__PURE__ */ (0, I.jsxs)(Pd, {
						to: Hd(e.slug[t], t),
						className: "block h-full rounded-xl border border-border/70 p-4 transition-colors hover:bg-secondary/50",
						children: [/* @__PURE__ */ (0, I.jsx)("span", {
							className: "font-display text-base",
							children: e.copy[t].h1
						}), /* @__PURE__ */ (0, I.jsx)("span", {
							className: "mt-1 block text-sm text-muted-foreground",
							children: e.copy[t].description
						})]
					}) }, e.id))
				})]
			}),
			/* @__PURE__ */ (0, I.jsx)("p", {
				className: "mt-12 text-sm text-muted-foreground",
				children: /* @__PURE__ */ (0, I.jsx)(Pd, {
					to: Bd("configurator", t),
					className: "underline hover:text-foreground",
					children: e("land.cta")
				})
			})
		]
	});
}
var Wd = {
	version: 1,
	asset_id: "2a8b6b37-9200-48fb-8901-66ac9c0c4d41",
	project_id: "9ee69a02-3870-4aa9-b8ae-aa6172fe39fa",
	url: "https://dearplace.studio/__l5e/assets-v1/2a8b6b37-9200-48fb-8901-66ac9c0c4d41/hero-cover.jpg",
	r2_key: "a/v1/9ee69a02-3870-4aa9-b8ae-aa6172fe39fa/2a8b6b37-9200-48fb-8901-66ac9c0c4d41/hero-cover.jpg",
	original_filename: "hero-cover.jpg",
	size: 2496530,
	content_type: "image/jpeg",
	created_at: "2026-08-17T14:37:06Z"
}, Gd = {
	version: 1,
	asset_id: "a56af515-a44c-4366-9f2d-efcb38857543",
	project_id: "9ee69a02-3870-4aa9-b8ae-aa6172fe39fa",
	url: "https://dearplace.studio/__l5e/assets-v1/a56af515-a44c-4366-9f2d-efcb38857543/gal1.jpg",
	r2_key: "a/v1/9ee69a02-3870-4aa9-b8ae-aa6172fe39fa/a56af515-a44c-4366-9f2d-efcb38857543/gal1.jpg",
	original_filename: "gal1.jpg",
	size: 170348,
	content_type: "image/jpeg",
	created_at: "2026-08-16T08:55:11Z"
}, Kd = {
	version: 1,
	asset_id: "1e978ac6-4156-4c36-9d2f-fb11e7b55286",
	project_id: "9ee69a02-3870-4aa9-b8ae-aa6172fe39fa",
	url: "https://dearplace.studio/__l5e/assets-v1/1e978ac6-4156-4c36-9d2f-fb11e7b55286/city-model-living.png",
	r2_key: "a/v1/9ee69a02-3870-4aa9-b8ae-aa6172fe39fa/1e978ac6-4156-4c36-9d2f-fb11e7b55286/city-model-living.png",
	original_filename: "city-model-living.png",
	size: 2090911,
	content_type: "image/png",
	created_at: "2026-08-18T19:49:41Z"
};
//#endregion
//#region src/components/pages/LandingPage.tsx
function qd({ copy: e, storyId: t, place: n, relatedCities: r, relatedOccasions: i }) {
	let { t: a, lang: o } = x(), c = document.getElementById("dearplace-app")?.dataset.storyImages?.split(",") ?? [], l = c[{
		"summer-house": 0,
		wedding: 1,
		housewarming: 2,
		hometown: 0,
		"moving-away": 4,
		gothenburg: 3,
		malmo: 2,
		copenhagen: 1,
		helsinki: 4,
		bergen: 3
	}[t ?? ""] ?? 0] || Wd.url, f = document.getElementById("dearplace-app")?.dataset.detailImage || Gd.url, p = Bd("configurator", o), m = n?.city ? {
		city: n.city,
		country: n.country
	} : void 0, h = r.map((e) => Fd.find((t) => t.id === e)).filter((e) => !!(e && e.slug[o] && e.copy[o])), g = i.map((e) => Id.find((t) => t.id === e)).filter((e) => !!(e && e.slug[o] && e.copy[o])), y = d.filter((e) => !u.includes(e));
	return /* @__PURE__ */ (0, I.jsxs)("article", {
		className: "mx-auto w-full max-w-5xl px-5 py-8 sm:py-12",
		children: [
			/* @__PURE__ */ (0, I.jsx)("nav", {
				"aria-label": "Breadcrumb",
				className: "text-xs text-muted-foreground",
				children: /* @__PURE__ */ (0, I.jsxs)("ol", {
					className: "flex flex-wrap items-center gap-1.5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: /* @__PURE__ */ (0, I.jsx)(Pd, {
							to: Bd("home", o),
							className: "hover:text-foreground",
							children: a("land.breadcrumb.home")
						}) }),
						/* @__PURE__ */ (0, I.jsx)("li", {
							"aria-hidden": "true",
							children: "/"
						}),
						/* @__PURE__ */ (0, I.jsx)("li", { children: /* @__PURE__ */ (0, I.jsx)(Pd, {
							to: Bd("inspiration", o),
							className: "hover:text-foreground",
							children: a("land.breadcrumb.inspiration")
						}) }),
						/* @__PURE__ */ (0, I.jsx)("li", {
							"aria-hidden": "true",
							children: "/"
						}),
						/* @__PURE__ */ (0, I.jsx)("li", {
							"aria-current": "page",
							className: "text-foreground",
							children: e.h1
						})
					]
				})
			}),
			/* @__PURE__ */ (0, I.jsxs)("header", {
				className: "mt-6 grid gap-8 lg:grid-cols-[1.1fr_1fr] lg:items-center",
				children: [/* @__PURE__ */ (0, I.jsxs)("div", { children: [
					/* @__PURE__ */ (0, I.jsx)("h1", {
						className: "font-display text-3xl font-light leading-tight sm:text-4xl",
						children: e.h1
					}),
					/* @__PURE__ */ (0, I.jsx)("p", {
						className: "mt-4 text-base leading-relaxed text-muted-foreground",
						children: e.intro
					}),
					/* @__PURE__ */ (0, I.jsxs)(Pd, {
						to: p,
						...m ? { search: m } : {},
						onClick: () => j("landing_hero"),
						className: "mt-6 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-medium text-primary-foreground transition-opacity hover:opacity-90",
						children: [a("land.cta"), /* @__PURE__ */ (0, I.jsx)(rr, {
							className: "h-4 w-4",
							"aria-hidden": "true"
						})]
					}),
					/* @__PURE__ */ (0, I.jsx)("p", {
						className: "mt-2 text-xs text-muted-foreground",
						children: a("land.cta.note")
					})
				] }), /* @__PURE__ */ (0, I.jsx)("img", {
					src: l,
					alt: o === "sv" ? "Inramade 3D-kartor som inredningsinspiration" : "Framed 3D maps shown as styling inspiration",
					width: 1656,
					height: 1104,
					className: "w-full rounded-2xl object-cover"
				})]
			}),
			/* @__PURE__ */ (0, I.jsx)("p", {
				className: "mt-3 text-xs text-muted-foreground",
				children: o === "sv" ? "Bilderna visar inredningsinspiration. Din karta skapas utifrån platsen du väljer." : "Images show styling inspiration. Your map is created from the place you choose."
			}),
			/* @__PURE__ */ (0, I.jsxs)("section", {
				className: "mt-12 grid gap-8 sm:grid-cols-2",
				children: [/* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("h2", {
					className: "font-display text-xl font-medium",
					children: a("land.geo.title")
				}), /* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-3 text-sm leading-relaxed text-muted-foreground",
					children: e.geography
				})] }), /* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("h2", {
					className: "font-display text-xl font-medium",
					children: a("land.detail.title")
				}), /* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-3 text-sm leading-relaxed text-muted-foreground",
					children: e.detail
				})] })]
			}),
			/* @__PURE__ */ (0, I.jsxs)("section", {
				className: "mt-12",
				children: [/* @__PURE__ */ (0, I.jsx)("h2", {
					className: "font-display text-xl font-medium",
					children: a("land.how.title")
				}), /* @__PURE__ */ (0, I.jsx)("ol", {
					className: "mt-4 grid gap-3 sm:grid-cols-3",
					children: [
						"land.how.1",
						"land.how.2",
						"land.how.3"
					].map((e, t) => /* @__PURE__ */ (0, I.jsxs)("li", {
						className: "rounded-xl border border-border/70 p-4 text-sm text-muted-foreground",
						children: [
							/* @__PURE__ */ (0, I.jsxs)("span", {
								className: "font-display text-foreground",
								children: [t + 1, "."]
							}),
							" ",
							a(e)
						]
					}, e))
				})]
			}),
			/* @__PURE__ */ (0, I.jsxs)("section", {
				className: "mt-12 grid gap-8 lg:grid-cols-[1fr_1fr] lg:items-center",
				children: [/* @__PURE__ */ (0, I.jsx)("img", {
					src: f,
					alt: o === "sv" ? "Närbild på tryckta husvolymer och gatunät i en 3D-karta" : "Close-up of printed building volumes and street grid in a 3D map",
					width: 1408,
					height: 1408,
					loading: "lazy",
					className: "w-full rounded-2xl object-cover"
				}), /* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("h2", {
					className: "font-display text-xl font-medium",
					children: a("land.specs.title")
				}), /* @__PURE__ */ (0, I.jsxs)("dl", {
					className: "mt-4 space-y-4 text-sm",
					children: [
						/* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("dt", {
							className: "font-medium",
							children: a("land.specs.sizes")
						}), /* @__PURE__ */ (0, I.jsx)("dd", {
							className: "text-muted-foreground",
							children: y.map((e) => `${e} (${s(e, "City", 1, o)})`).join(" · ")
						})] }),
						/* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("dt", {
							className: "font-medium",
							children: a("land.specs.frames")
						}), /* @__PURE__ */ (0, I.jsx)("dd", {
							className: "text-muted-foreground",
							children: _.map((e) => a(`base.${e}`)).join(" · ")
						})] }),
						/* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("dt", {
							className: "font-medium",
							children: a("land.specs.palettes")
						}), /* @__PURE__ */ (0, I.jsx)("dd", {
							className: "text-muted-foreground",
							children: v.map((e) => a(`theme.${e.id}`)).join(" · ")
						})] }),
						/* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("dt", {
							className: "font-medium",
							children: a("land.specs.delivery")
						}), /* @__PURE__ */ (0, I.jsxs)("dd", {
							className: "text-muted-foreground",
							children: [
								a("land.specs.delivery.body"),
								" ",
								/* @__PURE__ */ (0, I.jsx)(Pd, {
									to: Bd("shipping", o),
									className: "underline hover:text-foreground",
									children: a("footer.shipping")
								})
							]
						})] })
					]
				})] })]
			}),
			/* @__PURE__ */ (0, I.jsxs)("section", {
				className: "mt-12",
				children: [/* @__PURE__ */ (0, I.jsx)("h2", {
					className: "font-display text-xl font-medium",
					children: a("land.gallery.title")
				}), /* @__PURE__ */ (0, I.jsx)("img", {
					src: c[3] || Kd.url,
					alt: o === "sv" ? "Dear Place-kartor på en färgglad tavelvägg" : "Dear Place maps on a colourful gallery wall",
					width: 1408,
					height: 1056,
					loading: "lazy",
					className: "mt-4 w-full rounded-2xl object-cover"
				})]
			}),
			/* @__PURE__ */ (0, I.jsxs)("section", {
				className: "mt-12",
				children: [/* @__PURE__ */ (0, I.jsx)("h2", {
					className: "font-display text-xl font-medium",
					children: a("land.faq.title")
				}), /* @__PURE__ */ (0, I.jsx)(yd, {
					type: "single",
					collapsible: !0,
					className: "mt-3",
					children: e.faq.map((e) => /* @__PURE__ */ (0, I.jsxs)(Q, {
						value: e.q,
						children: [/* @__PURE__ */ (0, I.jsx)(bd, {
							className: "text-left text-sm",
							children: e.q
						}), /* @__PURE__ */ (0, I.jsx)(xd, {
							className: "text-sm text-muted-foreground",
							children: e.a
						})]
					}, e.q))
				})]
			}),
			(h.length > 0 || g.length > 0) && /* @__PURE__ */ (0, I.jsxs)("section", {
				className: "mt-12 grid gap-8 sm:grid-cols-2",
				children: [h.length > 0 && /* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("h2", {
					className: "font-display text-xl font-medium",
					children: a("land.related.cities")
				}), /* @__PURE__ */ (0, I.jsx)("ul", {
					className: "mt-3 space-y-2 text-sm",
					children: h.map((e) => /* @__PURE__ */ (0, I.jsx)("li", { children: /* @__PURE__ */ (0, I.jsxs)(Pd, {
						to: Vd(e.slug[o], o),
						className: "inline-flex items-center gap-2 text-muted-foreground hover:text-foreground",
						children: [/* @__PURE__ */ (0, I.jsx)(ir, {
							className: "h-3.5 w-3.5",
							"aria-hidden": "true"
						}), e.copy[o].h1]
					}) }, e.id))
				})] }), g.length > 0 && /* @__PURE__ */ (0, I.jsxs)("div", { children: [/* @__PURE__ */ (0, I.jsx)("h2", {
					className: "font-display text-xl font-medium",
					children: a("land.related.occasions")
				}), /* @__PURE__ */ (0, I.jsx)("ul", {
					className: "mt-3 space-y-2 text-sm",
					children: g.map((e) => /* @__PURE__ */ (0, I.jsx)("li", { children: /* @__PURE__ */ (0, I.jsxs)(Pd, {
						to: Hd(e.slug[o], o),
						className: "inline-flex items-center gap-2 text-muted-foreground hover:text-foreground",
						children: [/* @__PURE__ */ (0, I.jsx)(ir, {
							className: "h-3.5 w-3.5",
							"aria-hidden": "true"
						}), e.copy[o].h1]
					}) }, e.id))
				})] })]
			}),
			/* @__PURE__ */ (0, I.jsxs)("div", {
				className: "mt-14 rounded-2xl bg-secondary/50 p-8 text-center",
				children: [/* @__PURE__ */ (0, I.jsx)("p", {
					className: "font-display text-xl font-light",
					children: e.h1
				}), /* @__PURE__ */ (0, I.jsxs)(Pd, {
					to: p,
					...m ? { search: m } : {},
					onClick: () => j("landing_footer"),
					className: "mt-4 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-medium text-primary-foreground transition-opacity hover:opacity-90",
					children: [a("land.cta"), /* @__PURE__ */ (0, I.jsx)(rr, {
						className: "h-4 w-4",
						"aria-hidden": "true"
					})]
				})]
			})
		]
	});
}
//#endregion
//#region src/components/CookieConsent.tsx
var Jd = () => document.querySelector(".dp-cookie-settings")?.click();
//#endregion
//#region src/components/LegalPage.tsx
function Yd({ title: e, updated: t, sections: n }) {
	let { t: r } = x();
	return /* @__PURE__ */ (0, I.jsxs)("article", {
		className: "mx-auto w-full max-w-3xl px-5 py-12",
		children: [
			/* @__PURE__ */ (0, I.jsx)("h1", {
				className: "font-display text-3xl font-light sm:text-4xl",
				children: e
			}),
			/* @__PURE__ */ (0, I.jsx)("p", {
				className: "mt-2 text-xs uppercase tracking-[0.2em] text-muted-foreground",
				children: t
			}),
			/* @__PURE__ */ (0, I.jsx)("div", {
				className: "mt-8 space-y-8",
				children: n.map((e) => /* @__PURE__ */ (0, I.jsxs)("section", { children: [/* @__PURE__ */ (0, I.jsx)("h2", {
					className: "font-display text-lg font-medium",
					children: e.heading
				}), /* @__PURE__ */ (0, I.jsx)("div", {
					className: "mt-2 space-y-3 text-sm leading-relaxed text-muted-foreground",
					children: e.body
				})] }, e.heading))
			}),
			/* @__PURE__ */ (0, I.jsx)("button", {
				type: "button",
				onClick: () => {
					ie("cookie_settings_open", { placement: "legal_page" }), Jd();
				},
				className: "mt-10 rounded-full border border-border px-4 py-2 text-sm hover:bg-secondary",
				children: r("footer.cookieSettings")
			})
		]
	});
}
//#endregion
//#region src/components/pages/PrivacyPage.tsx
function Xd() {
	let { lang: e } = x(), t = e === "sv", n = t ? [
		{
			heading: "1. Personuppgiftsansvarig",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Curt & Co AB är personuppgiftsansvarigt för den behandling av personuppgifter som beskrivs i denna policy." }),
				/* @__PURE__ */ (0, I.jsxs)("p", {
					className: "not-italic",
					children: [
						"Curt & Co AB",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Organisationsnummer: 559040-8075",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Momsregistreringsnummer: ",
						G.vatNumber,
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Bäckegatan 30 B",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"413 16 Göteborg",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Sverige",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Varumärke och webbplats: ",
						G.tradingName,
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"E-post:",
						" ",
						/* @__PURE__ */ (0, I.jsx)("a", {
							href: `mailto:${G.email}`,
							className: "underline hover:text-foreground",
							children: G.email
						})
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi har inte utsett något dataskyddsombud eftersom verksamheten inte omfattas av något sådant krav. Frågor om personuppgifter skickas till adressen ovan." })
			] })
		},
		{
			heading: "2. När policyn gäller",
			body: /* @__PURE__ */ (0, I.jsxs)("p", { children: [
				"Policyn gäller när du besöker ",
				G.tradingName,
				", använder konfiguratorn, skapar eller begär en förhandsvisning, lägger en produkt i varukorgen, genomför ett köp, kontaktar vår support eller använder chatten, samtycker till statistik eller marknadsföring, eller prenumererar på marknadsföring."
			] })
		},
		{
			heading: "3. Personuppgifter vi behandlar",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "font-medium",
					children: "Kontakt- och kunduppgifter"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi kan behandla namn, e-postadress, telefonnummer, leveransadress, fakturaadress, land och uppgifter som du lämnar när du kontaktar oss." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Beställningsuppgifter"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi behandlar uppgifter om ordernummer, valda produkter, pris, betalningsstatus, leveranssätt, spårningsinformation, returer, reklamationer och kundkommunikation." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Din konfiguration"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "När du använder konfiguratorn kan vi behandla:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "sökt plats och platsnamn," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "koordinater och geografisk beskärning," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "storlek, färg och ram," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "eventuell gravyrtext," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "modell- och förhandsvisningsbilder," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "tekniska identifierare för din design," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "länkar till konfiguratorn och varukorgen." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "En vald plats kan vara en bostadsadress eller annan plats som är betydelsefull för dig. Vi behandlar uppgiften endast för de ändamål som anges i denna policy." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Betalningsuppgifter"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Betalningen hanteras av Shopify och den betalningsleverantör du väljer, exempelvis kortleverantör, Klarna, Shop Pay, Google Pay eller Apple Pay." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "DearPlace lagrar inte fullständiga kortnummer eller säkerhetskoder. Vi kan få information om betalningssätt, betalningsstatus, belopp och transaktionsreferens." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Teknisk information"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "När du använder webbplatsen kan vi behandla IP-adress, webbläsare, enhetstyp, operativsystem, språk, ungefärligt land, datum och tid, hänvisande sida, säkerhetsloggar och tekniska fel." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Viss teknisk information behöver behandlas även utan analyssamtycke för att webbplatsen ska kunna levereras och skyddas." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Statistikuppgifter"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om du godkänner statistik kan vi behandla information om sidvisningar, klick, sessioner, användning av konfiguratorn, skapade förhandsvisningar, varukorgshändelser och teknisk prestanda." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Efter analyssamtycke kan en e-postadress som anges för en förhandsvisning kopplas till produktstatistik i PostHog." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Marknadsföringsuppgifter"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om du godkänner marknadsföring kan vi behandla kampanjparametrar, Metas klickidentifierare, annonsinteraktioner, besökaridentifierare, produktinformation, varukorgshändelser och köpdata." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Meta Conversions API kan behandla en e-postadress i hashad form för mätning och matchning." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Chatt och support"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "När du kontaktar oss behandlar vi ditt meddelande, dina kontaktuppgifter, information om ärendet och relevant order- eller konfigurationsinformation." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Chatten bemannas av människor. Vi använder inte Crisps AI-agent för att besvara kundärenden." })
			] })
		},
		{
			heading: "4. Varifrån uppgifterna kommer",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "Vi samlar huvudsakligen in uppgifter direkt från dig, automatiskt från din webbläsare eller enhet, från Shopify och den betalningsleverantör du väljer, från PostNord i samband med leverans, från analys- och annonsplattformar om du har samtyckt, och från Mapbox när du använder plats- och adressökningen." })
		},
		{
			heading: "5. Varför vi behandlar uppgifterna",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("div", {
				className: "overflow-x-auto",
				children: /* @__PURE__ */ (0, I.jsxs)("table", {
					className: "w-full text-left text-sm",
					children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
						className: "border-b border-border",
						children: [
							/* @__PURE__ */ (0, I.jsx)("th", {
								className: "py-2 pr-4 font-medium",
								children: "Ändamål"
							}),
							/* @__PURE__ */ (0, I.jsx)("th", {
								className: "py-2 pr-4 font-medium",
								children: "Uppgifter"
							}),
							/* @__PURE__ */ (0, I.jsx)("th", {
								className: "py-2 font-medium",
								children: "Rättslig grund"
							})
						]
					}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
						className: "text-muted-foreground",
						children: [
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Visa konfiguratorn och skapa en förhandsvisning"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Plats, koordinater, beskärning, produktval och tekniska uppgifter"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Åtgärder på din begäran innan avtal ingås samt berättigat intresse av att tillhandahålla tjänsten"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Skicka den förhandsvisning du har begärt"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "E-postadress och konfiguration"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Åtgärder på din begäran innan avtal ingås"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Hantera beställning, betalning, produktion och leverans"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Kund-, order-, betalnings-, konfigurations- och leveransuppgifter"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Fullgörande av avtal"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Tillverka kartan internt i Göteborg"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Konfiguration, modellfiler och orderuppgifter"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Fullgörande av avtal"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Hantera support, reklamationer och tvister"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Kontakt-, order- och ärendeuppgifter"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Fullgörande av avtal, rättslig förpliktelse och berättigat intresse av att fastställa och försvara rättsliga anspråk"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Bokföring och skatteredovisning"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Faktura-, betalnings- och orderuppgifter"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Rättslig förpliktelse"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Förebygga bedrägerier och skydda webbplatsen"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "IP-adress, säkerhetsloggar, enhets- och transaktionsuppgifter"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Berättigat intresse av säkerhet och bedrägeribekämpning"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Kundchatt"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Kontaktuppgifter, meddelanden och teknisk sessionsinformation"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Åtgärder på din begäran samt berättigat intresse av att ge kundsupport"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Statistik och förbättring av webbplatsen"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Användnings-, sessions- och analysuppgifter"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Samtycke"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Annonsmätning och målgrupper hos Meta"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Marknadsförings-, kampanj-, produkt- och händelsedata"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Samtycke"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", { children: [
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "Marknadsföringsmejl och köpdrivande påminnelser"
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "E-postadress, konfiguration och marknadsföringshistorik"
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2",
									children: "Samtycke"
								})
							] })
						]
					})]
				})
			}), /* @__PURE__ */ (0, I.jsx)("p", {
				className: "mt-4",
				children: "När behandlingen grundas på berättigat intresse har vi bedömt att behandlingen är nödvändig och att vårt intresse inte väger tyngre än dina rättigheter och intressen."
			})] })
		},
		{
			heading: "6. Förhandsvisningar och mejl",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "När du anger din e-postadress för att få en förhandsvisning använder vi adressen för att skicka den förhandsvisning du uttryckligen har begärt och nödvändig information om leveransen av den." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Att begära en förhandsvisning innebär inte i sig att du har samtyckt till nyhetsbrev, övergiven-varukorgsmejl eller andra köpdrivande påminnelser." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Sådana marknadsföringsmejl skickas endast om du har lämnat ett separat giltigt samtycke eller om utskicket annars uttryckligen är tillåtet enligt lag." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Varje marknadsföringsmejl innehåller en tydlig möjlighet att avregistrera sig. Om du invänder mot direktmarknadsföring upphör vi med den utan dröjsmål." })
			] })
		},
		{
			heading: "7. Mottagare och leverantörer",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi lämnar endast ut uppgifter när det behövs för ett angivet ändamål." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Shopify International Limited"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Shopify tillhandahåller butik, varukorg, kassa, orderhantering och betalningsfunktioner. Shopify och dess koncernbolag eller underleverantörer kan behandla kund-, order-, enhets- och transaktionsuppgifter." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Shopify International Limited är den huvudsakliga avtalsparten för handlare inom EES." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Betalningsleverantörer"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Den betalningsleverantör du väljer behandlar uppgifter som krävs för att genomföra betalningen, förebygga bedrägerier och uppfylla rättsliga krav." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Leverantören kan agera som självständigt personuppgiftsansvarig för delar av behandlingen." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Supabase, Inc."
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Supabase används för databas- och backendfunktioner, bland annat hantering av konfigurationer, förhandsvisningar, tekniska modellidentifierare och leaduppgifter." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Mapbox, Inc."
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Mapbox används för plats- och adressökning. Sökningar, koordinater, IP-adress och teknisk information kan överföras till Mapbox när du använder kartfunktionen." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "PostNord"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "PostNord behandlar namn, adress, kontaktuppgifter, leveransuppgifter och spårningsinformation för att leverera beställningen inom Sverige." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Klaviyo, Inc."
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Klaviyo används för att skicka begärda förhandsvisningar och, när ett giltigt samtycke finns, marknadsföringsmejl och påminnelser." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Google Ireland Limited"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Google Analytics 4 används efter analyssamtycke. Google Fonts används för att visa webbplatsens typsnitt och kan behandla IP-adress och teknisk information när typsnitten hämtas." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "PostHog"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "PostHog används efter analyssamtycke för produkt- och användningsstatistik. Behandlingen är konfigurerad till PostHogs EU-miljö. Sessionsinspelning är avstängd." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Meta Platforms Ireland Limited"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Meta Pixel och Meta Conversions API används efter marknadsföringssamtycke för annonsmätning och målgrupper på Facebook och Instagram." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Crisp IM SAS"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Crisp tillhandahåller vår kundchatt. Tjänsten laddas när du väljer att öppna chatten. Crisp behandlar meddelanden och nödvändig teknisk sessionsinformation som personuppgiftsbiträde." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Lovable och Tinybird"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Dessa tjänster kan efter analyssamtycke behandla grundläggande teknisk webbstatistik och prestandainformation." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi kan även lämna uppgifter till myndigheter, domstolar, försäkringsbolag eller professionella rådgivare när det krävs enligt lag eller är nödvändigt för att fastställa, göra gällande eller försvara rättsliga anspråk." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Produktionen sker internt hos Curt & Co AB i Göteborg. Kunduppgifter lämnas inte till någon extern produktionspartner." })
			] })
		},
		{
			heading: "8. Överföringar utanför EU/EES",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vissa leverantörer eller deras underleverantörer kan behandla personuppgifter utanför EU/EES, bland annat i USA och Kanada." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "När personuppgifter överförs till ett land utanför EU/EES använder vi tillämpliga skyddsåtgärder, exempelvis:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "EU-kommissionens beslut om adekvat skyddsnivå," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "EU–USA:s ramverk för dataskydd när mottagaren omfattas av det," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "EU-kommissionens standardavtalsklausuler," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "andra lagliga överföringsmekanismer enligt GDPR." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Du kan kontakta oss för mer information om de skyddsåtgärder som gäller för en viss överföring." })
			] })
		},
		{
			heading: "9. Hur länge uppgifterna sparas",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi sparar inte personuppgifter längre än vad som behövs för respektive ändamål." }),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [/* @__PURE__ */ (0, I.jsx)("th", {
								className: "py-2 pr-4 font-medium",
								children: "Uppgift"
							}), /* @__PURE__ */ (0, I.jsx)("th", {
								className: "py-2 font-medium",
								children: "Normal lagringstid"
							})]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Förhandsvisning och e-postadress när inget köp genomförs"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Högst 90 dagar"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Uppgifter om en övergiven varukorg"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Högst 30 dagar efter senaste aktivitet"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Orderkonfiguration och modellunderlag"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "3 år efter leverans, eller längre om ett reklamationsärende fortfarande pågår"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Bokföringsunderlag"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "I enlighet med bokföringslagen, normalt till och med det sjunde året efter utgången av det kalenderår då räkenskapsåret avslutades"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Support- och chattärenden"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Normalt 12 månader efter avslutat ärende, eller längre om uppgifterna behövs för ett pågående krav"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Marknadsföringsuppgifter"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Tills samtycket återkallas, dock normalt högst 24 månader efter senaste aktivitet"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Spärrlista efter avregistrering"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Så länge det behövs för att säkerställa att inga nya marknadsföringsutskick skickas"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "GA4:s användar- och händelsedata"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Högst 14 månader"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Cookie- och samtyckesval"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Högst 12 månader"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", { children: [/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "Säkerhetsloggar"
								}), /* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2",
									children: "Så länge de behövs för säkerhet, felsökning eller rättsliga anspråk"
								})] })
							]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Aggregerade eller anonymiserade uppgifter som inte längre kan kopplas till en person kan sparas längre."
				})
			] })
		},
		{
			heading: "10. Dina rättigheter",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Beroende på omständigheterna har du rätt att:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "få information om hur vi behandlar dina uppgifter," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "få tillgång till dina personuppgifter," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "få felaktiga uppgifter rättade," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "begära att uppgifter raderas," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "begära att behandlingen begränsas," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "få ut vissa uppgifter i ett strukturerat och maskinläsbart format," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "invända mot behandling som grundas på berättigat intresse," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "återkalla ett lämnat samtycke." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Rätten till radering är inte absolut. Vi kan behöva behålla vissa uppgifter för exempelvis bokföring, reklamationer eller rättsliga anspråk." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Du har alltid rätt att invända mot direktmarknadsföring. När du gör det upphör vi med sådan behandling." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Återkallat samtycke påverkar inte lagligheten av behandling som redan har genomförts innan samtycket återkallades." }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Kontakta",
					" ",
					/* @__PURE__ */ (0, I.jsx)("a", {
						href: `mailto:${G.email}`,
						className: "underline hover:text-foreground",
						children: G.email
					}),
					" ",
					"för att utöva dina rättigheter. Vi besvarar normalt en begäran inom en månad. Vi kan behöva kontrollera din identitet innan uppgifter lämnas ut eller ändras."
				] })
			] })
		},
		{
			heading: "11. Automatiserat beslutsfattande och profilering",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi använder inte automatiserat beslutsfattande som medför rättsliga följder eller på liknande sätt påverkar dig betydligt." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Om du samtycker till marknadsföring kan Meta använda uppgifter för målgruppsanpassning och profilering av annonser. Du kan återkalla samtycket genom våra cookieinställningar." })] })
		},
		{
			heading: "12. Säkerhet",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi använder lämpliga tekniska och organisatoriska åtgärder för att skydda personuppgifter mot obehörig åtkomst, ändring, förlust och otillåten behandling." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Endast personer och leverantörer som behöver uppgifterna för sina arbetsuppgifter får tillgång till dem." })] })
		},
		{
			heading: "13. Klagomål",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Om du anser att vi behandlar dina personuppgifter felaktigt får du gärna kontakta oss först på",
					" ",
					/* @__PURE__ */ (0, I.jsx)("a", {
						href: `mailto:${G.email}`,
						className: "underline hover:text-foreground",
						children: G.email
					}),
					"."
				] }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Du har också rätt att lämna klagomål till:" }),
				/* @__PURE__ */ (0, I.jsxs)("p", {
					className: "not-italic",
					children: [
						"Integritetsskyddsmyndigheten",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Box 8114",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"104 20 Stockholm",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"www.imy.se"
					]
				})
			] })
		},
		{
			heading: "14. Ändringar av policyn",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi kan uppdatera policyn när våra tjänster, leverantörer eller rättsliga skyldigheter förändras." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Datumet högst upp visar när policyn senast uppdaterades. Vid väsentliga förändringar informerar vi på lämpligt sätt." })] })
		}
	] : [
		{
			heading: "1. Data controller",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Curt & Co AB is the data controller for the processing of personal data described in this policy." }),
				/* @__PURE__ */ (0, I.jsxs)("p", {
					className: "not-italic",
					children: [
						"Curt & Co AB",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Organisation number: 559040-8075",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"VAT registration number: ",
						G.vatNumber,
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Bäckegatan 30 B",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"413 16 Göteborg",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Sweden",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Brand and website: ",
						G.tradingName,
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Email:",
						" ",
						/* @__PURE__ */ (0, I.jsx)("a", {
							href: `mailto:${G.email}`,
							className: "underline hover:text-foreground",
							children: G.email
						})
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "We have not appointed a data protection officer because the operation is not subject to such a requirement. Questions about personal data should be sent to the address above." })
			] })
		},
		{
			heading: "2. When this policy applies",
			body: /* @__PURE__ */ (0, I.jsxs)("p", { children: [
				"This policy applies when you visit ",
				G.tradingName,
				", use the configurator, create or request a preview, add a product to the cart, make a purchase, contact our support or use the chat, consent to statistics or marketing, or subscribe to marketing."
			] })
		},
		{
			heading: "3. Personal data we process",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "font-medium",
					children: "Contact and customer data"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "We may process name, email address, phone number, delivery address, billing address, country and information you provide when contacting us." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Order data"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "We process information about order number, selected products, price, payment status, delivery method, tracking information, returns, complaints and customer communication." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Your configuration"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "When you use the configurator we may process:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "searched place and place name," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "coordinates and geographic crop," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "size, colour and frame," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "any engraving text," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "model and preview images," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "technical identifiers for your design," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "links to the configurator and cart." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "A chosen place may be a home address or another place that is meaningful to you. We only process the data for the purposes stated in this policy." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Payment data"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Payment is handled by Shopify and the payment provider you choose, such as card provider, Klarna, Shop Pay, Google Pay or Apple Pay." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "DearPlace does not store full card numbers or security codes. We may receive information about payment method, payment status, amount and transaction reference." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Technical information"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "When you use the website we may process IP address, browser, device type, operating system, language, approximate country, date and time, referring page, security logs and technical errors." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Some technical information must be processed even without analytics consent in order for the website to be delivered and protected." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Statistics data"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "If you approve statistics we may process information about page views, clicks, sessions, use of the configurator, created previews, cart events and technical performance." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "After analytics consent, an email address entered for a preview may be connected to product statistics in PostHog." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Marketing data"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "If you approve marketing we may process campaign parameters, Meta click identifiers, ad interactions, visitor identifiers, product information, cart events and purchase data." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Meta Conversions API may process an email address in hashed form for measurement and matching." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Chat and support"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "When you contact us we process your message, your contact details, information about the case and relevant order or configuration information." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "The chat is staffed by humans. We do not use Crisp’s AI agent to answer customer enquiries." })
			] })
		},
		{
			heading: "4. Where the data comes from",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "We mainly collect data directly from you, automatically from your browser or device, from Shopify and the payment provider you choose, from PostNord in connection with delivery, from analytics and advertising platforms if you have consented, and from Mapbox when you use the location and address search." })
		},
		{
			heading: "5. Why we process the data",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("div", {
				className: "overflow-x-auto",
				children: /* @__PURE__ */ (0, I.jsxs)("table", {
					className: "w-full text-left text-sm",
					children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
						className: "border-b border-border",
						children: [
							/* @__PURE__ */ (0, I.jsx)("th", {
								className: "py-2 pr-4 font-medium",
								children: "Purpose"
							}),
							/* @__PURE__ */ (0, I.jsx)("th", {
								className: "py-2 pr-4 font-medium",
								children: "Data"
							}),
							/* @__PURE__ */ (0, I.jsx)("th", {
								className: "py-2 font-medium",
								children: "Legal basis"
							})
						]
					}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
						className: "text-muted-foreground",
						children: [
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Display the configurator and create a preview"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Place, coordinates, crop, product choices and technical data"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Steps at your request before a contract is entered into and legitimate interest in providing the service"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Send the preview you requested"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Email address and configuration"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Steps at your request before a contract is entered into"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Manage order, payment, production and delivery"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Customer, order, payment, configuration and delivery data"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Performance of contract"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Manufacture the map internally in Gothenburg"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Configuration, model files and order data"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Performance of contract"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Handle support, complaints and disputes"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Contact, order and case data"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Performance of contract, legal obligation and legitimate interest in establishing and defending legal claims"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Accounting and tax reporting"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Invoice, payment and order data"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Legal obligation"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Prevent fraud and protect the website"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "IP address, security logs, device and transaction data"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Legitimate interest in security and fraud prevention"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Customer chat"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Contact details, messages and technical session information"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Steps at your request and legitimate interest in providing customer support"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Statistics and improvement of the website"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Usage, session and analytics data"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Consent"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Ad measurement and audiences with Meta"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Marketing, campaign, product and event data"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Consent"
									})
								]
							}),
							/* @__PURE__ */ (0, I.jsxs)("tr", { children: [
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "Marketing emails and purchase-driving reminders"
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "Email address, configuration and marketing history"
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2",
									children: "Consent"
								})
							] })
						]
					})]
				})
			}), /* @__PURE__ */ (0, I.jsx)("p", {
				className: "mt-4",
				children: "Where processing is based on legitimate interest, we have assessed that the processing is necessary and that our interest does not outweigh your rights and interests."
			})] })
		},
		{
			heading: "6. Previews and emails",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "When you enter your email address to receive a preview, we use the address to send the preview you explicitly requested and necessary information about its delivery." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Requesting a preview does not in itself mean you have consented to newsletters, abandoned-cart emails or other purchase-driving reminders." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Such marketing emails are only sent if you have given separate valid consent or if the sending is expressly permitted by law." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Every marketing email contains a clear opportunity to unsubscribe. If you object to direct marketing we will stop without delay." })
			] })
		},
		{
			heading: "7. Recipients and providers",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "We only disclose data when necessary for a stated purpose." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Shopify International Limited"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Shopify provides the store, cart, checkout, order management and payment functions. Shopify and its group companies or subcontractors may process customer, order, device and transaction data." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Shopify International Limited is the main contracting party for merchants within the EEA." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Payment providers"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "The payment provider you choose processes data required to carry out the payment, prevent fraud and meet legal requirements." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "The provider may act as an independent data controller for parts of the processing." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Supabase, Inc."
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Supabase is used for database and backend functions, including management of configurations, previews, technical model identifiers and lead data." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Mapbox, Inc."
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Mapbox is used for location and address search. Searches, coordinates, IP address and technical information may be transferred to Mapbox when you use the map feature." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "PostNord"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "PostNord processes name, address, contact details, delivery details and tracking information to deliver the order within Sweden." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Klaviyo, Inc."
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Klaviyo is used to send requested previews and, when valid consent exists, marketing emails and reminders." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Google Ireland Limited"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Google Analytics 4 is used after analytics consent. Google Fonts is used to display the website’s typefaces and may process IP address and technical information when fonts are fetched." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "PostHog"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "PostHog is used after analytics consent for product and usage statistics. Processing is configured to PostHog’s EU environment. Session recording is disabled." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Meta Platforms Ireland Limited"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Meta Pixel and Meta Conversions API are used after marketing consent for ad measurement and audiences on Facebook and Instagram." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Crisp IM SAS"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Crisp provides our customer chat. The service loads when you choose to open the chat. Crisp processes messages and necessary technical session information as a data processor." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Lovable and Tinybird"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "These services may, after analytics consent, process basic technical web statistics and performance information." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "We may also disclose data to authorities, courts, insurance companies or professional advisers when required by law or necessary to establish, exercise or defend legal claims." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Production takes place internally at Curt & Co AB in Gothenburg. Customer data is not disclosed to any external production partner." })
			] })
		},
		{
			heading: "8. Transfers outside the EU/EEA",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Some providers or their subcontractors may process personal data outside the EU/EEA, including in the United States and Canada." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "When personal data is transferred to a country outside the EU/EEA we use applicable safeguards, such as:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "the European Commission’s adequacy decision," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "the EU-US Data Privacy Framework where the recipient is covered by it," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "the European Commission’s standard contractual clauses," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "other lawful transfer mechanisms under the GDPR." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "You can contact us for more information about the safeguards applicable to a specific transfer." })
			] })
		},
		{
			heading: "9. How long data is kept",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "We do not keep personal data longer than necessary for the respective purpose." }),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [/* @__PURE__ */ (0, I.jsx)("th", {
								className: "py-2 pr-4 font-medium",
								children: "Data"
							}), /* @__PURE__ */ (0, I.jsx)("th", {
								className: "py-2 font-medium",
								children: "Normal retention period"
							})]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Preview and email address when no purchase is made"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Up to 90 days"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Abandoned cart data"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Up to 30 days after last activity"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Order configuration and model material"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "3 years after delivery, or longer if a complaint is ongoing"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Accounting records"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "In accordance with the Bookkeeping Act, normally until the end of the seventh year after the end of the calendar year in which the financial year ended"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Support and chat cases"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Normally 12 months after the case is closed, or longer if the data is needed for an ongoing claim"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Marketing data"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Until consent is withdrawn, but normally up to 24 months after last activity"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Suppression list after unsubscribe"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "As long as necessary to ensure no new marketing emails are sent"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "GA4 user and event data"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Up to 14 months"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Cookie and consent choices"
									}), /* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Up to 12 months"
									})]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", { children: [/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "Security logs"
								}), /* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2",
									children: "As long as needed for security, troubleshooting or legal claims"
								})] })
							]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Aggregated or anonymised data that can no longer be linked to a person may be kept longer."
				})
			] })
		},
		{
			heading: "10. Your rights",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Depending on the circumstances, you have the right to:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "receive information about how we process your data," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "access your personal data," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "have incorrect data rectified," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "request erasure of data," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "request restriction of processing," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "receive certain data in a structured and machine-readable format," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "object to processing based on legitimate interest," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "withdraw a given consent." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "The right to erasure is not absolute. We may need to retain certain data for accounting, complaints or legal claims." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "You always have the right to object to direct marketing. When you do, we stop such processing." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Withdrawn consent does not affect the lawfulness of processing already carried out before the consent was withdrawn." }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Contact",
					" ",
					/* @__PURE__ */ (0, I.jsx)("a", {
						href: `mailto:${G.email}`,
						className: "underline hover:text-foreground",
						children: G.email
					}),
					" ",
					"to exercise your rights. We normally respond within one month. We may need to verify your identity before data is disclosed or changed."
				] })
			] })
		},
		{
			heading: "11. Automated decision-making and profiling",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "We do not use automated decision-making that produces legal effects or otherwise significantly affects you." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "If you consent to marketing, Meta may use data for audience targeting and ad profiling. You can withdraw consent via our cookie settings." })] })
		},
		{
			heading: "12. Security",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "We use appropriate technical and organisational measures to protect personal data against unauthorised access, alteration, loss and unlawful processing." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Only persons and providers who need the data for their work may access it." })] })
		},
		{
			heading: "13. Complaints",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"If you believe we are processing your personal data incorrectly, please contact us first at",
					" ",
					/* @__PURE__ */ (0, I.jsx)("a", {
						href: `mailto:${G.email}`,
						className: "underline hover:text-foreground",
						children: G.email
					}),
					"."
				] }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "You also have the right to lodge a complaint with:" }),
				/* @__PURE__ */ (0, I.jsxs)("p", {
					className: "not-italic",
					children: [
						"The Swedish Authority for Privacy Protection",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"Box 8114",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"104 20 Stockholm",
						/* @__PURE__ */ (0, I.jsx)("br", {}),
						"www.imy.se"
					]
				})
			] })
		},
		{
			heading: "14. Changes to the policy",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "We may update the policy when our services, providers or legal obligations change." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "The date at the top shows when the policy was last updated. For material changes we will inform you in an appropriate manner." })] })
		}
	];
	return /* @__PURE__ */ (0, I.jsx)(Yd, {
		title: t ? "Integritetspolicy" : "Privacy policy",
		updated: t ? "Senast uppdaterad: 4 september 2026" : "Last updated: 4 September 2026",
		sections: n
	});
}
//#endregion
//#region src/components/pages/CookiesPage.tsx
function Zd() {
	let { lang: e } = x(), t = e === "sv", n = t ? [
		{
			heading: "1. Om denna policy",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "Denna policy beskriver hur dearplace.studio använder cookies och liknande tekniker, exempelvis localStorage, sessionStorage, pixlar och andra identifierare." })
		},
		{
			heading: "En cookie är en mindre textfil som sparas i din webbläsare. LocalStorage och sessionStorage fungerar på liknande sätt men lagrar information direkt i webbläsaren.",
			body: null
		},
		{
			heading: "2. Ditt samtycke",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Nödvändiga tekniker används för att webbplatsen, konfiguratorn, varukorgen, betalningen och kundsupporten ska fungera. De kräver normalt inte samtycke." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Statistik- och marknadsföringstekniker används endast efter att du aktivt har godkänt respektive kategori. Att fortsätta använda webbplatsen räknas inte som samtycke." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Du kan välja mellan att:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "godkänna alla kategorier," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "neka alla valfria kategorier," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "göra separata val för statistik och marknadsföring." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Du kan när som helst ändra eller återkalla ditt samtycke genom länken ”Cookie-inställningar” i sidfoten. Det ska vara lika enkelt att återkalla samtycket som att lämna det." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "När ett samtycke återkallas upphör den framtida behandlingen för det aktuella ändamålet. Identifierare som inte längre behövs tas bort eller inaktiveras där detta är tekniskt möjligt." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi sparar ditt cookieval i högst 12 månader. Därefter frågar vi igen. Vi kan också be om ett nytt val tidigare om användningen av cookies eller våra leverantörer förändras väsentligt." })
			] })
		},
		{
			heading: "3. Nödvändiga tekniker",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Dessa tekniker behövs för funktioner som du uttryckligen använder, exempelvis konfigurator, varukorg, kassa, språkval och chatt." }),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Namn eller leverantör"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Typ"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Ändamål"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Lagringstid"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dearplace.consent" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "localStorage"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Sparar dina cookieval och datumet för valet."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Högst 12 månader"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dearplace.lang" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "localStorage"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Kommer ihåg valt språk."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Tills valet ändras eller webbläsardata raderas"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "shopify-cart" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "localStorage"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Håller kvar varukorgens identifierare och valda konfiguration."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Tills varukorgen töms, upphör att vara giltig eller webbläsardata raderas"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dp.preview.latest.v1" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "localStorage"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Sparar din senaste plats, storlek, färgpalett, ram och en privat åtkomstnyckel så att förhandsvisningen kan hämtas från servern när du kommer tillbaka. Bilden sparas inte lokalt."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Upp till 14 dagar efter senaste användning, eller tills webbläsardata raderas"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Supabase sessionslagring"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "localStorage eller sessionslagring"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Teknisk sessionshantering samt lagring och hämtning av konfigurationer och förhandsvisningar."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Beroende på sessionens längd och den funktion som används"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "crisp-client/*" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Cookie"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Återställer en chatt och dess meddelanden när du själv öppnar kundchatten. Leverantör: Crisp IM SAS."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Normalt upp till 6 månader"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", { children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Shopify-kakor"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Cookies och liknande tekniker"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Varukorg, kassa, bedrägeriskydd, säker betalning, språk och andra nödvändiga butikstjänster."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Se exempel nedan"
									})
								] })
							]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Shopify kan bland annat använda följande nödvändiga cookies:"
				}),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Namn"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Ändamål"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Lagringstid"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_shopify_essential" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Nödvändig sessions-, kassa- och säkerhetsinformation."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Upp till 1 år"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_shopify_test" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Kontrollerar om webbläsaren tillåter cookies."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Cirka 1 minut"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_tracking_consent" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Sparar integritets- och samtyckesinställningar i Shopify."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Upp till 1 år"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "cart" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Kopplar webbläsaren till den aktuella varukorgen."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Upp till 2 veckor"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "cart_currency" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Sparar varukorgens valuta."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Upp till 2 veckor"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "localization" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Sparar land- och språkval."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Upp till 1 år"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", { children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: /* @__PURE__ */ (0, I.jsx)("code", { children: "shopify_pay" })
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Underlättar användning av Shop Pay när den tjänsten väljs."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Upp till 1 år"
									})
								] })
							]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Shopify kan ändra sina tekniska cookies när plattformen uppdateras. Aktuell information finns i Shopifys egen cookiepolicy."
				})
			] })
		},
		{
			heading: "4. Kart- och förhandsvisningstjänster",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "När du söker efter en adress eller plats skickas sökningen till Mapbox. Mapbox kan då behandla exempelvis:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "sökord och platsnamn," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "koordinater," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "IP-adress," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "webbläsare och enhetsinformation," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "tidpunkt och teknisk information om förfrågan." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Behandlingen är nödvändig för att leverera den plats- och kartfunktion som du har begärt. Mapbox kan behandla information i USA och andra länder." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Konfigurationer och förhandsvisningar hanteras genom Supabase och DearPlaces egna system. Det kan omfatta vald plats, koordinater, beskärning, storlek, färg, ram, gravyr och tekniska modellidentifierare." })
			] })
		},
		{
			heading: "5. Kundchatt",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Crisp Chat laddas först när du öppnar chatten eller annars uttryckligen begär att använda den." }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Crisp använder funktionella cookies med prefixet ",
					/* @__PURE__ */ (0, I.jsx)("code", { children: "crisp-client/*" }),
					" för att återställa chattsessionen. Chatten bemannas av människor. DearPlace använder inte Crisps AI-agent för att svara kunder."
				] }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om du inte startar en konversation tas en tillfällig Crisp-session normalt bort kort efter att den löpt ut. Om du skickar ett meddelande kan chatthistorik och teknisk information sparas för att hantera och följa upp ditt supportärende." })
			] })
		},
		{
			heading: "6. Statistik – endast med samtycke",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om du godkänner statistik använder vi Google Analytics 4, PostHog, Shopify Analytics och teknisk webbstatistik från Lovable/Tinybird." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Dessa tjänster hjälper oss att förstå hur webbplatsen och konfiguratorn används, upptäcka tekniska problem och förbättra användarupplevelsen." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Google Analytics 4"
				}),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Namn"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Ändamål"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Lagringstid"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_ga" })
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Skiljer mellan olika besökare."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Upp till 2 år"
									})
								]
							}), /* @__PURE__ */ (0, I.jsxs)("tr", { children: [
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_ga_<mät-id>" })
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "Sparar information om besök och sessioner."
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2",
									children: "Upp till 2 år"
								})
							] })]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Användar- och händelsedata i Google Analytics sparas i högst 14 månader. Aggregerad statistik kan sparas längre utan att direkt identifiera en enskild besökare."
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Mottagare: Google Ireland Limited och dess underleverantörer." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "PostHog"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "PostHog används för att mäta händelser i konfiguratorn, exempelvis påbörjad konfiguration, skapad förhandsvisning och tillagd produkt." }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"PostHog kan använda cookies och localStorage med namn som börjar med ",
					/* @__PURE__ */ (0, I.jsx)("code", { children: "ph_" }),
					". En lokal besökaridentifierare, ",
					/* @__PURE__ */ (0, I.jsx)("code", { children: "dp_visitor_id" }),
					", kan också användas efter samtycke."
				] }),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Namn"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Ändamål"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Lagringstid"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsxs)("td", {
										className: "py-2 pr-4",
										children: [/* @__PURE__ */ (0, I.jsx)("code", { children: "ph_<projekt-id>_posthog" }), " och relaterad lagring"]
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Produktstatistik och sessionsidentifiering."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Upp till 12 månader"
									})
								]
							}), /* @__PURE__ */ (0, I.jsxs)("tr", { children: [
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dp_visitor_id" })
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "Kopplar samman statistik från samma webbläsare."
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2",
									children: "Upp till 12 månader"
								})
							] })]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Om du anger din e-postadress för en förhandsvisning kan PostHog efter analyssamtycke koppla adressen till statistik om hur konfiguratorn används. Vi använder inte PostHog för sessionsinspelningar."
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "PostHog är konfigurerat för behandling i EU." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Shopify Analytics"
				}),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Namn"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Ändamål"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Lagringstid"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_shopify_y" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Skiljer mellan olika webbläsare för butiksstatistik."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Upp till 1 år"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_shopify_s" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Identifierar en besökssession."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Cirka 30 minuter"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dearplace.shopify_y" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Lokal kopia av Shopifys besökaridentifierare."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Upp till 1 år"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", { children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dearplace.shopify_s" })
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Lokal sessionsidentifierare för Shopify-statistik."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Cirka 30 minuter"
									})
								] })
							]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Lovable/Tinybird"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Lovable/Tinybird kan användas för grundläggande teknisk statistik och prestandamätning efter att du godkänt statistik." }),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Namn"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Ändamål"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Lagringstid"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsx)("tbody", {
							className: "text-muted-foreground",
							children: /* @__PURE__ */ (0, I.jsxs)("tr", { children: [
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: /* @__PURE__ */ (0, I.jsx)("code", { children: "session-id" })
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "Skiljer mellan besök under en kort session."
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2",
									children: "Cirka 30 minuter"
								})
							] })
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Informationen kan omfatta besökt sida, webbadress, hänvisande sida, språk, ungefärligt land, webbläsarinformation och tekniska prestandamått."
				})
			] })
		},
		{
			heading: "7. Marknadsföring – endast med samtycke",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om du godkänner marknadsföring använder vi Meta Pixel och Meta Conversions API för att mäta annonser på Facebook och Instagram samt skapa målgrupper." }),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Namn eller teknik"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Typ"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Ändamål"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Lagringstid"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_fbp" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Cookie"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Skiljer mellan webbläsare och mäter annonsresultat."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Upp till 90 dagar"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_fbc" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Cookie"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Sparar information från Metas klickidentifierare när en sådan finns."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Upp till 90 dagar"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dearplace.attribution" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "sessionStorage"
										}),
										/* @__PURE__ */ (0, I.jsxs)("td", {
											className: "py-2 pr-4",
											children: [
												"Sparar kampanjparametrar, exempelvis ",
												/* @__PURE__ */ (0, I.jsx)("code", { children: "utm_*" }),
												" och ",
												/* @__PURE__ */ (0, I.jsx)("code", { children: "fbclid" }),
												", under den aktuella sessionen."
											]
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Tills webbläsarsessionen avslutas"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", { children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Meta Conversions API"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Serveröverföring"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Skickar marknadsföringshändelser till Meta och hjälper till att mäta annonser."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Enligt Metas tillämpliga villkor"
									})
								] })
							]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Uppgifter som skickas genom Meta Conversions API kan omfatta:"
				}),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "typ av händelse," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "tidpunkt och händelseidentifierare," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "aktuell webbadress," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "produkt- och orderinformation," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "lokal besökaridentifierare," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "e-postadress i hashad form när den finns tillgänglig." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Mottagare: Meta Platforms Ireland Limited och andra bolag eller underleverantörer inom Metakoncernen." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Meta Pixel och Meta Conversions API aktiveras inte utan marknadsföringssamtycke." })
			] })
		},
		{
			heading: "8. Tjänster som inte nödvändigtvis lagrar cookies",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "Webbplatsen använder Google Fonts för att visa typsnitt. När typsnitten hämtas kan Google ta emot IP-adress, webbläsarinformation och teknisk information om förfrågan. Google Fonts används inte av oss för annonsering." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Mapbox, Supabase och andra leverantörer kan också behandla teknisk information utan att alltid lagra en cookie i din webbläsare. Dessa behandlingar beskrivs även i vår integritetspolicy." })] })
		},
		{
			heading: "9. Webbläsarinställningar",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "Du kan radera eller blockera cookies och annan lokal lagring genom webbläsarens inställningar. Om du blockerar nödvändiga tekniker kan exempelvis varukorgen, språkvalet, konfiguratorn eller kassan sluta fungera korrekt." })
		},
		{
			heading: "10. Kontakt",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "Personuppgiftsansvarig:" }), /* @__PURE__ */ (0, I.jsxs)("p", {
				className: "not-italic",
				children: [
					G.dataController,
					/* @__PURE__ */ (0, I.jsx)("br", {}),
					"Organisationsnummer: ",
					G.orgNumber.replace(/^SE/, "").replace(/(\d{6})(\d{4})/, "$1-$2"),
					/* @__PURE__ */ (0, I.jsx)("br", {}),
					G.address,
					/* @__PURE__ */ (0, I.jsx)("br", {}),
					"E-post:",
					" ",
					/* @__PURE__ */ (0, I.jsx)("a", {
						href: `mailto:${G.email}`,
						className: "underline hover:text-foreground",
						children: G.email
					})
				]
			})] })
		}
	] : [
		{
			heading: "1. About this policy",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "This policy describes how dearplace.studio uses cookies and similar technologies, such as localStorage, sessionStorage, pixels and other identifiers." })
		},
		{
			heading: "A cookie is a small text file stored in your browser. LocalStorage and sessionStorage work similarly but store information directly in the browser.",
			body: null
		},
		{
			heading: "2. Your consent",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Necessary technologies are used so the website, configurator, cart, checkout and customer support can function. They normally do not require consent." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Statistics and marketing technologies are only used after you have actively approved the respective category. Continued browsing is not treated as consent." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "You can choose to:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "approve all categories," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "decline all optional categories," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "make separate choices for statistics and marketing." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "You can change or withdraw your consent at any time via the “Cookie settings” link in the footer. Withdrawing consent must be as easy as giving it." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "When consent is withdrawn, future processing for that purpose stops. Identifiers that are no longer needed are removed or disabled where technically possible." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "We store your cookie choice for up to 12 months, then ask again. We may also ask for a new choice earlier if cookie usage or our providers change materially." })
			] })
		},
		{
			heading: "3. Necessary technologies",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "These technologies are needed for features you explicitly use, such as the configurator, cart, checkout, language selection and chat." }),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Name or provider"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Type"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Purpose"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Retention"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dearplace.consent" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "localStorage"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Saves your cookie choices and the date of the choice."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Up to 12 months"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dearplace.lang" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "localStorage"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Remembers selected language."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Until changed or browser data is cleared"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "shopify-cart" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "localStorage"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Keeps the cart identifier and selected configuration."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Until the cart is emptied, becomes invalid or browser data is cleared"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dp.preview.latest.v1" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "localStorage"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Saves your latest place, size, palette, frame and private access key so the preview can be retrieved from the server when you return. The image is not stored locally."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Up to 14 days after last use, or until browser data is cleared"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Supabase session storage"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "localStorage or sessionStorage"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Technical session management and storage/retrieval of configurations and previews."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Depends on session length and feature used"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "crisp-client/*" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Cookie"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Restores a chat and its messages when you open customer chat. Provider: Crisp IM SAS."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Normally up to 6 months"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", { children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Shopify cookies"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Cookies and similar technologies"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Cart, checkout, fraud prevention, secure payment, language and other necessary store services."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "See examples below"
									})
								] })
							]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Shopify may use the following necessary cookies, among others:"
				}),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Name"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Purpose"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Retention"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_shopify_essential" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Essential session, checkout and security information."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Up to 1 year"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_shopify_test" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Checks whether the browser allows cookies."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "About 1 minute"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_tracking_consent" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Saves privacy and consent settings in Shopify."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Up to 1 year"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "cart" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Links the browser to the current cart."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Up to 2 weeks"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "cart_currency" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Saves the cart currency."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Up to 2 weeks"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "localization" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Saves country and language choice."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Up to 1 year"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", { children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: /* @__PURE__ */ (0, I.jsx)("code", { children: "shopify_pay" })
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Facilitates use of Shop Pay when that service is selected."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Up to 1 year"
									})
								] })
							]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Shopify may change its technical cookies as the platform is updated. Current information is available in Shopify’s own cookie policy."
				})
			] })
		},
		{
			heading: "4. Map and preview services",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "When you search for an address or place, the query is sent to Mapbox. Mapbox may then process:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "search terms and place names," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "coordinates," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "IP address," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "browser and device information," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "time and technical request information." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "This processing is necessary to deliver the location and map feature you requested. Mapbox may process information in the United States and other countries." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Configurations and previews are handled through Supabase and DearPlace’s own systems. This may include selected place, coordinates, crop, size, colour, frame, engraving and technical model identifiers." })
			] })
		},
		{
			heading: "5. Customer chat",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Crisp Chat is only loaded when you open the chat or otherwise explicitly request to use it." }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Crisp uses functional cookies prefixed with ",
					/* @__PURE__ */ (0, I.jsx)("code", { children: "crisp-client/*" }),
					" to restore the chat session. The chat is staffed by humans. DearPlace does not use Crisp’s AI agent to answer customers."
				] }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "If you do not start a conversation, a temporary Crisp session is normally removed shortly after it expires. If you send a message, chat history and technical information may be saved to handle and follow up on your support case." })
			] })
		},
		{
			heading: "6. Statistics – only with consent",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "If you approve statistics, we use Google Analytics 4, PostHog, Shopify Analytics and technical web statistics from Lovable/Tinybird." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "These services help us understand how the website and configurator are used, detect technical issues and improve the user experience." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Google Analytics 4"
				}),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Name"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Purpose"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Retention"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_ga" })
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Distinguishes between visitors."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Up to 2 years"
									})
								]
							}), /* @__PURE__ */ (0, I.jsxs)("tr", { children: [
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_ga_<measurement-id>" })
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "Saves information about visits and sessions."
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2",
									children: "Up to 2 years"
								})
							] })]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "User and event data in Google Analytics is stored for up to 14 months. Aggregated statistics may be kept longer without directly identifying an individual visitor."
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Recipient: Google Ireland Limited and its subcontractors." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "PostHog"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "PostHog is used to measure events in the configurator, such as started configuration, created preview and added product." }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"PostHog may use cookies and localStorage with names starting with ",
					/* @__PURE__ */ (0, I.jsx)("code", { children: "ph_" }),
					". A local visitor identifier, ",
					/* @__PURE__ */ (0, I.jsx)("code", { children: "dp_visitor_id" }),
					", may also be used after consent."
				] }),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Name"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Purpose"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Retention"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [/* @__PURE__ */ (0, I.jsxs)("tr", {
								className: "border-b border-border/50",
								children: [
									/* @__PURE__ */ (0, I.jsxs)("td", {
										className: "py-2 pr-4",
										children: [/* @__PURE__ */ (0, I.jsx)("code", { children: "ph_<project-id>_posthog" }), " and related storage"]
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Product statistics and session identification."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Up to 12 months"
									})
								]
							}), /* @__PURE__ */ (0, I.jsxs)("tr", { children: [
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dp_visitor_id" })
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "Links statistics from the same browser."
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2",
									children: "Up to 12 months"
								})
							] })]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "If you enter your email address for a preview, PostHog may, after analytics consent, connect the address to statistics about how the configurator is used. We do not use PostHog for session recordings."
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "PostHog is configured for processing in the EU." }),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Shopify Analytics"
				}),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Name"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Purpose"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Retention"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_shopify_y" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Distinguishes between browsers for store statistics."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Up to 1 year"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_shopify_s" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Identifies a visit session."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "About 30 minutes"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dearplace.shopify_y" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Local copy of Shopify’s visitor identifier."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Up to 1 year"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", { children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dearplace.shopify_s" })
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Local session identifier for Shopify statistics."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "About 30 minutes"
									})
								] })
							]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("h3", {
					className: "mt-4 font-medium",
					children: "Lovable/Tinybird"
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Lovable/Tinybird may be used for basic technical statistics and performance measurement after you consent to statistics." }),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Name"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Purpose"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Retention"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsx)("tbody", {
							className: "text-muted-foreground",
							children: /* @__PURE__ */ (0, I.jsxs)("tr", { children: [
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: /* @__PURE__ */ (0, I.jsx)("code", { children: "session-id" })
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2 pr-4",
									children: "Distinguishes visits during a short session."
								}),
								/* @__PURE__ */ (0, I.jsx)("td", {
									className: "py-2",
									children: "About 30 minutes"
								})
							] })
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Information may include visited page, URL, referring page, language, approximate country, browser information and technical performance metrics."
				})
			] })
		},
		{
			heading: "7. Marketing – only with consent",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "If you approve marketing, we use Meta Pixel and Meta Conversions API to measure ads on Facebook and Instagram and to build audiences." }),
				/* @__PURE__ */ (0, I.jsx)("div", {
					className: "overflow-x-auto",
					children: /* @__PURE__ */ (0, I.jsxs)("table", {
						className: "w-full text-left text-sm",
						children: [/* @__PURE__ */ (0, I.jsx)("thead", { children: /* @__PURE__ */ (0, I.jsxs)("tr", {
							className: "border-b border-border",
							children: [
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Name or technology"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Type"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 pr-4 font-medium",
									children: "Purpose"
								}),
								/* @__PURE__ */ (0, I.jsx)("th", {
									className: "py-2 font-medium",
									children: "Retention"
								})
							]
						}) }), /* @__PURE__ */ (0, I.jsxs)("tbody", {
							className: "text-muted-foreground",
							children: [
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_fbp" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Cookie"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Distinguishes between browsers and measures ad performance."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Up to 90 days"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "_fbc" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Cookie"
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "Saves information from Meta’s click identifier when one is present."
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Up to 90 days"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", {
									className: "border-b border-border/50",
									children: [
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: /* @__PURE__ */ (0, I.jsx)("code", { children: "dearplace.attribution" })
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2 pr-4",
											children: "sessionStorage"
										}),
										/* @__PURE__ */ (0, I.jsxs)("td", {
											className: "py-2 pr-4",
											children: [
												"Saves campaign parameters, e.g. ",
												/* @__PURE__ */ (0, I.jsx)("code", { children: "utm_*" }),
												" and ",
												/* @__PURE__ */ (0, I.jsx)("code", { children: "fbclid" }),
												", during the current session."
											]
										}),
										/* @__PURE__ */ (0, I.jsx)("td", {
											className: "py-2",
											children: "Until the browser session ends"
										})
									]
								}),
								/* @__PURE__ */ (0, I.jsxs)("tr", { children: [
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Meta Conversions API"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Server transfer"
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2 pr-4",
										children: "Sends marketing events to Meta and helps measure ads."
									}),
									/* @__PURE__ */ (0, I.jsx)("td", {
										className: "py-2",
										children: "Under Meta’s applicable terms"
									})
								] })
							]
						})]
					})
				}),
				/* @__PURE__ */ (0, I.jsx)("p", {
					className: "mt-4",
					children: "Data sent via Meta Conversions API may include:"
				}),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "event type," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "time and event identifier," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "current URL," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "product and order information," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "local visitor identifier," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "email address in hashed form when available." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Recipient: Meta Platforms Ireland Limited and other companies or subcontractors within the Meta group." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Meta Pixel and Meta Conversions API are not activated without marketing consent." })
			] })
		},
		{
			heading: "8. Services that do not necessarily store cookies",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "The website uses Google Fonts to display typefaces. When fonts are fetched, Google may receive IP address, browser information and technical request information. We do not use Google Fonts for advertising." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Mapbox, Supabase and other providers may also process technical information without always storing a cookie in your browser. These processes are also described in our privacy policy." })] })
		},
		{
			heading: "9. Browser settings",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "You can delete or block cookies and other local storage through your browser settings. If you block necessary technologies, the cart, language selection, configurator or checkout may stop working correctly." })
		},
		{
			heading: "10. Contact",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "Data controller:" }), /* @__PURE__ */ (0, I.jsxs)("p", {
				className: "not-italic",
				children: [
					G.dataController,
					/* @__PURE__ */ (0, I.jsx)("br", {}),
					"Organisation number: ",
					G.orgNumber.replace(/^SE/, "").replace(/(\d{6})(\d{4})/, "$1-$2"),
					/* @__PURE__ */ (0, I.jsx)("br", {}),
					G.address,
					/* @__PURE__ */ (0, I.jsx)("br", {}),
					"Email:",
					" ",
					/* @__PURE__ */ (0, I.jsx)("a", {
						href: `mailto:${G.email}`,
						className: "underline hover:text-foreground",
						children: G.email
					})
				]
			})] })
		}
	];
	return /* @__PURE__ */ (0, I.jsx)(Yd, {
		title: t ? "Cookiepolicy och liknande tekniker" : "Cookie policy and similar technologies",
		updated: t ? "Senast uppdaterad: 4 september 2026" : "Last updated: 4 September 2026",
		sections: n
	});
}
//#endregion
//#region src/components/pages/TermsPage.tsx
function Qd() {
	let { lang: e } = x(), t = e === "sv", n = t ? [
		{
			heading: "1. Om DearPlace",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsxs)("p", { children: [
				"DearPlace drivs av:",
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				G.legalName,
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"Organisationsnummer: 559040-8075",
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"Bäckegatan 30 B",
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"413 16 Göteborg",
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"E-post: ",
				G.email,
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"Webbplats: dearplace.studio"
			] }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Vi svarar normalt på mejl inom 24–48 timmar på arbetsdagar." })] })
		},
		{
			heading: "2. Villkorens omfattning",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Dessa köpvillkor gäller för beställningar som görs via dearplace.studio och levereras inom Sverige." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Villkoren gäller både privatpersoner och företag. För privatpersoner gäller svensk konsumentskyddslagstiftning, bland annat konsumentköplagen och lagen om distansavtal och avtal utanför affärslokaler. Tvingande konsumentlagstiftning gäller alltid framför dessa villkor." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "För företagskunder gäller inte konsumentlagstiftningen. Där inget annat anges tillämpas köplagen." })
			] })
		},
		{
			heading: "3. Våra produkter",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Varje karta från DearPlace är personligt anpassad och tillverkas utifrån kundens egna val av bland annat plats, geografiskt område, beskärning, storlek, färg och ram." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Kartan 3D-printas i PLA och monteras i en ram av trä. Produkten har ingen glasskiva, plastfront eller annan skyddande front. Produktionen sker i Göteborg." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Den förhandsvisning som visas i konfiguratorn ligger till grund för tillverkningen. Den geografiska beskärningen och det valda området ska motsvara förhandsvisningen. Mindre färgskillnader kan förekomma mellan skärmen och den färdiga produkten på grund av skärminställningar, material, ljusförhållanden och tillverkningsprocessen." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Mindre färgskillnader räknas inte i sig som fel, förutsatt att produkten i övrigt överensstämmer med beställningen. Geografiskt innehåll eller beskärning ska däremot inte ändras från den godkända förhandsvisningen." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Varje karta kvalitetskontrolleras före leverans. Vi kontrollerar att kartan överensstämmer med den beställda 3D-modellen och att den inte har synliga tillverkningsfel." })
			] })
		},
		{
			heading: "4. Kundens ansvar före beställningen",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Innan beställningen genomförs ansvarar kunden för att kontrollera:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "vald plats och geografisk beskärning," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "kartans förhandsvisning," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "storlek och färg," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "val av ram," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "leveransadress och kontaktuppgifter." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi erbjuder normalt inte ändringar efter att beställningen har genomförts." })
			] })
		},
		{
			heading: "5. Pris och frakt",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Alla priser för privatpersoner anges i svenska kronor inklusive moms, om inget annat uttryckligen anges." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Eventuella fraktkostnader visas i kassan innan beställningen slutförs." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Standardfrakt kostar 59 kr. Vid beställningar över 550 kr ingår standardfrakt utan kostnad." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Det totala pris som visas i kassan innan betalningen genomförs är det pris som gäller för beställningen." })
			] })
		},
		{
			heading: "6. Beställning och avtal",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Ett bindande avtal ingås när kunden genomför betalningen och beställningen bekräftas av DearPlace." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "En orderbekräftelse skickas till den e-postadress som kunden har angett. Kunden ansvarar för att kontrollera att orderbekräftelsen stämmer överens med beställningen." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om orderbekräftelsen innehåller ett uppenbart fel ska kunden kontakta oss så snart som möjligt." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi förbehåller oss rätten att neka eller annullera en beställning om produkten inte kan tillverkas, om betalningen inte kan godkännas eller om beställningen innehåller ett uppenbart pris- eller systemfel. Om en betald beställning annulleras av oss återbetalas det erlagda beloppet." })
			] })
		},
		{
			heading: "7. Betalning",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi erbjuder de betalningsalternativ som visas i kassan, exempelvis:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "betalkort och kreditkort," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "Klarna," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "Shop Pay," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "Google Pay," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "Apple Pay." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Betalningen registreras i samband med beställningen. Exakt tidpunkt för debitering kan bero på det valda betalningssättet och betalningsleverantörens villkor." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Betalningar hanteras genom våra betalningsleverantörer. DearPlace lagrar inte fullständiga kortuppgifter." })
			] })
		},
		{
			heading: "8. Ändringar och avbeställning",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Eftersom varje karta är personligt anpassad kan vi normalt inte ändra en beställning efter att den har genomförts." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Produktionen planeras kort efter beställningen och påbörjas vanligtvis inom en till två arbetsdagar." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "En konsument har enligt konsumentköplagen rätt att avbeställa en vara innan den har levererats. Vid en sådan avbeställning kan DearPlace ha rätt till skälig ersättning för utfört arbete, material, administrativa kostnader och annan faktisk förlust som avbeställningen orsakar." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Eftersom kartan tillverkas särskilt för kunden och normalt inte kan säljas vidare kan ersättningen motsvara en stor del av, eller i vissa fall hela, ordervärdet. Ersättningen bedöms utifrån omständigheterna i det enskilda fallet." }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"En avbeställning måste skickas till ",
					G.email,
					" och är inte giltig förrän vi har tagit emot den."
				] }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "För företagskunder gäller ingen rätt till ändring eller avbeställning om detta inte har godkänts skriftligen av DearPlace." })
			] })
		},
		{
			heading: "9. Produktion och leverans",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Normal produktionstid är 2 arbetsdagar. Därefter är den normala transporttiden med PostNord 2–3 arbetsdagar." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "De angivna tiderna är uppskattningar. Kunden kan normalt räkna med leverans inom cirka 14 dagar, men leveranstiden kan påverkas av ordervolym, transportförseningar, helgdagar och omständigheter utanför vår kontroll." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Mer information finns i våra frakt- och leveransvillkor." })
			] })
		},
		{
			heading: "10. Ångerrätt och retur",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Alla produkter som säljs av DearPlace tillverkas enligt kundens personliga val och får en tydlig personlig prägel. Den lagstadgade ångerrätten gäller därför inte." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "DearPlace erbjuder inte heller öppet köp eller frivillig retur av felfria produkter." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Undantaget från ångerrätten påverkar inte kundens rätt att reklamera en felaktig eller transportskadad produkt." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Mer information finns i vår retur-, ånger- och reklamationspolicy." })
			] })
		},
		{
			heading: "11. Fel och reklamation",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Om en produkt är felaktig, transportskadad eller inte överensstämmer med beställningen ska kunden kontakta ",
					G.email,
					"."
				] }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Kontakta oss så snart som möjligt. En reklamation som görs inom två månader från att felet upptäcktes anses alltid ha gjorts i rätt tid." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Konsumenter har rätt att reklamera ursprungliga fel i upp till tre år från att produkten levererades." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vid ett godkänt fel försöker vi i första hand lösa problemet genom att avhjälpa felet eller tillverka och skicka en ersättningsprodukt. Om detta inte är möjligt eller inte kan göras inom skälig tid kan kunden ha rätt till prisavdrag eller återbetalning enligt tillämplig lag." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "DearPlace står för nödvändiga fraktkostnader när reklamationen är godkänd." })
			] })
		},
		{
			heading: "12. Felaktig adress och ej uthämtade paket",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Kunden ansvarar för att ange fullständiga och korrekta leveransuppgifter." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om ett paket returneras på grund av felaktig adress, ofullständiga uppgifter eller för att försändelsen inte har hämtats ut får DearPlace debitera kunden för våra faktiska kostnader för returhantering och en eventuell ny leverans." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Ett paket som inte hämtas ut räknas inte automatiskt som en avbeställning eller retur." })
			] })
		},
		{
			heading: "13. Försenad eller utebliven leverans",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om leveransen blir försenad ska kunden kontakta oss så att vi kan undersöka försändelsen tillsammans med PostNord." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Risken för produkten ligger kvar hos DearPlace tills kunden, eller någon som kunden har utsett, har tagit emot den." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om en försändelse bekräftas som förlorad erbjuder vi i första hand en ny produkt. Om en ny leverans inte är möjlig kan kunden få återbetalning i enlighet med tillämplig lag." })
			] })
		},
		{
			heading: "14. Ansvarsbegränsning",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "DearPlace ansvarar inte för förseningar som beror på omständigheter utanför vår rimliga kontroll, exempelvis myndighetsbeslut, omfattande transportstörningar, naturhändelser, arbetskonflikter eller avbrott i nödvändig infrastruktur." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Denna bestämmelse begränsar inte de rättigheter som en konsument har enligt tvingande lag." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "För företagskunder ansvarar DearPlace inte för indirekt skada eller utebliven vinst, annat än vid uppsåt eller grov vårdslöshet. DearPlaces sammanlagda ansvar gentemot en företagskund är, i den utsträckning lagen tillåter det, begränsat till beställningens värde." })
			] })
		},
		{
			heading: "15. Tvist och tillämplig lag",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Svensk lag gäller för dessa villkor." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om du är konsument och vi inte kan lösa en tvist tillsammans kan du vända dig till Allmänna reklamationsnämnden:" }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Allmänna reklamationsnämnden",
					/* @__PURE__ */ (0, I.jsx)("br", {}),
					"Box 174",
					/* @__PURE__ */ (0, I.jsx)("br", {}),
					"101 23 Stockholm",
					/* @__PURE__ */ (0, I.jsx)("br", {}),
					"www.arn.se"
				] }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "DearPlace medverkar i ARN:s prövning och följer nämndens rekommendationer." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Konsumenten har även rätt att få saken prövad av svensk allmän domstol." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Tvister med företagskunder ska avgöras av svensk allmän domstol, med Göteborgs tingsrätt som första instans." })
			] })
		},
		{
			heading: "16. Ändringar av villkoren",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "Vi kan uppdatera dessa villkor. Den version som gällde när beställningen genomfördes gäller för den aktuella beställningen." })
		}
	] : [
		{
			heading: "Seller",
			body: /* @__PURE__ */ (0, I.jsxs)("p", { children: [
				G.legalName,
				" (",
				G.tradingName,
				"), company no. ",
				G.orgNumber,
				", ",
				G.address,
				". Contact: ",
				G.email
			] })
		},
		{
			heading: "Orders and agreement",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "The agreement is formed when your order is confirmed by email. Every piece is made to order from the place and options you choose in the configurator. Please review the preview carefully — it shows what we produce." })
		},
		{
			heading: "Prices and payment",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "All prices are shown in SEK including VAT. Payment is taken in Shopify checkout using the methods shown there. Shipping is added and displayed before purchase." })
		},
		{
			heading: "Production and delivery",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "Production takes 2 business days, followed by 2–3 business days for standard delivery within Sweden. Standard shipping costs 59 kr and is free on orders over 550 kr." })
		},
		{
			heading: "Right of withdrawal",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "Products are custom made to your specification and are therefore exempt from the statutory right of withdrawal for distance sales. If you spot a mistake within 24 hours, contact us — before production starts we can usually adjust or cancel." })
		},
		{
			heading: "Faulty goods",
			body: /* @__PURE__ */ (0, I.jsxs)("p", { children: [
				"Faulty goods are covered by the Swedish Consumer Sales Act with a 3-year claim period. Email",
				" ",
				G.email,
				" with your order number and photos. Disputes may be referred to the Swedish National Board for Consumer Disputes (ARN) or the EU ODR platform."
			] })
		}
	];
	return /* @__PURE__ */ (0, I.jsx)(Yd, {
		title: t ? "Köpvillkor" : "Terms of sale",
		updated: t ? "Senast uppdaterad 4 september 2026" : "Last updated 17 Aug 2026",
		sections: n
	});
}
//#endregion
//#region src/components/pages/ShippingPage.tsx
function $d() {
	let { lang: e } = x(), t = e === "sv", n = Bd("terms", e), r = t ? [
		{
			heading: "Leveransområde",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "Vi levererar inom Sverige och till de internationella destinationer som är tillgängliga i kassan. Ange din leveransadress i kassan för aktuella fraktalternativ och priser. Leveranstiden 2–3 arbetsdagar efter produktion gäller Sverige; internationell transporttid visas i kassan." })
		},
		{
			heading: "Produktionstid",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "Alla våra kartor tillverkas personligt utifrån kundens val. Normal produktionstid är 2 arbetsdagar." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Produktionen påbörjas vanligtvis inom en till två arbetsdagar efter beställningen. Varje karta kvalitetskontrolleras innan den packas och skickas." })] })
		},
		{
			heading: "Leveranstid",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "När produktionen är färdig skickas beställningen med PostNord. Normal transporttid är 2–3 arbetsdagar." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Den sammanlagda leveranstiden är normalt cirka 6–7 arbetsdagar från beställningen." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Alla leveranstider är uppskattningar och inte garanterade leveransdatum. Helgdagar, hög ordervolym, transportstörningar och andra omständigheter kan påverka leveranstiden." })
			] })
		},
		{
			heading: "Fraktpriser",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsxs)("ul", {
				className: "list-disc space-y-1 pl-5",
				children: [/* @__PURE__ */ (0, I.jsx)("li", { children: "Standardfrakt: 59 kr" }), /* @__PURE__ */ (0, I.jsx)("li", { children: "Fri standardfrakt vid beställningar över 550 kr" })]
			}), /* @__PURE__ */ (0, I.jsx)("p", { children: "Det slutliga fraktpriset visas alltid i kassan innan betalningen genomförs." })] })
		},
		{
			heading: "Spårning",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "När beställningen har skickats får kunden normalt en leveransbekräftelse med spårningsinformation via e-post." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Det kan ta en kort stund innan spårningsinformationen blir synlig hos PostNord." })] })
		},
		{
			heading: "Leveransadress",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Kunden ansvarar för att ange en korrekt och fullständig leveransadress samt riktiga kontaktuppgifter." }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Kontakta ",
					G.email,
					" så snart som möjligt om leveransuppgifterna är fel. Eftersom beställningen behandlas snabbt kan vi inte garantera att adressen hinner ändras innan försändelsen skickas."
				] }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "DearPlace ansvarar inte för förseningar som beror på felaktiga eller ofullständiga uppgifter från kunden." })
			] })
		},
		{
			heading: "Ej uthämtade paket",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Ett paket som inte hämtas ut eller tas emot räknas inte automatiskt som en retur eller avbeställning." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om försändelsen returneras till oss på grund av att den inte hämtats ut, eller på grund av felaktiga leveransuppgifter, får vi debitera kunden för våra faktiska kostnader för returhantering och en eventuell ny leverans." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi kontaktar kunden innan produkten skickas på nytt." })
			] })
		},
		{
			heading: "Transportskador",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Kontrollera gärna paketet och produkten så snart som möjligt efter leveransen." }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Om kartan eller ramen har skadats under transporten ska kunden kontakta ",
					G.email,
					" och bifoga:"
				] }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc space-y-1 pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "ordernummer," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "en beskrivning av skadan," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "bilder på produkten," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "bilder på ytteremballage och inneremballage, om det är möjligt." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Att kunden inte kontaktar oss omedelbart innebär inte att den lagstadgade reklamationsrätten automatiskt går förlorad." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vid en godkänd transportskada tillverkar och skickar vi normalt en ersättningsprodukt utan kostnad. Om ersättning inte är möjlig hanteras ärendet enligt konsumentköplagen och vår reklamationspolicy." })
			] })
		},
		{
			heading: "Försenad leverans",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsxs)("p", { children: [
				"Om beställningen inte har kommit fram inom den beräknade tiden ska kunden kontakta ",
				G.email,
				"."
			] }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Vi undersöker då försändelsen tillsammans med PostNord. Om en leverans är försenad har konsumenten de rättigheter som följer av konsumentköplagen, bland annat rätt att under vissa förutsättningar kräva leverans eller häva köpet." })] })
		},
		{
			heading: "Förlorad försändelse",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "Risken för produkten ligger hos DearPlace fram till dess att kunden, eller någon som kunden har utsett, har tagit emot den." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Om PostNord bekräftar att försändelsen har gått förlorad erbjuder vi i första hand en ny, likvärdig karta utan extra kostnad. Om en ny leverans inte är möjlig kan kunden få återbetalning enligt tillämplig lag." })] })
		},
		{
			heading: "Kontakt",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Frågor om produktion och leverans skickas till:" }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: G.email }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi svarar normalt inom 24–48 timmar på arbetsdagar." })
			] })
		}
	] : [
		{
			heading: "Production time",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "Every piece is 3D-produced to order. Production takes 2 business days." })
		},
		{
			heading: "Shipping and rates",
			body: /* @__PURE__ */ (0, I.jsxs)("ul", {
				className: "list-disc space-y-1 pl-5",
				children: [/* @__PURE__ */ (0, I.jsx)("li", { children: "Tracked standard delivery costs 59 kr and is free on orders over 550 kr. Within Sweden, allow 2–3 business days after production (6–7 business days in total)." }), /* @__PURE__ */ (0, I.jsx)("li", { children: "Available destinations and the final shipping charge are shown at checkout." })]
			})
		},
		{
			heading: "Tracking",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "You receive a tracking number by email as soon as the parcel leaves our production partner." })
		},
		{
			heading: "Damaged or faulty parcels",
			body: /* @__PURE__ */ (0, I.jsxs)("p", { children: [
				"Email ",
				G.email,
				" within 14 days with your order number and photos, and we will remake or refund the order. We cover return shipping when the fault is ours."
			] })
		},
		{
			heading: "Returns",
			body: /* @__PURE__ */ (0, I.jsxs)("p", { children: [
				"Because each piece is custom made from your place and options, change-of-mind returns are not available. See the",
				" ",
				/* @__PURE__ */ (0, I.jsx)("a", {
					className: "underline",
					href: n,
					children: "terms of sale"
				}),
				" ",
				"for details and your rights if something is faulty."
			] })
		}
	];
	return /* @__PURE__ */ (0, I.jsx)(Yd, {
		title: t ? "Frakt och returer" : "Shipping and returns",
		updated: t ? "Senast uppdaterad 4 september 2026" : "Last updated 17 Aug 2026",
		sections: r
	});
}
//#endregion
//#region src/components/pages/ReturnsPage.tsx
function ef() {
	let { lang: e } = x(), t = e === "sv", n = t ? [
		{
			heading: "Personligt tillverkade produkter",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "Varje produkt från DearPlace tillverkas efter kundens personliga val av plats, geografisk beskärning, storlek, färg och ram." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Produkten tillverkas särskilt för kunden och kan normalt inte säljas vidare till någon annan." })] })
		},
		{
			heading: "Ingen lagstadgad ångerrätt",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "Den vanliga ångerrätten på 14 dagar gäller inte för varor som har tillverkats enligt konsumentens anvisningar eller som annars har fått en tydlig personlig prägel. Eftersom alla produkter från DearPlace är personligt anpassade omfattas de av detta undantag. Beställningen kan därför inte returneras med hänvisning till ångerrätt." })
		},
		{
			heading: "Inget öppet köp",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "DearPlace erbjuder inte öppet köp eller frivillig returrätt för felfria produkter. Att kunden ångrar sitt val av plats, beskärning, storlek, färg eller ram innebär inte att produkten är felaktig, förutsatt att den levererade produkten överensstämmer med beställningen och förhandsvisningen." })
		},
		{
			heading: "Avbeställning före leverans",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Avbeställning och ångerrätt är inte samma sak." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "En konsument får enligt konsumentköplagen avbeställa en vara innan den har levererats. DearPlace kan då ha rätt till skälig ersättning för utfört arbete, material, administration och annan faktisk förlust som avbeställningen medför." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Eftersom produkten är personligt tillverkad och normalt saknar värde för någon annan kan ersättningen motsvara en stor del av, eller i vissa fall hela, ordervärdet. Bedömningen görs utifrån hur långt beställningen har kommit och vilka kostnader och förluster som faktiskt har uppstått." }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"En avbeställning ska skickas till ",
					G.email,
					"."
				] }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "För företagskunder finns ingen rätt till avbeställning om detta inte har avtalats skriftligen med DearPlace." })
			] })
		},
		{
			heading: "Reklamationsrätt",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Undantaget från ångerrätten påverkar inte konsumentens reklamationsrätt." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "En konsument kan reklamera ett ursprungligt fel som visar sig inom tre år från att produkten levererades. Ett fel kan exempelvis vara att:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "den levererade kartan inte motsvarar det område eller den beskärning som visas i beställningen," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "fel storlek, färg eller ram har levererats," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "kartan eller ramen har ett tillverkningsfel," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "produkten har skadats under transporten," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "produkten på annat sätt avviker från vad som har avtalats." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Mindre färgskillnader mellan förhandsvisningen på skärmen och den färdiga produkten kan uppstå på grund av skärminställningar, ljus, material och tillverkning. Sådana mindre skillnader räknas normalt inte som fel." })
			] })
		},
		{
			heading: "Så reklamerar du",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Skicka reklamationen till ",
					G.email,
					" och ange:"
				] }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "namn," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "ordernummer," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "en tydlig beskrivning av felet," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "när felet upptäcktes," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "bilder som visar felet, om det är möjligt," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "bilder på förpackningen om produkten är transportskadad." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Kontakta oss så snart som möjligt. En reklamation som görs inom två månader från att felet upptäcktes anses alltid ha gjorts i rätt tid." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vi bekräftar reklamationen och återkommer normalt inom 24–48 timmar på arbetsdagar." })
			] })
		},
		{
			heading: "Hur ett fel åtgärdas",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "När en reklamation är godkänd försöker DearPlace normalt först lösa felet genom att avhjälpa det eller tillverka och skicka en ny karta." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Åtgärden ska genomföras inom skälig tid och utan kostnad eller väsentlig olägenhet för konsumenten." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om felet inte kan avhjälpas, om en ersättningsprodukt inte kan levereras inom skälig tid eller om felet kvarstår kan konsumenten ha rätt till prisavdrag eller att köpet hävs och betalningen återbetalas. Vid ett allvarligt fel kan andra rättigheter följa direkt av konsumentköplagen." })
			] })
		},
		{
			heading: "Retur av en felaktig produkt",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Skicka inte tillbaka produkten innan du har fått instruktioner från oss." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om produkten behöver returneras på grund av ett godkänt fel står DearPlace för den nödvändiga returfrakten. Vi skickar instruktioner och, när det är aktuellt, en returetikett." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Vid omleverans kan kunden behöva göra den felaktiga produkten tillgänglig för DearPlace. Den behöver dock normalt inte skickas tillbaka innan ersättningsprodukten har levererats, om inte annat överenskommes." })
			] })
		},
		{
			heading: "Återbetalning",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Om kunden har rätt till återbetalning sker den normalt till samma betalningssätt som användes vid köpet." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Återbetalningen görs utan onödigt dröjsmål och senast inom 14 dagar från det att rätten till återbetalning har fastställts. Om produkten ska lämnas tillbaka kan återbetalningen invänta att vi fått tillbaka produkten eller att kunden visat att den har skickats." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Ingen avgift tas ut för återbetalningen." })
			] })
		},
		{
			heading: "Företagskunder",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "För företagskunder gäller inte konsumentköplagen eller distansavtalslagens bestämmelser om konsumentskydd." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Företagskunder har ingen ångerrätt eller rätt till öppet köp. Fel ska reklameras inom skälig tid efter att felet upptäckts eller borde ha upptäckts. I övrigt gäller köplagen och de villkor som parterna har avtalat." })] })
		},
		{
			heading: "Kontakt",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsxs)("p", { children: [
				G.legalName,
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"Organisationsnummer: 559040-8075",
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"Bäckegatan 30 B",
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"413 16 Göteborg",
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"E-post: ",
				G.email
			] }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Vi svarar normalt inom 24–48 timmar på arbetsdagar." })] })
		}
	] : [
		{
			heading: "Made-to-order products",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "Every DearPlace product is made from the customer's personal choices of location, geographic crop, size, colour and frame." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "The product is made specifically for the customer and normally cannot be resold to anyone else." })] })
		},
		{
			heading: "No statutory right of withdrawal",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "The standard 14-day right of withdrawal does not apply to goods manufactured according to the consumer's instructions or otherwise given a clear personal character. Because all DearPlace products are personalised, they fall under this exception. Orders therefore cannot be returned on the basis of the right of withdrawal." })
		},
		{
			heading: "No open purchase",
			body: /* @__PURE__ */ (0, I.jsx)("p", { children: "DearPlace does not offer open purchase or voluntary returns for fault-free products. If the customer regrets their choice of location, crop, size, colour or frame, this does not mean the product is faulty, provided the delivered product matches the order and preview." })
		},
		{
			heading: "Cancellation before delivery",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Cancellation and the right of withdrawal are not the same thing." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Under the Swedish Consumer Sales Act, a consumer may cancel a product before it has been delivered. DearPlace may then be entitled to reasonable compensation for work performed, materials, administration and other actual losses caused by the cancellation." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Because the product is custom-made and normally has no value to anyone else, the compensation may correspond to a large part of, or in some cases the entire, order value. The assessment is based on how far the order has progressed and the costs and losses actually incurred." }),
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Cancellations must be sent to ",
					G.email,
					"."
				] }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Business customers have no right to cancel unless this has been agreed in writing with DearPlace." })
			] })
		},
		{
			heading: "Right to complain",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "The exception from the right of withdrawal does not affect the consumer's right to complain." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "A consumer may complain about an original defect that appears within three years of the product being delivered. A defect may, for example, be that:" }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "the delivered map does not match the area or crop shown in the order," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "the wrong size, colour or frame has been delivered," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "the map or frame has a manufacturing defect," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "the product was damaged during transport," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "the product otherwise deviates from what was agreed." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Minor colour differences between the on-screen preview and the finished product may occur due to screen settings, lighting, materials and manufacturing. Such minor differences are normally not considered defects." })
			] })
		},
		{
			heading: "How to make a complaint",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsxs)("p", { children: [
					"Send your complaint to ",
					G.email,
					" and include:"
				] }),
				/* @__PURE__ */ (0, I.jsxs)("ul", {
					className: "list-disc pl-5",
					children: [
						/* @__PURE__ */ (0, I.jsx)("li", { children: "name," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "order number," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "a clear description of the defect," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "when the defect was discovered," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "photos showing the defect, if possible," }),
						/* @__PURE__ */ (0, I.jsx)("li", { children: "photos of the packaging if the product is damaged in transit." })
					]
				}),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Contact us as soon as possible. A complaint made within two months of discovering the defect is always considered to have been made in time." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "We confirm the complaint and normally respond within 24–48 hours on business days." })
			] })
		},
		{
			heading: "How a defect is remedied",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Once a complaint is approved, DearPlace will normally first try to remedy the defect by repairing it or making and sending a new map." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "The remedy shall be carried out within a reasonable time and without cost or significant inconvenience." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "If the defect cannot be repaired, a replacement cannot be delivered within a reasonable time, or the defect persists, the consumer may be entitled to a price reduction or to have the purchase rescinded and the payment refunded. For a serious defect, other rights may follow directly from the Consumer Sales Act." })
			] })
		},
		{
			heading: "Returning a faulty product",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "Do not send the product back before receiving instructions from us." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "If the product needs to be returned due to an approved defect, DearPlace covers the necessary return shipping. We will send instructions and, where applicable, a return label." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "For a replacement delivery, the customer may need to make the faulty product available to DearPlace. However, it normally does not need to be returned before the replacement has been delivered, unless otherwise agreed." })
			] })
		},
		{
			heading: "Refund",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [
				/* @__PURE__ */ (0, I.jsx)("p", { children: "If the customer is entitled to a refund, it is normally made to the same payment method used for the purchase." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "The refund is made without undue delay and no later than 14 days from when the right to a refund was established. If the product is to be returned, the refund may wait until we have received the product or the customer has shown that it has been sent." }),
				/* @__PURE__ */ (0, I.jsx)("p", { children: "No fee is charged for the refund." })
			] })
		},
		{
			heading: "Business customers",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsx)("p", { children: "The Swedish Consumer Sales Act and the Distance Contracts Act consumer protection provisions do not apply to business customers." }), /* @__PURE__ */ (0, I.jsx)("p", { children: "Business customers have no right of withdrawal or open purchase. Defects must be complained about within a reasonable time after the defect was discovered or should have been discovered. Otherwise, the Sale of Goods Act and the terms agreed between the parties apply." })] })
		},
		{
			heading: "Contact",
			body: /* @__PURE__ */ (0, I.jsxs)(I.Fragment, { children: [/* @__PURE__ */ (0, I.jsxs)("p", { children: [
				G.legalName,
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"Company registration number: 559040-8075",
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"Bäckegatan 30 B",
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"413 16 Göteborg",
				/* @__PURE__ */ (0, I.jsx)("br", {}),
				"Email: ",
				G.email
			] }), /* @__PURE__ */ (0, I.jsx)("p", { children: "We normally reply within 24–48 hours on business days." })] })
		}
	];
	return /* @__PURE__ */ (0, I.jsx)(Yd, {
		title: t ? "Retur-, ånger- och reklamationspolicy" : "Returns, withdrawal and complaints policy",
		updated: t ? "Senast uppdaterad 4 september 2026" : "Last updated 4 September 2026",
		sections: n
	});
}
//#endregion
//#region src/theme.tsx
var tf = document.getElementById("dearplace-app");
if (tf && !tf.shadowRoot) {
	let e = tf.attachShadow({ mode: "open" }), t = document.createElement("link");
	t.rel = "stylesheet", t.href = tf.dataset.styles, e.append(t);
	let n = document.createElement("div");
	n.id = "dp-root", e.append(n);
	let r = document.createElement("div");
	r.id = "dp-portals", e.append(r);
	let i = new URLSearchParams(location.search), a = (i.get("lang") ?? tf.dataset.language) === "sv" ? "sv" : "en", o = tf.dataset.page;
	o === "configurator" && ne("configurator_viewed");
	let s = {
		inspiration: Ud,
		privacy: Xd,
		cookies: Zd,
		terms: Qd,
		shipping: $d,
		returns: ef
	}, c;
	if (o === "configurator") c = /* @__PURE__ */ (0, I.jsx)(Nd, { initialPlaceQuery: i.get("city") ?? void 0 });
	else if (o === "landing") {
		let e = (i.get("kind") === "occasion" ? Id : Fd).find((e) => e.slug[a] === i.get("slug") || e.id === i.get("slug"));
		c = e && e.copy[a] ? /* @__PURE__ */ (0, I.jsx)(qd, {
			storyId: e.id,
			copy: e.copy[a],
			place: "searchCity" in e ? {
				city: e.searchCity,
				country: e.country
			} : void 0,
			relatedCities: e.relatedCities,
			relatedOccasions: e.relatedOccasions
		}) : /* @__PURE__ */ (0, I.jsx)(Ud, {});
	} else {
		let e = s[o ?? ""] ?? Ud;
		c = /* @__PURE__ */ (0, I.jsx)(e, {});
	}
	(0, jt.createRoot)(n).render(/* @__PURE__ */ (0, I.jsx)(he, {
		client: new vt(),
		children: /* @__PURE__ */ (0, I.jsxs)(S, {
			lang: a,
			children: [c, /* @__PURE__ */ (0, I.jsx)(dn, {})]
		})
	}));
}
//#endregion
